// (C) 2024 GoodData Corporation
import globalAxios from "axios";
// Some imports not used depending on template conditions, we also need prettier-ignore so that the import does not get split and ts-ignore still works
// prettier-ignore
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, toPathString, createRequestFunction } from './common.js';
// Some imports not used depending on template conditions, we also need prettier-ignore so that the import does not get split and ts-ignore still works
// prettier-ignore
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI } from './base.js';
export const AfmObjectIdentifierAttributeIdentifierTypeEnum = {
    ATTRIBUTE: "attribute",
};
export const AfmObjectIdentifierCoreIdentifierTypeEnum = {
    ATTRIBUTE: "attribute",
    LABEL: "label",
    FACT: "fact",
    METRIC: "metric",
};
export const AfmObjectIdentifierDatasetIdentifierTypeEnum = {
    DATASET: "dataset",
};
export const AfmObjectIdentifierIdentifierTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
    ATTRIBUTE: "attribute",
    DASHBOARD_PLUGIN: "dashboardPlugin",
    DATASET: "dataset",
    FACT: "fact",
    LABEL: "label",
    METRIC: "metric",
    PROMPT: "prompt",
    VISUALIZATION_OBJECT: "visualizationObject",
    FILTER_CONTEXT: "filterContext",
};
export const AfmObjectIdentifierLabelIdentifierTypeEnum = {
    LABEL: "label",
};
export const ApiEntitlementNameEnum = {
    CACHE_STRATEGY: "CacheStrategy",
    CONTRACT: "Contract",
    CUSTOM_THEMING: "CustomTheming",
    EXTRA_CACHE: "ExtraCache",
    HIPAA: "Hipaa",
    PDF_EXPORTS: "PdfExports",
    MANAGED_OIDC: "ManagedOIDC",
    UI_LOCALIZATION: "UiLocalization",
    TIER: "Tier",
    USER_COUNT: "UserCount",
    UNLIMITED_USERS: "UnlimitedUsers",
    UNLIMITED_WORKSPACES: "UnlimitedWorkspaces",
    WHITE_LABELING: "WhiteLabeling",
    WORKSPACE_COUNT: "WorkspaceCount",
    USER_TELEMETRY_DISABLED: "UserTelemetryDisabled",
    AUTOMATION_COUNT: "AutomationCount",
    UNLIMITED_AUTOMATIONS: "UnlimitedAutomations",
    AUTOMATION_RECIPIENT_COUNT: "AutomationRecipientCount",
    UNLIMITED_AUTOMATION_RECIPIENTS: "UnlimitedAutomationRecipients",
    DAILY_SCHEDULED_ACTION_COUNT: "DailyScheduledActionCount",
    UNLIMITED_DAILY_SCHEDULED_ACTIONS: "UnlimitedDailyScheduledActions",
    DAILY_ALERT_ACTION_COUNT: "DailyAlertActionCount",
    UNLIMITED_DAILY_ALERT_ACTIONS: "UnlimitedDailyAlertActions",
    SCHEDULED_ACTION_MINIMUM_RECURRENCE_MINUTES: "ScheduledActionMinimumRecurrenceMinutes",
    FEDERATED_IDENTITY_MANAGEMENT: "FederatedIdentityManagement",
};
export const ArithmeticMeasureOperatorEnum = {
    DIFFERENCE: "DIFFERENCE",
    CHANGE: "CHANGE",
};
export const ArithmeticMeasureDefinitionArithmeticMeasureOperatorEnum = {
    SUM: "SUM",
    DIFFERENCE: "DIFFERENCE",
    MULTIPLICATION: "MULTIPLICATION",
    RATIO: "RATIO",
    CHANGE: "CHANGE",
};
export const AssigneeIdentifierTypeEnum = {
    USER: "user",
    USER_GROUP: "userGroup",
};
export const AssigneeRuleTypeEnum = {
    ALL_WORKSPACE_USERS: "allWorkspaceUsers",
};
export const AutomationAlertTriggerEnum = {
    ALWAYS: "ALWAYS",
    ONCE: "ONCE",
};
export const ColumnOverrideLdmTypeOverrideEnum = {
    FACT: "FACT",
    LABEL: "LABEL",
};
export const ColumnOverrideLabelTypeEnum = {
    TEXT: "TEXT",
    HYPERLINK: "HYPERLINK",
    GEO: "GEO",
    GEO_LONGITUDE: "GEO_LONGITUDE",
    GEO_LATITUDE: "GEO_LATITUDE",
    IMAGE: "IMAGE",
};
export const ComparisonOperatorEnum = {
    GREATER_THAN: "GREATER_THAN",
    GREATER_THAN_OR_EQUAL_TO: "GREATER_THAN_OR_EQUAL_TO",
    LESS_THAN: "LESS_THAN",
    LESS_THAN_OR_EQUAL_TO: "LESS_THAN_OR_EQUAL_TO",
    EQUAL_TO: "EQUAL_TO",
    NOT_EQUAL_TO: "NOT_EQUAL_TO",
};
export const ComparisonMeasureValueFilterComparisonMeasureValueFilterOperatorEnum = {
    GREATER_THAN: "GREATER_THAN",
    GREATER_THAN_OR_EQUAL_TO: "GREATER_THAN_OR_EQUAL_TO",
    LESS_THAN: "LESS_THAN",
    LESS_THAN_OR_EQUAL_TO: "LESS_THAN_OR_EQUAL_TO",
    EQUAL_TO: "EQUAL_TO",
    NOT_EQUAL_TO: "NOT_EQUAL_TO",
};
export const DataSourcePermissionAssignmentPermissionsEnum = {
    MANAGE: "MANAGE",
    USE: "USE",
};
export const DataSourceTableIdentifierTypeEnum = {
    DATA_SOURCE: "dataSource",
};
export const DatasetGrainTypeEnum = {
    ATTRIBUTE: "attribute",
    DATE: "date",
};
export const DatasetReferenceIdentifierTypeEnum = {
    DATASET: "dataset",
};
export const DatasetWorkspaceDataFilterIdentifierTypeEnum = {
    WORKSPACE_DATA_FILTER: "workspaceDataFilter",
};
export const DeclarativeAnalyticalDashboardIdentifierTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
};
export const DeclarativeAnalyticalDashboardPermissionAssignmentNameEnum = {
    EDIT: "EDIT",
    SHARE: "SHARE",
    VIEW: "VIEW",
};
export const DeclarativeAnalyticalDashboardPermissionForAssigneeNameEnum = {
    EDIT: "EDIT",
    SHARE: "SHARE",
    VIEW: "VIEW",
};
export const DeclarativeAnalyticalDashboardPermissionForAssigneeRuleNameEnum = {
    EDIT: "EDIT",
    SHARE: "SHARE",
    VIEW: "VIEW",
};
export const DeclarativeAttributeSortDirectionEnum = {
    ASC: "ASC",
    DESC: "DESC",
};
export const DeclarativeAttributeSourceColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const DeclarativeAutomationStateEnum = {
    ACTIVE: "ACTIVE",
    PAUSED: "PAUSED",
};
export const DeclarativeColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const DeclarativeDataSourceTypeEnum = {
    POSTGRESQL: "POSTGRESQL",
    REDSHIFT: "REDSHIFT",
    VERTICA: "VERTICA",
    SNOWFLAKE: "SNOWFLAKE",
    ADS: "ADS",
    BIGQUERY: "BIGQUERY",
    MSSQL: "MSSQL",
    PRESTO: "PRESTO",
    DREMIO: "DREMIO",
    DRILL: "DRILL",
    GREENPLUM: "GREENPLUM",
    AZURESQL: "AZURESQL",
    SYNAPSESQL: "SYNAPSESQL",
    DATABRICKS: "DATABRICKS",
    GDSTORAGE: "GDSTORAGE",
    CLICKHOUSE: "CLICKHOUSE",
    MYSQL: "MYSQL",
    MARIADB: "MARIADB",
    ORACLE: "ORACLE",
    PINOT: "PINOT",
    SINGLESTORE: "SINGLESTORE",
    MOTHERDUCK: "MOTHERDUCK",
    FLIGHTRPC: "FLIGHTRPC",
    FLEXCONNECT: "FLEXCONNECT",
};
export const DeclarativeDataSourceCacheStrategyEnum = {
    ALWAYS: "ALWAYS",
    NEVER: "NEVER",
};
export const DeclarativeDataSourcePermissionNameEnum = {
    MANAGE: "MANAGE",
    USE: "USE",
};
export const DeclarativeDateDatasetGranularitiesEnum = {
    MINUTE: "MINUTE",
    HOUR: "HOUR",
    DAY: "DAY",
    WEEK: "WEEK",
    MONTH: "MONTH",
    QUARTER: "QUARTER",
    YEAR: "YEAR",
    MINUTE_OF_HOUR: "MINUTE_OF_HOUR",
    HOUR_OF_DAY: "HOUR_OF_DAY",
    DAY_OF_WEEK: "DAY_OF_WEEK",
    DAY_OF_MONTH: "DAY_OF_MONTH",
    DAY_OF_YEAR: "DAY_OF_YEAR",
    WEEK_OF_YEAR: "WEEK_OF_YEAR",
    MONTH_OF_YEAR: "MONTH_OF_YEAR",
    QUARTER_OF_YEAR: "QUARTER_OF_YEAR",
};
export const DeclarativeExportDefinitionIdentifierTypeEnum = {
    EXPORT_DEFINITION: "exportDefinition",
};
export const DeclarativeFactSourceColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const DeclarativeLabelSourceColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const DeclarativeLabelValueTypeEnum = {
    TEXT: "TEXT",
    HYPERLINK: "HYPERLINK",
    GEO: "GEO",
    GEO_LONGITUDE: "GEO_LONGITUDE",
    GEO_LATITUDE: "GEO_LATITUDE",
    IMAGE: "IMAGE",
};
export const DeclarativeNotificationChannelDestinationTypeEnum = {
    WEBHOOK: "WEBHOOK",
    SMTP: "SMTP",
    DEFAULT_SMTP: "DEFAULT_SMTP",
    IN_PLATFORM: "IN_PLATFORM",
};
export const DeclarativeNotificationChannelAllowedRecipientsEnum = {
    CREATOR: "CREATOR",
    INTERNAL: "INTERNAL",
};
export const DeclarativeNotificationChannelIdentifierTypeEnum = {
    NOTIFICATION_CHANNEL: "notificationChannel",
};
export const DeclarativeOrganizationPermissionNameEnum = {
    MANAGE: "MANAGE",
    SELF_CREATE_TOKEN: "SELF_CREATE_TOKEN",
};
export const DeclarativeReferenceSourceColumnDataTypesEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const DeclarativeReferenceSourceDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const DeclarativeRsaSpecificationKtyEnum = {
    RSA: "RSA",
};
export const DeclarativeRsaSpecificationAlgEnum = {
    RS256: "RS256",
    RS384: "RS384",
    RS512: "RS512",
};
export const DeclarativeRsaSpecificationUseEnum = {
    SIG: "sig",
};
export const DeclarativeSettingTypeEnum = {
    TIMEZONE: "TIMEZONE",
    ACTIVE_THEME: "ACTIVE_THEME",
    ACTIVE_COLOR_PALETTE: "ACTIVE_COLOR_PALETTE",
    WHITE_LABELING: "WHITE_LABELING",
    LOCALE: "LOCALE",
    METADATA_LOCALE: "METADATA_LOCALE",
    FORMAT_LOCALE: "FORMAT_LOCALE",
    MAPBOX_TOKEN: "MAPBOX_TOKEN",
    WEEK_START: "WEEK_START",
    SHOW_HIDDEN_CATALOG_ITEMS: "SHOW_HIDDEN_CATALOG_ITEMS",
    OPERATOR_OVERRIDES: "OPERATOR_OVERRIDES",
    TIMEZONE_VALIDATION_ENABLED: "TIMEZONE_VALIDATION_ENABLED",
    OPENAI_CONFIG: "OPENAI_CONFIG",
    ENABLE_FILE_ANALYTICS: "ENABLE_FILE_ANALYTICS",
    ALERT: "ALERT",
    SEPARATORS: "SEPARATORS",
};
export const DeclarativeSingleWorkspacePermissionNameEnum = {
    MANAGE: "MANAGE",
    ANALYZE: "ANALYZE",
    EXPORT: "EXPORT",
    EXPORT_TABULAR: "EXPORT_TABULAR",
    EXPORT_PDF: "EXPORT_PDF",
    CREATE_AUTOMATION: "CREATE_AUTOMATION",
    CREATE_FILTER_VIEW: "CREATE_FILTER_VIEW",
    VIEW: "VIEW",
};
export const DeclarativeUserGroupIdentifierTypeEnum = {
    USER_GROUP: "userGroup",
};
export const DeclarativeUserGroupPermissionNameEnum = {
    SEE: "SEE",
};
export const DeclarativeUserIdentifierTypeEnum = {
    USER: "user",
};
export const DeclarativeUserPermissionNameEnum = {
    SEE: "SEE",
};
export const DeclarativeWorkspaceDataFilterColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const DeclarativeWorkspaceDataFilterReferencesFilterColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const DeclarativeWorkspaceHierarchyPermissionNameEnum = {
    MANAGE: "MANAGE",
    ANALYZE: "ANALYZE",
    EXPORT: "EXPORT",
    EXPORT_TABULAR: "EXPORT_TABULAR",
    EXPORT_PDF: "EXPORT_PDF",
    CREATE_AUTOMATION: "CREATE_AUTOMATION",
    CREATE_FILTER_VIEW: "CREATE_FILTER_VIEW",
    VIEW: "VIEW",
};
export const DefaultSmtpTypeEnum = {
    DEFAULT_SMTP: "DEFAULT_SMTP",
};
export const DefaultSmtpAllOfTypeEnum = {
    DEFAULT_SMTP: "DEFAULT_SMTP",
};
export const DependentEntitiesNodeTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
    ATTRIBUTE: "attribute",
    DASHBOARD_PLUGIN: "dashboardPlugin",
    DATASET: "dataset",
    FACT: "fact",
    LABEL: "label",
    METRIC: "metric",
    USER_DATA_FILTER: "userDataFilter",
    PROMPT: "prompt",
    VISUALIZATION_OBJECT: "visualizationObject",
    FILTER_CONTEXT: "filterContext",
};
export const EntitlementsRequestEntitlementsNameEnum = {
    CACHE_STRATEGY: "CacheStrategy",
    CONTRACT: "Contract",
    CUSTOM_THEMING: "CustomTheming",
    EXTRA_CACHE: "ExtraCache",
    HIPAA: "Hipaa",
    PDF_EXPORTS: "PdfExports",
    MANAGED_OIDC: "ManagedOIDC",
    UI_LOCALIZATION: "UiLocalization",
    TIER: "Tier",
    USER_COUNT: "UserCount",
    UNLIMITED_USERS: "UnlimitedUsers",
    UNLIMITED_WORKSPACES: "UnlimitedWorkspaces",
    WHITE_LABELING: "WhiteLabeling",
    WORKSPACE_COUNT: "WorkspaceCount",
    USER_TELEMETRY_DISABLED: "UserTelemetryDisabled",
    AUTOMATION_COUNT: "AutomationCount",
    UNLIMITED_AUTOMATIONS: "UnlimitedAutomations",
    AUTOMATION_RECIPIENT_COUNT: "AutomationRecipientCount",
    UNLIMITED_AUTOMATION_RECIPIENTS: "UnlimitedAutomationRecipients",
    DAILY_SCHEDULED_ACTION_COUNT: "DailyScheduledActionCount",
    UNLIMITED_DAILY_SCHEDULED_ACTIONS: "UnlimitedDailyScheduledActions",
    DAILY_ALERT_ACTION_COUNT: "DailyAlertActionCount",
    UNLIMITED_DAILY_ALERT_ACTIONS: "UnlimitedDailyAlertActions",
    SCHEDULED_ACTION_MINIMUM_RECURRENCE_MINUTES: "ScheduledActionMinimumRecurrenceMinutes",
    FEDERATED_IDENTITY_MANAGEMENT: "FederatedIdentityManagement",
};
export const EntityIdentifierTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
    ATTRIBUTE: "attribute",
    DASHBOARD_PLUGIN: "dashboardPlugin",
    DATASET: "dataset",
    FACT: "fact",
    LABEL: "label",
    METRIC: "metric",
    USER_DATA_FILTER: "userDataFilter",
    PROMPT: "prompt",
    VISUALIZATION_OBJECT: "visualizationObject",
    FILTER_CONTEXT: "filterContext",
};
export const GrainIdentifierTypeEnum = {
    ATTRIBUTE: "attribute",
    DATE: "date",
};
export const HierarchyObjectIdentificationTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
    ATTRIBUTE: "attribute",
    DASHBOARD_PLUGIN: "dashboardPlugin",
    DATASET: "dataset",
    FACT: "fact",
    LABEL: "label",
    METRIC: "metric",
    PROMPT: "prompt",
    VISUALIZATION_OBJECT: "visualizationObject",
    FILTER_CONTEXT: "filterContext",
    WORKSPACE_DATA_FILTER: "workspaceDataFilter",
    WORKSPACE_DATA_FILTER_SETTINGS: "workspaceDataFilterSettings",
};
export const IdentifierDuplicationsTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
    ATTRIBUTE: "attribute",
    DASHBOARD_PLUGIN: "dashboardPlugin",
    DATASET: "dataset",
    FACT: "fact",
    LABEL: "label",
    METRIC: "metric",
    PROMPT: "prompt",
    VISUALIZATION_OBJECT: "visualizationObject",
    FILTER_CONTEXT: "filterContext",
    WORKSPACE_DATA_FILTER: "workspaceDataFilter",
    WORKSPACE_DATA_FILTER_SETTINGS: "workspaceDataFilterSettings",
};
export const InPlatformTypeEnum = {
    IN_PLATFORM: "IN_PLATFORM",
};
export const InPlatformAllOfTypeEnum = {
    IN_PLATFORM: "IN_PLATFORM",
};
export const JsonApiAnalyticalDashboardInTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
};
export const JsonApiAnalyticalDashboardLinkageTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
};
export const JsonApiAnalyticalDashboardOutTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
};
export const JsonApiAnalyticalDashboardOutMetaPermissionsEnum = {
    EDIT: "EDIT",
    SHARE: "SHARE",
    VIEW: "VIEW",
};
export const JsonApiAnalyticalDashboardOutWithLinksTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
};
export const JsonApiAnalyticalDashboardPatchTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
};
export const JsonApiAnalyticalDashboardPostOptionalIdTypeEnum = {
    ANALYTICAL_DASHBOARD: "analyticalDashboard",
};
export const JsonApiApiTokenInTypeEnum = {
    API_TOKEN: "apiToken",
};
export const JsonApiApiTokenOutTypeEnum = {
    API_TOKEN: "apiToken",
};
export const JsonApiApiTokenOutWithLinksTypeEnum = {
    API_TOKEN: "apiToken",
};
export const JsonApiAttributeHierarchyInTypeEnum = {
    ATTRIBUTE_HIERARCHY: "attributeHierarchy",
};
export const JsonApiAttributeHierarchyLinkageTypeEnum = {
    ATTRIBUTE_HIERARCHY: "attributeHierarchy",
};
export const JsonApiAttributeHierarchyOutTypeEnum = {
    ATTRIBUTE_HIERARCHY: "attributeHierarchy",
};
export const JsonApiAttributeHierarchyOutWithLinksTypeEnum = {
    ATTRIBUTE_HIERARCHY: "attributeHierarchy",
};
export const JsonApiAttributeHierarchyPatchTypeEnum = {
    ATTRIBUTE_HIERARCHY: "attributeHierarchy",
};
export const JsonApiAttributeLinkageTypeEnum = {
    ATTRIBUTE: "attribute",
};
export const JsonApiAttributeOutTypeEnum = {
    ATTRIBUTE: "attribute",
};
export const JsonApiAttributeOutAttributesGranularityEnum = {
    MINUTE: "MINUTE",
    HOUR: "HOUR",
    DAY: "DAY",
    WEEK: "WEEK",
    MONTH: "MONTH",
    QUARTER: "QUARTER",
    YEAR: "YEAR",
    MINUTE_OF_HOUR: "MINUTE_OF_HOUR",
    HOUR_OF_DAY: "HOUR_OF_DAY",
    DAY_OF_WEEK: "DAY_OF_WEEK",
    DAY_OF_MONTH: "DAY_OF_MONTH",
    DAY_OF_YEAR: "DAY_OF_YEAR",
    WEEK_OF_YEAR: "WEEK_OF_YEAR",
    MONTH_OF_YEAR: "MONTH_OF_YEAR",
    QUARTER_OF_YEAR: "QUARTER_OF_YEAR",
};
export const JsonApiAttributeOutAttributesSortDirectionEnum = {
    ASC: "ASC",
    DESC: "DESC",
};
export const JsonApiAttributeOutAttributesSourceColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const JsonApiAttributeOutWithLinksTypeEnum = {
    ATTRIBUTE: "attribute",
};
export const JsonApiAutomationInTypeEnum = {
    AUTOMATION: "automation",
};
export const JsonApiAutomationInAttributesStateEnum = {
    ACTIVE: "ACTIVE",
    PAUSED: "PAUSED",
};
export const JsonApiAutomationLinkageTypeEnum = {
    AUTOMATION: "automation",
};
export const JsonApiAutomationOutTypeEnum = {
    AUTOMATION: "automation",
};
export const JsonApiAutomationOutAttributesStateEnum = {
    ACTIVE: "ACTIVE",
    PAUSED: "PAUSED",
};
export const JsonApiAutomationOutAttributesAlertTriggerEnum = {
    ALWAYS: "ALWAYS",
    ONCE: "ONCE",
};
export const JsonApiAutomationOutWithLinksTypeEnum = {
    AUTOMATION: "automation",
};
export const JsonApiAutomationPatchTypeEnum = {
    AUTOMATION: "automation",
};
export const JsonApiColorPaletteInTypeEnum = {
    COLOR_PALETTE: "colorPalette",
};
export const JsonApiColorPaletteOutTypeEnum = {
    COLOR_PALETTE: "colorPalette",
};
export const JsonApiColorPaletteOutWithLinksTypeEnum = {
    COLOR_PALETTE: "colorPalette",
};
export const JsonApiColorPalettePatchTypeEnum = {
    COLOR_PALETTE: "colorPalette",
};
export const JsonApiCookieSecurityConfigurationInTypeEnum = {
    COOKIE_SECURITY_CONFIGURATION: "cookieSecurityConfiguration",
};
export const JsonApiCookieSecurityConfigurationOutTypeEnum = {
    COOKIE_SECURITY_CONFIGURATION: "cookieSecurityConfiguration",
};
export const JsonApiCookieSecurityConfigurationPatchTypeEnum = {
    COOKIE_SECURITY_CONFIGURATION: "cookieSecurityConfiguration",
};
export const JsonApiCspDirectiveInTypeEnum = {
    CSP_DIRECTIVE: "cspDirective",
};
export const JsonApiCspDirectiveOutTypeEnum = {
    CSP_DIRECTIVE: "cspDirective",
};
export const JsonApiCspDirectiveOutWithLinksTypeEnum = {
    CSP_DIRECTIVE: "cspDirective",
};
export const JsonApiCspDirectivePatchTypeEnum = {
    CSP_DIRECTIVE: "cspDirective",
};
export const JsonApiCustomApplicationSettingInTypeEnum = {
    CUSTOM_APPLICATION_SETTING: "customApplicationSetting",
};
export const JsonApiCustomApplicationSettingOutTypeEnum = {
    CUSTOM_APPLICATION_SETTING: "customApplicationSetting",
};
export const JsonApiCustomApplicationSettingOutWithLinksTypeEnum = {
    CUSTOM_APPLICATION_SETTING: "customApplicationSetting",
};
export const JsonApiCustomApplicationSettingPatchTypeEnum = {
    CUSTOM_APPLICATION_SETTING: "customApplicationSetting",
};
export const JsonApiCustomApplicationSettingPostOptionalIdTypeEnum = {
    CUSTOM_APPLICATION_SETTING: "customApplicationSetting",
};
export const JsonApiDashboardPluginInTypeEnum = {
    DASHBOARD_PLUGIN: "dashboardPlugin",
};
export const JsonApiDashboardPluginLinkageTypeEnum = {
    DASHBOARD_PLUGIN: "dashboardPlugin",
};
export const JsonApiDashboardPluginOutTypeEnum = {
    DASHBOARD_PLUGIN: "dashboardPlugin",
};
export const JsonApiDashboardPluginOutWithLinksTypeEnum = {
    DASHBOARD_PLUGIN: "dashboardPlugin",
};
export const JsonApiDashboardPluginPatchTypeEnum = {
    DASHBOARD_PLUGIN: "dashboardPlugin",
};
export const JsonApiDashboardPluginPostOptionalIdTypeEnum = {
    DASHBOARD_PLUGIN: "dashboardPlugin",
};
export const JsonApiDataSourceIdentifierOutTypeEnum = {
    DATA_SOURCE_IDENTIFIER: "dataSourceIdentifier",
};
export const JsonApiDataSourceIdentifierOutAttributesTypeEnum = {
    POSTGRESQL: "POSTGRESQL",
    REDSHIFT: "REDSHIFT",
    VERTICA: "VERTICA",
    SNOWFLAKE: "SNOWFLAKE",
    ADS: "ADS",
    BIGQUERY: "BIGQUERY",
    MSSQL: "MSSQL",
    PRESTO: "PRESTO",
    DREMIO: "DREMIO",
    DRILL: "DRILL",
    GREENPLUM: "GREENPLUM",
    AZURESQL: "AZURESQL",
    SYNAPSESQL: "SYNAPSESQL",
    DATABRICKS: "DATABRICKS",
    GDSTORAGE: "GDSTORAGE",
    CLICKHOUSE: "CLICKHOUSE",
    MYSQL: "MYSQL",
    MARIADB: "MARIADB",
    ORACLE: "ORACLE",
    PINOT: "PINOT",
    SINGLESTORE: "SINGLESTORE",
    MOTHERDUCK: "MOTHERDUCK",
    FLIGHTRPC: "FLIGHTRPC",
    FLEXCONNECT: "FLEXCONNECT",
};
export const JsonApiDataSourceIdentifierOutWithLinksTypeEnum = {
    DATA_SOURCE_IDENTIFIER: "dataSourceIdentifier",
};
export const JsonApiDataSourceInTypeEnum = {
    DATA_SOURCE: "dataSource",
};
export const JsonApiDataSourceInAttributesTypeEnum = {
    POSTGRESQL: "POSTGRESQL",
    REDSHIFT: "REDSHIFT",
    VERTICA: "VERTICA",
    SNOWFLAKE: "SNOWFLAKE",
    ADS: "ADS",
    BIGQUERY: "BIGQUERY",
    MSSQL: "MSSQL",
    PRESTO: "PRESTO",
    DREMIO: "DREMIO",
    DRILL: "DRILL",
    GREENPLUM: "GREENPLUM",
    AZURESQL: "AZURESQL",
    SYNAPSESQL: "SYNAPSESQL",
    DATABRICKS: "DATABRICKS",
    GDSTORAGE: "GDSTORAGE",
    CLICKHOUSE: "CLICKHOUSE",
    MYSQL: "MYSQL",
    MARIADB: "MARIADB",
    ORACLE: "ORACLE",
    PINOT: "PINOT",
    SINGLESTORE: "SINGLESTORE",
    MOTHERDUCK: "MOTHERDUCK",
    FLIGHTRPC: "FLIGHTRPC",
    FLEXCONNECT: "FLEXCONNECT",
};
export const JsonApiDataSourceInAttributesCacheStrategyEnum = {
    ALWAYS: "ALWAYS",
    NEVER: "NEVER",
};
export const JsonApiDataSourceOutTypeEnum = {
    DATA_SOURCE: "dataSource",
};
export const JsonApiDataSourceOutAttributesTypeEnum = {
    POSTGRESQL: "POSTGRESQL",
    REDSHIFT: "REDSHIFT",
    VERTICA: "VERTICA",
    SNOWFLAKE: "SNOWFLAKE",
    ADS: "ADS",
    BIGQUERY: "BIGQUERY",
    MSSQL: "MSSQL",
    PRESTO: "PRESTO",
    DREMIO: "DREMIO",
    DRILL: "DRILL",
    GREENPLUM: "GREENPLUM",
    AZURESQL: "AZURESQL",
    SYNAPSESQL: "SYNAPSESQL",
    DATABRICKS: "DATABRICKS",
    GDSTORAGE: "GDSTORAGE",
    CLICKHOUSE: "CLICKHOUSE",
    MYSQL: "MYSQL",
    MARIADB: "MARIADB",
    ORACLE: "ORACLE",
    PINOT: "PINOT",
    SINGLESTORE: "SINGLESTORE",
    MOTHERDUCK: "MOTHERDUCK",
    FLIGHTRPC: "FLIGHTRPC",
    FLEXCONNECT: "FLEXCONNECT",
};
export const JsonApiDataSourceOutAttributesCacheStrategyEnum = {
    ALWAYS: "ALWAYS",
    NEVER: "NEVER",
};
export const JsonApiDataSourceOutAttributesAuthenticationTypeEnum = {
    USERNAME_PASSWORD: "USERNAME_PASSWORD",
    TOKEN: "TOKEN",
    KEY_PAIR: "KEY_PAIR",
};
export const JsonApiDataSourceOutMetaPermissionsEnum = {
    MANAGE: "MANAGE",
    USE: "USE",
};
export const JsonApiDataSourceOutWithLinksTypeEnum = {
    DATA_SOURCE: "dataSource",
};
export const JsonApiDataSourcePatchTypeEnum = {
    DATA_SOURCE: "dataSource",
};
export const JsonApiDataSourcePatchAttributesTypeEnum = {
    POSTGRESQL: "POSTGRESQL",
    REDSHIFT: "REDSHIFT",
    VERTICA: "VERTICA",
    SNOWFLAKE: "SNOWFLAKE",
    ADS: "ADS",
    BIGQUERY: "BIGQUERY",
    MSSQL: "MSSQL",
    PRESTO: "PRESTO",
    DREMIO: "DREMIO",
    DRILL: "DRILL",
    GREENPLUM: "GREENPLUM",
    AZURESQL: "AZURESQL",
    SYNAPSESQL: "SYNAPSESQL",
    DATABRICKS: "DATABRICKS",
    GDSTORAGE: "GDSTORAGE",
    CLICKHOUSE: "CLICKHOUSE",
    MYSQL: "MYSQL",
    MARIADB: "MARIADB",
    ORACLE: "ORACLE",
    PINOT: "PINOT",
    SINGLESTORE: "SINGLESTORE",
    MOTHERDUCK: "MOTHERDUCK",
    FLIGHTRPC: "FLIGHTRPC",
    FLEXCONNECT: "FLEXCONNECT",
};
export const JsonApiDataSourcePatchAttributesCacheStrategyEnum = {
    ALWAYS: "ALWAYS",
    NEVER: "NEVER",
};
export const JsonApiDatasetLinkageTypeEnum = {
    DATASET: "dataset",
};
export const JsonApiDatasetOutTypeEnum = {
    DATASET: "dataset",
};
export const JsonApiDatasetOutAttributesTypeEnum = {
    NORMAL: "NORMAL",
    DATE: "DATE",
};
export const JsonApiDatasetOutAttributesGrainTypeEnum = {
    ATTRIBUTE: "attribute",
    DATE: "date",
};
export const JsonApiDatasetOutAttributesReferencePropertiesSourceColumnDataTypesEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const JsonApiDatasetOutAttributesWorkspaceDataFilterColumnsDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const JsonApiDatasetOutAttributesWorkspaceDataFilterReferencesFilterColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const JsonApiDatasetOutWithLinksTypeEnum = {
    DATASET: "dataset",
};
export const JsonApiEntitlementOutTypeEnum = {
    ENTITLEMENT: "entitlement",
};
export const JsonApiEntitlementOutWithLinksTypeEnum = {
    ENTITLEMENT: "entitlement",
};
export const JsonApiExportDefinitionInTypeEnum = {
    EXPORT_DEFINITION: "exportDefinition",
};
export const JsonApiExportDefinitionLinkageTypeEnum = {
    EXPORT_DEFINITION: "exportDefinition",
};
export const JsonApiExportDefinitionOutTypeEnum = {
    EXPORT_DEFINITION: "exportDefinition",
};
export const JsonApiExportDefinitionOutWithLinksTypeEnum = {
    EXPORT_DEFINITION: "exportDefinition",
};
export const JsonApiExportDefinitionPatchTypeEnum = {
    EXPORT_DEFINITION: "exportDefinition",
};
export const JsonApiExportDefinitionPostOptionalIdTypeEnum = {
    EXPORT_DEFINITION: "exportDefinition",
};
export const JsonApiFactLinkageTypeEnum = {
    FACT: "fact",
};
export const JsonApiFactOutTypeEnum = {
    FACT: "fact",
};
export const JsonApiFactOutAttributesSourceColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const JsonApiFactOutWithLinksTypeEnum = {
    FACT: "fact",
};
export const JsonApiFilterContextInTypeEnum = {
    FILTER_CONTEXT: "filterContext",
};
export const JsonApiFilterContextLinkageTypeEnum = {
    FILTER_CONTEXT: "filterContext",
};
export const JsonApiFilterContextOutTypeEnum = {
    FILTER_CONTEXT: "filterContext",
};
export const JsonApiFilterContextOutWithLinksTypeEnum = {
    FILTER_CONTEXT: "filterContext",
};
export const JsonApiFilterContextPatchTypeEnum = {
    FILTER_CONTEXT: "filterContext",
};
export const JsonApiFilterContextPostOptionalIdTypeEnum = {
    FILTER_CONTEXT: "filterContext",
};
export const JsonApiFilterViewInTypeEnum = {
    FILTER_VIEW: "filterView",
};
export const JsonApiFilterViewOutTypeEnum = {
    FILTER_VIEW: "filterView",
};
export const JsonApiFilterViewOutWithLinksTypeEnum = {
    FILTER_VIEW: "filterView",
};
export const JsonApiFilterViewPatchTypeEnum = {
    FILTER_VIEW: "filterView",
};
export const JsonApiIdentityProviderInTypeEnum = {
    IDENTITY_PROVIDER: "identityProvider",
};
export const JsonApiIdentityProviderOutTypeEnum = {
    IDENTITY_PROVIDER: "identityProvider",
};
export const JsonApiIdentityProviderOutWithLinksTypeEnum = {
    IDENTITY_PROVIDER: "identityProvider",
};
export const JsonApiIdentityProviderPatchTypeEnum = {
    IDENTITY_PROVIDER: "identityProvider",
};
export const JsonApiJwkInTypeEnum = {
    JWK: "jwk",
};
export const JsonApiJwkOutTypeEnum = {
    JWK: "jwk",
};
export const JsonApiJwkOutWithLinksTypeEnum = {
    JWK: "jwk",
};
export const JsonApiJwkPatchTypeEnum = {
    JWK: "jwk",
};
export const JsonApiLabelLinkageTypeEnum = {
    LABEL: "label",
};
export const JsonApiLabelOutTypeEnum = {
    LABEL: "label",
};
export const JsonApiLabelOutAttributesSourceColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const JsonApiLabelOutAttributesValueTypeEnum = {
    TEXT: "TEXT",
    HYPERLINK: "HYPERLINK",
    GEO: "GEO",
    GEO_LONGITUDE: "GEO_LONGITUDE",
    GEO_LATITUDE: "GEO_LATITUDE",
    IMAGE: "IMAGE",
};
export const JsonApiLabelOutWithLinksTypeEnum = {
    LABEL: "label",
};
export const JsonApiLlmEndpointInTypeEnum = {
    LLM_ENDPOINT: "llmEndpoint",
};
export const JsonApiLlmEndpointInAttributesProviderEnum = {
    OPENAI: "OPENAI",
};
export const JsonApiLlmEndpointOutTypeEnum = {
    LLM_ENDPOINT: "llmEndpoint",
};
export const JsonApiLlmEndpointOutAttributesProviderEnum = {
    OPENAI: "OPENAI",
};
export const JsonApiLlmEndpointOutWithLinksTypeEnum = {
    LLM_ENDPOINT: "llmEndpoint",
};
export const JsonApiLlmEndpointPatchTypeEnum = {
    LLM_ENDPOINT: "llmEndpoint",
};
export const JsonApiLlmEndpointPatchAttributesProviderEnum = {
    OPENAI: "OPENAI",
};
export const JsonApiMetricInTypeEnum = {
    METRIC: "metric",
};
export const JsonApiMetricLinkageTypeEnum = {
    METRIC: "metric",
};
export const JsonApiMetricOutTypeEnum = {
    METRIC: "metric",
};
export const JsonApiMetricOutWithLinksTypeEnum = {
    METRIC: "metric",
};
export const JsonApiMetricPatchTypeEnum = {
    METRIC: "metric",
};
export const JsonApiMetricPostOptionalIdTypeEnum = {
    METRIC: "metric",
};
export const JsonApiNotificationChannelInTypeEnum = {
    NOTIFICATION_CHANNEL: "notificationChannel",
};
export const JsonApiNotificationChannelInAttributesDestinationTypeEnum = {
    WEBHOOK: "WEBHOOK",
    SMTP: "SMTP",
    DEFAULT_SMTP: "DEFAULT_SMTP",
    IN_PLATFORM: "IN_PLATFORM",
};
export const JsonApiNotificationChannelInAttributesAllowedRecipientsEnum = {
    CREATOR: "CREATOR",
    INTERNAL: "INTERNAL",
};
export const JsonApiNotificationChannelLinkageTypeEnum = {
    NOTIFICATION_CHANNEL: "notificationChannel",
};
export const JsonApiNotificationChannelOutTypeEnum = {
    NOTIFICATION_CHANNEL: "notificationChannel",
};
export const JsonApiNotificationChannelOutWithLinksTypeEnum = {
    NOTIFICATION_CHANNEL: "notificationChannel",
};
export const JsonApiNotificationChannelPatchTypeEnum = {
    NOTIFICATION_CHANNEL: "notificationChannel",
};
export const JsonApiNotificationChannelPostOptionalIdTypeEnum = {
    NOTIFICATION_CHANNEL: "notificationChannel",
};
export const JsonApiOrganizationInTypeEnum = {
    ORGANIZATION: "organization",
};
export const JsonApiOrganizationOutTypeEnum = {
    ORGANIZATION: "organization",
};
export const JsonApiOrganizationOutAttributesCacheSettingsCacheStrategyEnum = {
    DURABLE: "DURABLE",
    EPHEMERAL: "EPHEMERAL",
};
export const JsonApiOrganizationOutMetaPermissionsEnum = {
    MANAGE: "MANAGE",
    SELF_CREATE_TOKEN: "SELF_CREATE_TOKEN",
};
export const JsonApiOrganizationPatchTypeEnum = {
    ORGANIZATION: "organization",
};
export const JsonApiOrganizationSettingInTypeEnum = {
    ORGANIZATION_SETTING: "organizationSetting",
};
export const JsonApiOrganizationSettingInAttributesTypeEnum = {
    TIMEZONE: "TIMEZONE",
    ACTIVE_THEME: "ACTIVE_THEME",
    ACTIVE_COLOR_PALETTE: "ACTIVE_COLOR_PALETTE",
    WHITE_LABELING: "WHITE_LABELING",
    LOCALE: "LOCALE",
    METADATA_LOCALE: "METADATA_LOCALE",
    FORMAT_LOCALE: "FORMAT_LOCALE",
    MAPBOX_TOKEN: "MAPBOX_TOKEN",
    WEEK_START: "WEEK_START",
    SHOW_HIDDEN_CATALOG_ITEMS: "SHOW_HIDDEN_CATALOG_ITEMS",
    OPERATOR_OVERRIDES: "OPERATOR_OVERRIDES",
    TIMEZONE_VALIDATION_ENABLED: "TIMEZONE_VALIDATION_ENABLED",
    OPENAI_CONFIG: "OPENAI_CONFIG",
    ENABLE_FILE_ANALYTICS: "ENABLE_FILE_ANALYTICS",
    ALERT: "ALERT",
    SEPARATORS: "SEPARATORS",
};
export const JsonApiOrganizationSettingOutTypeEnum = {
    ORGANIZATION_SETTING: "organizationSetting",
};
export const JsonApiOrganizationSettingOutWithLinksTypeEnum = {
    ORGANIZATION_SETTING: "organizationSetting",
};
export const JsonApiOrganizationSettingPatchTypeEnum = {
    ORGANIZATION_SETTING: "organizationSetting",
};
export const JsonApiThemeInTypeEnum = {
    THEME: "theme",
};
export const JsonApiThemeOutTypeEnum = {
    THEME: "theme",
};
export const JsonApiThemeOutWithLinksTypeEnum = {
    THEME: "theme",
};
export const JsonApiThemePatchTypeEnum = {
    THEME: "theme",
};
export const JsonApiUserDataFilterInTypeEnum = {
    USER_DATA_FILTER: "userDataFilter",
};
export const JsonApiUserDataFilterOutTypeEnum = {
    USER_DATA_FILTER: "userDataFilter",
};
export const JsonApiUserDataFilterOutWithLinksTypeEnum = {
    USER_DATA_FILTER: "userDataFilter",
};
export const JsonApiUserDataFilterPatchTypeEnum = {
    USER_DATA_FILTER: "userDataFilter",
};
export const JsonApiUserDataFilterPostOptionalIdTypeEnum = {
    USER_DATA_FILTER: "userDataFilter",
};
export const JsonApiUserGroupInTypeEnum = {
    USER_GROUP: "userGroup",
};
export const JsonApiUserGroupLinkageTypeEnum = {
    USER_GROUP: "userGroup",
};
export const JsonApiUserGroupOutTypeEnum = {
    USER_GROUP: "userGroup",
};
export const JsonApiUserGroupOutWithLinksTypeEnum = {
    USER_GROUP: "userGroup",
};
export const JsonApiUserGroupPatchTypeEnum = {
    USER_GROUP: "userGroup",
};
export const JsonApiUserIdentifierLinkageTypeEnum = {
    USER_IDENTIFIER: "userIdentifier",
};
export const JsonApiUserIdentifierOutTypeEnum = {
    USER_IDENTIFIER: "userIdentifier",
};
export const JsonApiUserIdentifierOutWithLinksTypeEnum = {
    USER_IDENTIFIER: "userIdentifier",
};
export const JsonApiUserInTypeEnum = {
    USER: "user",
};
export const JsonApiUserLinkageTypeEnum = {
    USER: "user",
};
export const JsonApiUserOutTypeEnum = {
    USER: "user",
};
export const JsonApiUserOutWithLinksTypeEnum = {
    USER: "user",
};
export const JsonApiUserPatchTypeEnum = {
    USER: "user",
};
export const JsonApiUserSettingInTypeEnum = {
    USER_SETTING: "userSetting",
};
export const JsonApiUserSettingOutTypeEnum = {
    USER_SETTING: "userSetting",
};
export const JsonApiUserSettingOutWithLinksTypeEnum = {
    USER_SETTING: "userSetting",
};
export const JsonApiVisualizationObjectInTypeEnum = {
    VISUALIZATION_OBJECT: "visualizationObject",
};
export const JsonApiVisualizationObjectLinkageTypeEnum = {
    VISUALIZATION_OBJECT: "visualizationObject",
};
export const JsonApiVisualizationObjectOutTypeEnum = {
    VISUALIZATION_OBJECT: "visualizationObject",
};
export const JsonApiVisualizationObjectOutMetaOriginOriginTypeEnum = {
    NATIVE: "NATIVE",
    PARENT: "PARENT",
};
export const JsonApiVisualizationObjectOutWithLinksTypeEnum = {
    VISUALIZATION_OBJECT: "visualizationObject",
};
export const JsonApiVisualizationObjectPatchTypeEnum = {
    VISUALIZATION_OBJECT: "visualizationObject",
};
export const JsonApiVisualizationObjectPostOptionalIdTypeEnum = {
    VISUALIZATION_OBJECT: "visualizationObject",
};
export const JsonApiWorkspaceDataFilterInTypeEnum = {
    WORKSPACE_DATA_FILTER: "workspaceDataFilter",
};
export const JsonApiWorkspaceDataFilterLinkageTypeEnum = {
    WORKSPACE_DATA_FILTER: "workspaceDataFilter",
};
export const JsonApiWorkspaceDataFilterOutTypeEnum = {
    WORKSPACE_DATA_FILTER: "workspaceDataFilter",
};
export const JsonApiWorkspaceDataFilterOutWithLinksTypeEnum = {
    WORKSPACE_DATA_FILTER: "workspaceDataFilter",
};
export const JsonApiWorkspaceDataFilterPatchTypeEnum = {
    WORKSPACE_DATA_FILTER: "workspaceDataFilter",
};
export const JsonApiWorkspaceDataFilterSettingInTypeEnum = {
    WORKSPACE_DATA_FILTER_SETTING: "workspaceDataFilterSetting",
};
export const JsonApiWorkspaceDataFilterSettingLinkageTypeEnum = {
    WORKSPACE_DATA_FILTER_SETTING: "workspaceDataFilterSetting",
};
export const JsonApiWorkspaceDataFilterSettingOutTypeEnum = {
    WORKSPACE_DATA_FILTER_SETTING: "workspaceDataFilterSetting",
};
export const JsonApiWorkspaceDataFilterSettingOutWithLinksTypeEnum = {
    WORKSPACE_DATA_FILTER_SETTING: "workspaceDataFilterSetting",
};
export const JsonApiWorkspaceDataFilterSettingPatchTypeEnum = {
    WORKSPACE_DATA_FILTER_SETTING: "workspaceDataFilterSetting",
};
export const JsonApiWorkspaceInTypeEnum = {
    WORKSPACE: "workspace",
};
export const JsonApiWorkspaceLinkageTypeEnum = {
    WORKSPACE: "workspace",
};
export const JsonApiWorkspaceOutTypeEnum = {
    WORKSPACE: "workspace",
};
export const JsonApiWorkspaceOutMetaPermissionsEnum = {
    MANAGE: "MANAGE",
    ANALYZE: "ANALYZE",
    EXPORT: "EXPORT",
    EXPORT_TABULAR: "EXPORT_TABULAR",
    EXPORT_PDF: "EXPORT_PDF",
    CREATE_AUTOMATION: "CREATE_AUTOMATION",
    CREATE_FILTER_VIEW: "CREATE_FILTER_VIEW",
    VIEW: "VIEW",
};
export const JsonApiWorkspaceOutWithLinksTypeEnum = {
    WORKSPACE: "workspace",
};
export const JsonApiWorkspacePatchTypeEnum = {
    WORKSPACE: "workspace",
};
export const JsonApiWorkspaceSettingInTypeEnum = {
    WORKSPACE_SETTING: "workspaceSetting",
};
export const JsonApiWorkspaceSettingOutTypeEnum = {
    WORKSPACE_SETTING: "workspaceSetting",
};
export const JsonApiWorkspaceSettingOutWithLinksTypeEnum = {
    WORKSPACE_SETTING: "workspaceSetting",
};
export const JsonApiWorkspaceSettingPatchTypeEnum = {
    WORKSPACE_SETTING: "workspaceSetting",
};
export const JsonApiWorkspaceSettingPostOptionalIdTypeEnum = {
    WORKSPACE_SETTING: "workspaceSetting",
};
export const LabelIdentifierTypeEnum = {
    LABEL: "label",
};
export const ModelFileCanResegmentEnum = {
    YES: "YES",
    NO: "NO",
};
export const ModelFileTranslateEnum = {
    YES: "YES",
    NO: "NO",
};
export const ModelFileSrcDirEnum = {
    LTR: "LTR",
    RTL: "RTL",
    AUTO: "AUTO",
};
export const ModelFileTrgDirEnum = {
    LTR: "LTR",
    RTL: "RTL",
    AUTO: "AUTO",
};
export const NoteAppliesToEnum = {
    SOURCE: "SOURCE",
    TARGET: "TARGET",
};
export const OrganizationPermissionAssignmentPermissionsEnum = {
    MANAGE: "MANAGE",
    SELF_CREATE_TOKEN: "SELF_CREATE_TOKEN",
};
export const PlatformUsageNameEnum = {
    USER_COUNT: "UserCount",
    WORKSPACE_COUNT: "WorkspaceCount",
};
export const PlatformUsageRequestUsageItemNamesEnum = {
    USER_COUNT: "UserCount",
    WORKSPACE_COUNT: "WorkspaceCount",
};
export const RangeOperatorEnum = {
    BETWEEN: "BETWEEN",
    NOT_BETWEEN: "NOT_BETWEEN",
};
export const RangeMeasureValueFilterRangeMeasureValueFilterOperatorEnum = {
    BETWEEN: "BETWEEN",
    NOT_BETWEEN: "NOT_BETWEEN",
};
export const RankingFilterRankingFilterOperatorEnum = {
    TOP: "TOP",
    BOTTOM: "BOTTOM",
};
export const ReferenceIdentifierTypeEnum = {
    DATASET: "dataset",
};
export const ReferenceSourceColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const RelativeOperatorEnum = {
    INCREASES_BY: "INCREASES_BY",
    DECREASES_BY: "DECREASES_BY",
    CHANGES_BY: "CHANGES_BY",
};
export const RelativeDateFilterRelativeDateFilterGranularityEnum = {
    MINUTE: "MINUTE",
    HOUR: "HOUR",
    DAY: "DAY",
    WEEK: "WEEK",
    MONTH: "MONTH",
    QUARTER: "QUARTER",
    YEAR: "YEAR",
    MINUTE_OF_HOUR: "MINUTE_OF_HOUR",
    HOUR_OF_DAY: "HOUR_OF_DAY",
    DAY_OF_WEEK: "DAY_OF_WEEK",
    DAY_OF_MONTH: "DAY_OF_MONTH",
    DAY_OF_YEAR: "DAY_OF_YEAR",
    WEEK_OF_YEAR: "WEEK_OF_YEAR",
    MONTH_OF_YEAR: "MONTH_OF_YEAR",
    QUARTER_OF_YEAR: "QUARTER_OF_YEAR",
};
export const ResolvedSettingTypeEnum = {
    TIMEZONE: "TIMEZONE",
    ACTIVE_THEME: "ACTIVE_THEME",
    ACTIVE_COLOR_PALETTE: "ACTIVE_COLOR_PALETTE",
    WHITE_LABELING: "WHITE_LABELING",
    LOCALE: "LOCALE",
    METADATA_LOCALE: "METADATA_LOCALE",
    FORMAT_LOCALE: "FORMAT_LOCALE",
    MAPBOX_TOKEN: "MAPBOX_TOKEN",
    WEEK_START: "WEEK_START",
    SHOW_HIDDEN_CATALOG_ITEMS: "SHOW_HIDDEN_CATALOG_ITEMS",
    OPERATOR_OVERRIDES: "OPERATOR_OVERRIDES",
    TIMEZONE_VALIDATION_ENABLED: "TIMEZONE_VALIDATION_ENABLED",
    OPENAI_CONFIG: "OPENAI_CONFIG",
    ENABLE_FILE_ANALYTICS: "ENABLE_FILE_ANALYTICS",
    ALERT: "ALERT",
    SEPARATORS: "SEPARATORS",
};
export const RsaSpecificationKtyEnum = {
    RSA: "RSA",
};
export const RsaSpecificationAlgEnum = {
    RS256: "RS256",
    RS384: "RS384",
    RS512: "RS512",
};
export const RsaSpecificationUseEnum = {
    SIG: "sig",
};
export const SimpleMeasureDefinitionMeasureAggregationEnum = {
    SUM: "SUM",
    COUNT: "COUNT",
    AVG: "AVG",
    MIN: "MIN",
    MAX: "MAX",
    MEDIAN: "MEDIAN",
    RUNSUM: "RUNSUM",
    APPROXIMATE_COUNT: "APPROXIMATE_COUNT",
};
export const SmtpPortEnum = {
    NUMBER_25: 25,
    NUMBER_465: 465,
    NUMBER_587: 587,
    NUMBER_2525: 2525,
};
export const SmtpTypeEnum = {
    SMTP: "SMTP",
};
export const SmtpAllOfPortEnum = {
    NUMBER_25: 25,
    NUMBER_465: 465,
    NUMBER_587: 587,
    NUMBER_2525: 2525,
};
export const SmtpAllOfTypeEnum = {
    SMTP: "SMTP",
};
export const SqlColumnDataTypeEnum = {
    INT: "INT",
    STRING: "STRING",
    DATE: "DATE",
    NUMERIC: "NUMERIC",
    TIMESTAMP: "TIMESTAMP",
    TIMESTAMP_TZ: "TIMESTAMP_TZ",
    BOOLEAN: "BOOLEAN",
};
export const TabularExportRequestFormatEnum = {
    CSV: "CSV",
    XLSX: "XLSX",
    HTML: "HTML",
    PDF: "PDF",
};
export const UserManagementDataSourcePermissionAssignmentPermissionsEnum = {
    MANAGE: "MANAGE",
    USE: "USE",
};
export const UserManagementWorkspacePermissionAssignmentPermissionsEnum = {
    MANAGE: "MANAGE",
    ANALYZE: "ANALYZE",
    EXPORT: "EXPORT",
    EXPORT_TABULAR: "EXPORT_TABULAR",
    EXPORT_PDF: "EXPORT_PDF",
    CREATE_AUTOMATION: "CREATE_AUTOMATION",
    CREATE_FILTER_VIEW: "CREATE_FILTER_VIEW",
    VIEW: "VIEW",
};
export const UserManagementWorkspacePermissionAssignmentHierarchyPermissionsEnum = {
    MANAGE: "MANAGE",
    ANALYZE: "ANALYZE",
    EXPORT: "EXPORT",
    EXPORT_TABULAR: "EXPORT_TABULAR",
    EXPORT_PDF: "EXPORT_PDF",
    CREATE_AUTOMATION: "CREATE_AUTOMATION",
    CREATE_FILTER_VIEW: "CREATE_FILTER_VIEW",
    VIEW: "VIEW",
};
export const WebhookTypeEnum = {
    WEBHOOK: "WEBHOOK",
};
export const WebhookAllOfTypeEnum = {
    WEBHOOK: "WEBHOOK",
};
export const WorkspaceIdentifierTypeEnum = {
    WORKSPACE: "workspace",
};
export const WorkspacePermissionAssignmentPermissionsEnum = {
    MANAGE: "MANAGE",
    ANALYZE: "ANALYZE",
    EXPORT: "EXPORT",
    EXPORT_TABULAR: "EXPORT_TABULAR",
    EXPORT_PDF: "EXPORT_PDF",
    CREATE_AUTOMATION: "CREATE_AUTOMATION",
    CREATE_FILTER_VIEW: "CREATE_FILTER_VIEW",
    VIEW: "VIEW",
};
export const WorkspacePermissionAssignmentHierarchyPermissionsEnum = {
    MANAGE: "MANAGE",
    ANALYZE: "ANALYZE",
    EXPORT: "EXPORT",
    EXPORT_TABULAR: "EXPORT_TABULAR",
    EXPORT_PDF: "EXPORT_PDF",
    CREATE_AUTOMATION: "CREATE_AUTOMATION",
    CREATE_FILTER_VIEW: "CREATE_FILTER_VIEW",
    VIEW: "VIEW",
};
/**
 * AIApi - axios parameter creator
 * @export
 */
export const AIApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
         * @summary (BETA) Sync Metadata to other services
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSync: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("metadataSync", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/metadataSync`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
         * @summary (BETA) Sync organization scope Metadata to other services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSyncOrganization: async (options = {}) => {
            const localVarPath = `/api/v1/actions/organization/metadataSync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AIApi - functional programming interface
 * @export
 */
export const AIApiFp = function (configuration) {
    const localVarAxiosParamCreator = AIApiAxiosParamCreator(configuration);
    return {
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
         * @summary (BETA) Sync Metadata to other services
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metadataSync(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metadataSync(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
         * @summary (BETA) Sync organization scope Metadata to other services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metadataSyncOrganization(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metadataSyncOrganization(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AIApi - factory interface
 * @export
 */
export const AIApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AIApiFp(configuration);
    return {
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
         * @summary (BETA) Sync Metadata to other services
         * @param {AIApiMetadataSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSync(requestParameters, options) {
            return localVarFp
                .metadataSync(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
         * @summary (BETA) Sync organization scope Metadata to other services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSyncOrganization(options) {
            return localVarFp.metadataSyncOrganization(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AIApi - object-oriented interface
 * @export
 * @class AIApi
 * @extends {BaseAPI}
 */
export class AIApi extends BaseAPI {
    /**
     * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
     * @summary (BETA) Sync Metadata to other services
     * @param {AIApiMetadataSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    metadataSync(requestParameters, options) {
        return AIApiFp(this.configuration)
            .metadataSync(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
     * @summary (BETA) Sync organization scope Metadata to other services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    metadataSyncOrganization(options) {
        return AIApiFp(this.configuration)
            .metadataSyncOrganization(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * APITokensApi - axios parameter creator
 * @export
 */
export const APITokensApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post a new API token for the user
         * @param {string} userId
         * @param {JsonApiApiTokenInDocument} jsonApiApiTokenInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityApiTokens: async (userId, jsonApiApiTokenInDocument, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("createEntityApiTokens", "userId", userId);
            // verify required parameter 'jsonApiApiTokenInDocument' is not null or undefined
            assertParamExists("createEntityApiTokens", "jsonApiApiTokenInDocument", jsonApiApiTokenInDocument);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiApiTokenInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiApiTokenInDocument !== undefined ? jsonApiApiTokenInDocument : {})
                : jsonApiApiTokenInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityApiTokens: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("deleteEntityApiTokens", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityApiTokens", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all api tokens for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesApiTokens: async (userId, filter, page, size, sort, metaInclude, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getAllEntitiesApiTokens", "userId", userId);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityApiTokens: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getEntityApiTokens", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityApiTokens", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * APITokensApi - functional programming interface
 * @export
 */
export const APITokensApiFp = function (configuration) {
    const localVarAxiosParamCreator = APITokensApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post a new API token for the user
         * @param {string} userId
         * @param {JsonApiApiTokenInDocument} jsonApiApiTokenInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityApiTokens(userId, jsonApiApiTokenInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityApiTokens(userId, jsonApiApiTokenInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityApiTokens(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityApiTokens(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List all api tokens for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesApiTokens(userId, filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesApiTokens(userId, filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityApiTokens(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityApiTokens(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * APITokensApi - factory interface
 * @export
 */
export const APITokensApiFactory = function (configuration, basePath, axios) {
    const localVarFp = APITokensApiFp(configuration);
    return {
        /**
         *
         * @summary Post a new API token for the user
         * @param {APITokensApiCreateEntityApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityApiTokens(requestParameters, options) {
            return localVarFp
                .createEntityApiTokens(requestParameters.userId, requestParameters.jsonApiApiTokenInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an API Token for a user
         * @param {APITokensApiDeleteEntityApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityApiTokens(requestParameters, options) {
            return localVarFp
                .deleteEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all api tokens for a user
         * @param {APITokensApiGetAllEntitiesApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesApiTokens(requestParameters, options) {
            return localVarFp
                .getAllEntitiesApiTokens(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an API Token for a user
         * @param {APITokensApiGetEntityApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityApiTokens(requestParameters, options) {
            return localVarFp
                .getEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * APITokensApi - object-oriented interface
 * @export
 * @class APITokensApi
 * @extends {BaseAPI}
 */
export class APITokensApi extends BaseAPI {
    /**
     *
     * @summary Post a new API token for the user
     * @param {APITokensApiCreateEntityApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APITokensApi
     */
    createEntityApiTokens(requestParameters, options) {
        return APITokensApiFp(this.configuration)
            .createEntityApiTokens(requestParameters.userId, requestParameters.jsonApiApiTokenInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an API Token for a user
     * @param {APITokensApiDeleteEntityApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APITokensApi
     */
    deleteEntityApiTokens(requestParameters, options) {
        return APITokensApiFp(this.configuration)
            .deleteEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all api tokens for a user
     * @param {APITokensApiGetAllEntitiesApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APITokensApi
     */
    getAllEntitiesApiTokens(requestParameters, options) {
        return APITokensApiFp(this.configuration)
            .getAllEntitiesApiTokens(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an API Token for a user
     * @param {APITokensApiGetEntityApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APITokensApi
     */
    getEntityApiTokens(requestParameters, options) {
        return APITokensApiFp(this.configuration)
            .getEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ActionsApi - axios parameter creator
 * @export
 */
export const ActionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allPlatformUsage: async (options = {}) => {
            const localVarPath = `/api/v1/actions/collectUsage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Available Assignees
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableAssignees: async (workspaceId, dashboardId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("availableAssignees", "workspaceId", workspaceId);
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists("availableAssignees", "dashboardId", dashboardId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/analyticalDashboards/{dashboardId}/availableAssignees`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds entities with given ID in hierarchy (e.g. to check possible future conflicts).
         * @summary Finds entities with given ID in hierarchy.
         * @param {string} workspaceId
         * @param {Array<HierarchyObjectIdentification>} hierarchyObjectIdentification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEntityOverrides: async (workspaceId, hierarchyObjectIdentification, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("checkEntityOverrides", "workspaceId", workspaceId);
            // verify required parameter 'hierarchyObjectIdentification' is not null or undefined
            assertParamExists("checkEntityOverrides", "hierarchyObjectIdentification", hierarchyObjectIdentification);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/checkEntityOverrides`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof hierarchyObjectIdentification !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(hierarchyObjectIdentification !== undefined ? hierarchyObjectIdentification : {})
                : hierarchyObjectIdentification || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cleans up all translations for a particular locale.
         * @summary Cleans up translations.
         * @param {string} workspaceId
         * @param {LocaleRequest} localeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanTranslations: async (workspaceId, localeRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("cleanTranslations", "workspaceId", workspaceId);
            // verify required parameter 'localeRequest' is not null or undefined
            assertParamExists("cleanTranslations", "localeRequest", localeRequest);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/translations/clean`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof localeRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(localeRequest !== undefined ? localeRequest : {})
                : localeRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Dashboard Permissions
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardPermissions: async (workspaceId, dashboardId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("dashboardPermissions", "workspaceId", workspaceId);
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists("dashboardPermissions", "dashboardId", dashboardId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/analyticalDashboards/{dashboardId}/permissions`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate logical data model (LDM) from physical data model (PDM) stored in data source.
         * @summary Generate logical data model (LDM) from physical data model (PDM)
         * @param {string} dataSourceId
         * @param {GenerateLdmRequest} generateLdmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLogicalModel: async (dataSourceId, generateLdmRequest, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("generateLogicalModel", "dataSourceId", dataSourceId);
            // verify required parameter 'generateLdmRequest' is not null or undefined
            assertParamExists("generateLogicalModel", "generateLdmRequest", generateLdmRequest);
            const localVarPath = `/api/v1/actions/dataSources/{dataSourceId}/generateLogicalModel`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof generateLdmRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(generateLdmRequest !== undefined ? generateLdmRequest : {})
                : generateLdmRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Computes the dependent entities graph
         * @summary Computes the dependent entities graph
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependentEntitiesGraph: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getDependentEntitiesGraph", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/dependentEntitiesGraph`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Computes the dependent entities graph from given entry points
         * @summary Computes the dependent entities graph from given entry points
         * @param {string} workspaceId
         * @param {DependentEntitiesRequest} dependentEntitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependentEntitiesGraphFromEntryPoints: async (workspaceId, dependentEntitiesRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getDependentEntitiesGraphFromEntryPoints", "workspaceId", workspaceId);
            // verify required parameter 'dependentEntitiesRequest' is not null or undefined
            assertParamExists("getDependentEntitiesGraphFromEntryPoints", "dependentEntitiesRequest", dependentEntitiesRequest);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/dependentEntitiesGraph`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof dependentEntitiesRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(dependentEntitiesRequest !== undefined ? dependentEntitiesRequest : {})
                : dependentEntitiesRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provides a list of effective translation tags.
         * @summary Get translation tags.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationTags: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getTranslationTags", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/translations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds API identifier conflicts in given workspace hierarchy.
         * @summary Finds identifier conflicts in workspace hierarchy.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inheritedEntityConflicts: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("inheritedEntityConflicts", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/inheritedEntityConflicts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get used entity prefixes in hierarchy of parent workspaces
         * @summary Get used entity prefixes in hierarchy
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inheritedEntityPrefixes: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("inheritedEntityPrefixes", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/inheritedEntityPrefixes`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} workspaceId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned.
         * @param {string} [name] Filter by user name. Note that user name is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkspaceUserGroups: async (workspaceId, page, size, name, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("listWorkspaceUserGroups", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/userGroups`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (name !== undefined) {
                localVarQueryParameter["name"] = name;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} workspaceId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned.
         * @param {string} [name] Filter by user name. Note that user name is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkspaceUsers: async (workspaceId, page, size, name, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("listWorkspaceUsers", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/users`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (name !== undefined) {
                localVarQueryParameter["name"] = name;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Manage Permissions for a Dashboard
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {Array<PermissionsForAssignee | PermissionsForAssigneeRule>} permissionsForAssigneePermissionsForAssigneeRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDashboardPermissions: async (workspaceId, dashboardId, permissionsForAssigneePermissionsForAssigneeRule, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("manageDashboardPermissions", "workspaceId", workspaceId);
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists("manageDashboardPermissions", "dashboardId", dashboardId);
            // verify required parameter 'permissionsForAssigneePermissionsForAssigneeRule' is not null or undefined
            assertParamExists("manageDashboardPermissions", "permissionsForAssigneePermissionsForAssigneeRule", permissionsForAssigneePermissionsForAssigneeRule);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/analyticalDashboards/{dashboardId}/managePermissions`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof permissionsForAssigneePermissionsForAssigneeRule !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(permissionsForAssigneePermissionsForAssigneeRule !== undefined
                    ? permissionsForAssigneePermissionsForAssigneeRule
                    : {})
                : permissionsForAssigneePermissionsForAssigneeRule || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manage Permissions for a Data Source
         * @summary Manage Permissions for a Data Source
         * @param {string} dataSourceId
         * @param {Array<DataSourcePermissionAssignment>} dataSourcePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDataSourcePermissions: async (dataSourceId, dataSourcePermissionAssignment, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("manageDataSourcePermissions", "dataSourceId", dataSourceId);
            // verify required parameter 'dataSourcePermissionAssignment' is not null or undefined
            assertParamExists("manageDataSourcePermissions", "dataSourcePermissionAssignment", dataSourcePermissionAssignment);
            const localVarPath = `/api/v1/actions/dataSources/{dataSourceId}/managePermissions`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof dataSourcePermissionAssignment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(dataSourcePermissionAssignment !== undefined ? dataSourcePermissionAssignment : {})
                : dataSourcePermissionAssignment || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manage Permissions for a Organization
         * @summary Manage Permissions for a Organization
         * @param {Array<OrganizationPermissionAssignment>} organizationPermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageOrganizationPermissions: async (organizationPermissionAssignment, options = {}) => {
            // verify required parameter 'organizationPermissionAssignment' is not null or undefined
            assertParamExists("manageOrganizationPermissions", "organizationPermissionAssignment", organizationPermissionAssignment);
            const localVarPath = `/api/v1/actions/organization/managePermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof organizationPermissionAssignment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(organizationPermissionAssignment !== undefined ? organizationPermissionAssignment : {})
                : organizationPermissionAssignment || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manage Permissions for a Workspace and its Workspace Hierarchy
         * @summary Manage Permissions for a Workspace
         * @param {string} workspaceId
         * @param {Array<WorkspacePermissionAssignment>} workspacePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageWorkspacePermissions: async (workspaceId, workspacePermissionAssignment, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("manageWorkspacePermissions", "workspaceId", workspaceId);
            // verify required parameter 'workspacePermissionAssignment' is not null or undefined
            assertParamExists("manageWorkspacePermissions", "workspacePermissionAssignment", workspacePermissionAssignment);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/managePermissions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof workspacePermissionAssignment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(workspacePermissionAssignment !== undefined ? workspacePermissionAssignment : {})
                : workspacePermissionAssignment || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
         * @summary (BETA) Sync Metadata to other services
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSync: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("metadataSync", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/metadataSync`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
         * @summary (BETA) Sync organization scope Metadata to other services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSyncOrganization: async (options = {}) => {
            const localVarPath = `/api/v1/actions/organization/metadataSync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds API identifier overrides in given workspace hierarchy.
         * @summary Finds identifier overrides in workspace hierarchy.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overriddenChildEntities: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("overriddenChildEntities", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/overriddenChildEntities`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage for particular items.
         * @param {PlatformUsageRequest} platformUsageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        particularPlatformUsage: async (platformUsageRequest, options = {}) => {
            // verify required parameter 'platformUsageRequest' is not null or undefined
            assertParamExists("particularPlatformUsage", "platformUsageRequest", platformUsageRequest);
            const localVarPath = `/api/v1/actions/collectUsage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof platformUsageRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(platformUsageRequest !== undefined ? platformUsageRequest : {})
                : platformUsageRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Notification sets up all reports to be computed again with new data.
         * @summary Register an upload notification
         * @param {string} dataSourceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUploadNotification: async (dataSourceId, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("registerUploadNotification", "dataSourceId", dataSourceId);
            const localVarPath = `/api/v1/actions/dataSources/{dataSourceId}/uploadNotification`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves values of available entitlements for the organization.
         * @summary Values for all public entitlements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAllEntitlements: async (options = {}) => {
            const localVarPath = `/api/v1/actions/resolveEntitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves values for all settings without workspace by current user, organization, or default settings.
         * @summary Values for all settings without workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAllSettingsWithoutWorkspace: async (options = {}) => {
            const localVarPath = `/api/v1/actions/resolveSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves values for requested entitlements in the organization.
         * @summary Values for requested public entitlements.
         * @param {EntitlementsRequest} entitlementsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveRequestedEntitlements: async (entitlementsRequest, options = {}) => {
            // verify required parameter 'entitlementsRequest' is not null or undefined
            assertParamExists("resolveRequestedEntitlements", "entitlementsRequest", entitlementsRequest);
            const localVarPath = `/api/v1/actions/resolveEntitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof entitlementsRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(entitlementsRequest !== undefined ? entitlementsRequest : {})
                : entitlementsRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves values for selected settings without workspace by current user, organization, or default settings.
         * @summary Values for selected settings without workspace.
         * @param {ResolveSettingsRequest} resolveSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSettingsWithoutWorkspace: async (resolveSettingsRequest, options = {}) => {
            // verify required parameter 'resolveSettingsRequest' is not null or undefined
            assertParamExists("resolveSettingsWithoutWorkspace", "resolveSettingsRequest", resolveSettingsRequest);
            const localVarPath = `/api/v1/actions/resolveSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof resolveSettingsRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(resolveSettingsRequest !== undefined ? resolveSettingsRequest : {})
                : resolveSettingsRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all translation for existing entities in a particular locale. The source translations returned by this endpoint are always original, not translated, texts. Because the XLIFF schema definition has the \'xs:language\' constraint for the \'srcLang\' attribute, it is always set to \'en-US\' value.
         * @summary Retrieve translations for entities.
         * @param {string} workspaceId
         * @param {LocaleRequest} localeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTranslations: async (workspaceId, localeRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("retrieveTranslations", "workspaceId", workspaceId);
            // verify required parameter 'localeRequest' is not null or undefined
            assertParamExists("retrieveTranslations", "localeRequest", localeRequest);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/translations/retrieve`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof localeRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(localeRequest !== undefined ? localeRequest : {})
                : localeRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set translation for existing entities in a particular locale.
         * @summary Set translations for entities.
         * @param {string} workspaceId
         * @param {Xliff} xliff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTranslations: async (workspaceId, xliff, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setTranslations", "workspaceId", workspaceId);
            // verify required parameter 'xliff' is not null or undefined
            assertParamExists("setTranslations", "xliff", xliff);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/translations/set`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/xml";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof xliff !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(xliff !== undefined ? xliff : {})
                : xliff || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unsubscribe from all automations in all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeAllAutomations: async (options = {}) => {
            const localVarPath = `/api/v1/actions/organization/automations/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unsubscribe from an automation
         * @param {string} workspaceId
         * @param {string} automationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeAutomation: async (workspaceId, automationId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("unsubscribeAutomation", "workspaceId", workspaceId);
            // verify required parameter 'automationId' is not null or undefined
            assertParamExists("unsubscribeAutomation", "automationId", automationId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/automations/{automationId}/unsubscribe`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"automationId"}}`, encodeURIComponent(String(automationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unsubscribe from all automations in the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWorkspaceAutomations: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("unsubscribeWorkspaceAutomations", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/automations/unsubscribe`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves values for all settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for all settings.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceResolveAllSettings: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("workspaceResolveAllSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/resolveSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves value for selected settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for selected settings.
         * @param {string} workspaceId
         * @param {ResolveSettingsRequest} resolveSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceResolveSettings: async (workspaceId, resolveSettingsRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("workspaceResolveSettings", "workspaceId", workspaceId);
            // verify required parameter 'resolveSettingsRequest' is not null or undefined
            assertParamExists("workspaceResolveSettings", "resolveSettingsRequest", resolveSettingsRequest);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/resolveSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof resolveSettingsRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(resolveSettingsRequest !== undefined ? resolveSettingsRequest : {})
                : resolveSettingsRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ActionsApi - functional programming interface
 * @export
 */
export const ActionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ActionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allPlatformUsage(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allPlatformUsage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Available Assignees
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availableAssignees(workspaceId, dashboardId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.availableAssignees(workspaceId, dashboardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finds entities with given ID in hierarchy (e.g. to check possible future conflicts).
         * @summary Finds entities with given ID in hierarchy.
         * @param {string} workspaceId
         * @param {Array<HierarchyObjectIdentification>} hierarchyObjectIdentification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkEntityOverrides(workspaceId, hierarchyObjectIdentification, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkEntityOverrides(workspaceId, hierarchyObjectIdentification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cleans up all translations for a particular locale.
         * @summary Cleans up translations.
         * @param {string} workspaceId
         * @param {LocaleRequest} localeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cleanTranslations(workspaceId, localeRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cleanTranslations(workspaceId, localeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Dashboard Permissions
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardPermissions(workspaceId, dashboardId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardPermissions(workspaceId, dashboardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generate logical data model (LDM) from physical data model (PDM) stored in data source.
         * @summary Generate logical data model (LDM) from physical data model (PDM)
         * @param {string} dataSourceId
         * @param {GenerateLdmRequest} generateLdmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLogicalModel(dataSourceId, generateLdmRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLogicalModel(dataSourceId, generateLdmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Computes the dependent entities graph
         * @summary Computes the dependent entities graph
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDependentEntitiesGraph(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDependentEntitiesGraph(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Computes the dependent entities graph from given entry points
         * @summary Computes the dependent entities graph from given entry points
         * @param {string} workspaceId
         * @param {DependentEntitiesRequest} dependentEntitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDependentEntitiesGraphFromEntryPoints(workspaceId, dependentEntitiesRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDependentEntitiesGraphFromEntryPoints(workspaceId, dependentEntitiesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Provides a list of effective translation tags.
         * @summary Get translation tags.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslationTags(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslationTags(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finds API identifier conflicts in given workspace hierarchy.
         * @summary Finds identifier conflicts in workspace hierarchy.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inheritedEntityConflicts(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inheritedEntityConflicts(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get used entity prefixes in hierarchy of parent workspaces
         * @summary Get used entity prefixes in hierarchy
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inheritedEntityPrefixes(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inheritedEntityPrefixes(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} workspaceId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned.
         * @param {string} [name] Filter by user name. Note that user name is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkspaceUserGroups(workspaceId, page, size, name, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkspaceUserGroups(workspaceId, page, size, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} workspaceId
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned.
         * @param {string} [name] Filter by user name. Note that user name is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkspaceUsers(workspaceId, page, size, name, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkspaceUsers(workspaceId, page, size, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Manage Permissions for a Dashboard
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {Array<PermissionsForAssignee | PermissionsForAssigneeRule>} permissionsForAssigneePermissionsForAssigneeRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageDashboardPermissions(workspaceId, dashboardId, permissionsForAssigneePermissionsForAssigneeRule, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageDashboardPermissions(workspaceId, dashboardId, permissionsForAssigneePermissionsForAssigneeRule, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Manage Permissions for a Data Source
         * @summary Manage Permissions for a Data Source
         * @param {string} dataSourceId
         * @param {Array<DataSourcePermissionAssignment>} dataSourcePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageDataSourcePermissions(dataSourceId, dataSourcePermissionAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageDataSourcePermissions(dataSourceId, dataSourcePermissionAssignment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Manage Permissions for a Organization
         * @summary Manage Permissions for a Organization
         * @param {Array<OrganizationPermissionAssignment>} organizationPermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageOrganizationPermissions(organizationPermissionAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageOrganizationPermissions(organizationPermissionAssignment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Manage Permissions for a Workspace and its Workspace Hierarchy
         * @summary Manage Permissions for a Workspace
         * @param {string} workspaceId
         * @param {Array<WorkspacePermissionAssignment>} workspacePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageWorkspacePermissions(workspaceId, workspacePermissionAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageWorkspacePermissions(workspaceId, workspacePermissionAssignment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
         * @summary (BETA) Sync Metadata to other services
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metadataSync(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metadataSync(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
         * @summary (BETA) Sync organization scope Metadata to other services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metadataSyncOrganization(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metadataSyncOrganization(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finds API identifier overrides in given workspace hierarchy.
         * @summary Finds identifier overrides in workspace hierarchy.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overriddenChildEntities(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overriddenChildEntities(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage for particular items.
         * @param {PlatformUsageRequest} platformUsageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async particularPlatformUsage(platformUsageRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.particularPlatformUsage(platformUsageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Notification sets up all reports to be computed again with new data.
         * @summary Register an upload notification
         * @param {string} dataSourceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerUploadNotification(dataSourceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerUploadNotification(dataSourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves values of available entitlements for the organization.
         * @summary Values for all public entitlements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveAllEntitlements(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveAllEntitlements(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves values for all settings without workspace by current user, organization, or default settings.
         * @summary Values for all settings without workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveAllSettingsWithoutWorkspace(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveAllSettingsWithoutWorkspace(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves values for requested entitlements in the organization.
         * @summary Values for requested public entitlements.
         * @param {EntitlementsRequest} entitlementsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveRequestedEntitlements(entitlementsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveRequestedEntitlements(entitlementsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves values for selected settings without workspace by current user, organization, or default settings.
         * @summary Values for selected settings without workspace.
         * @param {ResolveSettingsRequest} resolveSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveSettingsWithoutWorkspace(resolveSettingsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveSettingsWithoutWorkspace(resolveSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all translation for existing entities in a particular locale. The source translations returned by this endpoint are always original, not translated, texts. Because the XLIFF schema definition has the \'xs:language\' constraint for the \'srcLang\' attribute, it is always set to \'en-US\' value.
         * @summary Retrieve translations for entities.
         * @param {string} workspaceId
         * @param {LocaleRequest} localeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTranslations(workspaceId, localeRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTranslations(workspaceId, localeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set translation for existing entities in a particular locale.
         * @summary Set translations for entities.
         * @param {string} workspaceId
         * @param {Xliff} xliff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTranslations(workspaceId, xliff, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTranslations(workspaceId, xliff, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unsubscribe from all automations in all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeAllAutomations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeAllAutomations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unsubscribe from an automation
         * @param {string} workspaceId
         * @param {string} automationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeAutomation(workspaceId, automationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeAutomation(workspaceId, automationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unsubscribe from all automations in the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeWorkspaceAutomations(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeWorkspaceAutomations(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves values for all settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for all settings.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceResolveAllSettings(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceResolveAllSettings(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves value for selected settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for selected settings.
         * @param {string} workspaceId
         * @param {ResolveSettingsRequest} resolveSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceResolveSettings(workspaceId, resolveSettingsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceResolveSettings(workspaceId, resolveSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ActionsApi - factory interface
 * @export
 */
export const ActionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ActionsApiFp(configuration);
    return {
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allPlatformUsage(options) {
            return localVarFp.allPlatformUsage(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Available Assignees
         * @param {ActionsApiAvailableAssigneesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableAssignees(requestParameters, options) {
            return localVarFp
                .availableAssignees(requestParameters.workspaceId, requestParameters.dashboardId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Finds entities with given ID in hierarchy (e.g. to check possible future conflicts).
         * @summary Finds entities with given ID in hierarchy.
         * @param {ActionsApiCheckEntityOverridesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEntityOverrides(requestParameters, options) {
            return localVarFp
                .checkEntityOverrides(requestParameters.workspaceId, requestParameters.hierarchyObjectIdentification, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Cleans up all translations for a particular locale.
         * @summary Cleans up translations.
         * @param {ActionsApiCleanTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanTranslations(requestParameters, options) {
            return localVarFp
                .cleanTranslations(requestParameters.workspaceId, requestParameters.localeRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Dashboard Permissions
         * @param {ActionsApiDashboardPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardPermissions(requestParameters, options) {
            return localVarFp
                .dashboardPermissions(requestParameters.workspaceId, requestParameters.dashboardId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Generate logical data model (LDM) from physical data model (PDM) stored in data source.
         * @summary Generate logical data model (LDM) from physical data model (PDM)
         * @param {ActionsApiGenerateLogicalModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLogicalModel(requestParameters, options) {
            return localVarFp
                .generateLogicalModel(requestParameters.dataSourceId, requestParameters.generateLdmRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Computes the dependent entities graph
         * @summary Computes the dependent entities graph
         * @param {ActionsApiGetDependentEntitiesGraphRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependentEntitiesGraph(requestParameters, options) {
            return localVarFp
                .getDependentEntitiesGraph(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Computes the dependent entities graph from given entry points
         * @summary Computes the dependent entities graph from given entry points
         * @param {ActionsApiGetDependentEntitiesGraphFromEntryPointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependentEntitiesGraphFromEntryPoints(requestParameters, options) {
            return localVarFp
                .getDependentEntitiesGraphFromEntryPoints(requestParameters.workspaceId, requestParameters.dependentEntitiesRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Provides a list of effective translation tags.
         * @summary Get translation tags.
         * @param {ActionsApiGetTranslationTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationTags(requestParameters, options) {
            return localVarFp
                .getTranslationTags(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Finds API identifier conflicts in given workspace hierarchy.
         * @summary Finds identifier conflicts in workspace hierarchy.
         * @param {ActionsApiInheritedEntityConflictsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inheritedEntityConflicts(requestParameters, options) {
            return localVarFp
                .inheritedEntityConflicts(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get used entity prefixes in hierarchy of parent workspaces
         * @summary Get used entity prefixes in hierarchy
         * @param {ActionsApiInheritedEntityPrefixesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inheritedEntityPrefixes(requestParameters, options) {
            return localVarFp
                .inheritedEntityPrefixes(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ActionsApiListWorkspaceUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkspaceUserGroups(requestParameters, options) {
            return localVarFp
                .listWorkspaceUserGroups(requestParameters.workspaceId, requestParameters.page, requestParameters.size, requestParameters.name, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ActionsApiListWorkspaceUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkspaceUsers(requestParameters, options) {
            return localVarFp
                .listWorkspaceUsers(requestParameters.workspaceId, requestParameters.page, requestParameters.size, requestParameters.name, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Manage Permissions for a Dashboard
         * @param {ActionsApiManageDashboardPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDashboardPermissions(requestParameters, options) {
            return localVarFp
                .manageDashboardPermissions(requestParameters.workspaceId, requestParameters.dashboardId, requestParameters.permissionsForAssigneePermissionsForAssigneeRule, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Manage Permissions for a Data Source
         * @summary Manage Permissions for a Data Source
         * @param {ActionsApiManageDataSourcePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDataSourcePermissions(requestParameters, options) {
            return localVarFp
                .manageDataSourcePermissions(requestParameters.dataSourceId, requestParameters.dataSourcePermissionAssignment, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Manage Permissions for a Organization
         * @summary Manage Permissions for a Organization
         * @param {ActionsApiManageOrganizationPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageOrganizationPermissions(requestParameters, options) {
            return localVarFp
                .manageOrganizationPermissions(requestParameters.organizationPermissionAssignment, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Manage Permissions for a Workspace and its Workspace Hierarchy
         * @summary Manage Permissions for a Workspace
         * @param {ActionsApiManageWorkspacePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageWorkspacePermissions(requestParameters, options) {
            return localVarFp
                .manageWorkspacePermissions(requestParameters.workspaceId, requestParameters.workspacePermissionAssignment, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
         * @summary (BETA) Sync Metadata to other services
         * @param {ActionsApiMetadataSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSync(requestParameters, options) {
            return localVarFp
                .metadataSync(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
         * @summary (BETA) Sync organization scope Metadata to other services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSyncOrganization(options) {
            return localVarFp.metadataSyncOrganization(options).then((request) => request(axios, basePath));
        },
        /**
         * Finds API identifier overrides in given workspace hierarchy.
         * @summary Finds identifier overrides in workspace hierarchy.
         * @param {ActionsApiOverriddenChildEntitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overriddenChildEntities(requestParameters, options) {
            return localVarFp
                .overriddenChildEntities(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage for particular items.
         * @param {ActionsApiParticularPlatformUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        particularPlatformUsage(requestParameters, options) {
            return localVarFp
                .particularPlatformUsage(requestParameters.platformUsageRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Notification sets up all reports to be computed again with new data.
         * @summary Register an upload notification
         * @param {ActionsApiRegisterUploadNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUploadNotification(requestParameters, options) {
            return localVarFp
                .registerUploadNotification(requestParameters.dataSourceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Resolves values of available entitlements for the organization.
         * @summary Values for all public entitlements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAllEntitlements(options) {
            return localVarFp.resolveAllEntitlements(options).then((request) => request(axios, basePath));
        },
        /**
         * Resolves values for all settings without workspace by current user, organization, or default settings.
         * @summary Values for all settings without workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAllSettingsWithoutWorkspace(options) {
            return localVarFp
                .resolveAllSettingsWithoutWorkspace(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Resolves values for requested entitlements in the organization.
         * @summary Values for requested public entitlements.
         * @param {ActionsApiResolveRequestedEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveRequestedEntitlements(requestParameters, options) {
            return localVarFp
                .resolveRequestedEntitlements(requestParameters.entitlementsRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Resolves values for selected settings without workspace by current user, organization, or default settings.
         * @summary Values for selected settings without workspace.
         * @param {ActionsApiResolveSettingsWithoutWorkspaceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSettingsWithoutWorkspace(requestParameters, options) {
            return localVarFp
                .resolveSettingsWithoutWorkspace(requestParameters.resolveSettingsRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all translation for existing entities in a particular locale. The source translations returned by this endpoint are always original, not translated, texts. Because the XLIFF schema definition has the \'xs:language\' constraint for the \'srcLang\' attribute, it is always set to \'en-US\' value.
         * @summary Retrieve translations for entities.
         * @param {ActionsApiRetrieveTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTranslations(requestParameters, options) {
            return localVarFp
                .retrieveTranslations(requestParameters.workspaceId, requestParameters.localeRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set translation for existing entities in a particular locale.
         * @summary Set translations for entities.
         * @param {ActionsApiSetTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTranslations(requestParameters, options) {
            return localVarFp
                .setTranslations(requestParameters.workspaceId, requestParameters.xliff, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unsubscribe from all automations in all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeAllAutomations(options) {
            return localVarFp.unsubscribeAllAutomations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unsubscribe from an automation
         * @param {ActionsApiUnsubscribeAutomationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeAutomation(requestParameters, options) {
            return localVarFp
                .unsubscribeAutomation(requestParameters.workspaceId, requestParameters.automationId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unsubscribe from all automations in the workspace
         * @param {ActionsApiUnsubscribeWorkspaceAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWorkspaceAutomations(requestParameters, options) {
            return localVarFp
                .unsubscribeWorkspaceAutomations(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Resolves values for all settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for all settings.
         * @param {ActionsApiWorkspaceResolveAllSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceResolveAllSettings(requestParameters, options) {
            return localVarFp
                .workspaceResolveAllSettings(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Resolves value for selected settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for selected settings.
         * @param {ActionsApiWorkspaceResolveSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceResolveSettings(requestParameters, options) {
            return localVarFp
                .workspaceResolveSettings(requestParameters.workspaceId, requestParameters.resolveSettingsRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ActionsApi - object-oriented interface
 * @export
 * @class ActionsApi
 * @extends {BaseAPI}
 */
export class ActionsApi extends BaseAPI {
    /**
     * Provides information about platform usage, like amount of users, workspaces, ...
     * @summary Info about the platform usage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    allPlatformUsage(options) {
        return ActionsApiFp(this.configuration)
            .allPlatformUsage(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Available Assignees
     * @param {ActionsApiAvailableAssigneesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    availableAssignees(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .availableAssignees(requestParameters.workspaceId, requestParameters.dashboardId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Finds entities with given ID in hierarchy (e.g. to check possible future conflicts).
     * @summary Finds entities with given ID in hierarchy.
     * @param {ActionsApiCheckEntityOverridesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    checkEntityOverrides(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .checkEntityOverrides(requestParameters.workspaceId, requestParameters.hierarchyObjectIdentification, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Cleans up all translations for a particular locale.
     * @summary Cleans up translations.
     * @param {ActionsApiCleanTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    cleanTranslations(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .cleanTranslations(requestParameters.workspaceId, requestParameters.localeRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Dashboard Permissions
     * @param {ActionsApiDashboardPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    dashboardPermissions(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .dashboardPermissions(requestParameters.workspaceId, requestParameters.dashboardId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Generate logical data model (LDM) from physical data model (PDM) stored in data source.
     * @summary Generate logical data model (LDM) from physical data model (PDM)
     * @param {ActionsApiGenerateLogicalModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    generateLogicalModel(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .generateLogicalModel(requestParameters.dataSourceId, requestParameters.generateLdmRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Computes the dependent entities graph
     * @summary Computes the dependent entities graph
     * @param {ActionsApiGetDependentEntitiesGraphRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    getDependentEntitiesGraph(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .getDependentEntitiesGraph(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Computes the dependent entities graph from given entry points
     * @summary Computes the dependent entities graph from given entry points
     * @param {ActionsApiGetDependentEntitiesGraphFromEntryPointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    getDependentEntitiesGraphFromEntryPoints(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .getDependentEntitiesGraphFromEntryPoints(requestParameters.workspaceId, requestParameters.dependentEntitiesRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides a list of effective translation tags.
     * @summary Get translation tags.
     * @param {ActionsApiGetTranslationTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    getTranslationTags(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .getTranslationTags(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Finds API identifier conflicts in given workspace hierarchy.
     * @summary Finds identifier conflicts in workspace hierarchy.
     * @param {ActionsApiInheritedEntityConflictsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    inheritedEntityConflicts(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .inheritedEntityConflicts(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get used entity prefixes in hierarchy of parent workspaces
     * @summary Get used entity prefixes in hierarchy
     * @param {ActionsApiInheritedEntityPrefixesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    inheritedEntityPrefixes(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .inheritedEntityPrefixes(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ActionsApiListWorkspaceUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    listWorkspaceUserGroups(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .listWorkspaceUserGroups(requestParameters.workspaceId, requestParameters.page, requestParameters.size, requestParameters.name, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ActionsApiListWorkspaceUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    listWorkspaceUsers(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .listWorkspaceUsers(requestParameters.workspaceId, requestParameters.page, requestParameters.size, requestParameters.name, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Manage Permissions for a Dashboard
     * @param {ActionsApiManageDashboardPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    manageDashboardPermissions(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .manageDashboardPermissions(requestParameters.workspaceId, requestParameters.dashboardId, requestParameters.permissionsForAssigneePermissionsForAssigneeRule, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Manage Permissions for a Data Source
     * @summary Manage Permissions for a Data Source
     * @param {ActionsApiManageDataSourcePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    manageDataSourcePermissions(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .manageDataSourcePermissions(requestParameters.dataSourceId, requestParameters.dataSourcePermissionAssignment, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Manage Permissions for a Organization
     * @summary Manage Permissions for a Organization
     * @param {ActionsApiManageOrganizationPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    manageOrganizationPermissions(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .manageOrganizationPermissions(requestParameters.organizationPermissionAssignment, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Manage Permissions for a Workspace and its Workspace Hierarchy
     * @summary Manage Permissions for a Workspace
     * @param {ActionsApiManageWorkspacePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    manageWorkspacePermissions(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .manageWorkspacePermissions(requestParameters.workspaceId, requestParameters.workspacePermissionAssignment, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
     * @summary (BETA) Sync Metadata to other services
     * @param {ActionsApiMetadataSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    metadataSync(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .metadataSync(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
     * @summary (BETA) Sync organization scope Metadata to other services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    metadataSyncOrganization(options) {
        return ActionsApiFp(this.configuration)
            .metadataSyncOrganization(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Finds API identifier overrides in given workspace hierarchy.
     * @summary Finds identifier overrides in workspace hierarchy.
     * @param {ActionsApiOverriddenChildEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    overriddenChildEntities(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .overriddenChildEntities(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides information about platform usage, like amount of users, workspaces, ...
     * @summary Info about the platform usage for particular items.
     * @param {ActionsApiParticularPlatformUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    particularPlatformUsage(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .particularPlatformUsage(requestParameters.platformUsageRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Notification sets up all reports to be computed again with new data.
     * @summary Register an upload notification
     * @param {ActionsApiRegisterUploadNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    registerUploadNotification(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .registerUploadNotification(requestParameters.dataSourceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves values of available entitlements for the organization.
     * @summary Values for all public entitlements.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    resolveAllEntitlements(options) {
        return ActionsApiFp(this.configuration)
            .resolveAllEntitlements(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves values for all settings without workspace by current user, organization, or default settings.
     * @summary Values for all settings without workspace.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    resolveAllSettingsWithoutWorkspace(options) {
        return ActionsApiFp(this.configuration)
            .resolveAllSettingsWithoutWorkspace(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves values for requested entitlements in the organization.
     * @summary Values for requested public entitlements.
     * @param {ActionsApiResolveRequestedEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    resolveRequestedEntitlements(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .resolveRequestedEntitlements(requestParameters.entitlementsRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves values for selected settings without workspace by current user, organization, or default settings.
     * @summary Values for selected settings without workspace.
     * @param {ActionsApiResolveSettingsWithoutWorkspaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    resolveSettingsWithoutWorkspace(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .resolveSettingsWithoutWorkspace(requestParameters.resolveSettingsRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all translation for existing entities in a particular locale. The source translations returned by this endpoint are always original, not translated, texts. Because the XLIFF schema definition has the \'xs:language\' constraint for the \'srcLang\' attribute, it is always set to \'en-US\' value.
     * @summary Retrieve translations for entities.
     * @param {ActionsApiRetrieveTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    retrieveTranslations(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .retrieveTranslations(requestParameters.workspaceId, requestParameters.localeRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set translation for existing entities in a particular locale.
     * @summary Set translations for entities.
     * @param {ActionsApiSetTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    setTranslations(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .setTranslations(requestParameters.workspaceId, requestParameters.xliff, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unsubscribe from all automations in all workspaces
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    unsubscribeAllAutomations(options) {
        return ActionsApiFp(this.configuration)
            .unsubscribeAllAutomations(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unsubscribe from an automation
     * @param {ActionsApiUnsubscribeAutomationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    unsubscribeAutomation(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .unsubscribeAutomation(requestParameters.workspaceId, requestParameters.automationId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unsubscribe from all automations in the workspace
     * @param {ActionsApiUnsubscribeWorkspaceAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    unsubscribeWorkspaceAutomations(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .unsubscribeWorkspaceAutomations(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves values for all settings in a workspace by current user, workspace, organization, or default settings.
     * @summary Values for all settings.
     * @param {ActionsApiWorkspaceResolveAllSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    workspaceResolveAllSettings(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .workspaceResolveAllSettings(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves value for selected settings in a workspace by current user, workspace, organization, or default settings.
     * @summary Values for selected settings.
     * @param {ActionsApiWorkspaceResolveSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    workspaceResolveSettings(requestParameters, options) {
        return ActionsApiFp(this.configuration)
            .workspaceResolveSettings(requestParameters.workspaceId, requestParameters.resolveSettingsRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AnalyticsModelApi - axios parameter creator
 * @export
 */
export const AnalyticsModelApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve current analytics model of the workspace.
         * @summary Get analytics model
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalyticsModel: async (workspaceId, exclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAnalyticsModel", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/analyticsModel`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective analytics model of the workspace.
         * @summary Set analytics model
         * @param {string} workspaceId
         * @param {DeclarativeAnalytics} declarativeAnalytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalyticsModel: async (workspaceId, declarativeAnalytics, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setAnalyticsModel", "workspaceId", workspaceId);
            // verify required parameter 'declarativeAnalytics' is not null or undefined
            assertParamExists("setAnalyticsModel", "declarativeAnalytics", declarativeAnalytics);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/analyticsModel`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeAnalytics !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeAnalytics !== undefined ? declarativeAnalytics : {})
                : declarativeAnalytics || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnalyticsModelApi - functional programming interface
 * @export
 */
export const AnalyticsModelApiFp = function (configuration) {
    const localVarAxiosParamCreator = AnalyticsModelApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve current analytics model of the workspace.
         * @summary Get analytics model
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalyticsModel(workspaceId, exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalyticsModel(workspaceId, exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective analytics model of the workspace.
         * @summary Set analytics model
         * @param {string} workspaceId
         * @param {DeclarativeAnalytics} declarativeAnalytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAnalyticsModel(workspaceId, declarativeAnalytics, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAnalyticsModel(workspaceId, declarativeAnalytics, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AnalyticsModelApi - factory interface
 * @export
 */
export const AnalyticsModelApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AnalyticsModelApiFp(configuration);
    return {
        /**
         * Retrieve current analytics model of the workspace.
         * @summary Get analytics model
         * @param {AnalyticsModelApiGetAnalyticsModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalyticsModel(requestParameters, options) {
            return localVarFp
                .getAnalyticsModel(requestParameters.workspaceId, requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective analytics model of the workspace.
         * @summary Set analytics model
         * @param {AnalyticsModelApiSetAnalyticsModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalyticsModel(requestParameters, options) {
            return localVarFp
                .setAnalyticsModel(requestParameters.workspaceId, requestParameters.declarativeAnalytics, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AnalyticsModelApi - object-oriented interface
 * @export
 * @class AnalyticsModelApi
 * @extends {BaseAPI}
 */
export class AnalyticsModelApi extends BaseAPI {
    /**
     * Retrieve current analytics model of the workspace.
     * @summary Get analytics model
     * @param {AnalyticsModelApiGetAnalyticsModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsModelApi
     */
    getAnalyticsModel(requestParameters, options) {
        return AnalyticsModelApiFp(this.configuration)
            .getAnalyticsModel(requestParameters.workspaceId, requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective analytics model of the workspace.
     * @summary Set analytics model
     * @param {AnalyticsModelApiSetAnalyticsModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsModelApi
     */
    setAnalyticsModel(requestParameters, options) {
        return AnalyticsModelApiFp(this.configuration)
            .setAnalyticsModel(requestParameters.workspaceId, requestParameters.declarativeAnalytics, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AppearanceApi - axios parameter creator
 * @export
 */
export const AppearanceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Color Pallettes
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityColorPalettes: async (jsonApiColorPaletteInDocument, options = {}) => {
            // verify required parameter 'jsonApiColorPaletteInDocument' is not null or undefined
            assertParamExists("createEntityColorPalettes", "jsonApiColorPaletteInDocument", jsonApiColorPaletteInDocument);
            const localVarPath = `/api/v1/entities/colorPalettes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiColorPaletteInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiColorPaletteInDocument !== undefined ? jsonApiColorPaletteInDocument : {})
                : jsonApiColorPaletteInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Theming
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityThemes: async (jsonApiThemeInDocument, options = {}) => {
            // verify required parameter 'jsonApiThemeInDocument' is not null or undefined
            assertParamExists("createEntityThemes", "jsonApiThemeInDocument", jsonApiThemeInDocument);
            const localVarPath = `/api/v1/entities/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiThemeInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiThemeInDocument !== undefined ? jsonApiThemeInDocument : {})
                : jsonApiThemeInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityColorPalettes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityColorPalettes", "id", id);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityThemes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityThemes", "id", id);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Color Pallettes
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesColorPalettes: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/colorPalettes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Theming entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesThemes: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityColorPalettes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityColorPalettes", "id", id);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityThemes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityThemes", "id", id);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Color Pallette
         * @param {string} id
         * @param {JsonApiColorPalettePatchDocument} jsonApiColorPalettePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityColorPalettes: async (id, jsonApiColorPalettePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityColorPalettes", "id", id);
            // verify required parameter 'jsonApiColorPalettePatchDocument' is not null or undefined
            assertParamExists("patchEntityColorPalettes", "jsonApiColorPalettePatchDocument", jsonApiColorPalettePatchDocument);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiColorPalettePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiColorPalettePatchDocument !== undefined ? jsonApiColorPalettePatchDocument : {})
                : jsonApiColorPalettePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Theming
         * @param {string} id
         * @param {JsonApiThemePatchDocument} jsonApiThemePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityThemes: async (id, jsonApiThemePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityThemes", "id", id);
            // verify required parameter 'jsonApiThemePatchDocument' is not null or undefined
            assertParamExists("patchEntityThemes", "jsonApiThemePatchDocument", jsonApiThemePatchDocument);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiThemePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiThemePatchDocument !== undefined ? jsonApiThemePatchDocument : {})
                : jsonApiThemePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Color Pallette
         * @param {string} id
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityColorPalettes: async (id, jsonApiColorPaletteInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityColorPalettes", "id", id);
            // verify required parameter 'jsonApiColorPaletteInDocument' is not null or undefined
            assertParamExists("updateEntityColorPalettes", "jsonApiColorPaletteInDocument", jsonApiColorPaletteInDocument);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiColorPaletteInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiColorPaletteInDocument !== undefined ? jsonApiColorPaletteInDocument : {})
                : jsonApiColorPaletteInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Theming
         * @param {string} id
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityThemes: async (id, jsonApiThemeInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityThemes", "id", id);
            // verify required parameter 'jsonApiThemeInDocument' is not null or undefined
            assertParamExists("updateEntityThemes", "jsonApiThemeInDocument", jsonApiThemeInDocument);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiThemeInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiThemeInDocument !== undefined ? jsonApiThemeInDocument : {})
                : jsonApiThemeInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AppearanceApi - functional programming interface
 * @export
 */
export const AppearanceApiFp = function (configuration) {
    const localVarAxiosParamCreator = AppearanceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Color Pallettes
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityColorPalettes(jsonApiColorPaletteInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityColorPalettes(jsonApiColorPaletteInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Theming
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityThemes(jsonApiThemeInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityThemes(jsonApiThemeInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityColorPalettes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityColorPalettes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityThemes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityThemes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Color Pallettes
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesColorPalettes(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesColorPalettes(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Theming entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesThemes(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesThemes(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityColorPalettes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityColorPalettes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityThemes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityThemes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Color Pallette
         * @param {string} id
         * @param {JsonApiColorPalettePatchDocument} jsonApiColorPalettePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityColorPalettes(id, jsonApiColorPalettePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityColorPalettes(id, jsonApiColorPalettePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Theming
         * @param {string} id
         * @param {JsonApiThemePatchDocument} jsonApiThemePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityThemes(id, jsonApiThemePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityThemes(id, jsonApiThemePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Color Pallette
         * @param {string} id
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityColorPalettes(id, jsonApiColorPaletteInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityColorPalettes(id, jsonApiColorPaletteInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Theming
         * @param {string} id
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityThemes(id, jsonApiThemeInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityThemes(id, jsonApiThemeInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AppearanceApi - factory interface
 * @export
 */
export const AppearanceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AppearanceApiFp(configuration);
    return {
        /**
         *
         * @summary Post Color Pallettes
         * @param {AppearanceApiCreateEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .createEntityColorPalettes(requestParameters.jsonApiColorPaletteInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Theming
         * @param {AppearanceApiCreateEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityThemes(requestParameters, options) {
            return localVarFp
                .createEntityThemes(requestParameters.jsonApiThemeInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Color Pallette
         * @param {AppearanceApiDeleteEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .deleteEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Theming
         * @param {AppearanceApiDeleteEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityThemes(requestParameters, options) {
            return localVarFp
                .deleteEntityThemes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Color Pallettes
         * @param {AppearanceApiGetAllEntitiesColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesColorPalettes(requestParameters, options) {
            return localVarFp
                .getAllEntitiesColorPalettes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Theming entities
         * @param {AppearanceApiGetAllEntitiesThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesThemes(requestParameters, options) {
            return localVarFp
                .getAllEntitiesThemes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Color Pallette
         * @param {AppearanceApiGetEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .getEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Theming
         * @param {AppearanceApiGetEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityThemes(requestParameters, options) {
            return localVarFp
                .getEntityThemes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Color Pallette
         * @param {AppearanceApiPatchEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .patchEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPalettePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Theming
         * @param {AppearanceApiPatchEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityThemes(requestParameters, options) {
            return localVarFp
                .patchEntityThemes(requestParameters.id, requestParameters.jsonApiThemePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Color Pallette
         * @param {AppearanceApiUpdateEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .updateEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPaletteInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Theming
         * @param {AppearanceApiUpdateEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityThemes(requestParameters, options) {
            return localVarFp
                .updateEntityThemes(requestParameters.id, requestParameters.jsonApiThemeInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppearanceApi - object-oriented interface
 * @export
 * @class AppearanceApi
 * @extends {BaseAPI}
 */
export class AppearanceApi extends BaseAPI {
    /**
     *
     * @summary Post Color Pallettes
     * @param {AppearanceApiCreateEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    createEntityColorPalettes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .createEntityColorPalettes(requestParameters.jsonApiColorPaletteInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Theming
     * @param {AppearanceApiCreateEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    createEntityThemes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .createEntityThemes(requestParameters.jsonApiThemeInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Color Pallette
     * @param {AppearanceApiDeleteEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    deleteEntityColorPalettes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .deleteEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Theming
     * @param {AppearanceApiDeleteEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    deleteEntityThemes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .deleteEntityThemes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Color Pallettes
     * @param {AppearanceApiGetAllEntitiesColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    getAllEntitiesColorPalettes(requestParameters = {}, options) {
        return AppearanceApiFp(this.configuration)
            .getAllEntitiesColorPalettes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Theming entities
     * @param {AppearanceApiGetAllEntitiesThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    getAllEntitiesThemes(requestParameters = {}, options) {
        return AppearanceApiFp(this.configuration)
            .getAllEntitiesThemes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Color Pallette
     * @param {AppearanceApiGetEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    getEntityColorPalettes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .getEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Theming
     * @param {AppearanceApiGetEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    getEntityThemes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .getEntityThemes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Color Pallette
     * @param {AppearanceApiPatchEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    patchEntityColorPalettes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .patchEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPalettePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Theming
     * @param {AppearanceApiPatchEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    patchEntityThemes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .patchEntityThemes(requestParameters.id, requestParameters.jsonApiThemePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Color Pallette
     * @param {AppearanceApiUpdateEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    updateEntityColorPalettes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .updateEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPaletteInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Theming
     * @param {AppearanceApiUpdateEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppearanceApi
     */
    updateEntityThemes(requestParameters, options) {
        return AppearanceApiFp(this.configuration)
            .updateEntityThemes(requestParameters.id, requestParameters.jsonApiThemeInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AttributeHierarchiesApi - axios parameter creator
 * @export
 */
export const AttributeHierarchiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Attribute Hierarchies
         * @param {string} workspaceId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAttributeHierarchies: async (workspaceId, jsonApiAttributeHierarchyInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiAttributeHierarchyInDocument' is not null or undefined
            assertParamExists("createEntityAttributeHierarchies", "jsonApiAttributeHierarchyInDocument", jsonApiAttributeHierarchyInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAttributeHierarchyInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAttributeHierarchyInDocument !== undefined
                    ? jsonApiAttributeHierarchyInDocument
                    : {})
                : jsonApiAttributeHierarchyInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAttributeHierarchies: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityAttributeHierarchies", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Attribute Hierarchies
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributeHierarchies: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAttributeHierarchies", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributeHierarchies: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAttributeHierarchies", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyPatchDocument} jsonApiAttributeHierarchyPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAttributeHierarchies: async (workspaceId, objectId, jsonApiAttributeHierarchyPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityAttributeHierarchies", "objectId", objectId);
            // verify required parameter 'jsonApiAttributeHierarchyPatchDocument' is not null or undefined
            assertParamExists("patchEntityAttributeHierarchies", "jsonApiAttributeHierarchyPatchDocument", jsonApiAttributeHierarchyPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAttributeHierarchyPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAttributeHierarchyPatchDocument !== undefined
                    ? jsonApiAttributeHierarchyPatchDocument
                    : {})
                : jsonApiAttributeHierarchyPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAttributeHierarchies: async (workspaceId, objectId, jsonApiAttributeHierarchyInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityAttributeHierarchies", "objectId", objectId);
            // verify required parameter 'jsonApiAttributeHierarchyInDocument' is not null or undefined
            assertParamExists("updateEntityAttributeHierarchies", "jsonApiAttributeHierarchyInDocument", jsonApiAttributeHierarchyInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAttributeHierarchyInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAttributeHierarchyInDocument !== undefined
                    ? jsonApiAttributeHierarchyInDocument
                    : {})
                : jsonApiAttributeHierarchyInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AttributeHierarchiesApi - functional programming interface
 * @export
 */
export const AttributeHierarchiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AttributeHierarchiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Attribute Hierarchies
         * @param {string} workspaceId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityAttributeHierarchies(workspaceId, jsonApiAttributeHierarchyInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityAttributeHierarchies(workspaceId, jsonApiAttributeHierarchyInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAttributeHierarchies(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAttributeHierarchies(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Attribute Hierarchies
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAttributeHierarchies(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAttributeHierarchies(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAttributeHierarchies(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAttributeHierarchies(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyPatchDocument} jsonApiAttributeHierarchyPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AttributeHierarchiesApi - factory interface
 * @export
 */
export const AttributeHierarchiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AttributeHierarchiesApiFp(configuration);
    return {
        /**
         *
         * @summary Post Attribute Hierarchies
         * @param {AttributeHierarchiesApiCreateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .createEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Attribute Hierarchy
         * @param {AttributeHierarchiesApiDeleteEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .deleteEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Attribute Hierarchies
         * @param {AttributeHierarchiesApiGetAllEntitiesAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAttributeHierarchies(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Attribute Hierarchy
         * @param {AttributeHierarchiesApiGetEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .getEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an Attribute Hierarchy
         * @param {AttributeHierarchiesApiPatchEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .patchEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put an Attribute Hierarchy
         * @param {AttributeHierarchiesApiUpdateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .updateEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AttributeHierarchiesApi - object-oriented interface
 * @export
 * @class AttributeHierarchiesApi
 * @extends {BaseAPI}
 */
export class AttributeHierarchiesApi extends BaseAPI {
    /**
     *
     * @summary Post Attribute Hierarchies
     * @param {AttributeHierarchiesApiCreateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeHierarchiesApi
     */
    createEntityAttributeHierarchies(requestParameters, options) {
        return AttributeHierarchiesApiFp(this.configuration)
            .createEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Attribute Hierarchy
     * @param {AttributeHierarchiesApiDeleteEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeHierarchiesApi
     */
    deleteEntityAttributeHierarchies(requestParameters, options) {
        return AttributeHierarchiesApiFp(this.configuration)
            .deleteEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Attribute Hierarchies
     * @param {AttributeHierarchiesApiGetAllEntitiesAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeHierarchiesApi
     */
    getAllEntitiesAttributeHierarchies(requestParameters, options) {
        return AttributeHierarchiesApiFp(this.configuration)
            .getAllEntitiesAttributeHierarchies(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Attribute Hierarchy
     * @param {AttributeHierarchiesApiGetEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeHierarchiesApi
     */
    getEntityAttributeHierarchies(requestParameters, options) {
        return AttributeHierarchiesApiFp(this.configuration)
            .getEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an Attribute Hierarchy
     * @param {AttributeHierarchiesApiPatchEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeHierarchiesApi
     */
    patchEntityAttributeHierarchies(requestParameters, options) {
        return AttributeHierarchiesApiFp(this.configuration)
            .patchEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put an Attribute Hierarchy
     * @param {AttributeHierarchiesApiUpdateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributeHierarchiesApi
     */
    updateEntityAttributeHierarchies(requestParameters, options) {
        return AttributeHierarchiesApiFp(this.configuration)
            .updateEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AttributesApi - axios parameter creator
 * @export
 */
export const AttributesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all Attributes
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributes: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAttributes", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributes`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Attribute
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributes: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAttributes", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAttributes", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributes/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AttributesApi - functional programming interface
 * @export
 */
export const AttributesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AttributesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all Attributes
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAttributes(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAttributes(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Attribute
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAttributes(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAttributes(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AttributesApi - factory interface
 * @export
 */
export const AttributesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AttributesApiFp(configuration);
    return {
        /**
         *
         * @summary Get all Attributes
         * @param {AttributesApiGetAllEntitiesAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributes(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAttributes(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Attribute
         * @param {AttributesApiGetEntityAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributes(requestParameters, options) {
            return localVarFp
                .getEntityAttributes(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AttributesApi - object-oriented interface
 * @export
 * @class AttributesApi
 * @extends {BaseAPI}
 */
export class AttributesApi extends BaseAPI {
    /**
     *
     * @summary Get all Attributes
     * @param {AttributesApiGetAllEntitiesAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    getAllEntitiesAttributes(requestParameters, options) {
        return AttributesApiFp(this.configuration)
            .getAllEntitiesAttributes(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Attribute
     * @param {AttributesApiGetEntityAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    getEntityAttributes(requestParameters, options) {
        return AttributesApiFp(this.configuration)
            .getEntityAttributes(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AutomationsApi - axios parameter creator
 * @export
 */
export const AutomationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Automations
         * @param {string} workspaceId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAutomations: async (workspaceId, jsonApiAutomationInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiAutomationInDocument' is not null or undefined
            assertParamExists("createEntityAutomations", "jsonApiAutomationInDocument", jsonApiAutomationInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAutomationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAutomationInDocument !== undefined ? jsonApiAutomationInDocument : {})
                : jsonApiAutomationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAutomations: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityAutomations", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Automations
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAutomations: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAutomations", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve automations for the specific workspace
         * @summary Get automations
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutomations: async (workspaceId, exclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAutomations", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAutomations: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAutomations", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationPatchDocument} jsonApiAutomationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAutomations: async (workspaceId, objectId, jsonApiAutomationPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityAutomations", "objectId", objectId);
            // verify required parameter 'jsonApiAutomationPatchDocument' is not null or undefined
            assertParamExists("patchEntityAutomations", "jsonApiAutomationPatchDocument", jsonApiAutomationPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAutomationPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAutomationPatchDocument !== undefined ? jsonApiAutomationPatchDocument : {})
                : jsonApiAutomationPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set automations for the specific workspace.
         * @summary Set automations
         * @param {string} workspaceId
         * @param {Array<DeclarativeAutomation>} declarativeAutomation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAutomations: async (workspaceId, declarativeAutomation, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setAutomations", "workspaceId", workspaceId);
            // verify required parameter 'declarativeAutomation' is not null or undefined
            assertParamExists("setAutomations", "declarativeAutomation", declarativeAutomation);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeAutomation !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeAutomation !== undefined ? declarativeAutomation : {})
                : declarativeAutomation || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAutomations: async (workspaceId, objectId, jsonApiAutomationInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityAutomations", "objectId", objectId);
            // verify required parameter 'jsonApiAutomationInDocument' is not null or undefined
            assertParamExists("updateEntityAutomations", "jsonApiAutomationInDocument", jsonApiAutomationInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAutomationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAutomationInDocument !== undefined ? jsonApiAutomationInDocument : {})
                : jsonApiAutomationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AutomationsApi - functional programming interface
 * @export
 */
export const AutomationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AutomationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Automations
         * @param {string} workspaceId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityAutomations(workspaceId, jsonApiAutomationInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityAutomations(workspaceId, jsonApiAutomationInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAutomations(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAutomations(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Automations
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAutomations(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAutomations(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve automations for the specific workspace
         * @summary Get automations
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutomations(workspaceId, exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutomations(workspaceId, exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAutomations(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAutomations(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationPatchDocument} jsonApiAutomationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityAutomations(workspaceId, objectId, jsonApiAutomationPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityAutomations(workspaceId, objectId, jsonApiAutomationPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set automations for the specific workspace.
         * @summary Set automations
         * @param {string} workspaceId
         * @param {Array<DeclarativeAutomation>} declarativeAutomation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAutomations(workspaceId, declarativeAutomation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAutomations(workspaceId, declarativeAutomation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAutomations(workspaceId, objectId, jsonApiAutomationInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAutomations(workspaceId, objectId, jsonApiAutomationInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AutomationsApi - factory interface
 * @export
 */
export const AutomationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AutomationsApiFp(configuration);
    return {
        /**
         *
         * @summary Post Automations
         * @param {AutomationsApiCreateEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAutomations(requestParameters, options) {
            return localVarFp
                .createEntityAutomations(requestParameters.workspaceId, requestParameters.jsonApiAutomationInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Automation
         * @param {AutomationsApiDeleteEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAutomations(requestParameters, options) {
            return localVarFp
                .deleteEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Automations
         * @param {AutomationsApiGetAllEntitiesAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAutomations(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAutomations(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve automations for the specific workspace
         * @summary Get automations
         * @param {AutomationsApiGetAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutomations(requestParameters, options) {
            return localVarFp
                .getAutomations(requestParameters.workspaceId, requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Automation
         * @param {AutomationsApiGetEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAutomations(requestParameters, options) {
            return localVarFp
                .getEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an Automation
         * @param {AutomationsApiPatchEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAutomations(requestParameters, options) {
            return localVarFp
                .patchEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set automations for the specific workspace.
         * @summary Set automations
         * @param {AutomationsApiSetAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAutomations(requestParameters, options) {
            return localVarFp
                .setAutomations(requestParameters.workspaceId, requestParameters.declarativeAutomation, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put an Automation
         * @param {AutomationsApiUpdateEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAutomations(requestParameters, options) {
            return localVarFp
                .updateEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AutomationsApi - object-oriented interface
 * @export
 * @class AutomationsApi
 * @extends {BaseAPI}
 */
export class AutomationsApi extends BaseAPI {
    /**
     *
     * @summary Post Automations
     * @param {AutomationsApiCreateEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    createEntityAutomations(requestParameters, options) {
        return AutomationsApiFp(this.configuration)
            .createEntityAutomations(requestParameters.workspaceId, requestParameters.jsonApiAutomationInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Automation
     * @param {AutomationsApiDeleteEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    deleteEntityAutomations(requestParameters, options) {
        return AutomationsApiFp(this.configuration)
            .deleteEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Automations
     * @param {AutomationsApiGetAllEntitiesAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    getAllEntitiesAutomations(requestParameters, options) {
        return AutomationsApiFp(this.configuration)
            .getAllEntitiesAutomations(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve automations for the specific workspace
     * @summary Get automations
     * @param {AutomationsApiGetAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    getAutomations(requestParameters, options) {
        return AutomationsApiFp(this.configuration)
            .getAutomations(requestParameters.workspaceId, requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Automation
     * @param {AutomationsApiGetEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    getEntityAutomations(requestParameters, options) {
        return AutomationsApiFp(this.configuration)
            .getEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an Automation
     * @param {AutomationsApiPatchEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    patchEntityAutomations(requestParameters, options) {
        return AutomationsApiFp(this.configuration)
            .patchEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set automations for the specific workspace.
     * @summary Set automations
     * @param {AutomationsApiSetAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    setAutomations(requestParameters, options) {
        return AutomationsApiFp(this.configuration)
            .setAutomations(requestParameters.workspaceId, requestParameters.declarativeAutomation, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put an Automation
     * @param {AutomationsApiUpdateEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    updateEntityAutomations(requestParameters, options) {
        return AutomationsApiFp(this.configuration)
            .updateEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AvailableDriversApi - axios parameter creator
 * @export
 */
export const AvailableDriversApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves a list of all supported data sources along with information about the used drivers.
         * @summary Get all available data source drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourceDrivers: async (options = {}) => {
            const localVarPath = `/api/v1/options/availableDrivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AvailableDriversApi - functional programming interface
 * @export
 */
export const AvailableDriversApiFp = function (configuration) {
    const localVarAxiosParamCreator = AvailableDriversApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves a list of all supported data sources along with information about the used drivers.
         * @summary Get all available data source drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourceDrivers(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourceDrivers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * AvailableDriversApi - factory interface
 * @export
 */
export const AvailableDriversApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AvailableDriversApiFp(configuration);
    return {
        /**
         * Retrieves a list of all supported data sources along with information about the used drivers.
         * @summary Get all available data source drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourceDrivers(options) {
            return localVarFp.getDataSourceDrivers(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AvailableDriversApi - object-oriented interface
 * @export
 * @class AvailableDriversApi
 * @extends {BaseAPI}
 */
export class AvailableDriversApi extends BaseAPI {
    /**
     * Retrieves a list of all supported data sources along with information about the used drivers.
     * @summary Get all available data source drivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDriversApi
     */
    getDataSourceDrivers(options) {
        return AvailableDriversApiFp(this.configuration)
            .getDataSourceDrivers(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CSPDirectivesApi - axios parameter creator
 * @export
 */
export const CSPDirectivesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *  Context Security Police Directive
         * @summary Post CSP Directives
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCspDirectives: async (jsonApiCspDirectiveInDocument, options = {}) => {
            // verify required parameter 'jsonApiCspDirectiveInDocument' is not null or undefined
            assertParamExists("createEntityCspDirectives", "jsonApiCspDirectiveInDocument", jsonApiCspDirectiveInDocument);
            const localVarPath = `/api/v1/entities/cspDirectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCspDirectiveInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCspDirectiveInDocument !== undefined ? jsonApiCspDirectiveInDocument : {})
                : jsonApiCspDirectiveInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Delete CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCspDirectives: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityCspDirectives", "id", id);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCspDirectives: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/cspDirectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCspDirectives: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityCspDirectives", "id", id);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Patch CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectivePatchDocument} jsonApiCspDirectivePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCspDirectives: async (id, jsonApiCspDirectivePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityCspDirectives", "id", id);
            // verify required parameter 'jsonApiCspDirectivePatchDocument' is not null or undefined
            assertParamExists("patchEntityCspDirectives", "jsonApiCspDirectivePatchDocument", jsonApiCspDirectivePatchDocument);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCspDirectivePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCspDirectivePatchDocument !== undefined ? jsonApiCspDirectivePatchDocument : {})
                : jsonApiCspDirectivePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Put CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCspDirectives: async (id, jsonApiCspDirectiveInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityCspDirectives", "id", id);
            // verify required parameter 'jsonApiCspDirectiveInDocument' is not null or undefined
            assertParamExists("updateEntityCspDirectives", "jsonApiCspDirectiveInDocument", jsonApiCspDirectiveInDocument);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCspDirectiveInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCspDirectiveInDocument !== undefined ? jsonApiCspDirectiveInDocument : {})
                : jsonApiCspDirectiveInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CSPDirectivesApi - functional programming interface
 * @export
 */
export const CSPDirectivesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CSPDirectivesApiAxiosParamCreator(configuration);
    return {
        /**
         *  Context Security Police Directive
         * @summary Post CSP Directives
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityCspDirectives(jsonApiCspDirectiveInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityCspDirectives(jsonApiCspDirectiveInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Delete CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityCspDirectives(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityCspDirectives(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesCspDirectives(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesCspDirectives(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCspDirectives(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCspDirectives(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Patch CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectivePatchDocument} jsonApiCspDirectivePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityCspDirectives(id, jsonApiCspDirectivePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityCspDirectives(id, jsonApiCspDirectivePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Put CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityCspDirectives(id, jsonApiCspDirectiveInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityCspDirectives(id, jsonApiCspDirectiveInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CSPDirectivesApi - factory interface
 * @export
 */
export const CSPDirectivesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CSPDirectivesApiFp(configuration);
    return {
        /**
         *  Context Security Police Directive
         * @summary Post CSP Directives
         * @param {CSPDirectivesApiCreateEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .createEntityCspDirectives(requestParameters.jsonApiCspDirectiveInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Delete CSP Directives
         * @param {CSPDirectivesApiDeleteEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .deleteEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {CSPDirectivesApiGetAllEntitiesCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCspDirectives(requestParameters, options) {
            return localVarFp
                .getAllEntitiesCspDirectives(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {CSPDirectivesApiGetEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .getEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Patch CSP Directives
         * @param {CSPDirectivesApiPatchEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .patchEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectivePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Put CSP Directives
         * @param {CSPDirectivesApiUpdateEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .updateEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectiveInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * CSPDirectivesApi - object-oriented interface
 * @export
 * @class CSPDirectivesApi
 * @extends {BaseAPI}
 */
export class CSPDirectivesApi extends BaseAPI {
    /**
     *  Context Security Police Directive
     * @summary Post CSP Directives
     * @param {CSPDirectivesApiCreateEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CSPDirectivesApi
     */
    createEntityCspDirectives(requestParameters, options) {
        return CSPDirectivesApiFp(this.configuration)
            .createEntityCspDirectives(requestParameters.jsonApiCspDirectiveInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Delete CSP Directives
     * @param {CSPDirectivesApiDeleteEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CSPDirectivesApi
     */
    deleteEntityCspDirectives(requestParameters, options) {
        return CSPDirectivesApiFp(this.configuration)
            .deleteEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Get CSP Directives
     * @param {CSPDirectivesApiGetAllEntitiesCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CSPDirectivesApi
     */
    getAllEntitiesCspDirectives(requestParameters = {}, options) {
        return CSPDirectivesApiFp(this.configuration)
            .getAllEntitiesCspDirectives(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Get CSP Directives
     * @param {CSPDirectivesApiGetEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CSPDirectivesApi
     */
    getEntityCspDirectives(requestParameters, options) {
        return CSPDirectivesApiFp(this.configuration)
            .getEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Patch CSP Directives
     * @param {CSPDirectivesApiPatchEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CSPDirectivesApi
     */
    patchEntityCspDirectives(requestParameters, options) {
        return CSPDirectivesApiFp(this.configuration)
            .patchEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectivePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Put CSP Directives
     * @param {CSPDirectivesApiUpdateEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CSPDirectivesApi
     */
    updateEntityCspDirectives(requestParameters, options) {
        return CSPDirectivesApiFp(this.configuration)
            .updateEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectiveInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContextFiltersApi - axios parameter creator
 * @export
 */
export const ContextFiltersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Context Filters
         * @param {string} workspaceId
         * @param {JsonApiFilterContextPostOptionalIdDocument} jsonApiFilterContextPostOptionalIdDocument
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterContexts: async (workspaceId, jsonApiFilterContextPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiFilterContextPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityFilterContexts", "jsonApiFilterContextPostOptionalIdDocument", jsonApiFilterContextPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterContextPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterContextPostOptionalIdDocument !== undefined
                    ? jsonApiFilterContextPostOptionalIdDocument
                    : {})
                : jsonApiFilterContextPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterContexts: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityFilterContexts", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Context Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterContexts: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesFilterContexts", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterContexts: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityFilterContexts", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextPatchDocument} jsonApiFilterContextPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterContexts: async (workspaceId, objectId, jsonApiFilterContextPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityFilterContexts", "objectId", objectId);
            // verify required parameter 'jsonApiFilterContextPatchDocument' is not null or undefined
            assertParamExists("patchEntityFilterContexts", "jsonApiFilterContextPatchDocument", jsonApiFilterContextPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterContextPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterContextPatchDocument !== undefined
                    ? jsonApiFilterContextPatchDocument
                    : {})
                : jsonApiFilterContextPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextInDocument} jsonApiFilterContextInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterContexts: async (workspaceId, objectId, jsonApiFilterContextInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityFilterContexts", "objectId", objectId);
            // verify required parameter 'jsonApiFilterContextInDocument' is not null or undefined
            assertParamExists("updateEntityFilterContexts", "jsonApiFilterContextInDocument", jsonApiFilterContextInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterContextInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterContextInDocument !== undefined ? jsonApiFilterContextInDocument : {})
                : jsonApiFilterContextInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContextFiltersApi - functional programming interface
 * @export
 */
export const ContextFiltersApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContextFiltersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Context Filters
         * @param {string} workspaceId
         * @param {JsonApiFilterContextPostOptionalIdDocument} jsonApiFilterContextPostOptionalIdDocument
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityFilterContexts(workspaceId, jsonApiFilterContextPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityFilterContexts(workspaceId, jsonApiFilterContextPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityFilterContexts(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityFilterContexts(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Context Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFilterContexts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFilterContexts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityFilterContexts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityFilterContexts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextPatchDocument} jsonApiFilterContextPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextInDocument} jsonApiFilterContextInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ContextFiltersApi - factory interface
 * @export
 */
export const ContextFiltersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContextFiltersApiFp(configuration);
    return {
        /**
         *
         * @summary Post Context Filters
         * @param {ContextFiltersApiCreateEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .createEntityFilterContexts(requestParameters.workspaceId, requestParameters.jsonApiFilterContextPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Context Filter
         * @param {ContextFiltersApiDeleteEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .deleteEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Context Filters
         * @param {ContextFiltersApiGetAllEntitiesFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterContexts(requestParameters, options) {
            return localVarFp
                .getAllEntitiesFilterContexts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Context Filter
         * @param {ContextFiltersApiGetEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .getEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Context Filter
         * @param {ContextFiltersApiPatchEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .patchEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Context Filter
         * @param {ContextFiltersApiUpdateEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .updateEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContextFiltersApi - object-oriented interface
 * @export
 * @class ContextFiltersApi
 * @extends {BaseAPI}
 */
export class ContextFiltersApi extends BaseAPI {
    /**
     *
     * @summary Post Context Filters
     * @param {ContextFiltersApiCreateEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextFiltersApi
     */
    createEntityFilterContexts(requestParameters, options) {
        return ContextFiltersApiFp(this.configuration)
            .createEntityFilterContexts(requestParameters.workspaceId, requestParameters.jsonApiFilterContextPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Context Filter
     * @param {ContextFiltersApiDeleteEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextFiltersApi
     */
    deleteEntityFilterContexts(requestParameters, options) {
        return ContextFiltersApiFp(this.configuration)
            .deleteEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Context Filters
     * @param {ContextFiltersApiGetAllEntitiesFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextFiltersApi
     */
    getAllEntitiesFilterContexts(requestParameters, options) {
        return ContextFiltersApiFp(this.configuration)
            .getAllEntitiesFilterContexts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Context Filter
     * @param {ContextFiltersApiGetEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextFiltersApi
     */
    getEntityFilterContexts(requestParameters, options) {
        return ContextFiltersApiFp(this.configuration)
            .getEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Context Filter
     * @param {ContextFiltersApiPatchEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextFiltersApi
     */
    patchEntityFilterContexts(requestParameters, options) {
        return ContextFiltersApiFp(this.configuration)
            .patchEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Context Filter
     * @param {ContextFiltersApiUpdateEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextFiltersApi
     */
    updateEntityFilterContexts(requestParameters, options) {
        return ContextFiltersApiFp(this.configuration)
            .updateEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CookieSecurityConfigurationApi - axios parameter creator
 * @export
 */
export const CookieSecurityConfigurationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get CookieSecurityConfiguration
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCookieSecurityConfigurations: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityCookieSecurityConfigurations", "id", id);
            const localVarPath = `/api/v1/entities/admin/cookieSecurityConfigurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationPatchDocument} jsonApiCookieSecurityConfigurationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCookieSecurityConfigurations: async (id, jsonApiCookieSecurityConfigurationPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityCookieSecurityConfigurations", "id", id);
            // verify required parameter 'jsonApiCookieSecurityConfigurationPatchDocument' is not null or undefined
            assertParamExists("patchEntityCookieSecurityConfigurations", "jsonApiCookieSecurityConfigurationPatchDocument", jsonApiCookieSecurityConfigurationPatchDocument);
            const localVarPath = `/api/v1/entities/admin/cookieSecurityConfigurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCookieSecurityConfigurationPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCookieSecurityConfigurationPatchDocument !== undefined
                    ? jsonApiCookieSecurityConfigurationPatchDocument
                    : {})
                : jsonApiCookieSecurityConfigurationPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationInDocument} jsonApiCookieSecurityConfigurationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCookieSecurityConfigurations: async (id, jsonApiCookieSecurityConfigurationInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityCookieSecurityConfigurations", "id", id);
            // verify required parameter 'jsonApiCookieSecurityConfigurationInDocument' is not null or undefined
            assertParamExists("updateEntityCookieSecurityConfigurations", "jsonApiCookieSecurityConfigurationInDocument", jsonApiCookieSecurityConfigurationInDocument);
            const localVarPath = `/api/v1/entities/admin/cookieSecurityConfigurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCookieSecurityConfigurationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCookieSecurityConfigurationInDocument !== undefined
                    ? jsonApiCookieSecurityConfigurationInDocument
                    : {})
                : jsonApiCookieSecurityConfigurationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CookieSecurityConfigurationApi - functional programming interface
 * @export
 */
export const CookieSecurityConfigurationApiFp = function (configuration) {
    const localVarAxiosParamCreator = CookieSecurityConfigurationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get CookieSecurityConfiguration
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCookieSecurityConfigurations(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCookieSecurityConfigurations(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationPatchDocument} jsonApiCookieSecurityConfigurationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationInDocument} jsonApiCookieSecurityConfigurationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * CookieSecurityConfigurationApi - factory interface
 * @export
 */
export const CookieSecurityConfigurationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CookieSecurityConfigurationApiFp(configuration);
    return {
        /**
         *
         * @summary Get CookieSecurityConfiguration
         * @param {CookieSecurityConfigurationApiGetEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCookieSecurityConfigurations(requestParameters, options) {
            return localVarFp
                .getEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch CookieSecurityConfiguration
         * @param {CookieSecurityConfigurationApiPatchEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCookieSecurityConfigurations(requestParameters, options) {
            return localVarFp
                .patchEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put CookieSecurityConfiguration
         * @param {CookieSecurityConfigurationApiUpdateEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCookieSecurityConfigurations(requestParameters, options) {
            return localVarFp
                .updateEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * CookieSecurityConfigurationApi - object-oriented interface
 * @export
 * @class CookieSecurityConfigurationApi
 * @extends {BaseAPI}
 */
export class CookieSecurityConfigurationApi extends BaseAPI {
    /**
     *
     * @summary Get CookieSecurityConfiguration
     * @param {CookieSecurityConfigurationApiGetEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CookieSecurityConfigurationApi
     */
    getEntityCookieSecurityConfigurations(requestParameters, options) {
        return CookieSecurityConfigurationApiFp(this.configuration)
            .getEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch CookieSecurityConfiguration
     * @param {CookieSecurityConfigurationApiPatchEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CookieSecurityConfigurationApi
     */
    patchEntityCookieSecurityConfigurations(requestParameters, options) {
        return CookieSecurityConfigurationApiFp(this.configuration)
            .patchEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put CookieSecurityConfiguration
     * @param {CookieSecurityConfigurationApiUpdateEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CookieSecurityConfigurationApi
     */
    updateEntityCookieSecurityConfigurations(requestParameters, options) {
        return CookieSecurityConfigurationApiFp(this.configuration)
            .updateEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DashboardsApi - axios parameter creator
 * @export
 */
export const DashboardsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Dashboards
         * @param {string} workspaceId
         * @param {JsonApiAnalyticalDashboardPostOptionalIdDocument} jsonApiAnalyticalDashboardPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAnalyticalDashboards: async (workspaceId, jsonApiAnalyticalDashboardPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiAnalyticalDashboardPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityAnalyticalDashboards", "jsonApiAnalyticalDashboardPostOptionalIdDocument", jsonApiAnalyticalDashboardPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAnalyticalDashboardPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAnalyticalDashboardPostOptionalIdDocument !== undefined
                    ? jsonApiAnalyticalDashboardPostOptionalIdDocument
                    : {})
                : jsonApiAnalyticalDashboardPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAnalyticalDashboards: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityAnalyticalDashboards", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Dashboards
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAnalyticalDashboards: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAnalyticalDashboards", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAnalyticalDashboards: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAnalyticalDashboards", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardPatchDocument} jsonApiAnalyticalDashboardPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAnalyticalDashboards: async (workspaceId, objectId, jsonApiAnalyticalDashboardPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityAnalyticalDashboards", "objectId", objectId);
            // verify required parameter 'jsonApiAnalyticalDashboardPatchDocument' is not null or undefined
            assertParamExists("patchEntityAnalyticalDashboards", "jsonApiAnalyticalDashboardPatchDocument", jsonApiAnalyticalDashboardPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAnalyticalDashboardPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAnalyticalDashboardPatchDocument !== undefined
                    ? jsonApiAnalyticalDashboardPatchDocument
                    : {})
                : jsonApiAnalyticalDashboardPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Dashboards
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardInDocument} jsonApiAnalyticalDashboardInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAnalyticalDashboards: async (workspaceId, objectId, jsonApiAnalyticalDashboardInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityAnalyticalDashboards", "objectId", objectId);
            // verify required parameter 'jsonApiAnalyticalDashboardInDocument' is not null or undefined
            assertParamExists("updateEntityAnalyticalDashboards", "jsonApiAnalyticalDashboardInDocument", jsonApiAnalyticalDashboardInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAnalyticalDashboardInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAnalyticalDashboardInDocument !== undefined
                    ? jsonApiAnalyticalDashboardInDocument
                    : {})
                : jsonApiAnalyticalDashboardInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DashboardsApi - functional programming interface
 * @export
 */
export const DashboardsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DashboardsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Dashboards
         * @param {string} workspaceId
         * @param {JsonApiAnalyticalDashboardPostOptionalIdDocument} jsonApiAnalyticalDashboardPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityAnalyticalDashboards(workspaceId, jsonApiAnalyticalDashboardPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityAnalyticalDashboards(workspaceId, jsonApiAnalyticalDashboardPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAnalyticalDashboards(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAnalyticalDashboards(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Dashboards
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAnalyticalDashboards(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAnalyticalDashboards(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAnalyticalDashboards(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAnalyticalDashboards(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardPatchDocument} jsonApiAnalyticalDashboardPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Dashboards
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardInDocument} jsonApiAnalyticalDashboardInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DashboardsApi - factory interface
 * @export
 */
export const DashboardsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DashboardsApiFp(configuration);
    return {
        /**
         *
         * @summary Post Dashboards
         * @param {DashboardsApiCreateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .createEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.jsonApiAnalyticalDashboardPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Dashboard
         * @param {DashboardsApiDeleteEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .deleteEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Dashboards
         * @param {DashboardsApiGetAllEntitiesAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAnalyticalDashboards(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Dashboard
         * @param {DashboardsApiGetEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .getEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Dashboard
         * @param {DashboardsApiPatchEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .patchEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Dashboards
         * @param {DashboardsApiUpdateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .updateEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DashboardsApi - object-oriented interface
 * @export
 * @class DashboardsApi
 * @extends {BaseAPI}
 */
export class DashboardsApi extends BaseAPI {
    /**
     *
     * @summary Post Dashboards
     * @param {DashboardsApiCreateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    createEntityAnalyticalDashboards(requestParameters, options) {
        return DashboardsApiFp(this.configuration)
            .createEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.jsonApiAnalyticalDashboardPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Dashboard
     * @param {DashboardsApiDeleteEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    deleteEntityAnalyticalDashboards(requestParameters, options) {
        return DashboardsApiFp(this.configuration)
            .deleteEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Dashboards
     * @param {DashboardsApiGetAllEntitiesAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    getAllEntitiesAnalyticalDashboards(requestParameters, options) {
        return DashboardsApiFp(this.configuration)
            .getAllEntitiesAnalyticalDashboards(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Dashboard
     * @param {DashboardsApiGetEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    getEntityAnalyticalDashboards(requestParameters, options) {
        return DashboardsApiFp(this.configuration)
            .getEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Dashboard
     * @param {DashboardsApiPatchEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    patchEntityAnalyticalDashboards(requestParameters, options) {
        return DashboardsApiFp(this.configuration)
            .patchEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Dashboards
     * @param {DashboardsApiUpdateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    updateEntityAnalyticalDashboards(requestParameters, options) {
        return DashboardsApiFp(this.configuration)
            .updateEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DataFiltersApi - axios parameter creator
 * @export
 */
export const DataFiltersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post User Data Filters
         * @param {string} workspaceId
         * @param {JsonApiUserDataFilterPostOptionalIdDocument} jsonApiUserDataFilterPostOptionalIdDocument
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserDataFilters: async (workspaceId, jsonApiUserDataFilterPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiUserDataFilterPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityUserDataFilters", "jsonApiUserDataFilterPostOptionalIdDocument", jsonApiUserDataFilterPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserDataFilterPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserDataFilterPostOptionalIdDocument !== undefined
                    ? jsonApiUserDataFilterPostOptionalIdDocument
                    : {})
                : jsonApiUserDataFilterPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilterSettings: async (workspaceId, jsonApiWorkspaceDataFilterSettingInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiWorkspaceDataFilterSettingInDocument' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilterSettings", "jsonApiWorkspaceDataFilterSettingInDocument", jsonApiWorkspaceDataFilterSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterSettingInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterSettingInDocument
                    : {})
                : jsonApiWorkspaceDataFilterSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilters: async (workspaceId, jsonApiWorkspaceDataFilterInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiWorkspaceDataFilterInDocument' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilters", "jsonApiWorkspaceDataFilterInDocument", jsonApiWorkspaceDataFilterInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterInDocument
                    : {})
                : jsonApiWorkspaceDataFilterInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserDataFilters: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityUserDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilterSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilters: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all User Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserDataFilters: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesUserDataFilters", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilterSettings: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilters: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesWorkspaceDataFilters", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserDataFilters: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityUserDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Setting for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilterSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilters: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all workspaces and related workspace data filters (and their settings / values).
         * @summary Get workspace data filters for all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDataFiltersLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/workspaceDataFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterPatchDocument} jsonApiUserDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserDataFilters: async (workspaceId, objectId, jsonApiUserDataFilterPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityUserDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiUserDataFilterPatchDocument' is not null or undefined
            assertParamExists("patchEntityUserDataFilters", "jsonApiUserDataFilterPatchDocument", jsonApiUserDataFilterPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserDataFilterPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserDataFilterPatchDocument !== undefined
                    ? jsonApiUserDataFilterPatchDocument
                    : {})
                : jsonApiUserDataFilterPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingPatchDocument} jsonApiWorkspaceDataFilterSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, jsonApiWorkspaceDataFilterSettingPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilterSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilterSettings", "jsonApiWorkspaceDataFilterSettingPatchDocument", jsonApiWorkspaceDataFilterSettingPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterSettingPatchDocument !== undefined
                    ? jsonApiWorkspaceDataFilterSettingPatchDocument
                    : {})
                : jsonApiWorkspaceDataFilterSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterPatchDocument} jsonApiWorkspaceDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilters: async (workspaceId, objectId, jsonApiWorkspaceDataFilterPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterPatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilters", "jsonApiWorkspaceDataFilterPatchDocument", jsonApiWorkspaceDataFilterPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterPatchDocument !== undefined
                    ? jsonApiWorkspaceDataFilterPatchDocument
                    : {})
                : jsonApiWorkspaceDataFilterPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets workspace data filters in all workspaces in entire organization.
         * @summary Set all workspace data filters
         * @param {DeclarativeWorkspaceDataFilters} declarativeWorkspaceDataFilters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspaceDataFiltersLayout: async (declarativeWorkspaceDataFilters, options = {}) => {
            // verify required parameter 'declarativeWorkspaceDataFilters' is not null or undefined
            assertParamExists("setWorkspaceDataFiltersLayout", "declarativeWorkspaceDataFilters", declarativeWorkspaceDataFilters);
            const localVarPath = `/api/v1/layout/workspaceDataFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeWorkspaceDataFilters !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeWorkspaceDataFilters !== undefined ? declarativeWorkspaceDataFilters : {})
                : declarativeWorkspaceDataFilters || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterInDocument} jsonApiUserDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserDataFilters: async (workspaceId, objectId, jsonApiUserDataFilterInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityUserDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiUserDataFilterInDocument' is not null or undefined
            assertParamExists("updateEntityUserDataFilters", "jsonApiUserDataFilterInDocument", jsonApiUserDataFilterInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserDataFilterInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserDataFilterInDocument !== undefined ? jsonApiUserDataFilterInDocument : {})
                : jsonApiUserDataFilterInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, jsonApiWorkspaceDataFilterSettingInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilterSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterSettingInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilterSettings", "jsonApiWorkspaceDataFilterSettingInDocument", jsonApiWorkspaceDataFilterSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterSettingInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterSettingInDocument
                    : {})
                : jsonApiWorkspaceDataFilterSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilters: async (workspaceId, objectId, jsonApiWorkspaceDataFilterInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilters", "jsonApiWorkspaceDataFilterInDocument", jsonApiWorkspaceDataFilterInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterInDocument
                    : {})
                : jsonApiWorkspaceDataFilterInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DataFiltersApi - functional programming interface
 * @export
 */
export const DataFiltersApiFp = function (configuration) {
    const localVarAxiosParamCreator = DataFiltersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post User Data Filters
         * @param {string} workspaceId
         * @param {JsonApiUserDataFilterPostOptionalIdDocument} jsonApiUserDataFilterPostOptionalIdDocument
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUserDataFilters(workspaceId, jsonApiUserDataFilterPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUserDataFilters(workspaceId, jsonApiUserDataFilterPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaceDataFilterSettings(workspaceId, jsonApiWorkspaceDataFilterSettingInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaceDataFilterSettings(workspaceId, jsonApiWorkspaceDataFilterSettingInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaceDataFilters(workspaceId, jsonApiWorkspaceDataFilterInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaceDataFilters(workspaceId, jsonApiWorkspaceDataFilterInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUserDataFilters(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUserDataFilters(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaceDataFilters(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaceDataFilters(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all User Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaceDataFilterSettings(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaceDataFilterSettings(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaceDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaceDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Setting for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaceDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaceDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all workspaces and related workspace data filters (and their settings / values).
         * @summary Get workspace data filters for all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceDataFiltersLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceDataFiltersLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterPatchDocument} jsonApiUserDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingPatchDocument} jsonApiWorkspaceDataFilterSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterPatchDocument} jsonApiWorkspaceDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets workspace data filters in all workspaces in entire organization.
         * @summary Set all workspace data filters
         * @param {DeclarativeWorkspaceDataFilters} declarativeWorkspaceDataFilters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWorkspaceDataFiltersLayout(declarativeWorkspaceDataFilters, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWorkspaceDataFiltersLayout(declarativeWorkspaceDataFilters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterInDocument} jsonApiUserDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DataFiltersApi - factory interface
 * @export
 */
export const DataFiltersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DataFiltersApiFp(configuration);
    return {
        /**
         *
         * @summary Post User Data Filters
         * @param {DataFiltersApiCreateEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .createEntityUserDataFilters(requestParameters.workspaceId, requestParameters.jsonApiUserDataFilterPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Settings for Workspace Data Filters
         * @param {DataFiltersApiCreateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Workspace Data Filters
         * @param {DataFiltersApiCreateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a User Data Filter
         * @param {DataFiltersApiDeleteEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .deleteEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Settings for Workspace Data Filter
         * @param {DataFiltersApiDeleteEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Workspace Data Filter
         * @param {DataFiltersApiDeleteEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all User Data Filters
         * @param {DataFiltersApiGetAllEntitiesUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserDataFilters(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Settings for Workspace Data Filters
         * @param {DataFiltersApiGetAllEntitiesWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Workspace Data Filters
         * @param {DataFiltersApiGetAllEntitiesWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a User Data Filter
         * @param {DataFiltersApiGetEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .getEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Setting for Workspace Data Filter
         * @param {DataFiltersApiGetEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Workspace Data Filter
         * @param {DataFiltersApiGetEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all workspaces and related workspace data filters (and their settings / values).
         * @summary Get workspace data filters for all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDataFiltersLayout(options) {
            return localVarFp
                .getWorkspaceDataFiltersLayout(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a User Data Filter
         * @param {DataFiltersApiPatchEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .patchEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Settings for Workspace Data Filter
         * @param {DataFiltersApiPatchEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Workspace Data Filter
         * @param {DataFiltersApiPatchEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets workspace data filters in all workspaces in entire organization.
         * @summary Set all workspace data filters
         * @param {DataFiltersApiSetWorkspaceDataFiltersLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspaceDataFiltersLayout(requestParameters, options) {
            return localVarFp
                .setWorkspaceDataFiltersLayout(requestParameters.declarativeWorkspaceDataFilters, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a User Data Filter
         * @param {DataFiltersApiUpdateEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .updateEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Settings for Workspace Data Filter
         * @param {DataFiltersApiUpdateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Workspace Data Filter
         * @param {DataFiltersApiUpdateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DataFiltersApi - object-oriented interface
 * @export
 * @class DataFiltersApi
 * @extends {BaseAPI}
 */
export class DataFiltersApi extends BaseAPI {
    /**
     *
     * @summary Post User Data Filters
     * @param {DataFiltersApiCreateEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    createEntityUserDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .createEntityUserDataFilters(requestParameters.workspaceId, requestParameters.jsonApiUserDataFilterPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Settings for Workspace Data Filters
     * @param {DataFiltersApiCreateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    createEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .createEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Workspace Data Filters
     * @param {DataFiltersApiCreateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    createEntityWorkspaceDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .createEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a User Data Filter
     * @param {DataFiltersApiDeleteEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    deleteEntityUserDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .deleteEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Settings for Workspace Data Filter
     * @param {DataFiltersApiDeleteEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    deleteEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .deleteEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Workspace Data Filter
     * @param {DataFiltersApiDeleteEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    deleteEntityWorkspaceDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .deleteEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all User Data Filters
     * @param {DataFiltersApiGetAllEntitiesUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    getAllEntitiesUserDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .getAllEntitiesUserDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Settings for Workspace Data Filters
     * @param {DataFiltersApiGetAllEntitiesWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    getAllEntitiesWorkspaceDataFilterSettings(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .getAllEntitiesWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Workspace Data Filters
     * @param {DataFiltersApiGetAllEntitiesWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    getAllEntitiesWorkspaceDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .getAllEntitiesWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a User Data Filter
     * @param {DataFiltersApiGetEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    getEntityUserDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .getEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Setting for Workspace Data Filter
     * @param {DataFiltersApiGetEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    getEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .getEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Workspace Data Filter
     * @param {DataFiltersApiGetEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    getEntityWorkspaceDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .getEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all workspaces and related workspace data filters (and their settings / values).
     * @summary Get workspace data filters for all workspaces
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    getWorkspaceDataFiltersLayout(options) {
        return DataFiltersApiFp(this.configuration)
            .getWorkspaceDataFiltersLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a User Data Filter
     * @param {DataFiltersApiPatchEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    patchEntityUserDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .patchEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Settings for Workspace Data Filter
     * @param {DataFiltersApiPatchEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    patchEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .patchEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Workspace Data Filter
     * @param {DataFiltersApiPatchEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    patchEntityWorkspaceDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .patchEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets workspace data filters in all workspaces in entire organization.
     * @summary Set all workspace data filters
     * @param {DataFiltersApiSetWorkspaceDataFiltersLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    setWorkspaceDataFiltersLayout(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .setWorkspaceDataFiltersLayout(requestParameters.declarativeWorkspaceDataFilters, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a User Data Filter
     * @param {DataFiltersApiUpdateEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    updateEntityUserDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .updateEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Settings for Workspace Data Filter
     * @param {DataFiltersApiUpdateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    updateEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .updateEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Workspace Data Filter
     * @param {DataFiltersApiUpdateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataFiltersApi
     */
    updateEntityWorkspaceDataFilters(requestParameters, options) {
        return DataFiltersApiFp(this.configuration)
            .updateEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DataSourceDeclarativeAPIsApi - axios parameter creator
 * @export
 */
export const DataSourceDeclarativeAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve all data sources including related physical model.
         * @summary Get all data sources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcesLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set all data sources including related physical model.
         * @summary Put all data sources
         * @param {DeclarativeDataSources} declarativeDataSources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDataSourcesLayout: async (declarativeDataSources, options = {}) => {
            // verify required parameter 'declarativeDataSources' is not null or undefined
            assertParamExists("putDataSourcesLayout", "declarativeDataSources", declarativeDataSources);
            const localVarPath = `/api/v1/layout/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeDataSources !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeDataSources !== undefined ? declarativeDataSources : {})
                : declarativeDataSources || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DataSourceDeclarativeAPIsApi - functional programming interface
 * @export
 */
export const DataSourceDeclarativeAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DataSourceDeclarativeAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve all data sources including related physical model.
         * @summary Get all data sources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourcesLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourcesLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set all data sources including related physical model.
         * @summary Put all data sources
         * @param {DeclarativeDataSources} declarativeDataSources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDataSourcesLayout(declarativeDataSources, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDataSourcesLayout(declarativeDataSources, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DataSourceDeclarativeAPIsApi - factory interface
 * @export
 */
export const DataSourceDeclarativeAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DataSourceDeclarativeAPIsApiFp(configuration);
    return {
        /**
         * Retrieve all data sources including related physical model.
         * @summary Get all data sources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcesLayout(options) {
            return localVarFp.getDataSourcesLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * Set all data sources including related physical model.
         * @summary Put all data sources
         * @param {DataSourceDeclarativeAPIsApiPutDataSourcesLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDataSourcesLayout(requestParameters, options) {
            return localVarFp
                .putDataSourcesLayout(requestParameters.declarativeDataSources, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DataSourceDeclarativeAPIsApi - object-oriented interface
 * @export
 * @class DataSourceDeclarativeAPIsApi
 * @extends {BaseAPI}
 */
export class DataSourceDeclarativeAPIsApi extends BaseAPI {
    /**
     * Retrieve all data sources including related physical model.
     * @summary Get all data sources
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceDeclarativeAPIsApi
     */
    getDataSourcesLayout(options) {
        return DataSourceDeclarativeAPIsApiFp(this.configuration)
            .getDataSourcesLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set all data sources including related physical model.
     * @summary Put all data sources
     * @param {DataSourceDeclarativeAPIsApiPutDataSourcesLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceDeclarativeAPIsApi
     */
    putDataSourcesLayout(requestParameters, options) {
        return DataSourceDeclarativeAPIsApiFp(this.configuration)
            .putDataSourcesLayout(requestParameters.declarativeDataSources, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DataSourceEntityAPIsApi - axios parameter creator
 * @export
 */
export const DataSourceEntityAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Data Source - represents data source for the workspace
         * @summary Post Data Sources
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDataSources: async (jsonApiDataSourceInDocument, metaInclude, options = {}) => {
            // verify required parameter 'jsonApiDataSourceInDocument' is not null or undefined
            assertParamExists("createEntityDataSources", "jsonApiDataSourceInDocument", jsonApiDataSourceInDocument);
            const localVarPath = `/api/v1/entities/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDataSourceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDataSourceInDocument !== undefined ? jsonApiDataSourceInDocument : {})
                : jsonApiDataSourceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Delete Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDataSources: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityDataSources", "id", id);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Data Source Identifiers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSourceIdentifiers: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/dataSourceIdentifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSources: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Data Source Identifier
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSourceIdentifiers: async (id, filter, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityDataSourceIdentifiers", "id", id);
            const localVarPath = `/api/v1/entities/dataSourceIdentifiers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSources: async (id, filter, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityDataSources", "id", id);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Patch Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourcePatchDocument} jsonApiDataSourcePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDataSources: async (id, jsonApiDataSourcePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityDataSources", "id", id);
            // verify required parameter 'jsonApiDataSourcePatchDocument' is not null or undefined
            assertParamExists("patchEntityDataSources", "jsonApiDataSourcePatchDocument", jsonApiDataSourcePatchDocument);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDataSourcePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDataSourcePatchDocument !== undefined ? jsonApiDataSourcePatchDocument : {})
                : jsonApiDataSourcePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Put Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDataSources: async (id, jsonApiDataSourceInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityDataSources", "id", id);
            // verify required parameter 'jsonApiDataSourceInDocument' is not null or undefined
            assertParamExists("updateEntityDataSources", "jsonApiDataSourceInDocument", jsonApiDataSourceInDocument);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDataSourceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDataSourceInDocument !== undefined ? jsonApiDataSourceInDocument : {})
                : jsonApiDataSourceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DataSourceEntityAPIsApi - functional programming interface
 * @export
 */
export const DataSourceEntityAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DataSourceEntityAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * Data Source - represents data source for the workspace
         * @summary Post Data Sources
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityDataSources(jsonApiDataSourceInDocument, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityDataSources(jsonApiDataSourceInDocument, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Delete Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityDataSources(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityDataSources(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Data Source Identifiers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDataSourceIdentifiers(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDataSourceIdentifiers(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDataSources(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDataSources(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Data Source Identifier
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDataSourceIdentifiers(id, filter, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDataSourceIdentifiers(id, filter, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDataSources(id, filter, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDataSources(id, filter, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Patch Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourcePatchDocument} jsonApiDataSourcePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityDataSources(id, jsonApiDataSourcePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityDataSources(id, jsonApiDataSourcePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Put Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityDataSources(id, jsonApiDataSourceInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityDataSources(id, jsonApiDataSourceInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DataSourceEntityAPIsApi - factory interface
 * @export
 */
export const DataSourceEntityAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DataSourceEntityAPIsApiFp(configuration);
    return {
        /**
         * Data Source - represents data source for the workspace
         * @summary Post Data Sources
         * @param {DataSourceEntityAPIsApiCreateEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDataSources(requestParameters, options) {
            return localVarFp
                .createEntityDataSources(requestParameters.jsonApiDataSourceInDocument, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Delete Data Source entity
         * @param {DataSourceEntityAPIsApiDeleteEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDataSources(requestParameters, options) {
            return localVarFp
                .deleteEntityDataSources(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Data Source Identifiers
         * @param {DataSourceEntityAPIsApiGetAllEntitiesDataSourceIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSourceIdentifiers(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDataSourceIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entities
         * @param {DataSourceEntityAPIsApiGetAllEntitiesDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSources(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDataSources(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Data Source Identifier
         * @param {DataSourceEntityAPIsApiGetEntityDataSourceIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSourceIdentifiers(requestParameters, options) {
            return localVarFp
                .getEntityDataSourceIdentifiers(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entity
         * @param {DataSourceEntityAPIsApiGetEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSources(requestParameters, options) {
            return localVarFp
                .getEntityDataSources(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Patch Data Source entity
         * @param {DataSourceEntityAPIsApiPatchEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDataSources(requestParameters, options) {
            return localVarFp
                .patchEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourcePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Put Data Source entity
         * @param {DataSourceEntityAPIsApiUpdateEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDataSources(requestParameters, options) {
            return localVarFp
                .updateEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourceInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DataSourceEntityAPIsApi - object-oriented interface
 * @export
 * @class DataSourceEntityAPIsApi
 * @extends {BaseAPI}
 */
export class DataSourceEntityAPIsApi extends BaseAPI {
    /**
     * Data Source - represents data source for the workspace
     * @summary Post Data Sources
     * @param {DataSourceEntityAPIsApiCreateEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceEntityAPIsApi
     */
    createEntityDataSources(requestParameters, options) {
        return DataSourceEntityAPIsApiFp(this.configuration)
            .createEntityDataSources(requestParameters.jsonApiDataSourceInDocument, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Delete Data Source entity
     * @param {DataSourceEntityAPIsApiDeleteEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceEntityAPIsApi
     */
    deleteEntityDataSources(requestParameters, options) {
        return DataSourceEntityAPIsApiFp(this.configuration)
            .deleteEntityDataSources(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Data Source Identifiers
     * @param {DataSourceEntityAPIsApiGetAllEntitiesDataSourceIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceEntityAPIsApi
     */
    getAllEntitiesDataSourceIdentifiers(requestParameters = {}, options) {
        return DataSourceEntityAPIsApiFp(this.configuration)
            .getAllEntitiesDataSourceIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Get Data Source entities
     * @param {DataSourceEntityAPIsApiGetAllEntitiesDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceEntityAPIsApi
     */
    getAllEntitiesDataSources(requestParameters = {}, options) {
        return DataSourceEntityAPIsApiFp(this.configuration)
            .getAllEntitiesDataSources(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Data Source Identifier
     * @param {DataSourceEntityAPIsApiGetEntityDataSourceIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceEntityAPIsApi
     */
    getEntityDataSourceIdentifiers(requestParameters, options) {
        return DataSourceEntityAPIsApiFp(this.configuration)
            .getEntityDataSourceIdentifiers(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Get Data Source entity
     * @param {DataSourceEntityAPIsApiGetEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceEntityAPIsApi
     */
    getEntityDataSources(requestParameters, options) {
        return DataSourceEntityAPIsApiFp(this.configuration)
            .getEntityDataSources(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Patch Data Source entity
     * @param {DataSourceEntityAPIsApiPatchEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceEntityAPIsApi
     */
    patchEntityDataSources(requestParameters, options) {
        return DataSourceEntityAPIsApiFp(this.configuration)
            .patchEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourcePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Put Data Source entity
     * @param {DataSourceEntityAPIsApiUpdateEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceEntityAPIsApi
     */
    updateEntityDataSources(requestParameters, options) {
        return DataSourceEntityAPIsApiFp(this.configuration)
            .updateEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourceInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DatasetsApi - axios parameter creator
 * @export
 */
export const DatasetsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all Datasets
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDatasets: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesDatasets", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/datasets`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Dataset
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDatasets: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityDatasets", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityDatasets", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/datasets/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DatasetsApi - functional programming interface
 * @export
 */
export const DatasetsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DatasetsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all Datasets
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDatasets(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDatasets(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Dataset
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDatasets(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDatasets(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DatasetsApi - factory interface
 * @export
 */
export const DatasetsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DatasetsApiFp(configuration);
    return {
        /**
         *
         * @summary Get all Datasets
         * @param {DatasetsApiGetAllEntitiesDatasetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDatasets(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDatasets(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Dataset
         * @param {DatasetsApiGetEntityDatasetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDatasets(requestParameters, options) {
            return localVarFp
                .getEntityDatasets(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DatasetsApi - object-oriented interface
 * @export
 * @class DatasetsApi
 * @extends {BaseAPI}
 */
export class DatasetsApi extends BaseAPI {
    /**
     *
     * @summary Get all Datasets
     * @param {DatasetsApiGetAllEntitiesDatasetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    getAllEntitiesDatasets(requestParameters, options) {
        return DatasetsApiFp(this.configuration)
            .getAllEntitiesDatasets(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Dataset
     * @param {DatasetsApiGetEntityDatasetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    getEntityDatasets(requestParameters, options) {
        return DatasetsApiFp(this.configuration)
            .getEntityDatasets(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DependencyGraphApi - axios parameter creator
 * @export
 */
export const DependencyGraphApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Computes the dependent entities graph
         * @summary Computes the dependent entities graph
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependentEntitiesGraph: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getDependentEntitiesGraph", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/dependentEntitiesGraph`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Computes the dependent entities graph from given entry points
         * @summary Computes the dependent entities graph from given entry points
         * @param {string} workspaceId
         * @param {DependentEntitiesRequest} dependentEntitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependentEntitiesGraphFromEntryPoints: async (workspaceId, dependentEntitiesRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getDependentEntitiesGraphFromEntryPoints", "workspaceId", workspaceId);
            // verify required parameter 'dependentEntitiesRequest' is not null or undefined
            assertParamExists("getDependentEntitiesGraphFromEntryPoints", "dependentEntitiesRequest", dependentEntitiesRequest);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/dependentEntitiesGraph`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof dependentEntitiesRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(dependentEntitiesRequest !== undefined ? dependentEntitiesRequest : {})
                : dependentEntitiesRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DependencyGraphApi - functional programming interface
 * @export
 */
export const DependencyGraphApiFp = function (configuration) {
    const localVarAxiosParamCreator = DependencyGraphApiAxiosParamCreator(configuration);
    return {
        /**
         * Computes the dependent entities graph
         * @summary Computes the dependent entities graph
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDependentEntitiesGraph(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDependentEntitiesGraph(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Computes the dependent entities graph from given entry points
         * @summary Computes the dependent entities graph from given entry points
         * @param {string} workspaceId
         * @param {DependentEntitiesRequest} dependentEntitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDependentEntitiesGraphFromEntryPoints(workspaceId, dependentEntitiesRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDependentEntitiesGraphFromEntryPoints(workspaceId, dependentEntitiesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DependencyGraphApi - factory interface
 * @export
 */
export const DependencyGraphApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DependencyGraphApiFp(configuration);
    return {
        /**
         * Computes the dependent entities graph
         * @summary Computes the dependent entities graph
         * @param {DependencyGraphApiGetDependentEntitiesGraphRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependentEntitiesGraph(requestParameters, options) {
            return localVarFp
                .getDependentEntitiesGraph(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Computes the dependent entities graph from given entry points
         * @summary Computes the dependent entities graph from given entry points
         * @param {DependencyGraphApiGetDependentEntitiesGraphFromEntryPointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDependentEntitiesGraphFromEntryPoints(requestParameters, options) {
            return localVarFp
                .getDependentEntitiesGraphFromEntryPoints(requestParameters.workspaceId, requestParameters.dependentEntitiesRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * DependencyGraphApi - object-oriented interface
 * @export
 * @class DependencyGraphApi
 * @extends {BaseAPI}
 */
export class DependencyGraphApi extends BaseAPI {
    /**
     * Computes the dependent entities graph
     * @summary Computes the dependent entities graph
     * @param {DependencyGraphApiGetDependentEntitiesGraphRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DependencyGraphApi
     */
    getDependentEntitiesGraph(requestParameters, options) {
        return DependencyGraphApiFp(this.configuration)
            .getDependentEntitiesGraph(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Computes the dependent entities graph from given entry points
     * @summary Computes the dependent entities graph from given entry points
     * @param {DependencyGraphApiGetDependentEntitiesGraphFromEntryPointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DependencyGraphApi
     */
    getDependentEntitiesGraphFromEntryPoints(requestParameters, options) {
        return DependencyGraphApiFp(this.configuration)
            .getDependentEntitiesGraphFromEntryPoints(requestParameters.workspaceId, requestParameters.dependentEntitiesRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EntitiesApi - axios parameter creator
 * @export
 */
export const EntitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Dashboards
         * @param {string} workspaceId
         * @param {JsonApiAnalyticalDashboardPostOptionalIdDocument} jsonApiAnalyticalDashboardPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAnalyticalDashboards: async (workspaceId, jsonApiAnalyticalDashboardPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiAnalyticalDashboardPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityAnalyticalDashboards", "jsonApiAnalyticalDashboardPostOptionalIdDocument", jsonApiAnalyticalDashboardPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAnalyticalDashboardPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAnalyticalDashboardPostOptionalIdDocument !== undefined
                    ? jsonApiAnalyticalDashboardPostOptionalIdDocument
                    : {})
                : jsonApiAnalyticalDashboardPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post a new API token for the user
         * @param {string} userId
         * @param {JsonApiApiTokenInDocument} jsonApiApiTokenInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityApiTokens: async (userId, jsonApiApiTokenInDocument, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("createEntityApiTokens", "userId", userId);
            // verify required parameter 'jsonApiApiTokenInDocument' is not null or undefined
            assertParamExists("createEntityApiTokens", "jsonApiApiTokenInDocument", jsonApiApiTokenInDocument);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiApiTokenInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiApiTokenInDocument !== undefined ? jsonApiApiTokenInDocument : {})
                : jsonApiApiTokenInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Attribute Hierarchies
         * @param {string} workspaceId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAttributeHierarchies: async (workspaceId, jsonApiAttributeHierarchyInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiAttributeHierarchyInDocument' is not null or undefined
            assertParamExists("createEntityAttributeHierarchies", "jsonApiAttributeHierarchyInDocument", jsonApiAttributeHierarchyInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAttributeHierarchyInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAttributeHierarchyInDocument !== undefined
                    ? jsonApiAttributeHierarchyInDocument
                    : {})
                : jsonApiAttributeHierarchyInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Automations
         * @param {string} workspaceId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAutomations: async (workspaceId, jsonApiAutomationInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiAutomationInDocument' is not null or undefined
            assertParamExists("createEntityAutomations", "jsonApiAutomationInDocument", jsonApiAutomationInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAutomationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAutomationInDocument !== undefined ? jsonApiAutomationInDocument : {})
                : jsonApiAutomationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Color Pallettes
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityColorPalettes: async (jsonApiColorPaletteInDocument, options = {}) => {
            // verify required parameter 'jsonApiColorPaletteInDocument' is not null or undefined
            assertParamExists("createEntityColorPalettes", "jsonApiColorPaletteInDocument", jsonApiColorPaletteInDocument);
            const localVarPath = `/api/v1/entities/colorPalettes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiColorPaletteInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiColorPaletteInDocument !== undefined ? jsonApiColorPaletteInDocument : {})
                : jsonApiColorPaletteInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Post CSP Directives
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCspDirectives: async (jsonApiCspDirectiveInDocument, options = {}) => {
            // verify required parameter 'jsonApiCspDirectiveInDocument' is not null or undefined
            assertParamExists("createEntityCspDirectives", "jsonApiCspDirectiveInDocument", jsonApiCspDirectiveInDocument);
            const localVarPath = `/api/v1/entities/cspDirectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCspDirectiveInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCspDirectiveInDocument !== undefined ? jsonApiCspDirectiveInDocument : {})
                : jsonApiCspDirectiveInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Custom Application Settings
         * @param {string} workspaceId
         * @param {JsonApiCustomApplicationSettingPostOptionalIdDocument} jsonApiCustomApplicationSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCustomApplicationSettings: async (workspaceId, jsonApiCustomApplicationSettingPostOptionalIdDocument, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiCustomApplicationSettingPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityCustomApplicationSettings", "jsonApiCustomApplicationSettingPostOptionalIdDocument", jsonApiCustomApplicationSettingPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCustomApplicationSettingPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCustomApplicationSettingPostOptionalIdDocument !== undefined
                    ? jsonApiCustomApplicationSettingPostOptionalIdDocument
                    : {})
                : jsonApiCustomApplicationSettingPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Plugins
         * @param {string} workspaceId
         * @param {JsonApiDashboardPluginPostOptionalIdDocument} jsonApiDashboardPluginPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDashboardPlugins: async (workspaceId, jsonApiDashboardPluginPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiDashboardPluginPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityDashboardPlugins", "jsonApiDashboardPluginPostOptionalIdDocument", jsonApiDashboardPluginPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDashboardPluginPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDashboardPluginPostOptionalIdDocument !== undefined
                    ? jsonApiDashboardPluginPostOptionalIdDocument
                    : {})
                : jsonApiDashboardPluginPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Post Data Sources
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDataSources: async (jsonApiDataSourceInDocument, metaInclude, options = {}) => {
            // verify required parameter 'jsonApiDataSourceInDocument' is not null or undefined
            assertParamExists("createEntityDataSources", "jsonApiDataSourceInDocument", jsonApiDataSourceInDocument);
            const localVarPath = `/api/v1/entities/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDataSourceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDataSourceInDocument !== undefined ? jsonApiDataSourceInDocument : {})
                : jsonApiDataSourceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Export Definitions
         * @param {string} workspaceId
         * @param {JsonApiExportDefinitionPostOptionalIdDocument} jsonApiExportDefinitionPostOptionalIdDocument
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityExportDefinitions: async (workspaceId, jsonApiExportDefinitionPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiExportDefinitionPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityExportDefinitions", "jsonApiExportDefinitionPostOptionalIdDocument", jsonApiExportDefinitionPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiExportDefinitionPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiExportDefinitionPostOptionalIdDocument !== undefined
                    ? jsonApiExportDefinitionPostOptionalIdDocument
                    : {})
                : jsonApiExportDefinitionPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Context Filters
         * @param {string} workspaceId
         * @param {JsonApiFilterContextPostOptionalIdDocument} jsonApiFilterContextPostOptionalIdDocument
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterContexts: async (workspaceId, jsonApiFilterContextPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiFilterContextPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityFilterContexts", "jsonApiFilterContextPostOptionalIdDocument", jsonApiFilterContextPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterContextPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterContextPostOptionalIdDocument !== undefined
                    ? jsonApiFilterContextPostOptionalIdDocument
                    : {})
                : jsonApiFilterContextPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Filter views
         * @param {string} workspaceId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterViews: async (workspaceId, jsonApiFilterViewInDocument, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiFilterViewInDocument' is not null or undefined
            assertParamExists("createEntityFilterViews", "jsonApiFilterViewInDocument", jsonApiFilterViewInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterViewInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterViewInDocument !== undefined ? jsonApiFilterViewInDocument : {})
                : jsonApiFilterViewInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Identity Providers
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityIdentityProviders: async (jsonApiIdentityProviderInDocument, options = {}) => {
            // verify required parameter 'jsonApiIdentityProviderInDocument' is not null or undefined
            assertParamExists("createEntityIdentityProviders", "jsonApiIdentityProviderInDocument", jsonApiIdentityProviderInDocument);
            const localVarPath = `/api/v1/entities/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiIdentityProviderInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiIdentityProviderInDocument !== undefined
                    ? jsonApiIdentityProviderInDocument
                    : {})
                : jsonApiIdentityProviderInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Post Jwks
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityJwks: async (jsonApiJwkInDocument, options = {}) => {
            // verify required parameter 'jsonApiJwkInDocument' is not null or undefined
            assertParamExists("createEntityJwks", "jsonApiJwkInDocument", jsonApiJwkInDocument);
            const localVarPath = `/api/v1/entities/jwks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiJwkInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiJwkInDocument !== undefined ? jsonApiJwkInDocument : {})
                : jsonApiJwkInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post LLM endpoint entities
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityLlmEndpoints: async (jsonApiLlmEndpointInDocument, options = {}) => {
            // verify required parameter 'jsonApiLlmEndpointInDocument' is not null or undefined
            assertParamExists("createEntityLlmEndpoints", "jsonApiLlmEndpointInDocument", jsonApiLlmEndpointInDocument);
            const localVarPath = `/api/v1/entities/llmEndpoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiLlmEndpointInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiLlmEndpointInDocument !== undefined ? jsonApiLlmEndpointInDocument : {})
                : jsonApiLlmEndpointInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Metrics
         * @param {string} workspaceId
         * @param {JsonApiMetricPostOptionalIdDocument} jsonApiMetricPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityMetrics: async (workspaceId, jsonApiMetricPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiMetricPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityMetrics", "jsonApiMetricPostOptionalIdDocument", jsonApiMetricPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiMetricPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiMetricPostOptionalIdDocument !== undefined
                    ? jsonApiMetricPostOptionalIdDocument
                    : {})
                : jsonApiMetricPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Notification Channel entities
         * @param {JsonApiNotificationChannelPostOptionalIdDocument} jsonApiNotificationChannelPostOptionalIdDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityNotificationChannels: async (jsonApiNotificationChannelPostOptionalIdDocument, options = {}) => {
            // verify required parameter 'jsonApiNotificationChannelPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityNotificationChannels", "jsonApiNotificationChannelPostOptionalIdDocument", jsonApiNotificationChannelPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiNotificationChannelPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiNotificationChannelPostOptionalIdDocument !== undefined
                    ? jsonApiNotificationChannelPostOptionalIdDocument
                    : {})
                : jsonApiNotificationChannelPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Organization Setting entities
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityOrganizationSettings: async (jsonApiOrganizationSettingInDocument, options = {}) => {
            // verify required parameter 'jsonApiOrganizationSettingInDocument' is not null or undefined
            assertParamExists("createEntityOrganizationSettings", "jsonApiOrganizationSettingInDocument", jsonApiOrganizationSettingInDocument);
            const localVarPath = `/api/v1/entities/organizationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationSettingInDocument !== undefined
                    ? jsonApiOrganizationSettingInDocument
                    : {})
                : jsonApiOrganizationSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Theming
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityThemes: async (jsonApiThemeInDocument, options = {}) => {
            // verify required parameter 'jsonApiThemeInDocument' is not null or undefined
            assertParamExists("createEntityThemes", "jsonApiThemeInDocument", jsonApiThemeInDocument);
            const localVarPath = `/api/v1/entities/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiThemeInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiThemeInDocument !== undefined ? jsonApiThemeInDocument : {})
                : jsonApiThemeInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post User Data Filters
         * @param {string} workspaceId
         * @param {JsonApiUserDataFilterPostOptionalIdDocument} jsonApiUserDataFilterPostOptionalIdDocument
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserDataFilters: async (workspaceId, jsonApiUserDataFilterPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiUserDataFilterPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityUserDataFilters", "jsonApiUserDataFilterPostOptionalIdDocument", jsonApiUserDataFilterPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserDataFilterPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserDataFilterPostOptionalIdDocument !== undefined
                    ? jsonApiUserDataFilterPostOptionalIdDocument
                    : {})
                : jsonApiUserDataFilterPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Post User Group entities
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserGroups: async (jsonApiUserGroupInDocument, include, options = {}) => {
            // verify required parameter 'jsonApiUserGroupInDocument' is not null or undefined
            assertParamExists("createEntityUserGroups", "jsonApiUserGroupInDocument", jsonApiUserGroupInDocument);
            const localVarPath = `/api/v1/entities/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserGroupInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserGroupInDocument !== undefined ? jsonApiUserGroupInDocument : {})
                : jsonApiUserGroupInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post new user settings for the user
         * @param {string} userId
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserSettings: async (userId, jsonApiUserSettingInDocument, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("createEntityUserSettings", "userId", userId);
            // verify required parameter 'jsonApiUserSettingInDocument' is not null or undefined
            assertParamExists("createEntityUserSettings", "jsonApiUserSettingInDocument", jsonApiUserSettingInDocument);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserSettingInDocument !== undefined ? jsonApiUserSettingInDocument : {})
                : jsonApiUserSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Post User entities
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUsers: async (jsonApiUserInDocument, include, options = {}) => {
            // verify required parameter 'jsonApiUserInDocument' is not null or undefined
            assertParamExists("createEntityUsers", "jsonApiUserInDocument", jsonApiUserInDocument);
            const localVarPath = `/api/v1/entities/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserInDocument !== undefined ? jsonApiUserInDocument : {})
                : jsonApiUserInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Visualization Objects
         * @param {string} workspaceId
         * @param {JsonApiVisualizationObjectPostOptionalIdDocument} jsonApiVisualizationObjectPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityVisualizationObjects: async (workspaceId, jsonApiVisualizationObjectPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiVisualizationObjectPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityVisualizationObjects", "jsonApiVisualizationObjectPostOptionalIdDocument", jsonApiVisualizationObjectPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiVisualizationObjectPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiVisualizationObjectPostOptionalIdDocument !== undefined
                    ? jsonApiVisualizationObjectPostOptionalIdDocument
                    : {})
                : jsonApiVisualizationObjectPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilterSettings: async (workspaceId, jsonApiWorkspaceDataFilterSettingInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiWorkspaceDataFilterSettingInDocument' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilterSettings", "jsonApiWorkspaceDataFilterSettingInDocument", jsonApiWorkspaceDataFilterSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterSettingInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterSettingInDocument
                    : {})
                : jsonApiWorkspaceDataFilterSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilters: async (workspaceId, jsonApiWorkspaceDataFilterInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiWorkspaceDataFilterInDocument' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilters", "jsonApiWorkspaceDataFilterInDocument", jsonApiWorkspaceDataFilterInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterInDocument
                    : {})
                : jsonApiWorkspaceDataFilterInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Settings for Workspaces
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceSettingPostOptionalIdDocument} jsonApiWorkspaceSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceSettings: async (workspaceId, jsonApiWorkspaceSettingPostOptionalIdDocument, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiWorkspaceSettingPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityWorkspaceSettings", "jsonApiWorkspaceSettingPostOptionalIdDocument", jsonApiWorkspaceSettingPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceSettingPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceSettingPostOptionalIdDocument !== undefined
                    ? jsonApiWorkspaceSettingPostOptionalIdDocument
                    : {})
                : jsonApiWorkspaceSettingPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Post Workspace entities
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaces: async (jsonApiWorkspaceInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'jsonApiWorkspaceInDocument' is not null or undefined
            assertParamExists("createEntityWorkspaces", "jsonApiWorkspaceInDocument", jsonApiWorkspaceInDocument);
            const localVarPath = `/api/v1/entities/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceInDocument !== undefined ? jsonApiWorkspaceInDocument : {})
                : jsonApiWorkspaceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAnalyticalDashboards: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityAnalyticalDashboards", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityApiTokens: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("deleteEntityApiTokens", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityApiTokens", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAttributeHierarchies: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityAttributeHierarchies", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAutomations: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityAutomations", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityColorPalettes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityColorPalettes", "id", id);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Delete CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCspDirectives: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityCspDirectives", "id", id);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCustomApplicationSettings: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityCustomApplicationSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDashboardPlugins: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityDashboardPlugins", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Delete Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDataSources: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityDataSources", "id", id);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityExportDefinitions: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityExportDefinitions", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterContexts: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityFilterContexts", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterViews: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityFilterViews", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityIdentityProviders: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityIdentityProviders", "id", id);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Delete Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityJwks: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityJwks", "id", id);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityLlmEndpoints: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityLlmEndpoints", "id", id);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityMetrics: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityMetrics", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityNotificationChannels: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityNotificationChannels", "id", id);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityOrganizationSettings: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityOrganizationSettings", "id", id);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityThemes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityThemes", "id", id);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserDataFilters: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityUserDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Delete UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserGroups: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityUserGroups", "id", id);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserSettings: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("deleteEntityUserSettings", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityUserSettings", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Delete User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUsers: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityUsers", "id", id);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityVisualizationObjects: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityVisualizationObjects", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilterSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilters: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceSettings: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Delete Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaces: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityWorkspaces", "id", id);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Dashboards
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAnalyticalDashboards: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAnalyticalDashboards", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all api tokens for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesApiTokens: async (userId, filter, page, size, sort, metaInclude, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getAllEntitiesApiTokens", "userId", userId);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Attribute Hierarchies
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributeHierarchies: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAttributeHierarchies", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Attributes
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributes: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAttributes", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributes`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Automations
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAutomations: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAutomations", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Color Pallettes
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesColorPalettes: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/colorPalettes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCspDirectives: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/cspDirectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Custom Application Settings
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCustomApplicationSettings: async (workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesCustomApplicationSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Plugins
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDashboardPlugins: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesDashboardPlugins", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Data Source Identifiers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSourceIdentifiers: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/dataSourceIdentifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSources: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Datasets
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDatasets: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesDatasets", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/datasets`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlements
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesEntitlements: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Export Definitions
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesExportDefinitions: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesExportDefinitions", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Facts
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFacts: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesFacts", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/facts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Context Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterContexts: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesFilterContexts", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Filter views
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterViews: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesFilterViews", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Identity Providers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesIdentityProviders: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
         * @summary Get all Jwks
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesJwks: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/jwks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Labels
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLabels: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesLabels", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/labels`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all LLM endpoint entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLlmEndpoints: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/llmEndpoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Metrics
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesMetrics: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesMetrics", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Notification Channel entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesNotificationChannels: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Organization entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesOrganizationSettings: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/organizationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Theming entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesThemes: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all User Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserDataFilters: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesUserDataFilters", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserGroups: async (filter, include, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UserIdentifier - represents entity interacting with platform
         * @summary Get UserIdentifier entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserIdentifiers: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/userIdentifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all settings for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserSettings: async (userId, filter, page, size, sort, metaInclude, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getAllEntitiesUserSettings", "userId", userId);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUsers: async (filter, include, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Visualization Objects
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesVisualizationObjects: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesVisualizationObjects", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilterSettings: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilters: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesWorkspaceDataFilters", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Setting for Workspaces
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceSettings: async (workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesWorkspaceSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaces: async (filter, include, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves links for all options for different configurations.
         * @summary Links for all configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOptions: async (options = {}) => {
            const localVarPath = `/api/v1/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all supported data sources along with information about the used drivers.
         * @summary Get all available data source drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourceDrivers: async (options = {}) => {
            const localVarPath = `/api/v1/options/availableDrivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAnalyticalDashboards: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAnalyticalDashboards", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityApiTokens: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getEntityApiTokens", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityApiTokens", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributeHierarchies: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAttributeHierarchies", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Attribute
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributes: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAttributes", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAttributes", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributes/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAutomations: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAutomations", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityColorPalettes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityColorPalettes", "id", id);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get CookieSecurityConfiguration
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCookieSecurityConfigurations: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityCookieSecurityConfigurations", "id", id);
            const localVarPath = `/api/v1/entities/admin/cookieSecurityConfigurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCspDirectives: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityCspDirectives", "id", id);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomApplicationSettings: async (workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityCustomApplicationSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDashboardPlugins: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityDashboardPlugins", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Data Source Identifier
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSourceIdentifiers: async (id, filter, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityDataSourceIdentifiers", "id", id);
            const localVarPath = `/api/v1/entities/dataSourceIdentifiers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSources: async (id, filter, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityDataSources", "id", id);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Dataset
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDatasets: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityDatasets", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityDatasets", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/datasets/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlement
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityEntitlements: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityEntitlements", "id", id);
            const localVarPath = `/api/v1/entities/entitlements/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityExportDefinitions: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityExportDefinitions", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Fact
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFacts: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityFacts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityFacts", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/facts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterContexts: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityFilterContexts", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterViews: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityFilterViews", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityIdentityProviders: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityIdentityProviders", "id", id);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Get Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityJwks: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityJwks", "id", id);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Label
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLabels: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityLabels", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityLabels", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/labels/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get LLM endpoint entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLlmEndpoints: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityLlmEndpoints", "id", id);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityMetrics: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityMetrics", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityNotificationChannels: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityNotificationChannels", "id", id);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizationSettings: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityOrganizationSettings", "id", id);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Organizations
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizations: async (id, filter, include, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityOrganizations", "id", id);
            const localVarPath = `/api/v1/entities/admin/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityThemes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityThemes", "id", id);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserDataFilters: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityUserDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserGroups: async (id, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUserGroups", "id", id);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UserIdentifier - represents basic information about entity interacting with platform
         * @summary Get UserIdentifier entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserIdentifiers: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUserIdentifiers", "id", id);
            const localVarPath = `/api/v1/entities/userIdentifiers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserSettings: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getEntityUserSettings", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUserSettings", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUsers: async (id, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUsers", "id", id);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityVisualizationObjects: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityVisualizationObjects", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Setting for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilterSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilters: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceSettings: async (workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityWorkspaceSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaces: async (id, filter, include, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityWorkspaces", "id", id);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a basic information about organization.
         * @summary Get current organization info
         * @param {Array<'permissions' | 'all'>} [metaInclude] Return list of permissions available to logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardPatchDocument} jsonApiAnalyticalDashboardPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAnalyticalDashboards: async (workspaceId, objectId, jsonApiAnalyticalDashboardPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityAnalyticalDashboards", "objectId", objectId);
            // verify required parameter 'jsonApiAnalyticalDashboardPatchDocument' is not null or undefined
            assertParamExists("patchEntityAnalyticalDashboards", "jsonApiAnalyticalDashboardPatchDocument", jsonApiAnalyticalDashboardPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAnalyticalDashboardPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAnalyticalDashboardPatchDocument !== undefined
                    ? jsonApiAnalyticalDashboardPatchDocument
                    : {})
                : jsonApiAnalyticalDashboardPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyPatchDocument} jsonApiAttributeHierarchyPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAttributeHierarchies: async (workspaceId, objectId, jsonApiAttributeHierarchyPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityAttributeHierarchies", "objectId", objectId);
            // verify required parameter 'jsonApiAttributeHierarchyPatchDocument' is not null or undefined
            assertParamExists("patchEntityAttributeHierarchies", "jsonApiAttributeHierarchyPatchDocument", jsonApiAttributeHierarchyPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAttributeHierarchyPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAttributeHierarchyPatchDocument !== undefined
                    ? jsonApiAttributeHierarchyPatchDocument
                    : {})
                : jsonApiAttributeHierarchyPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationPatchDocument} jsonApiAutomationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAutomations: async (workspaceId, objectId, jsonApiAutomationPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityAutomations", "objectId", objectId);
            // verify required parameter 'jsonApiAutomationPatchDocument' is not null or undefined
            assertParamExists("patchEntityAutomations", "jsonApiAutomationPatchDocument", jsonApiAutomationPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAutomationPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAutomationPatchDocument !== undefined ? jsonApiAutomationPatchDocument : {})
                : jsonApiAutomationPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Color Pallette
         * @param {string} id
         * @param {JsonApiColorPalettePatchDocument} jsonApiColorPalettePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityColorPalettes: async (id, jsonApiColorPalettePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityColorPalettes", "id", id);
            // verify required parameter 'jsonApiColorPalettePatchDocument' is not null or undefined
            assertParamExists("patchEntityColorPalettes", "jsonApiColorPalettePatchDocument", jsonApiColorPalettePatchDocument);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiColorPalettePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiColorPalettePatchDocument !== undefined ? jsonApiColorPalettePatchDocument : {})
                : jsonApiColorPalettePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationPatchDocument} jsonApiCookieSecurityConfigurationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCookieSecurityConfigurations: async (id, jsonApiCookieSecurityConfigurationPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityCookieSecurityConfigurations", "id", id);
            // verify required parameter 'jsonApiCookieSecurityConfigurationPatchDocument' is not null or undefined
            assertParamExists("patchEntityCookieSecurityConfigurations", "jsonApiCookieSecurityConfigurationPatchDocument", jsonApiCookieSecurityConfigurationPatchDocument);
            const localVarPath = `/api/v1/entities/admin/cookieSecurityConfigurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCookieSecurityConfigurationPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCookieSecurityConfigurationPatchDocument !== undefined
                    ? jsonApiCookieSecurityConfigurationPatchDocument
                    : {})
                : jsonApiCookieSecurityConfigurationPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Patch CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectivePatchDocument} jsonApiCspDirectivePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCspDirectives: async (id, jsonApiCspDirectivePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityCspDirectives", "id", id);
            // verify required parameter 'jsonApiCspDirectivePatchDocument' is not null or undefined
            assertParamExists("patchEntityCspDirectives", "jsonApiCspDirectivePatchDocument", jsonApiCspDirectivePatchDocument);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCspDirectivePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCspDirectivePatchDocument !== undefined ? jsonApiCspDirectivePatchDocument : {})
                : jsonApiCspDirectivePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingPatchDocument} jsonApiCustomApplicationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCustomApplicationSettings: async (workspaceId, objectId, jsonApiCustomApplicationSettingPatchDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityCustomApplicationSettings", "objectId", objectId);
            // verify required parameter 'jsonApiCustomApplicationSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityCustomApplicationSettings", "jsonApiCustomApplicationSettingPatchDocument", jsonApiCustomApplicationSettingPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCustomApplicationSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCustomApplicationSettingPatchDocument !== undefined
                    ? jsonApiCustomApplicationSettingPatchDocument
                    : {})
                : jsonApiCustomApplicationSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginPatchDocument} jsonApiDashboardPluginPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDashboardPlugins: async (workspaceId, objectId, jsonApiDashboardPluginPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityDashboardPlugins", "objectId", objectId);
            // verify required parameter 'jsonApiDashboardPluginPatchDocument' is not null or undefined
            assertParamExists("patchEntityDashboardPlugins", "jsonApiDashboardPluginPatchDocument", jsonApiDashboardPluginPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDashboardPluginPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDashboardPluginPatchDocument !== undefined
                    ? jsonApiDashboardPluginPatchDocument
                    : {})
                : jsonApiDashboardPluginPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Patch Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourcePatchDocument} jsonApiDataSourcePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDataSources: async (id, jsonApiDataSourcePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityDataSources", "id", id);
            // verify required parameter 'jsonApiDataSourcePatchDocument' is not null or undefined
            assertParamExists("patchEntityDataSources", "jsonApiDataSourcePatchDocument", jsonApiDataSourcePatchDocument);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDataSourcePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDataSourcePatchDocument !== undefined ? jsonApiDataSourcePatchDocument : {})
                : jsonApiDataSourcePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionPatchDocument} jsonApiExportDefinitionPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityExportDefinitions: async (workspaceId, objectId, jsonApiExportDefinitionPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityExportDefinitions", "objectId", objectId);
            // verify required parameter 'jsonApiExportDefinitionPatchDocument' is not null or undefined
            assertParamExists("patchEntityExportDefinitions", "jsonApiExportDefinitionPatchDocument", jsonApiExportDefinitionPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiExportDefinitionPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiExportDefinitionPatchDocument !== undefined
                    ? jsonApiExportDefinitionPatchDocument
                    : {})
                : jsonApiExportDefinitionPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextPatchDocument} jsonApiFilterContextPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterContexts: async (workspaceId, objectId, jsonApiFilterContextPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityFilterContexts", "objectId", objectId);
            // verify required parameter 'jsonApiFilterContextPatchDocument' is not null or undefined
            assertParamExists("patchEntityFilterContexts", "jsonApiFilterContextPatchDocument", jsonApiFilterContextPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterContextPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterContextPatchDocument !== undefined
                    ? jsonApiFilterContextPatchDocument
                    : {})
                : jsonApiFilterContextPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewPatchDocument} jsonApiFilterViewPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterViews: async (workspaceId, objectId, jsonApiFilterViewPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityFilterViews", "objectId", objectId);
            // verify required parameter 'jsonApiFilterViewPatchDocument' is not null or undefined
            assertParamExists("patchEntityFilterViews", "jsonApiFilterViewPatchDocument", jsonApiFilterViewPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterViewPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterViewPatchDocument !== undefined ? jsonApiFilterViewPatchDocument : {})
                : jsonApiFilterViewPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderPatchDocument} jsonApiIdentityProviderPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityIdentityProviders: async (id, jsonApiIdentityProviderPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityIdentityProviders", "id", id);
            // verify required parameter 'jsonApiIdentityProviderPatchDocument' is not null or undefined
            assertParamExists("patchEntityIdentityProviders", "jsonApiIdentityProviderPatchDocument", jsonApiIdentityProviderPatchDocument);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiIdentityProviderPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiIdentityProviderPatchDocument !== undefined
                    ? jsonApiIdentityProviderPatchDocument
                    : {})
                : jsonApiIdentityProviderPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patches JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Patch Jwk
         * @param {string} id
         * @param {JsonApiJwkPatchDocument} jsonApiJwkPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityJwks: async (id, jsonApiJwkPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityJwks", "id", id);
            // verify required parameter 'jsonApiJwkPatchDocument' is not null or undefined
            assertParamExists("patchEntityJwks", "jsonApiJwkPatchDocument", jsonApiJwkPatchDocument);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiJwkPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiJwkPatchDocument !== undefined ? jsonApiJwkPatchDocument : {})
                : jsonApiJwkPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointPatchDocument} jsonApiLlmEndpointPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityLlmEndpoints: async (id, jsonApiLlmEndpointPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityLlmEndpoints", "id", id);
            // verify required parameter 'jsonApiLlmEndpointPatchDocument' is not null or undefined
            assertParamExists("patchEntityLlmEndpoints", "jsonApiLlmEndpointPatchDocument", jsonApiLlmEndpointPatchDocument);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiLlmEndpointPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiLlmEndpointPatchDocument !== undefined ? jsonApiLlmEndpointPatchDocument : {})
                : jsonApiLlmEndpointPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricPatchDocument} jsonApiMetricPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityMetrics: async (workspaceId, objectId, jsonApiMetricPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityMetrics", "objectId", objectId);
            // verify required parameter 'jsonApiMetricPatchDocument' is not null or undefined
            assertParamExists("patchEntityMetrics", "jsonApiMetricPatchDocument", jsonApiMetricPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiMetricPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiMetricPatchDocument !== undefined ? jsonApiMetricPatchDocument : {})
                : jsonApiMetricPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelPatchDocument} jsonApiNotificationChannelPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityNotificationChannels: async (id, jsonApiNotificationChannelPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityNotificationChannels", "id", id);
            // verify required parameter 'jsonApiNotificationChannelPatchDocument' is not null or undefined
            assertParamExists("patchEntityNotificationChannels", "jsonApiNotificationChannelPatchDocument", jsonApiNotificationChannelPatchDocument);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiNotificationChannelPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiNotificationChannelPatchDocument !== undefined
                    ? jsonApiNotificationChannelPatchDocument
                    : {})
                : jsonApiNotificationChannelPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingPatchDocument} jsonApiOrganizationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizationSettings: async (id, jsonApiOrganizationSettingPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityOrganizationSettings", "id", id);
            // verify required parameter 'jsonApiOrganizationSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityOrganizationSettings", "jsonApiOrganizationSettingPatchDocument", jsonApiOrganizationSettingPatchDocument);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationSettingPatchDocument !== undefined
                    ? jsonApiOrganizationSettingPatchDocument
                    : {})
                : jsonApiOrganizationSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Organization
         * @param {string} id
         * @param {JsonApiOrganizationPatchDocument} jsonApiOrganizationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizations: async (id, jsonApiOrganizationPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityOrganizations", "id", id);
            // verify required parameter 'jsonApiOrganizationPatchDocument' is not null or undefined
            assertParamExists("patchEntityOrganizations", "jsonApiOrganizationPatchDocument", jsonApiOrganizationPatchDocument);
            const localVarPath = `/api/v1/entities/admin/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationPatchDocument !== undefined ? jsonApiOrganizationPatchDocument : {})
                : jsonApiOrganizationPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Theming
         * @param {string} id
         * @param {JsonApiThemePatchDocument} jsonApiThemePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityThemes: async (id, jsonApiThemePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityThemes", "id", id);
            // verify required parameter 'jsonApiThemePatchDocument' is not null or undefined
            assertParamExists("patchEntityThemes", "jsonApiThemePatchDocument", jsonApiThemePatchDocument);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiThemePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiThemePatchDocument !== undefined ? jsonApiThemePatchDocument : {})
                : jsonApiThemePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterPatchDocument} jsonApiUserDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserDataFilters: async (workspaceId, objectId, jsonApiUserDataFilterPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityUserDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiUserDataFilterPatchDocument' is not null or undefined
            assertParamExists("patchEntityUserDataFilters", "jsonApiUserDataFilterPatchDocument", jsonApiUserDataFilterPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserDataFilterPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserDataFilterPatchDocument !== undefined
                    ? jsonApiUserDataFilterPatchDocument
                    : {})
                : jsonApiUserDataFilterPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Patch UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupPatchDocument} jsonApiUserGroupPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserGroups: async (id, jsonApiUserGroupPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityUserGroups", "id", id);
            // verify required parameter 'jsonApiUserGroupPatchDocument' is not null or undefined
            assertParamExists("patchEntityUserGroups", "jsonApiUserGroupPatchDocument", jsonApiUserGroupPatchDocument);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserGroupPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserGroupPatchDocument !== undefined ? jsonApiUserGroupPatchDocument : {})
                : jsonApiUserGroupPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Patch User entity
         * @param {string} id
         * @param {JsonApiUserPatchDocument} jsonApiUserPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUsers: async (id, jsonApiUserPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityUsers", "id", id);
            // verify required parameter 'jsonApiUserPatchDocument' is not null or undefined
            assertParamExists("patchEntityUsers", "jsonApiUserPatchDocument", jsonApiUserPatchDocument);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserPatchDocument !== undefined ? jsonApiUserPatchDocument : {})
                : jsonApiUserPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectPatchDocument} jsonApiVisualizationObjectPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityVisualizationObjects: async (workspaceId, objectId, jsonApiVisualizationObjectPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityVisualizationObjects", "objectId", objectId);
            // verify required parameter 'jsonApiVisualizationObjectPatchDocument' is not null or undefined
            assertParamExists("patchEntityVisualizationObjects", "jsonApiVisualizationObjectPatchDocument", jsonApiVisualizationObjectPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiVisualizationObjectPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiVisualizationObjectPatchDocument !== undefined
                    ? jsonApiVisualizationObjectPatchDocument
                    : {})
                : jsonApiVisualizationObjectPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingPatchDocument} jsonApiWorkspaceDataFilterSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, jsonApiWorkspaceDataFilterSettingPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilterSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilterSettings", "jsonApiWorkspaceDataFilterSettingPatchDocument", jsonApiWorkspaceDataFilterSettingPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterSettingPatchDocument !== undefined
                    ? jsonApiWorkspaceDataFilterSettingPatchDocument
                    : {})
                : jsonApiWorkspaceDataFilterSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterPatchDocument} jsonApiWorkspaceDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilters: async (workspaceId, objectId, jsonApiWorkspaceDataFilterPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterPatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilters", "jsonApiWorkspaceDataFilterPatchDocument", jsonApiWorkspaceDataFilterPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterPatchDocument !== undefined
                    ? jsonApiWorkspaceDataFilterPatchDocument
                    : {})
                : jsonApiWorkspaceDataFilterPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingPatchDocument} jsonApiWorkspaceSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceSettings: async (workspaceId, objectId, jsonApiWorkspaceSettingPatchDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityWorkspaceSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaceSettings", "jsonApiWorkspaceSettingPatchDocument", jsonApiWorkspaceSettingPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceSettingPatchDocument !== undefined
                    ? jsonApiWorkspaceSettingPatchDocument
                    : {})
                : jsonApiWorkspaceSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Patch Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspacePatchDocument} jsonApiWorkspacePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaces: async (id, jsonApiWorkspacePatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityWorkspaces", "id", id);
            // verify required parameter 'jsonApiWorkspacePatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaces", "jsonApiWorkspacePatchDocument", jsonApiWorkspacePatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspacePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspacePatchDocument !== undefined ? jsonApiWorkspacePatchDocument : {})
                : jsonApiWorkspacePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Dashboards
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardInDocument} jsonApiAnalyticalDashboardInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAnalyticalDashboards: async (workspaceId, objectId, jsonApiAnalyticalDashboardInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityAnalyticalDashboards", "objectId", objectId);
            // verify required parameter 'jsonApiAnalyticalDashboardInDocument' is not null or undefined
            assertParamExists("updateEntityAnalyticalDashboards", "jsonApiAnalyticalDashboardInDocument", jsonApiAnalyticalDashboardInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAnalyticalDashboardInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAnalyticalDashboardInDocument !== undefined
                    ? jsonApiAnalyticalDashboardInDocument
                    : {})
                : jsonApiAnalyticalDashboardInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAttributeHierarchies: async (workspaceId, objectId, jsonApiAttributeHierarchyInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityAttributeHierarchies", "objectId", objectId);
            // verify required parameter 'jsonApiAttributeHierarchyInDocument' is not null or undefined
            assertParamExists("updateEntityAttributeHierarchies", "jsonApiAttributeHierarchyInDocument", jsonApiAttributeHierarchyInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAttributeHierarchyInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAttributeHierarchyInDocument !== undefined
                    ? jsonApiAttributeHierarchyInDocument
                    : {})
                : jsonApiAttributeHierarchyInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAutomations: async (workspaceId, objectId, jsonApiAutomationInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityAutomations", "objectId", objectId);
            // verify required parameter 'jsonApiAutomationInDocument' is not null or undefined
            assertParamExists("updateEntityAutomations", "jsonApiAutomationInDocument", jsonApiAutomationInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAutomationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAutomationInDocument !== undefined ? jsonApiAutomationInDocument : {})
                : jsonApiAutomationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Color Pallette
         * @param {string} id
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityColorPalettes: async (id, jsonApiColorPaletteInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityColorPalettes", "id", id);
            // verify required parameter 'jsonApiColorPaletteInDocument' is not null or undefined
            assertParamExists("updateEntityColorPalettes", "jsonApiColorPaletteInDocument", jsonApiColorPaletteInDocument);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiColorPaletteInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiColorPaletteInDocument !== undefined ? jsonApiColorPaletteInDocument : {})
                : jsonApiColorPaletteInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationInDocument} jsonApiCookieSecurityConfigurationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCookieSecurityConfigurations: async (id, jsonApiCookieSecurityConfigurationInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityCookieSecurityConfigurations", "id", id);
            // verify required parameter 'jsonApiCookieSecurityConfigurationInDocument' is not null or undefined
            assertParamExists("updateEntityCookieSecurityConfigurations", "jsonApiCookieSecurityConfigurationInDocument", jsonApiCookieSecurityConfigurationInDocument);
            const localVarPath = `/api/v1/entities/admin/cookieSecurityConfigurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCookieSecurityConfigurationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCookieSecurityConfigurationInDocument !== undefined
                    ? jsonApiCookieSecurityConfigurationInDocument
                    : {})
                : jsonApiCookieSecurityConfigurationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Put CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCspDirectives: async (id, jsonApiCspDirectiveInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityCspDirectives", "id", id);
            // verify required parameter 'jsonApiCspDirectiveInDocument' is not null or undefined
            assertParamExists("updateEntityCspDirectives", "jsonApiCspDirectiveInDocument", jsonApiCspDirectiveInDocument);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCspDirectiveInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCspDirectiveInDocument !== undefined ? jsonApiCspDirectiveInDocument : {})
                : jsonApiCspDirectiveInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingInDocument} jsonApiCustomApplicationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCustomApplicationSettings: async (workspaceId, objectId, jsonApiCustomApplicationSettingInDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityCustomApplicationSettings", "objectId", objectId);
            // verify required parameter 'jsonApiCustomApplicationSettingInDocument' is not null or undefined
            assertParamExists("updateEntityCustomApplicationSettings", "jsonApiCustomApplicationSettingInDocument", jsonApiCustomApplicationSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCustomApplicationSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCustomApplicationSettingInDocument !== undefined
                    ? jsonApiCustomApplicationSettingInDocument
                    : {})
                : jsonApiCustomApplicationSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginInDocument} jsonApiDashboardPluginInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDashboardPlugins: async (workspaceId, objectId, jsonApiDashboardPluginInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityDashboardPlugins", "objectId", objectId);
            // verify required parameter 'jsonApiDashboardPluginInDocument' is not null or undefined
            assertParamExists("updateEntityDashboardPlugins", "jsonApiDashboardPluginInDocument", jsonApiDashboardPluginInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDashboardPluginInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDashboardPluginInDocument !== undefined ? jsonApiDashboardPluginInDocument : {})
                : jsonApiDashboardPluginInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Put Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDataSources: async (id, jsonApiDataSourceInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityDataSources", "id", id);
            // verify required parameter 'jsonApiDataSourceInDocument' is not null or undefined
            assertParamExists("updateEntityDataSources", "jsonApiDataSourceInDocument", jsonApiDataSourceInDocument);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDataSourceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDataSourceInDocument !== undefined ? jsonApiDataSourceInDocument : {})
                : jsonApiDataSourceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionInDocument} jsonApiExportDefinitionInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityExportDefinitions: async (workspaceId, objectId, jsonApiExportDefinitionInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityExportDefinitions", "objectId", objectId);
            // verify required parameter 'jsonApiExportDefinitionInDocument' is not null or undefined
            assertParamExists("updateEntityExportDefinitions", "jsonApiExportDefinitionInDocument", jsonApiExportDefinitionInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiExportDefinitionInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiExportDefinitionInDocument !== undefined
                    ? jsonApiExportDefinitionInDocument
                    : {})
                : jsonApiExportDefinitionInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextInDocument} jsonApiFilterContextInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterContexts: async (workspaceId, objectId, jsonApiFilterContextInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityFilterContexts", "objectId", objectId);
            // verify required parameter 'jsonApiFilterContextInDocument' is not null or undefined
            assertParamExists("updateEntityFilterContexts", "jsonApiFilterContextInDocument", jsonApiFilterContextInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterContextInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterContextInDocument !== undefined ? jsonApiFilterContextInDocument : {})
                : jsonApiFilterContextInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Filter views
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterViews: async (workspaceId, objectId, jsonApiFilterViewInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityFilterViews", "objectId", objectId);
            // verify required parameter 'jsonApiFilterViewInDocument' is not null or undefined
            assertParamExists("updateEntityFilterViews", "jsonApiFilterViewInDocument", jsonApiFilterViewInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterViewInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterViewInDocument !== undefined ? jsonApiFilterViewInDocument : {})
                : jsonApiFilterViewInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityIdentityProviders: async (id, jsonApiIdentityProviderInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityIdentityProviders", "id", id);
            // verify required parameter 'jsonApiIdentityProviderInDocument' is not null or undefined
            assertParamExists("updateEntityIdentityProviders", "jsonApiIdentityProviderInDocument", jsonApiIdentityProviderInDocument);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiIdentityProviderInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiIdentityProviderInDocument !== undefined
                    ? jsonApiIdentityProviderInDocument
                    : {})
                : jsonApiIdentityProviderInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Put Jwk
         * @param {string} id
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityJwks: async (id, jsonApiJwkInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityJwks", "id", id);
            // verify required parameter 'jsonApiJwkInDocument' is not null or undefined
            assertParamExists("updateEntityJwks", "jsonApiJwkInDocument", jsonApiJwkInDocument);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiJwkInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiJwkInDocument !== undefined ? jsonApiJwkInDocument : {})
                : jsonApiJwkInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary PUT LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityLlmEndpoints: async (id, jsonApiLlmEndpointInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityLlmEndpoints", "id", id);
            // verify required parameter 'jsonApiLlmEndpointInDocument' is not null or undefined
            assertParamExists("updateEntityLlmEndpoints", "jsonApiLlmEndpointInDocument", jsonApiLlmEndpointInDocument);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiLlmEndpointInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiLlmEndpointInDocument !== undefined ? jsonApiLlmEndpointInDocument : {})
                : jsonApiLlmEndpointInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricInDocument} jsonApiMetricInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityMetrics: async (workspaceId, objectId, jsonApiMetricInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityMetrics", "objectId", objectId);
            // verify required parameter 'jsonApiMetricInDocument' is not null or undefined
            assertParamExists("updateEntityMetrics", "jsonApiMetricInDocument", jsonApiMetricInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiMetricInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiMetricInDocument !== undefined ? jsonApiMetricInDocument : {})
                : jsonApiMetricInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelInDocument} jsonApiNotificationChannelInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityNotificationChannels: async (id, jsonApiNotificationChannelInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityNotificationChannels", "id", id);
            // verify required parameter 'jsonApiNotificationChannelInDocument' is not null or undefined
            assertParamExists("updateEntityNotificationChannels", "jsonApiNotificationChannelInDocument", jsonApiNotificationChannelInDocument);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiNotificationChannelInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiNotificationChannelInDocument !== undefined
                    ? jsonApiNotificationChannelInDocument
                    : {})
                : jsonApiNotificationChannelInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizationSettings: async (id, jsonApiOrganizationSettingInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityOrganizationSettings", "id", id);
            // verify required parameter 'jsonApiOrganizationSettingInDocument' is not null or undefined
            assertParamExists("updateEntityOrganizationSettings", "jsonApiOrganizationSettingInDocument", jsonApiOrganizationSettingInDocument);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationSettingInDocument !== undefined
                    ? jsonApiOrganizationSettingInDocument
                    : {})
                : jsonApiOrganizationSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Organization
         * @param {string} id
         * @param {JsonApiOrganizationInDocument} jsonApiOrganizationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizations: async (id, jsonApiOrganizationInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityOrganizations", "id", id);
            // verify required parameter 'jsonApiOrganizationInDocument' is not null or undefined
            assertParamExists("updateEntityOrganizations", "jsonApiOrganizationInDocument", jsonApiOrganizationInDocument);
            const localVarPath = `/api/v1/entities/admin/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationInDocument !== undefined ? jsonApiOrganizationInDocument : {})
                : jsonApiOrganizationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Theming
         * @param {string} id
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityThemes: async (id, jsonApiThemeInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityThemes", "id", id);
            // verify required parameter 'jsonApiThemeInDocument' is not null or undefined
            assertParamExists("updateEntityThemes", "jsonApiThemeInDocument", jsonApiThemeInDocument);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiThemeInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiThemeInDocument !== undefined ? jsonApiThemeInDocument : {})
                : jsonApiThemeInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterInDocument} jsonApiUserDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserDataFilters: async (workspaceId, objectId, jsonApiUserDataFilterInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityUserDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiUserDataFilterInDocument' is not null or undefined
            assertParamExists("updateEntityUserDataFilters", "jsonApiUserDataFilterInDocument", jsonApiUserDataFilterInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserDataFilterInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserDataFilterInDocument !== undefined ? jsonApiUserDataFilterInDocument : {})
                : jsonApiUserDataFilterInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Put UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserGroups: async (id, jsonApiUserGroupInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityUserGroups", "id", id);
            // verify required parameter 'jsonApiUserGroupInDocument' is not null or undefined
            assertParamExists("updateEntityUserGroups", "jsonApiUserGroupInDocument", jsonApiUserGroupInDocument);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserGroupInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserGroupInDocument !== undefined ? jsonApiUserGroupInDocument : {})
                : jsonApiUserGroupInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put new user settings for the user
         * @param {string} userId
         * @param {string} id
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserSettings: async (userId, id, jsonApiUserSettingInDocument, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("updateEntityUserSettings", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityUserSettings", "id", id);
            // verify required parameter 'jsonApiUserSettingInDocument' is not null or undefined
            assertParamExists("updateEntityUserSettings", "jsonApiUserSettingInDocument", jsonApiUserSettingInDocument);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserSettingInDocument !== undefined ? jsonApiUserSettingInDocument : {})
                : jsonApiUserSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Put User entity
         * @param {string} id
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUsers: async (id, jsonApiUserInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityUsers", "id", id);
            // verify required parameter 'jsonApiUserInDocument' is not null or undefined
            assertParamExists("updateEntityUsers", "jsonApiUserInDocument", jsonApiUserInDocument);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserInDocument !== undefined ? jsonApiUserInDocument : {})
                : jsonApiUserInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectInDocument} jsonApiVisualizationObjectInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityVisualizationObjects: async (workspaceId, objectId, jsonApiVisualizationObjectInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityVisualizationObjects", "objectId", objectId);
            // verify required parameter 'jsonApiVisualizationObjectInDocument' is not null or undefined
            assertParamExists("updateEntityVisualizationObjects", "jsonApiVisualizationObjectInDocument", jsonApiVisualizationObjectInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiVisualizationObjectInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiVisualizationObjectInDocument !== undefined
                    ? jsonApiVisualizationObjectInDocument
                    : {})
                : jsonApiVisualizationObjectInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, jsonApiWorkspaceDataFilterSettingInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilterSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterSettingInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilterSettings", "jsonApiWorkspaceDataFilterSettingInDocument", jsonApiWorkspaceDataFilterSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterSettingInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterSettingInDocument
                    : {})
                : jsonApiWorkspaceDataFilterSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilters: async (workspaceId, objectId, jsonApiWorkspaceDataFilterInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilters", "jsonApiWorkspaceDataFilterInDocument", jsonApiWorkspaceDataFilterInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterInDocument
                    : {})
                : jsonApiWorkspaceDataFilterInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Setting for a Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingInDocument} jsonApiWorkspaceSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceSettings: async (workspaceId, objectId, jsonApiWorkspaceSettingInDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityWorkspaceSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceSettingInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaceSettings", "jsonApiWorkspaceSettingInDocument", jsonApiWorkspaceSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceSettingInDocument !== undefined
                    ? jsonApiWorkspaceSettingInDocument
                    : {})
                : jsonApiWorkspaceSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Put Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaces: async (id, jsonApiWorkspaceInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityWorkspaces", "id", id);
            // verify required parameter 'jsonApiWorkspaceInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaces", "jsonApiWorkspaceInDocument", jsonApiWorkspaceInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceInDocument !== undefined ? jsonApiWorkspaceInDocument : {})
                : jsonApiWorkspaceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EntitiesApi - functional programming interface
 * @export
 */
export const EntitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = EntitiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Dashboards
         * @param {string} workspaceId
         * @param {JsonApiAnalyticalDashboardPostOptionalIdDocument} jsonApiAnalyticalDashboardPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityAnalyticalDashboards(workspaceId, jsonApiAnalyticalDashboardPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityAnalyticalDashboards(workspaceId, jsonApiAnalyticalDashboardPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post a new API token for the user
         * @param {string} userId
         * @param {JsonApiApiTokenInDocument} jsonApiApiTokenInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityApiTokens(userId, jsonApiApiTokenInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityApiTokens(userId, jsonApiApiTokenInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Attribute Hierarchies
         * @param {string} workspaceId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityAttributeHierarchies(workspaceId, jsonApiAttributeHierarchyInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityAttributeHierarchies(workspaceId, jsonApiAttributeHierarchyInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Automations
         * @param {string} workspaceId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityAutomations(workspaceId, jsonApiAutomationInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityAutomations(workspaceId, jsonApiAutomationInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Color Pallettes
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityColorPalettes(jsonApiColorPaletteInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityColorPalettes(jsonApiColorPaletteInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Post CSP Directives
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityCspDirectives(jsonApiCspDirectiveInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityCspDirectives(jsonApiCspDirectiveInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Custom Application Settings
         * @param {string} workspaceId
         * @param {JsonApiCustomApplicationSettingPostOptionalIdDocument} jsonApiCustomApplicationSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityCustomApplicationSettings(workspaceId, jsonApiCustomApplicationSettingPostOptionalIdDocument, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityCustomApplicationSettings(workspaceId, jsonApiCustomApplicationSettingPostOptionalIdDocument, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Plugins
         * @param {string} workspaceId
         * @param {JsonApiDashboardPluginPostOptionalIdDocument} jsonApiDashboardPluginPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityDashboardPlugins(workspaceId, jsonApiDashboardPluginPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityDashboardPlugins(workspaceId, jsonApiDashboardPluginPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Post Data Sources
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityDataSources(jsonApiDataSourceInDocument, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityDataSources(jsonApiDataSourceInDocument, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Export Definitions
         * @param {string} workspaceId
         * @param {JsonApiExportDefinitionPostOptionalIdDocument} jsonApiExportDefinitionPostOptionalIdDocument
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityExportDefinitions(workspaceId, jsonApiExportDefinitionPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityExportDefinitions(workspaceId, jsonApiExportDefinitionPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Context Filters
         * @param {string} workspaceId
         * @param {JsonApiFilterContextPostOptionalIdDocument} jsonApiFilterContextPostOptionalIdDocument
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityFilterContexts(workspaceId, jsonApiFilterContextPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityFilterContexts(workspaceId, jsonApiFilterContextPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Filter views
         * @param {string} workspaceId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityFilterViews(workspaceId, jsonApiFilterViewInDocument, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityFilterViews(workspaceId, jsonApiFilterViewInDocument, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Identity Providers
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityIdentityProviders(jsonApiIdentityProviderInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityIdentityProviders(jsonApiIdentityProviderInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Post Jwks
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityJwks(jsonApiJwkInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityJwks(jsonApiJwkInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post LLM endpoint entities
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityLlmEndpoints(jsonApiLlmEndpointInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityLlmEndpoints(jsonApiLlmEndpointInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Metrics
         * @param {string} workspaceId
         * @param {JsonApiMetricPostOptionalIdDocument} jsonApiMetricPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityMetrics(workspaceId, jsonApiMetricPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityMetrics(workspaceId, jsonApiMetricPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Notification Channel entities
         * @param {JsonApiNotificationChannelPostOptionalIdDocument} jsonApiNotificationChannelPostOptionalIdDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityNotificationChannels(jsonApiNotificationChannelPostOptionalIdDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityNotificationChannels(jsonApiNotificationChannelPostOptionalIdDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Organization Setting entities
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityOrganizationSettings(jsonApiOrganizationSettingInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityOrganizationSettings(jsonApiOrganizationSettingInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Theming
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityThemes(jsonApiThemeInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityThemes(jsonApiThemeInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post User Data Filters
         * @param {string} workspaceId
         * @param {JsonApiUserDataFilterPostOptionalIdDocument} jsonApiUserDataFilterPostOptionalIdDocument
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUserDataFilters(workspaceId, jsonApiUserDataFilterPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUserDataFilters(workspaceId, jsonApiUserDataFilterPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Post User Group entities
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUserGroups(jsonApiUserGroupInDocument, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUserGroups(jsonApiUserGroupInDocument, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post new user settings for the user
         * @param {string} userId
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUserSettings(userId, jsonApiUserSettingInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUserSettings(userId, jsonApiUserSettingInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Post User entities
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUsers(jsonApiUserInDocument, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUsers(jsonApiUserInDocument, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Visualization Objects
         * @param {string} workspaceId
         * @param {JsonApiVisualizationObjectPostOptionalIdDocument} jsonApiVisualizationObjectPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityVisualizationObjects(workspaceId, jsonApiVisualizationObjectPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityVisualizationObjects(workspaceId, jsonApiVisualizationObjectPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaceDataFilterSettings(workspaceId, jsonApiWorkspaceDataFilterSettingInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaceDataFilterSettings(workspaceId, jsonApiWorkspaceDataFilterSettingInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaceDataFilters(workspaceId, jsonApiWorkspaceDataFilterInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaceDataFilters(workspaceId, jsonApiWorkspaceDataFilterInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Settings for Workspaces
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceSettingPostOptionalIdDocument} jsonApiWorkspaceSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaceSettings(workspaceId, jsonApiWorkspaceSettingPostOptionalIdDocument, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaceSettings(workspaceId, jsonApiWorkspaceSettingPostOptionalIdDocument, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Post Workspace entities
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaces(jsonApiWorkspaceInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaces(jsonApiWorkspaceInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAnalyticalDashboards(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAnalyticalDashboards(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityApiTokens(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityApiTokens(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAttributeHierarchies(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAttributeHierarchies(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAutomations(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAutomations(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityColorPalettes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityColorPalettes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Delete CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityCspDirectives(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityCspDirectives(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityCustomApplicationSettings(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityCustomApplicationSettings(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityDashboardPlugins(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityDashboardPlugins(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Delete Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityDataSources(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityDataSources(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityExportDefinitions(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityExportDefinitions(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityFilterContexts(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityFilterContexts(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityFilterViews(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityFilterViews(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityIdentityProviders(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityIdentityProviders(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Delete Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityJwks(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityJwks(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityLlmEndpoints(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityLlmEndpoints(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityMetrics(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityMetrics(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityNotificationChannels(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityNotificationChannels(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityOrganizationSettings(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityOrganizationSettings(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityThemes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityThemes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUserDataFilters(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUserDataFilters(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Delete UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUserGroups(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUserGroups(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUserSettings(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUserSettings(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Delete User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUsers(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUsers(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityVisualizationObjects(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityVisualizationObjects(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaceDataFilters(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaceDataFilters(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaceSettings(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaceSettings(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Delete Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaces(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaces(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Dashboards
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAnalyticalDashboards(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAnalyticalDashboards(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List all api tokens for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesApiTokens(userId, filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesApiTokens(userId, filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Attribute Hierarchies
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAttributeHierarchies(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAttributeHierarchies(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Attributes
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAttributes(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAttributes(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Automations
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAutomations(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAutomations(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Color Pallettes
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesColorPalettes(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesColorPalettes(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesCspDirectives(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesCspDirectives(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Custom Application Settings
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesCustomApplicationSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesCustomApplicationSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Plugins
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDashboardPlugins(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDashboardPlugins(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Data Source Identifiers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDataSourceIdentifiers(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDataSourceIdentifiers(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDataSources(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDataSources(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Datasets
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDatasets(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDatasets(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlements
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesEntitlements(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesEntitlements(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Export Definitions
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesExportDefinitions(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesExportDefinitions(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Facts
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFacts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFacts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Context Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFilterContexts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFilterContexts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Filter views
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFilterViews(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFilterViews(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Identity Providers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesIdentityProviders(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesIdentityProviders(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
         * @summary Get all Jwks
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesJwks(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesJwks(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Labels
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesLabels(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesLabels(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all LLM endpoint entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesLlmEndpoints(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesLlmEndpoints(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Metrics
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesMetrics(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesMetrics(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Notification Channel entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesNotificationChannels(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesNotificationChannels(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Organization entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesOrganizationSettings(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesOrganizationSettings(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Theming entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesThemes(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesThemes(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all User Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserGroups(filter, include, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserGroups(filter, include, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UserIdentifier - represents entity interacting with platform
         * @summary Get UserIdentifier entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserIdentifiers(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserIdentifiers(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List all settings for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserSettings(userId, filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserSettings(userId, filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUsers(filter, include, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUsers(filter, include, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Visualization Objects
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesVisualizationObjects(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesVisualizationObjects(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaceDataFilterSettings(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaceDataFilterSettings(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaceDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaceDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Setting for Workspaces
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaceSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaceSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaces(filter, include, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaces(filter, include, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves links for all options for different configurations.
         * @summary Links for all configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOptions(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a list of all supported data sources along with information about the used drivers.
         * @summary Get all available data source drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourceDrivers(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourceDrivers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAnalyticalDashboards(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAnalyticalDashboards(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityApiTokens(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityApiTokens(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAttributeHierarchies(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAttributeHierarchies(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Attribute
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAttributes(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAttributes(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAutomations(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAutomations(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityColorPalettes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityColorPalettes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get CookieSecurityConfiguration
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCookieSecurityConfigurations(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCookieSecurityConfigurations(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCspDirectives(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCspDirectives(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCustomApplicationSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCustomApplicationSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDashboardPlugins(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDashboardPlugins(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Data Source Identifier
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDataSourceIdentifiers(id, filter, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDataSourceIdentifiers(id, filter, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDataSources(id, filter, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDataSources(id, filter, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Dataset
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDatasets(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDatasets(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlement
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityEntitlements(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityEntitlements(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityExportDefinitions(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityExportDefinitions(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Fact
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityFacts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityFacts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityFilterContexts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityFilterContexts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityFilterViews(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityFilterViews(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityIdentityProviders(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityIdentityProviders(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Get Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityJwks(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityJwks(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Label
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityLabels(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityLabels(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get LLM endpoint entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityLlmEndpoints(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityLlmEndpoints(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityMetrics(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityMetrics(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityNotificationChannels(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityNotificationChannels(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityOrganizationSettings(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityOrganizationSettings(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Organizations
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityOrganizations(id, filter, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityOrganizations(id, filter, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityThemes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityThemes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserGroups(id, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserGroups(id, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UserIdentifier - represents basic information about entity interacting with platform
         * @summary Get UserIdentifier entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserIdentifiers(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserIdentifiers(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserSettings(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserSettings(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUsers(id, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUsers(id, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityVisualizationObjects(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityVisualizationObjects(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Setting for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaceDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaceDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaceSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaceSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaces(id, filter, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaces(id, filter, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a basic information about organization.
         * @summary Get current organization info
         * @param {Array<'permissions' | 'all'>} [metaInclude] Return list of permissions available to logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardPatchDocument} jsonApiAnalyticalDashboardPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyPatchDocument} jsonApiAttributeHierarchyPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationPatchDocument} jsonApiAutomationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityAutomations(workspaceId, objectId, jsonApiAutomationPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityAutomations(workspaceId, objectId, jsonApiAutomationPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Color Pallette
         * @param {string} id
         * @param {JsonApiColorPalettePatchDocument} jsonApiColorPalettePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityColorPalettes(id, jsonApiColorPalettePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityColorPalettes(id, jsonApiColorPalettePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationPatchDocument} jsonApiCookieSecurityConfigurationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Patch CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectivePatchDocument} jsonApiCspDirectivePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityCspDirectives(id, jsonApiCspDirectivePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityCspDirectives(id, jsonApiCspDirectivePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingPatchDocument} jsonApiCustomApplicationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginPatchDocument} jsonApiDashboardPluginPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Patch Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourcePatchDocument} jsonApiDataSourcePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityDataSources(id, jsonApiDataSourcePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityDataSources(id, jsonApiDataSourcePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionPatchDocument} jsonApiExportDefinitionPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextPatchDocument} jsonApiFilterContextPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewPatchDocument} jsonApiFilterViewPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityFilterViews(workspaceId, objectId, jsonApiFilterViewPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityFilterViews(workspaceId, objectId, jsonApiFilterViewPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderPatchDocument} jsonApiIdentityProviderPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityIdentityProviders(id, jsonApiIdentityProviderPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityIdentityProviders(id, jsonApiIdentityProviderPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Patches JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Patch Jwk
         * @param {string} id
         * @param {JsonApiJwkPatchDocument} jsonApiJwkPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityJwks(id, jsonApiJwkPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityJwks(id, jsonApiJwkPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointPatchDocument} jsonApiLlmEndpointPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityLlmEndpoints(id, jsonApiLlmEndpointPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityLlmEndpoints(id, jsonApiLlmEndpointPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricPatchDocument} jsonApiMetricPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityMetrics(workspaceId, objectId, jsonApiMetricPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityMetrics(workspaceId, objectId, jsonApiMetricPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelPatchDocument} jsonApiNotificationChannelPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityNotificationChannels(id, jsonApiNotificationChannelPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityNotificationChannels(id, jsonApiNotificationChannelPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingPatchDocument} jsonApiOrganizationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityOrganizationSettings(id, jsonApiOrganizationSettingPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityOrganizationSettings(id, jsonApiOrganizationSettingPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Organization
         * @param {string} id
         * @param {JsonApiOrganizationPatchDocument} jsonApiOrganizationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityOrganizations(id, jsonApiOrganizationPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityOrganizations(id, jsonApiOrganizationPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Theming
         * @param {string} id
         * @param {JsonApiThemePatchDocument} jsonApiThemePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityThemes(id, jsonApiThemePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityThemes(id, jsonApiThemePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterPatchDocument} jsonApiUserDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Patch UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupPatchDocument} jsonApiUserGroupPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityUserGroups(id, jsonApiUserGroupPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityUserGroups(id, jsonApiUserGroupPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Patch User entity
         * @param {string} id
         * @param {JsonApiUserPatchDocument} jsonApiUserPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityUsers(id, jsonApiUserPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityUsers(id, jsonApiUserPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectPatchDocument} jsonApiVisualizationObjectPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingPatchDocument} jsonApiWorkspaceDataFilterSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterPatchDocument} jsonApiWorkspaceDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingPatchDocument} jsonApiWorkspaceSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Patch Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspacePatchDocument} jsonApiWorkspacePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaces(id, jsonApiWorkspacePatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaces(id, jsonApiWorkspacePatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Dashboards
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardInDocument} jsonApiAnalyticalDashboardInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAutomations(workspaceId, objectId, jsonApiAutomationInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAutomations(workspaceId, objectId, jsonApiAutomationInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Color Pallette
         * @param {string} id
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityColorPalettes(id, jsonApiColorPaletteInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityColorPalettes(id, jsonApiColorPaletteInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationInDocument} jsonApiCookieSecurityConfigurationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Put CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityCspDirectives(id, jsonApiCspDirectiveInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityCspDirectives(id, jsonApiCspDirectiveInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingInDocument} jsonApiCustomApplicationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginInDocument} jsonApiDashboardPluginInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Put Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityDataSources(id, jsonApiDataSourceInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityDataSources(id, jsonApiDataSourceInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionInDocument} jsonApiExportDefinitionInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextInDocument} jsonApiFilterContextInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Filter views
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityFilterViews(workspaceId, objectId, jsonApiFilterViewInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityFilterViews(workspaceId, objectId, jsonApiFilterViewInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityIdentityProviders(id, jsonApiIdentityProviderInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityIdentityProviders(id, jsonApiIdentityProviderInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Put Jwk
         * @param {string} id
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityJwks(id, jsonApiJwkInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityJwks(id, jsonApiJwkInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary PUT LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityLlmEndpoints(id, jsonApiLlmEndpointInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityLlmEndpoints(id, jsonApiLlmEndpointInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricInDocument} jsonApiMetricInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityMetrics(workspaceId, objectId, jsonApiMetricInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityMetrics(workspaceId, objectId, jsonApiMetricInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelInDocument} jsonApiNotificationChannelInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityNotificationChannels(id, jsonApiNotificationChannelInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityNotificationChannels(id, jsonApiNotificationChannelInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityOrganizationSettings(id, jsonApiOrganizationSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityOrganizationSettings(id, jsonApiOrganizationSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Organization
         * @param {string} id
         * @param {JsonApiOrganizationInDocument} jsonApiOrganizationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityOrganizations(id, jsonApiOrganizationInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityOrganizations(id, jsonApiOrganizationInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Theming
         * @param {string} id
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityThemes(id, jsonApiThemeInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityThemes(id, jsonApiThemeInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterInDocument} jsonApiUserDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Put UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUserGroups(id, jsonApiUserGroupInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUserGroups(id, jsonApiUserGroupInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put new user settings for the user
         * @param {string} userId
         * @param {string} id
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUserSettings(userId, id, jsonApiUserSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUserSettings(userId, id, jsonApiUserSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Put User entity
         * @param {string} id
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUsers(id, jsonApiUserInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUsers(id, jsonApiUserInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectInDocument} jsonApiVisualizationObjectInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Setting for a Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingInDocument} jsonApiWorkspaceSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Put Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaces(id, jsonApiWorkspaceInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaces(id, jsonApiWorkspaceInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * EntitiesApi - factory interface
 * @export
 */
export const EntitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EntitiesApiFp(configuration);
    return {
        /**
         *
         * @summary Post Dashboards
         * @param {EntitiesApiCreateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .createEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.jsonApiAnalyticalDashboardPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a new API token for the user
         * @param {EntitiesApiCreateEntityApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityApiTokens(requestParameters, options) {
            return localVarFp
                .createEntityApiTokens(requestParameters.userId, requestParameters.jsonApiApiTokenInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Attribute Hierarchies
         * @param {EntitiesApiCreateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .createEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Automations
         * @param {EntitiesApiCreateEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAutomations(requestParameters, options) {
            return localVarFp
                .createEntityAutomations(requestParameters.workspaceId, requestParameters.jsonApiAutomationInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Color Pallettes
         * @param {EntitiesApiCreateEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .createEntityColorPalettes(requestParameters.jsonApiColorPaletteInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Post CSP Directives
         * @param {EntitiesApiCreateEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .createEntityCspDirectives(requestParameters.jsonApiCspDirectiveInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Custom Application Settings
         * @param {EntitiesApiCreateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .createEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.jsonApiCustomApplicationSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Plugins
         * @param {EntitiesApiCreateEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .createEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.jsonApiDashboardPluginPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Post Data Sources
         * @param {EntitiesApiCreateEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDataSources(requestParameters, options) {
            return localVarFp
                .createEntityDataSources(requestParameters.jsonApiDataSourceInDocument, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Export Definitions
         * @param {EntitiesApiCreateEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .createEntityExportDefinitions(requestParameters.workspaceId, requestParameters.jsonApiExportDefinitionPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Context Filters
         * @param {EntitiesApiCreateEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .createEntityFilterContexts(requestParameters.workspaceId, requestParameters.jsonApiFilterContextPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Filter views
         * @param {EntitiesApiCreateEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterViews(requestParameters, options) {
            return localVarFp
                .createEntityFilterViews(requestParameters.workspaceId, requestParameters.jsonApiFilterViewInDocument, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Identity Providers
         * @param {EntitiesApiCreateEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .createEntityIdentityProviders(requestParameters.jsonApiIdentityProviderInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Post Jwks
         * @param {EntitiesApiCreateEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityJwks(requestParameters, options) {
            return localVarFp
                .createEntityJwks(requestParameters.jsonApiJwkInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post LLM endpoint entities
         * @param {EntitiesApiCreateEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .createEntityLlmEndpoints(requestParameters.jsonApiLlmEndpointInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Metrics
         * @param {EntitiesApiCreateEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityMetrics(requestParameters, options) {
            return localVarFp
                .createEntityMetrics(requestParameters.workspaceId, requestParameters.jsonApiMetricPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Notification Channel entities
         * @param {EntitiesApiCreateEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .createEntityNotificationChannels(requestParameters.jsonApiNotificationChannelPostOptionalIdDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Organization Setting entities
         * @param {EntitiesApiCreateEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .createEntityOrganizationSettings(requestParameters.jsonApiOrganizationSettingInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Theming
         * @param {EntitiesApiCreateEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityThemes(requestParameters, options) {
            return localVarFp
                .createEntityThemes(requestParameters.jsonApiThemeInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post User Data Filters
         * @param {EntitiesApiCreateEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .createEntityUserDataFilters(requestParameters.workspaceId, requestParameters.jsonApiUserDataFilterPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Post User Group entities
         * @param {EntitiesApiCreateEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserGroups(requestParameters, options) {
            return localVarFp
                .createEntityUserGroups(requestParameters.jsonApiUserGroupInDocument, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post new user settings for the user
         * @param {EntitiesApiCreateEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserSettings(requestParameters, options) {
            return localVarFp
                .createEntityUserSettings(requestParameters.userId, requestParameters.jsonApiUserSettingInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Post User entities
         * @param {EntitiesApiCreateEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUsers(requestParameters, options) {
            return localVarFp
                .createEntityUsers(requestParameters.jsonApiUserInDocument, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Visualization Objects
         * @param {EntitiesApiCreateEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .createEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.jsonApiVisualizationObjectPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Settings for Workspace Data Filters
         * @param {EntitiesApiCreateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Workspace Data Filters
         * @param {EntitiesApiCreateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Settings for Workspaces
         * @param {EntitiesApiCreateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Post Workspace entities
         * @param {EntitiesApiCreateEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaces(requestParameters.jsonApiWorkspaceInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Dashboard
         * @param {EntitiesApiDeleteEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .deleteEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an API Token for a user
         * @param {EntitiesApiDeleteEntityApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityApiTokens(requestParameters, options) {
            return localVarFp
                .deleteEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Attribute Hierarchy
         * @param {EntitiesApiDeleteEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .deleteEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Automation
         * @param {EntitiesApiDeleteEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAutomations(requestParameters, options) {
            return localVarFp
                .deleteEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Color Pallette
         * @param {EntitiesApiDeleteEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .deleteEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Delete CSP Directives
         * @param {EntitiesApiDeleteEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .deleteEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Custom Application Setting
         * @param {EntitiesApiDeleteEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Plugin
         * @param {EntitiesApiDeleteEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .deleteEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Delete Data Source entity
         * @param {EntitiesApiDeleteEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDataSources(requestParameters, options) {
            return localVarFp
                .deleteEntityDataSources(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Export Definition
         * @param {EntitiesApiDeleteEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .deleteEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Context Filter
         * @param {EntitiesApiDeleteEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .deleteEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Filter view
         * @param {EntitiesApiDeleteEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterViews(requestParameters, options) {
            return localVarFp
                .deleteEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Identity Provider
         * @param {EntitiesApiDeleteEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .deleteEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Deletes JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Delete Jwk
         * @param {EntitiesApiDeleteEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityJwks(requestParameters, options) {
            return localVarFp
                .deleteEntityJwks(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EntitiesApiDeleteEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .deleteEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Metric
         * @param {EntitiesApiDeleteEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityMetrics(requestParameters, options) {
            return localVarFp
                .deleteEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Notification Channel entity
         * @param {EntitiesApiDeleteEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .deleteEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Organization entity
         * @param {EntitiesApiDeleteEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Theming
         * @param {EntitiesApiDeleteEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityThemes(requestParameters, options) {
            return localVarFp
                .deleteEntityThemes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a User Data Filter
         * @param {EntitiesApiDeleteEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .deleteEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Delete UserGroup entity
         * @param {EntitiesApiDeleteEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserGroups(requestParameters, options) {
            return localVarFp
                .deleteEntityUserGroups(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a setting for a user
         * @param {EntitiesApiDeleteEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Delete User entity
         * @param {EntitiesApiDeleteEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUsers(requestParameters, options) {
            return localVarFp
                .deleteEntityUsers(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Visualization Object
         * @param {EntitiesApiDeleteEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .deleteEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Settings for Workspace Data Filter
         * @param {EntitiesApiDeleteEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Workspace Data Filter
         * @param {EntitiesApiDeleteEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Setting for Workspace
         * @param {EntitiesApiDeleteEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Delete Workspace entity
         * @param {EntitiesApiDeleteEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaces(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Dashboards
         * @param {EntitiesApiGetAllEntitiesAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAnalyticalDashboards(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all api tokens for a user
         * @param {EntitiesApiGetAllEntitiesApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesApiTokens(requestParameters, options) {
            return localVarFp
                .getAllEntitiesApiTokens(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Attribute Hierarchies
         * @param {EntitiesApiGetAllEntitiesAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAttributeHierarchies(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Attributes
         * @param {EntitiesApiGetAllEntitiesAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributes(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAttributes(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Automations
         * @param {EntitiesApiGetAllEntitiesAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAutomations(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAutomations(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Color Pallettes
         * @param {EntitiesApiGetAllEntitiesColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesColorPalettes(requestParameters, options) {
            return localVarFp
                .getAllEntitiesColorPalettes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {EntitiesApiGetAllEntitiesCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCspDirectives(requestParameters, options) {
            return localVarFp
                .getAllEntitiesCspDirectives(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Custom Application Settings
         * @param {EntitiesApiGetAllEntitiesCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesCustomApplicationSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Plugins
         * @param {EntitiesApiGetAllEntitiesDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDashboardPlugins(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDashboardPlugins(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Data Source Identifiers
         * @param {EntitiesApiGetAllEntitiesDataSourceIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSourceIdentifiers(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDataSourceIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entities
         * @param {EntitiesApiGetAllEntitiesDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSources(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDataSources(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Datasets
         * @param {EntitiesApiGetAllEntitiesDatasetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDatasets(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDatasets(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlements
         * @param {EntitiesApiGetAllEntitiesEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesEntitlements(requestParameters, options) {
            return localVarFp
                .getAllEntitiesEntitlements(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Export Definitions
         * @param {EntitiesApiGetAllEntitiesExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesExportDefinitions(requestParameters, options) {
            return localVarFp
                .getAllEntitiesExportDefinitions(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Facts
         * @param {EntitiesApiGetAllEntitiesFactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFacts(requestParameters, options) {
            return localVarFp
                .getAllEntitiesFacts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Context Filters
         * @param {EntitiesApiGetAllEntitiesFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterContexts(requestParameters, options) {
            return localVarFp
                .getAllEntitiesFilterContexts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Filter views
         * @param {EntitiesApiGetAllEntitiesFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterViews(requestParameters, options) {
            return localVarFp
                .getAllEntitiesFilterViews(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Identity Providers
         * @param {EntitiesApiGetAllEntitiesIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesIdentityProviders(requestParameters, options) {
            return localVarFp
                .getAllEntitiesIdentityProviders(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
         * @summary Get all Jwks
         * @param {EntitiesApiGetAllEntitiesJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesJwks(requestParameters, options) {
            return localVarFp
                .getAllEntitiesJwks(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Labels
         * @param {EntitiesApiGetAllEntitiesLabelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLabels(requestParameters, options) {
            return localVarFp
                .getAllEntitiesLabels(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all LLM endpoint entities
         * @param {EntitiesApiGetAllEntitiesLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLlmEndpoints(requestParameters, options) {
            return localVarFp
                .getAllEntitiesLlmEndpoints(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Metrics
         * @param {EntitiesApiGetAllEntitiesMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesMetrics(requestParameters, options) {
            return localVarFp
                .getAllEntitiesMetrics(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Notification Channel entities
         * @param {EntitiesApiGetAllEntitiesNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesNotificationChannels(requestParameters, options) {
            return localVarFp
                .getAllEntitiesNotificationChannels(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Organization entities
         * @param {EntitiesApiGetAllEntitiesOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesOrganizationSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesOrganizationSettings(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Theming entities
         * @param {EntitiesApiGetAllEntitiesThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesThemes(requestParameters, options) {
            return localVarFp
                .getAllEntitiesThemes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all User Data Filters
         * @param {EntitiesApiGetAllEntitiesUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserDataFilters(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entities
         * @param {EntitiesApiGetAllEntitiesUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserGroups(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserGroups(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * UserIdentifier - represents entity interacting with platform
         * @summary Get UserIdentifier entities
         * @param {EntitiesApiGetAllEntitiesUserIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserIdentifiers(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all settings for a user
         * @param {EntitiesApiGetAllEntitiesUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserSettings(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entities
         * @param {EntitiesApiGetAllEntitiesUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUsers(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUsers(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Visualization Objects
         * @param {EntitiesApiGetAllEntitiesVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesVisualizationObjects(requestParameters, options) {
            return localVarFp
                .getAllEntitiesVisualizationObjects(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Settings for Workspace Data Filters
         * @param {EntitiesApiGetAllEntitiesWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Workspace Data Filters
         * @param {EntitiesApiGetAllEntitiesWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Setting for Workspaces
         * @param {EntitiesApiGetAllEntitiesWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaceSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entities
         * @param {EntitiesApiGetAllEntitiesWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaces(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaces(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves links for all options for different configurations.
         * @summary Links for all configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOptions(options) {
            return localVarFp.getAllOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all supported data sources along with information about the used drivers.
         * @summary Get all available data source drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourceDrivers(options) {
            return localVarFp.getDataSourceDrivers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Dashboard
         * @param {EntitiesApiGetEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .getEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an API Token for a user
         * @param {EntitiesApiGetEntityApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityApiTokens(requestParameters, options) {
            return localVarFp
                .getEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Attribute Hierarchy
         * @param {EntitiesApiGetEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .getEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Attribute
         * @param {EntitiesApiGetEntityAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributes(requestParameters, options) {
            return localVarFp
                .getEntityAttributes(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Automation
         * @param {EntitiesApiGetEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAutomations(requestParameters, options) {
            return localVarFp
                .getEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Color Pallette
         * @param {EntitiesApiGetEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .getEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get CookieSecurityConfiguration
         * @param {EntitiesApiGetEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCookieSecurityConfigurations(requestParameters, options) {
            return localVarFp
                .getEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {EntitiesApiGetEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .getEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Custom Application Setting
         * @param {EntitiesApiGetEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .getEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Plugin
         * @param {EntitiesApiGetEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .getEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Data Source Identifier
         * @param {EntitiesApiGetEntityDataSourceIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSourceIdentifiers(requestParameters, options) {
            return localVarFp
                .getEntityDataSourceIdentifiers(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entity
         * @param {EntitiesApiGetEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSources(requestParameters, options) {
            return localVarFp
                .getEntityDataSources(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Dataset
         * @param {EntitiesApiGetEntityDatasetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDatasets(requestParameters, options) {
            return localVarFp
                .getEntityDatasets(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlement
         * @param {EntitiesApiGetEntityEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityEntitlements(requestParameters, options) {
            return localVarFp
                .getEntityEntitlements(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Export Definition
         * @param {EntitiesApiGetEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .getEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Fact
         * @param {EntitiesApiGetEntityFactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFacts(requestParameters, options) {
            return localVarFp
                .getEntityFacts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Context Filter
         * @param {EntitiesApiGetEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .getEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Filter view
         * @param {EntitiesApiGetEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterViews(requestParameters, options) {
            return localVarFp
                .getEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Identity Provider
         * @param {EntitiesApiGetEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .getEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Get Jwk
         * @param {EntitiesApiGetEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityJwks(requestParameters, options) {
            return localVarFp
                .getEntityJwks(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Label
         * @param {EntitiesApiGetEntityLabelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLabels(requestParameters, options) {
            return localVarFp
                .getEntityLabels(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get LLM endpoint entity
         * @param {EntitiesApiGetEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .getEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Metric
         * @param {EntitiesApiGetEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityMetrics(requestParameters, options) {
            return localVarFp
                .getEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Notification Channel entity
         * @param {EntitiesApiGetEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .getEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Organization entity
         * @param {EntitiesApiGetEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .getEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Organizations
         * @param {EntitiesApiGetEntityOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizations(requestParameters, options) {
            return localVarFp
                .getEntityOrganizations(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Theming
         * @param {EntitiesApiGetEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityThemes(requestParameters, options) {
            return localVarFp
                .getEntityThemes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a User Data Filter
         * @param {EntitiesApiGetEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .getEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entity
         * @param {EntitiesApiGetEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserGroups(requestParameters, options) {
            return localVarFp
                .getEntityUserGroups(requestParameters.id, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * UserIdentifier - represents basic information about entity interacting with platform
         * @summary Get UserIdentifier entity
         * @param {EntitiesApiGetEntityUserIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserIdentifiers(requestParameters, options) {
            return localVarFp
                .getEntityUserIdentifiers(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a setting for a user
         * @param {EntitiesApiGetEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserSettings(requestParameters, options) {
            return localVarFp
                .getEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entity
         * @param {EntitiesApiGetEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUsers(requestParameters, options) {
            return localVarFp
                .getEntityUsers(requestParameters.id, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Visualization Object
         * @param {EntitiesApiGetEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .getEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Setting for Workspace Data Filter
         * @param {EntitiesApiGetEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Workspace Data Filter
         * @param {EntitiesApiGetEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Setting for Workspace
         * @param {EntitiesApiGetEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entity
         * @param {EntitiesApiGetEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaces(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Gets a basic information about organization.
         * @summary Get current organization info
         * @param {EntitiesApiGetOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(requestParameters, options) {
            return localVarFp
                .getOrganization(requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Dashboard
         * @param {EntitiesApiPatchEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .patchEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an Attribute Hierarchy
         * @param {EntitiesApiPatchEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .patchEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an Automation
         * @param {EntitiesApiPatchEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAutomations(requestParameters, options) {
            return localVarFp
                .patchEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Color Pallette
         * @param {EntitiesApiPatchEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .patchEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPalettePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch CookieSecurityConfiguration
         * @param {EntitiesApiPatchEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCookieSecurityConfigurations(requestParameters, options) {
            return localVarFp
                .patchEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Patch CSP Directives
         * @param {EntitiesApiPatchEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .patchEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectivePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Custom Application Setting
         * @param {EntitiesApiPatchEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .patchEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Plugin
         * @param {EntitiesApiPatchEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .patchEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Patch Data Source entity
         * @param {EntitiesApiPatchEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDataSources(requestParameters, options) {
            return localVarFp
                .patchEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourcePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an Export Definition
         * @param {EntitiesApiPatchEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .patchEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Context Filter
         * @param {EntitiesApiPatchEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .patchEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Filter view
         * @param {EntitiesApiPatchEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterViews(requestParameters, options) {
            return localVarFp
                .patchEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Identity Provider
         * @param {EntitiesApiPatchEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .patchEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Patches JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Patch Jwk
         * @param {EntitiesApiPatchEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityJwks(requestParameters, options) {
            return localVarFp
                .patchEntityJwks(requestParameters.id, requestParameters.jsonApiJwkPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch LLM endpoint entity
         * @param {EntitiesApiPatchEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .patchEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Metric
         * @param {EntitiesApiPatchEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityMetrics(requestParameters, options) {
            return localVarFp
                .patchEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Notification Channel entity
         * @param {EntitiesApiPatchEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .patchEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Organization entity
         * @param {EntitiesApiPatchEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .patchEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Organization
         * @param {EntitiesApiPatchEntityOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizations(requestParameters, options) {
            return localVarFp
                .patchEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Theming
         * @param {EntitiesApiPatchEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityThemes(requestParameters, options) {
            return localVarFp
                .patchEntityThemes(requestParameters.id, requestParameters.jsonApiThemePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a User Data Filter
         * @param {EntitiesApiPatchEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .patchEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Patch UserGroup entity
         * @param {EntitiesApiPatchEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserGroups(requestParameters, options) {
            return localVarFp
                .patchEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Patch User entity
         * @param {EntitiesApiPatchEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUsers(requestParameters, options) {
            return localVarFp
                .patchEntityUsers(requestParameters.id, requestParameters.jsonApiUserPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Visualization Object
         * @param {EntitiesApiPatchEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .patchEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Settings for Workspace Data Filter
         * @param {EntitiesApiPatchEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Workspace Data Filter
         * @param {EntitiesApiPatchEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Setting for Workspace
         * @param {EntitiesApiPatchEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Patch Workspace entity
         * @param {EntitiesApiPatchEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspacePatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Dashboards
         * @param {EntitiesApiUpdateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .updateEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put an Attribute Hierarchy
         * @param {EntitiesApiUpdateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .updateEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put an Automation
         * @param {EntitiesApiUpdateEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAutomations(requestParameters, options) {
            return localVarFp
                .updateEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Color Pallette
         * @param {EntitiesApiUpdateEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .updateEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPaletteInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put CookieSecurityConfiguration
         * @param {EntitiesApiUpdateEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCookieSecurityConfigurations(requestParameters, options) {
            return localVarFp
                .updateEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Put CSP Directives
         * @param {EntitiesApiUpdateEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .updateEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectiveInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Custom Application Setting
         * @param {EntitiesApiUpdateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .updateEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Plugin
         * @param {EntitiesApiUpdateEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .updateEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Put Data Source entity
         * @param {EntitiesApiUpdateEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDataSources(requestParameters, options) {
            return localVarFp
                .updateEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourceInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put an Export Definition
         * @param {EntitiesApiUpdateEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .updateEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Context Filter
         * @param {EntitiesApiUpdateEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .updateEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Filter views
         * @param {EntitiesApiUpdateEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterViews(requestParameters, options) {
            return localVarFp
                .updateEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Identity Provider
         * @param {EntitiesApiUpdateEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .updateEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Updates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Put Jwk
         * @param {EntitiesApiUpdateEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityJwks(requestParameters, options) {
            return localVarFp
                .updateEntityJwks(requestParameters.id, requestParameters.jsonApiJwkInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary PUT LLM endpoint entity
         * @param {EntitiesApiUpdateEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .updateEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Metric
         * @param {EntitiesApiUpdateEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityMetrics(requestParameters, options) {
            return localVarFp
                .updateEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Notification Channel entity
         * @param {EntitiesApiUpdateEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .updateEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Organization entity
         * @param {EntitiesApiUpdateEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .updateEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Organization
         * @param {EntitiesApiUpdateEntityOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizations(requestParameters, options) {
            return localVarFp
                .updateEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Theming
         * @param {EntitiesApiUpdateEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityThemes(requestParameters, options) {
            return localVarFp
                .updateEntityThemes(requestParameters.id, requestParameters.jsonApiThemeInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a User Data Filter
         * @param {EntitiesApiUpdateEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .updateEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Put UserGroup entity
         * @param {EntitiesApiUpdateEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserGroups(requestParameters, options) {
            return localVarFp
                .updateEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put new user settings for the user
         * @param {EntitiesApiUpdateEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserSettings(requestParameters, options) {
            return localVarFp
                .updateEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.jsonApiUserSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Put User entity
         * @param {EntitiesApiUpdateEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUsers(requestParameters, options) {
            return localVarFp
                .updateEntityUsers(requestParameters.id, requestParameters.jsonApiUserInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Visualization Object
         * @param {EntitiesApiUpdateEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .updateEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Settings for Workspace Data Filter
         * @param {EntitiesApiUpdateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Workspace Data Filter
         * @param {EntitiesApiUpdateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Setting for a Workspace
         * @param {EntitiesApiUpdateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Put Workspace entity
         * @param {EntitiesApiUpdateEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspaceInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EntitiesApi - object-oriented interface
 * @export
 * @class EntitiesApi
 * @extends {BaseAPI}
 */
export class EntitiesApi extends BaseAPI {
    /**
     *
     * @summary Post Dashboards
     * @param {EntitiesApiCreateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityAnalyticalDashboards(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.jsonApiAnalyticalDashboardPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a new API token for the user
     * @param {EntitiesApiCreateEntityApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityApiTokens(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityApiTokens(requestParameters.userId, requestParameters.jsonApiApiTokenInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Attribute Hierarchies
     * @param {EntitiesApiCreateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityAttributeHierarchies(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Automations
     * @param {EntitiesApiCreateEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityAutomations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityAutomations(requestParameters.workspaceId, requestParameters.jsonApiAutomationInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Color Pallettes
     * @param {EntitiesApiCreateEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityColorPalettes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityColorPalettes(requestParameters.jsonApiColorPaletteInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Post CSP Directives
     * @param {EntitiesApiCreateEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityCspDirectives(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityCspDirectives(requestParameters.jsonApiCspDirectiveInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Custom Application Settings
     * @param {EntitiesApiCreateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityCustomApplicationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.jsonApiCustomApplicationSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Plugins
     * @param {EntitiesApiCreateEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityDashboardPlugins(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.jsonApiDashboardPluginPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Post Data Sources
     * @param {EntitiesApiCreateEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityDataSources(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityDataSources(requestParameters.jsonApiDataSourceInDocument, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Export Definitions
     * @param {EntitiesApiCreateEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityExportDefinitions(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityExportDefinitions(requestParameters.workspaceId, requestParameters.jsonApiExportDefinitionPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Context Filters
     * @param {EntitiesApiCreateEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityFilterContexts(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityFilterContexts(requestParameters.workspaceId, requestParameters.jsonApiFilterContextPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Filter views
     * @param {EntitiesApiCreateEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityFilterViews(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityFilterViews(requestParameters.workspaceId, requestParameters.jsonApiFilterViewInDocument, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Identity Providers
     * @param {EntitiesApiCreateEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityIdentityProviders(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityIdentityProviders(requestParameters.jsonApiIdentityProviderInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Post Jwks
     * @param {EntitiesApiCreateEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityJwks(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityJwks(requestParameters.jsonApiJwkInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post LLM endpoint entities
     * @param {EntitiesApiCreateEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityLlmEndpoints(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityLlmEndpoints(requestParameters.jsonApiLlmEndpointInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Metrics
     * @param {EntitiesApiCreateEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityMetrics(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityMetrics(requestParameters.workspaceId, requestParameters.jsonApiMetricPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Notification Channel entities
     * @param {EntitiesApiCreateEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityNotificationChannels(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityNotificationChannels(requestParameters.jsonApiNotificationChannelPostOptionalIdDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Organization Setting entities
     * @param {EntitiesApiCreateEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityOrganizationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityOrganizationSettings(requestParameters.jsonApiOrganizationSettingInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Theming
     * @param {EntitiesApiCreateEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityThemes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityThemes(requestParameters.jsonApiThemeInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post User Data Filters
     * @param {EntitiesApiCreateEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityUserDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityUserDataFilters(requestParameters.workspaceId, requestParameters.jsonApiUserDataFilterPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Post User Group entities
     * @param {EntitiesApiCreateEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityUserGroups(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityUserGroups(requestParameters.jsonApiUserGroupInDocument, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post new user settings for the user
     * @param {EntitiesApiCreateEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityUserSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityUserSettings(requestParameters.userId, requestParameters.jsonApiUserSettingInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Post User entities
     * @param {EntitiesApiCreateEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityUsers(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityUsers(requestParameters.jsonApiUserInDocument, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Visualization Objects
     * @param {EntitiesApiCreateEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityVisualizationObjects(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.jsonApiVisualizationObjectPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Settings for Workspace Data Filters
     * @param {EntitiesApiCreateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Workspace Data Filters
     * @param {EntitiesApiCreateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityWorkspaceDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Settings for Workspaces
     * @param {EntitiesApiCreateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityWorkspaceSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Post Workspace entities
     * @param {EntitiesApiCreateEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    createEntityWorkspaces(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .createEntityWorkspaces(requestParameters.jsonApiWorkspaceInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Dashboard
     * @param {EntitiesApiDeleteEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityAnalyticalDashboards(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an API Token for a user
     * @param {EntitiesApiDeleteEntityApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityApiTokens(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Attribute Hierarchy
     * @param {EntitiesApiDeleteEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityAttributeHierarchies(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Automation
     * @param {EntitiesApiDeleteEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityAutomations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Color Pallette
     * @param {EntitiesApiDeleteEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityColorPalettes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Delete CSP Directives
     * @param {EntitiesApiDeleteEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityCspDirectives(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Custom Application Setting
     * @param {EntitiesApiDeleteEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityCustomApplicationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Plugin
     * @param {EntitiesApiDeleteEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityDashboardPlugins(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Delete Data Source entity
     * @param {EntitiesApiDeleteEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityDataSources(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityDataSources(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Export Definition
     * @param {EntitiesApiDeleteEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityExportDefinitions(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Context Filter
     * @param {EntitiesApiDeleteEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityFilterContexts(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Filter view
     * @param {EntitiesApiDeleteEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityFilterViews(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Identity Provider
     * @param {EntitiesApiDeleteEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityIdentityProviders(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Delete Jwk
     * @param {EntitiesApiDeleteEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityJwks(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityJwks(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EntitiesApiDeleteEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityLlmEndpoints(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Metric
     * @param {EntitiesApiDeleteEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityMetrics(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Notification Channel entity
     * @param {EntitiesApiDeleteEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityNotificationChannels(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Organization entity
     * @param {EntitiesApiDeleteEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityOrganizationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Theming
     * @param {EntitiesApiDeleteEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityThemes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityThemes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a User Data Filter
     * @param {EntitiesApiDeleteEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityUserDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Delete UserGroup entity
     * @param {EntitiesApiDeleteEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityUserGroups(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityUserGroups(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a setting for a user
     * @param {EntitiesApiDeleteEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityUserSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Delete User entity
     * @param {EntitiesApiDeleteEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityUsers(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityUsers(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Visualization Object
     * @param {EntitiesApiDeleteEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityVisualizationObjects(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Settings for Workspace Data Filter
     * @param {EntitiesApiDeleteEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Workspace Data Filter
     * @param {EntitiesApiDeleteEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityWorkspaceDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Setting for Workspace
     * @param {EntitiesApiDeleteEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityWorkspaceSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Delete Workspace entity
     * @param {EntitiesApiDeleteEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    deleteEntityWorkspaces(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .deleteEntityWorkspaces(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Dashboards
     * @param {EntitiesApiGetAllEntitiesAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesAnalyticalDashboards(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesAnalyticalDashboards(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all api tokens for a user
     * @param {EntitiesApiGetAllEntitiesApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesApiTokens(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesApiTokens(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Attribute Hierarchies
     * @param {EntitiesApiGetAllEntitiesAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesAttributeHierarchies(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesAttributeHierarchies(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Attributes
     * @param {EntitiesApiGetAllEntitiesAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesAttributes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesAttributes(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Automations
     * @param {EntitiesApiGetAllEntitiesAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesAutomations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesAutomations(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Color Pallettes
     * @param {EntitiesApiGetAllEntitiesColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesColorPalettes(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesColorPalettes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Get CSP Directives
     * @param {EntitiesApiGetAllEntitiesCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesCspDirectives(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesCspDirectives(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Custom Application Settings
     * @param {EntitiesApiGetAllEntitiesCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesCustomApplicationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesCustomApplicationSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Plugins
     * @param {EntitiesApiGetAllEntitiesDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesDashboardPlugins(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesDashboardPlugins(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Data Source Identifiers
     * @param {EntitiesApiGetAllEntitiesDataSourceIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesDataSourceIdentifiers(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesDataSourceIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Get Data Source entities
     * @param {EntitiesApiGetAllEntitiesDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesDataSources(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesDataSources(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Datasets
     * @param {EntitiesApiGetAllEntitiesDatasetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesDatasets(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesDatasets(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Entitlements
     * @param {EntitiesApiGetAllEntitiesEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesEntitlements(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesEntitlements(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Export Definitions
     * @param {EntitiesApiGetAllEntitiesExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesExportDefinitions(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesExportDefinitions(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Facts
     * @param {EntitiesApiGetAllEntitiesFactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesFacts(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesFacts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Context Filters
     * @param {EntitiesApiGetAllEntitiesFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesFilterContexts(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesFilterContexts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Filter views
     * @param {EntitiesApiGetAllEntitiesFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesFilterViews(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesFilterViews(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Identity Providers
     * @param {EntitiesApiGetAllEntitiesIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesIdentityProviders(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesIdentityProviders(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
     * @summary Get all Jwks
     * @param {EntitiesApiGetAllEntitiesJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesJwks(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesJwks(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Labels
     * @param {EntitiesApiGetAllEntitiesLabelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesLabels(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesLabels(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all LLM endpoint entities
     * @param {EntitiesApiGetAllEntitiesLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesLlmEndpoints(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesLlmEndpoints(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Metrics
     * @param {EntitiesApiGetAllEntitiesMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesMetrics(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesMetrics(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Notification Channel entities
     * @param {EntitiesApiGetAllEntitiesNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesNotificationChannels(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesNotificationChannels(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Organization entities
     * @param {EntitiesApiGetAllEntitiesOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesOrganizationSettings(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesOrganizationSettings(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Theming entities
     * @param {EntitiesApiGetAllEntitiesThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesThemes(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesThemes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all User Data Filters
     * @param {EntitiesApiGetAllEntitiesUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesUserDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesUserDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Get UserGroup entities
     * @param {EntitiesApiGetAllEntitiesUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesUserGroups(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesUserGroups(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * UserIdentifier - represents entity interacting with platform
     * @summary Get UserIdentifier entities
     * @param {EntitiesApiGetAllEntitiesUserIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesUserIdentifiers(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesUserIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all settings for a user
     * @param {EntitiesApiGetAllEntitiesUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesUserSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesUserSettings(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Get User entities
     * @param {EntitiesApiGetAllEntitiesUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesUsers(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesUsers(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Visualization Objects
     * @param {EntitiesApiGetAllEntitiesVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesVisualizationObjects(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesVisualizationObjects(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Settings for Workspace Data Filters
     * @param {EntitiesApiGetAllEntitiesWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesWorkspaceDataFilterSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Workspace Data Filters
     * @param {EntitiesApiGetAllEntitiesWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesWorkspaceDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Setting for Workspaces
     * @param {EntitiesApiGetAllEntitiesWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesWorkspaceSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesWorkspaceSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Workspace entities
     * @param {EntitiesApiGetAllEntitiesWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllEntitiesWorkspaces(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getAllEntitiesWorkspaces(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves links for all options for different configurations.
     * @summary Links for all configuration options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getAllOptions(options) {
        return EntitiesApiFp(this.configuration)
            .getAllOptions(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a list of all supported data sources along with information about the used drivers.
     * @summary Get all available data source drivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getDataSourceDrivers(options) {
        return EntitiesApiFp(this.configuration)
            .getDataSourceDrivers(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Dashboard
     * @param {EntitiesApiGetEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityAnalyticalDashboards(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an API Token for a user
     * @param {EntitiesApiGetEntityApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityApiTokens(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Attribute Hierarchy
     * @param {EntitiesApiGetEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityAttributeHierarchies(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Attribute
     * @param {EntitiesApiGetEntityAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityAttributes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityAttributes(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Automation
     * @param {EntitiesApiGetEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityAutomations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Color Pallette
     * @param {EntitiesApiGetEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityColorPalettes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get CookieSecurityConfiguration
     * @param {EntitiesApiGetEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityCookieSecurityConfigurations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Get CSP Directives
     * @param {EntitiesApiGetEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityCspDirectives(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Custom Application Setting
     * @param {EntitiesApiGetEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityCustomApplicationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Plugin
     * @param {EntitiesApiGetEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityDashboardPlugins(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Data Source Identifier
     * @param {EntitiesApiGetEntityDataSourceIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityDataSourceIdentifiers(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityDataSourceIdentifiers(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Get Data Source entity
     * @param {EntitiesApiGetEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityDataSources(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityDataSources(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Dataset
     * @param {EntitiesApiGetEntityDatasetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityDatasets(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityDatasets(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Entitlement
     * @param {EntitiesApiGetEntityEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityEntitlements(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityEntitlements(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Export Definition
     * @param {EntitiesApiGetEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityExportDefinitions(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Fact
     * @param {EntitiesApiGetEntityFactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityFacts(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityFacts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Context Filter
     * @param {EntitiesApiGetEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityFilterContexts(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Filter view
     * @param {EntitiesApiGetEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityFilterViews(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Identity Provider
     * @param {EntitiesApiGetEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityIdentityProviders(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Get Jwk
     * @param {EntitiesApiGetEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityJwks(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityJwks(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Label
     * @param {EntitiesApiGetEntityLabelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityLabels(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityLabels(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get LLM endpoint entity
     * @param {EntitiesApiGetEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityLlmEndpoints(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Metric
     * @param {EntitiesApiGetEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityMetrics(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Notification Channel entity
     * @param {EntitiesApiGetEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityNotificationChannels(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Organization entity
     * @param {EntitiesApiGetEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityOrganizationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Organizations
     * @param {EntitiesApiGetEntityOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityOrganizations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityOrganizations(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Theming
     * @param {EntitiesApiGetEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityThemes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityThemes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a User Data Filter
     * @param {EntitiesApiGetEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityUserDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Get UserGroup entity
     * @param {EntitiesApiGetEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityUserGroups(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityUserGroups(requestParameters.id, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * UserIdentifier - represents basic information about entity interacting with platform
     * @summary Get UserIdentifier entity
     * @param {EntitiesApiGetEntityUserIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityUserIdentifiers(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityUserIdentifiers(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a setting for a user
     * @param {EntitiesApiGetEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityUserSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Get User entity
     * @param {EntitiesApiGetEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityUsers(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityUsers(requestParameters.id, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Visualization Object
     * @param {EntitiesApiGetEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityVisualizationObjects(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Setting for Workspace Data Filter
     * @param {EntitiesApiGetEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Workspace Data Filter
     * @param {EntitiesApiGetEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityWorkspaceDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Setting for Workspace
     * @param {EntitiesApiGetEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityWorkspaceSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Workspace entity
     * @param {EntitiesApiGetEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityWorkspaces(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .getEntityWorkspaces(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a basic information about organization.
     * @summary Get current organization info
     * @param {EntitiesApiGetOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getOrganization(requestParameters = {}, options) {
        return EntitiesApiFp(this.configuration)
            .getOrganization(requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Dashboard
     * @param {EntitiesApiPatchEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityAnalyticalDashboards(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an Attribute Hierarchy
     * @param {EntitiesApiPatchEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityAttributeHierarchies(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an Automation
     * @param {EntitiesApiPatchEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityAutomations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Color Pallette
     * @param {EntitiesApiPatchEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityColorPalettes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPalettePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch CookieSecurityConfiguration
     * @param {EntitiesApiPatchEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityCookieSecurityConfigurations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Patch CSP Directives
     * @param {EntitiesApiPatchEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityCspDirectives(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectivePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Custom Application Setting
     * @param {EntitiesApiPatchEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityCustomApplicationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Plugin
     * @param {EntitiesApiPatchEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityDashboardPlugins(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Patch Data Source entity
     * @param {EntitiesApiPatchEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityDataSources(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourcePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an Export Definition
     * @param {EntitiesApiPatchEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityExportDefinitions(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Context Filter
     * @param {EntitiesApiPatchEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityFilterContexts(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Filter view
     * @param {EntitiesApiPatchEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityFilterViews(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Identity Provider
     * @param {EntitiesApiPatchEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityIdentityProviders(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Patches JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Patch Jwk
     * @param {EntitiesApiPatchEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityJwks(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityJwks(requestParameters.id, requestParameters.jsonApiJwkPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch LLM endpoint entity
     * @param {EntitiesApiPatchEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityLlmEndpoints(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Metric
     * @param {EntitiesApiPatchEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityMetrics(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Notification Channel entity
     * @param {EntitiesApiPatchEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityNotificationChannels(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Organization entity
     * @param {EntitiesApiPatchEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityOrganizationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Organization
     * @param {EntitiesApiPatchEntityOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityOrganizations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Theming
     * @param {EntitiesApiPatchEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityThemes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityThemes(requestParameters.id, requestParameters.jsonApiThemePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a User Data Filter
     * @param {EntitiesApiPatchEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityUserDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Patch UserGroup entity
     * @param {EntitiesApiPatchEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityUserGroups(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Patch User entity
     * @param {EntitiesApiPatchEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityUsers(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityUsers(requestParameters.id, requestParameters.jsonApiUserPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Visualization Object
     * @param {EntitiesApiPatchEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityVisualizationObjects(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Settings for Workspace Data Filter
     * @param {EntitiesApiPatchEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Workspace Data Filter
     * @param {EntitiesApiPatchEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityWorkspaceDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Setting for Workspace
     * @param {EntitiesApiPatchEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityWorkspaceSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Patch Workspace entity
     * @param {EntitiesApiPatchEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    patchEntityWorkspaces(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .patchEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspacePatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Dashboards
     * @param {EntitiesApiUpdateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityAnalyticalDashboards(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put an Attribute Hierarchy
     * @param {EntitiesApiUpdateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityAttributeHierarchies(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put an Automation
     * @param {EntitiesApiUpdateEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityAutomations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Color Pallette
     * @param {EntitiesApiUpdateEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityColorPalettes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPaletteInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put CookieSecurityConfiguration
     * @param {EntitiesApiUpdateEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityCookieSecurityConfigurations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Put CSP Directives
     * @param {EntitiesApiUpdateEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityCspDirectives(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectiveInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Custom Application Setting
     * @param {EntitiesApiUpdateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityCustomApplicationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Plugin
     * @param {EntitiesApiUpdateEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityDashboardPlugins(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Put Data Source entity
     * @param {EntitiesApiUpdateEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityDataSources(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourceInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put an Export Definition
     * @param {EntitiesApiUpdateEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityExportDefinitions(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Context Filter
     * @param {EntitiesApiUpdateEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityFilterContexts(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Filter views
     * @param {EntitiesApiUpdateEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityFilterViews(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Identity Provider
     * @param {EntitiesApiUpdateEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityIdentityProviders(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Put Jwk
     * @param {EntitiesApiUpdateEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityJwks(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityJwks(requestParameters.id, requestParameters.jsonApiJwkInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PUT LLM endpoint entity
     * @param {EntitiesApiUpdateEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityLlmEndpoints(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Metric
     * @param {EntitiesApiUpdateEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityMetrics(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Notification Channel entity
     * @param {EntitiesApiUpdateEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityNotificationChannels(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Organization entity
     * @param {EntitiesApiUpdateEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityOrganizationSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Organization
     * @param {EntitiesApiUpdateEntityOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityOrganizations(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Theming
     * @param {EntitiesApiUpdateEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityThemes(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityThemes(requestParameters.id, requestParameters.jsonApiThemeInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a User Data Filter
     * @param {EntitiesApiUpdateEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityUserDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Put UserGroup entity
     * @param {EntitiesApiUpdateEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityUserGroups(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put new user settings for the user
     * @param {EntitiesApiUpdateEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityUserSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.jsonApiUserSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Put User entity
     * @param {EntitiesApiUpdateEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityUsers(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityUsers(requestParameters.id, requestParameters.jsonApiUserInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Visualization Object
     * @param {EntitiesApiUpdateEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityVisualizationObjects(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Settings for Workspace Data Filter
     * @param {EntitiesApiUpdateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Workspace Data Filter
     * @param {EntitiesApiUpdateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityWorkspaceDataFilters(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Setting for a Workspace
     * @param {EntitiesApiUpdateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityWorkspaceSettings(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Put Workspace entity
     * @param {EntitiesApiUpdateEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    updateEntityWorkspaces(requestParameters, options) {
        return EntitiesApiFp(this.configuration)
            .updateEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspaceInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EntitlementApi - axios parameter creator
 * @export
 */
export const EntitlementApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Space of the shared interest
         * @summary Get Entitlements
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesEntitlements: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlement
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityEntitlements: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityEntitlements", "id", id);
            const localVarPath = `/api/v1/entities/entitlements/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves values of available entitlements for the organization.
         * @summary Values for all public entitlements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAllEntitlements: async (options = {}) => {
            const localVarPath = `/api/v1/actions/resolveEntitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves values for requested entitlements in the organization.
         * @summary Values for requested public entitlements.
         * @param {EntitlementsRequest} entitlementsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveRequestedEntitlements: async (entitlementsRequest, options = {}) => {
            // verify required parameter 'entitlementsRequest' is not null or undefined
            assertParamExists("resolveRequestedEntitlements", "entitlementsRequest", entitlementsRequest);
            const localVarPath = `/api/v1/actions/resolveEntitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof entitlementsRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(entitlementsRequest !== undefined ? entitlementsRequest : {})
                : entitlementsRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EntitlementApi - functional programming interface
 * @export
 */
export const EntitlementApiFp = function (configuration) {
    const localVarAxiosParamCreator = EntitlementApiAxiosParamCreator(configuration);
    return {
        /**
         * Space of the shared interest
         * @summary Get Entitlements
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesEntitlements(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesEntitlements(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlement
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityEntitlements(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityEntitlements(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves values of available entitlements for the organization.
         * @summary Values for all public entitlements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveAllEntitlements(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveAllEntitlements(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves values for requested entitlements in the organization.
         * @summary Values for requested public entitlements.
         * @param {EntitlementsRequest} entitlementsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveRequestedEntitlements(entitlementsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveRequestedEntitlements(entitlementsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * EntitlementApi - factory interface
 * @export
 */
export const EntitlementApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EntitlementApiFp(configuration);
    return {
        /**
         * Space of the shared interest
         * @summary Get Entitlements
         * @param {EntitlementApiGetAllEntitiesEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesEntitlements(requestParameters, options) {
            return localVarFp
                .getAllEntitiesEntitlements(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlement
         * @param {EntitlementApiGetEntityEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityEntitlements(requestParameters, options) {
            return localVarFp
                .getEntityEntitlements(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Resolves values of available entitlements for the organization.
         * @summary Values for all public entitlements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAllEntitlements(options) {
            return localVarFp.resolveAllEntitlements(options).then((request) => request(axios, basePath));
        },
        /**
         * Resolves values for requested entitlements in the organization.
         * @summary Values for requested public entitlements.
         * @param {EntitlementApiResolveRequestedEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveRequestedEntitlements(requestParameters, options) {
            return localVarFp
                .resolveRequestedEntitlements(requestParameters.entitlementsRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * EntitlementApi - object-oriented interface
 * @export
 * @class EntitlementApi
 * @extends {BaseAPI}
 */
export class EntitlementApi extends BaseAPI {
    /**
     * Space of the shared interest
     * @summary Get Entitlements
     * @param {EntitlementApiGetAllEntitiesEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    getAllEntitiesEntitlements(requestParameters = {}, options) {
        return EntitlementApiFp(this.configuration)
            .getAllEntitiesEntitlements(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Entitlement
     * @param {EntitlementApiGetEntityEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    getEntityEntitlements(requestParameters, options) {
        return EntitlementApiFp(this.configuration)
            .getEntityEntitlements(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves values of available entitlements for the organization.
     * @summary Values for all public entitlements.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    resolveAllEntitlements(options) {
        return EntitlementApiFp(this.configuration)
            .resolveAllEntitlements(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves values for requested entitlements in the organization.
     * @summary Values for requested public entitlements.
     * @param {EntitlementApiResolveRequestedEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    resolveRequestedEntitlements(requestParameters, options) {
        return EntitlementApiFp(this.configuration)
            .resolveRequestedEntitlements(requestParameters.entitlementsRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExportDefinitionsApi - axios parameter creator
 * @export
 */
export const ExportDefinitionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Export Definitions
         * @param {string} workspaceId
         * @param {JsonApiExportDefinitionPostOptionalIdDocument} jsonApiExportDefinitionPostOptionalIdDocument
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityExportDefinitions: async (workspaceId, jsonApiExportDefinitionPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiExportDefinitionPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityExportDefinitions", "jsonApiExportDefinitionPostOptionalIdDocument", jsonApiExportDefinitionPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiExportDefinitionPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiExportDefinitionPostOptionalIdDocument !== undefined
                    ? jsonApiExportDefinitionPostOptionalIdDocument
                    : {})
                : jsonApiExportDefinitionPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityExportDefinitions: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityExportDefinitions", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Export Definitions
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesExportDefinitions: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesExportDefinitions", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityExportDefinitions: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityExportDefinitions", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionPatchDocument} jsonApiExportDefinitionPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityExportDefinitions: async (workspaceId, objectId, jsonApiExportDefinitionPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityExportDefinitions", "objectId", objectId);
            // verify required parameter 'jsonApiExportDefinitionPatchDocument' is not null or undefined
            assertParamExists("patchEntityExportDefinitions", "jsonApiExportDefinitionPatchDocument", jsonApiExportDefinitionPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiExportDefinitionPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiExportDefinitionPatchDocument !== undefined
                    ? jsonApiExportDefinitionPatchDocument
                    : {})
                : jsonApiExportDefinitionPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionInDocument} jsonApiExportDefinitionInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityExportDefinitions: async (workspaceId, objectId, jsonApiExportDefinitionInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityExportDefinitions", "objectId", objectId);
            // verify required parameter 'jsonApiExportDefinitionInDocument' is not null or undefined
            assertParamExists("updateEntityExportDefinitions", "jsonApiExportDefinitionInDocument", jsonApiExportDefinitionInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiExportDefinitionInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiExportDefinitionInDocument !== undefined
                    ? jsonApiExportDefinitionInDocument
                    : {})
                : jsonApiExportDefinitionInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ExportDefinitionsApi - functional programming interface
 * @export
 */
export const ExportDefinitionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExportDefinitionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Export Definitions
         * @param {string} workspaceId
         * @param {JsonApiExportDefinitionPostOptionalIdDocument} jsonApiExportDefinitionPostOptionalIdDocument
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityExportDefinitions(workspaceId, jsonApiExportDefinitionPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityExportDefinitions(workspaceId, jsonApiExportDefinitionPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityExportDefinitions(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityExportDefinitions(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Export Definitions
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesExportDefinitions(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesExportDefinitions(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityExportDefinitions(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityExportDefinitions(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionPatchDocument} jsonApiExportDefinitionPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionInDocument} jsonApiExportDefinitionInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ExportDefinitionsApi - factory interface
 * @export
 */
export const ExportDefinitionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExportDefinitionsApiFp(configuration);
    return {
        /**
         *
         * @summary Post Export Definitions
         * @param {ExportDefinitionsApiCreateEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .createEntityExportDefinitions(requestParameters.workspaceId, requestParameters.jsonApiExportDefinitionPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Export Definition
         * @param {ExportDefinitionsApiDeleteEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .deleteEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Export Definitions
         * @param {ExportDefinitionsApiGetAllEntitiesExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesExportDefinitions(requestParameters, options) {
            return localVarFp
                .getAllEntitiesExportDefinitions(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Export Definition
         * @param {ExportDefinitionsApiGetEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .getEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an Export Definition
         * @param {ExportDefinitionsApiPatchEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .patchEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put an Export Definition
         * @param {ExportDefinitionsApiUpdateEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .updateEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExportDefinitionsApi - object-oriented interface
 * @export
 * @class ExportDefinitionsApi
 * @extends {BaseAPI}
 */
export class ExportDefinitionsApi extends BaseAPI {
    /**
     *
     * @summary Post Export Definitions
     * @param {ExportDefinitionsApiCreateEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportDefinitionsApi
     */
    createEntityExportDefinitions(requestParameters, options) {
        return ExportDefinitionsApiFp(this.configuration)
            .createEntityExportDefinitions(requestParameters.workspaceId, requestParameters.jsonApiExportDefinitionPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Export Definition
     * @param {ExportDefinitionsApiDeleteEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportDefinitionsApi
     */
    deleteEntityExportDefinitions(requestParameters, options) {
        return ExportDefinitionsApiFp(this.configuration)
            .deleteEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Export Definitions
     * @param {ExportDefinitionsApiGetAllEntitiesExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportDefinitionsApi
     */
    getAllEntitiesExportDefinitions(requestParameters, options) {
        return ExportDefinitionsApiFp(this.configuration)
            .getAllEntitiesExportDefinitions(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Export Definition
     * @param {ExportDefinitionsApiGetEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportDefinitionsApi
     */
    getEntityExportDefinitions(requestParameters, options) {
        return ExportDefinitionsApiFp(this.configuration)
            .getEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an Export Definition
     * @param {ExportDefinitionsApiPatchEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportDefinitionsApi
     */
    patchEntityExportDefinitions(requestParameters, options) {
        return ExportDefinitionsApiFp(this.configuration)
            .patchEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put an Export Definition
     * @param {ExportDefinitionsApiUpdateEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportDefinitionsApi
     */
    updateEntityExportDefinitions(requestParameters, options) {
        return ExportDefinitionsApiFp(this.configuration)
            .updateEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FactsApi - axios parameter creator
 * @export
 */
export const FactsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all Facts
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFacts: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesFacts", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/facts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Fact
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFacts: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityFacts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityFacts", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/facts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FactsApi - functional programming interface
 * @export
 */
export const FactsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FactsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all Facts
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFacts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFacts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Fact
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityFacts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityFacts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * FactsApi - factory interface
 * @export
 */
export const FactsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FactsApiFp(configuration);
    return {
        /**
         *
         * @summary Get all Facts
         * @param {FactsApiGetAllEntitiesFactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFacts(requestParameters, options) {
            return localVarFp
                .getAllEntitiesFacts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Fact
         * @param {FactsApiGetEntityFactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFacts(requestParameters, options) {
            return localVarFp
                .getEntityFacts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FactsApi - object-oriented interface
 * @export
 * @class FactsApi
 * @extends {BaseAPI}
 */
export class FactsApi extends BaseAPI {
    /**
     *
     * @summary Get all Facts
     * @param {FactsApiGetAllEntitiesFactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactsApi
     */
    getAllEntitiesFacts(requestParameters, options) {
        return FactsApiFp(this.configuration)
            .getAllEntitiesFacts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Fact
     * @param {FactsApiGetEntityFactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactsApi
     */
    getEntityFacts(requestParameters, options) {
        return FactsApiFp(this.configuration)
            .getEntityFacts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FilterViewsApi - axios parameter creator
 * @export
 */
export const FilterViewsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Filter views
         * @param {string} workspaceId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterViews: async (workspaceId, jsonApiFilterViewInDocument, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiFilterViewInDocument' is not null or undefined
            assertParamExists("createEntityFilterViews", "jsonApiFilterViewInDocument", jsonApiFilterViewInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterViewInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterViewInDocument !== undefined ? jsonApiFilterViewInDocument : {})
                : jsonApiFilterViewInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterViews: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityFilterViews", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Filter views
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterViews: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesFilterViews", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterViews: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityFilterViews", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve filter views for the specific workspace
         * @summary Get filter views
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterViews: async (workspaceId, exclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getFilterViews", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewPatchDocument} jsonApiFilterViewPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterViews: async (workspaceId, objectId, jsonApiFilterViewPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityFilterViews", "objectId", objectId);
            // verify required parameter 'jsonApiFilterViewPatchDocument' is not null or undefined
            assertParamExists("patchEntityFilterViews", "jsonApiFilterViewPatchDocument", jsonApiFilterViewPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterViewPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterViewPatchDocument !== undefined ? jsonApiFilterViewPatchDocument : {})
                : jsonApiFilterViewPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set filter views for the specific workspace.
         * @summary Set filter views
         * @param {string} workspaceId
         * @param {Array<DeclarativeFilterView>} declarativeFilterView
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFilterViews: async (workspaceId, declarativeFilterView, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'declarativeFilterView' is not null or undefined
            assertParamExists("setFilterViews", "declarativeFilterView", declarativeFilterView);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeFilterView !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeFilterView !== undefined ? declarativeFilterView : {})
                : declarativeFilterView || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Filter views
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterViews: async (workspaceId, objectId, jsonApiFilterViewInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityFilterViews", "objectId", objectId);
            // verify required parameter 'jsonApiFilterViewInDocument' is not null or undefined
            assertParamExists("updateEntityFilterViews", "jsonApiFilterViewInDocument", jsonApiFilterViewInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterViewInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterViewInDocument !== undefined ? jsonApiFilterViewInDocument : {})
                : jsonApiFilterViewInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FilterViewsApi - functional programming interface
 * @export
 */
export const FilterViewsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FilterViewsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Filter views
         * @param {string} workspaceId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityFilterViews(workspaceId, jsonApiFilterViewInDocument, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityFilterViews(workspaceId, jsonApiFilterViewInDocument, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityFilterViews(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityFilterViews(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Filter views
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFilterViews(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFilterViews(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityFilterViews(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityFilterViews(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve filter views for the specific workspace
         * @summary Get filter views
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilterViews(workspaceId, exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilterViews(workspaceId, exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewPatchDocument} jsonApiFilterViewPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityFilterViews(workspaceId, objectId, jsonApiFilterViewPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityFilterViews(workspaceId, objectId, jsonApiFilterViewPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set filter views for the specific workspace.
         * @summary Set filter views
         * @param {string} workspaceId
         * @param {Array<DeclarativeFilterView>} declarativeFilterView
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFilterViews(workspaceId, declarativeFilterView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFilterViews(workspaceId, declarativeFilterView, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Filter views
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityFilterViews(workspaceId, objectId, jsonApiFilterViewInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityFilterViews(workspaceId, objectId, jsonApiFilterViewInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * FilterViewsApi - factory interface
 * @export
 */
export const FilterViewsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FilterViewsApiFp(configuration);
    return {
        /**
         *
         * @summary Post Filter views
         * @param {FilterViewsApiCreateEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterViews(requestParameters, options) {
            return localVarFp
                .createEntityFilterViews(requestParameters.workspaceId, requestParameters.jsonApiFilterViewInDocument, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Filter view
         * @param {FilterViewsApiDeleteEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterViews(requestParameters, options) {
            return localVarFp
                .deleteEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Filter views
         * @param {FilterViewsApiGetAllEntitiesFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterViews(requestParameters, options) {
            return localVarFp
                .getAllEntitiesFilterViews(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Filter view
         * @param {FilterViewsApiGetEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterViews(requestParameters, options) {
            return localVarFp
                .getEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve filter views for the specific workspace
         * @summary Get filter views
         * @param {FilterViewsApiGetFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterViews(requestParameters, options) {
            return localVarFp
                .getFilterViews(requestParameters.workspaceId, requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Filter view
         * @param {FilterViewsApiPatchEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterViews(requestParameters, options) {
            return localVarFp
                .patchEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set filter views for the specific workspace.
         * @summary Set filter views
         * @param {FilterViewsApiSetFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFilterViews(requestParameters, options) {
            return localVarFp
                .setFilterViews(requestParameters.workspaceId, requestParameters.declarativeFilterView, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Filter views
         * @param {FilterViewsApiUpdateEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterViews(requestParameters, options) {
            return localVarFp
                .updateEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FilterViewsApi - object-oriented interface
 * @export
 * @class FilterViewsApi
 * @extends {BaseAPI}
 */
export class FilterViewsApi extends BaseAPI {
    /**
     *
     * @summary Post Filter views
     * @param {FilterViewsApiCreateEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewsApi
     */
    createEntityFilterViews(requestParameters, options) {
        return FilterViewsApiFp(this.configuration)
            .createEntityFilterViews(requestParameters.workspaceId, requestParameters.jsonApiFilterViewInDocument, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Filter view
     * @param {FilterViewsApiDeleteEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewsApi
     */
    deleteEntityFilterViews(requestParameters, options) {
        return FilterViewsApiFp(this.configuration)
            .deleteEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Filter views
     * @param {FilterViewsApiGetAllEntitiesFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewsApi
     */
    getAllEntitiesFilterViews(requestParameters, options) {
        return FilterViewsApiFp(this.configuration)
            .getAllEntitiesFilterViews(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Filter view
     * @param {FilterViewsApiGetEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewsApi
     */
    getEntityFilterViews(requestParameters, options) {
        return FilterViewsApiFp(this.configuration)
            .getEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve filter views for the specific workspace
     * @summary Get filter views
     * @param {FilterViewsApiGetFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewsApi
     */
    getFilterViews(requestParameters, options) {
        return FilterViewsApiFp(this.configuration)
            .getFilterViews(requestParameters.workspaceId, requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Filter view
     * @param {FilterViewsApiPatchEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewsApi
     */
    patchEntityFilterViews(requestParameters, options) {
        return FilterViewsApiFp(this.configuration)
            .patchEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set filter views for the specific workspace.
     * @summary Set filter views
     * @param {FilterViewsApiSetFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewsApi
     */
    setFilterViews(requestParameters, options) {
        return FilterViewsApiFp(this.configuration)
            .setFilterViews(requestParameters.workspaceId, requestParameters.declarativeFilterView, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Filter views
     * @param {FilterViewsApiUpdateEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewsApi
     */
    updateEntityFilterViews(requestParameters, options) {
        return FilterViewsApiFp(this.configuration)
            .updateEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GenerateLogicalDataModelApi - axios parameter creator
 * @export
 */
export const GenerateLogicalDataModelApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Generate logical data model (LDM) from physical data model (PDM) stored in data source.
         * @summary Generate logical data model (LDM) from physical data model (PDM)
         * @param {string} dataSourceId
         * @param {GenerateLdmRequest} generateLdmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLogicalModel: async (dataSourceId, generateLdmRequest, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("generateLogicalModel", "dataSourceId", dataSourceId);
            // verify required parameter 'generateLdmRequest' is not null or undefined
            assertParamExists("generateLogicalModel", "generateLdmRequest", generateLdmRequest);
            const localVarPath = `/api/v1/actions/dataSources/{dataSourceId}/generateLogicalModel`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof generateLdmRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(generateLdmRequest !== undefined ? generateLdmRequest : {})
                : generateLdmRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * GenerateLogicalDataModelApi - functional programming interface
 * @export
 */
export const GenerateLogicalDataModelApiFp = function (configuration) {
    const localVarAxiosParamCreator = GenerateLogicalDataModelApiAxiosParamCreator(configuration);
    return {
        /**
         * Generate logical data model (LDM) from physical data model (PDM) stored in data source.
         * @summary Generate logical data model (LDM) from physical data model (PDM)
         * @param {string} dataSourceId
         * @param {GenerateLdmRequest} generateLdmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLogicalModel(dataSourceId, generateLdmRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLogicalModel(dataSourceId, generateLdmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * GenerateLogicalDataModelApi - factory interface
 * @export
 */
export const GenerateLogicalDataModelApiFactory = function (configuration, basePath, axios) {
    const localVarFp = GenerateLogicalDataModelApiFp(configuration);
    return {
        /**
         * Generate logical data model (LDM) from physical data model (PDM) stored in data source.
         * @summary Generate logical data model (LDM) from physical data model (PDM)
         * @param {GenerateLogicalDataModelApiGenerateLogicalModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLogicalModel(requestParameters, options) {
            return localVarFp
                .generateLogicalModel(requestParameters.dataSourceId, requestParameters.generateLdmRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * GenerateLogicalDataModelApi - object-oriented interface
 * @export
 * @class GenerateLogicalDataModelApi
 * @extends {BaseAPI}
 */
export class GenerateLogicalDataModelApi extends BaseAPI {
    /**
     * Generate logical data model (LDM) from physical data model (PDM) stored in data source.
     * @summary Generate logical data model (LDM) from physical data model (PDM)
     * @param {GenerateLogicalDataModelApiGenerateLogicalModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenerateLogicalDataModelApi
     */
    generateLogicalModel(requestParameters, options) {
        return GenerateLogicalDataModelApiFp(this.configuration)
            .generateLogicalModel(requestParameters.dataSourceId, requestParameters.generateLdmRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HierarchyApi - axios parameter creator
 * @export
 */
export const HierarchyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Finds entities with given ID in hierarchy (e.g. to check possible future conflicts).
         * @summary Finds entities with given ID in hierarchy.
         * @param {string} workspaceId
         * @param {Array<HierarchyObjectIdentification>} hierarchyObjectIdentification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEntityOverrides: async (workspaceId, hierarchyObjectIdentification, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("checkEntityOverrides", "workspaceId", workspaceId);
            // verify required parameter 'hierarchyObjectIdentification' is not null or undefined
            assertParamExists("checkEntityOverrides", "hierarchyObjectIdentification", hierarchyObjectIdentification);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/checkEntityOverrides`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof hierarchyObjectIdentification !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(hierarchyObjectIdentification !== undefined ? hierarchyObjectIdentification : {})
                : hierarchyObjectIdentification || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds API identifier conflicts in given workspace hierarchy.
         * @summary Finds identifier conflicts in workspace hierarchy.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inheritedEntityConflicts: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("inheritedEntityConflicts", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/inheritedEntityConflicts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get used entity prefixes in hierarchy of parent workspaces
         * @summary Get used entity prefixes in hierarchy
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inheritedEntityPrefixes: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("inheritedEntityPrefixes", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/inheritedEntityPrefixes`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds API identifier overrides in given workspace hierarchy.
         * @summary Finds identifier overrides in workspace hierarchy.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overriddenChildEntities: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("overriddenChildEntities", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/overriddenChildEntities`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HierarchyApi - functional programming interface
 * @export
 */
export const HierarchyApiFp = function (configuration) {
    const localVarAxiosParamCreator = HierarchyApiAxiosParamCreator(configuration);
    return {
        /**
         * Finds entities with given ID in hierarchy (e.g. to check possible future conflicts).
         * @summary Finds entities with given ID in hierarchy.
         * @param {string} workspaceId
         * @param {Array<HierarchyObjectIdentification>} hierarchyObjectIdentification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkEntityOverrides(workspaceId, hierarchyObjectIdentification, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkEntityOverrides(workspaceId, hierarchyObjectIdentification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finds API identifier conflicts in given workspace hierarchy.
         * @summary Finds identifier conflicts in workspace hierarchy.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inheritedEntityConflicts(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inheritedEntityConflicts(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get used entity prefixes in hierarchy of parent workspaces
         * @summary Get used entity prefixes in hierarchy
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inheritedEntityPrefixes(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inheritedEntityPrefixes(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finds API identifier overrides in given workspace hierarchy.
         * @summary Finds identifier overrides in workspace hierarchy.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overriddenChildEntities(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overriddenChildEntities(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * HierarchyApi - factory interface
 * @export
 */
export const HierarchyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HierarchyApiFp(configuration);
    return {
        /**
         * Finds entities with given ID in hierarchy (e.g. to check possible future conflicts).
         * @summary Finds entities with given ID in hierarchy.
         * @param {HierarchyApiCheckEntityOverridesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEntityOverrides(requestParameters, options) {
            return localVarFp
                .checkEntityOverrides(requestParameters.workspaceId, requestParameters.hierarchyObjectIdentification, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Finds API identifier conflicts in given workspace hierarchy.
         * @summary Finds identifier conflicts in workspace hierarchy.
         * @param {HierarchyApiInheritedEntityConflictsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inheritedEntityConflicts(requestParameters, options) {
            return localVarFp
                .inheritedEntityConflicts(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get used entity prefixes in hierarchy of parent workspaces
         * @summary Get used entity prefixes in hierarchy
         * @param {HierarchyApiInheritedEntityPrefixesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inheritedEntityPrefixes(requestParameters, options) {
            return localVarFp
                .inheritedEntityPrefixes(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Finds API identifier overrides in given workspace hierarchy.
         * @summary Finds identifier overrides in workspace hierarchy.
         * @param {HierarchyApiOverriddenChildEntitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overriddenChildEntities(requestParameters, options) {
            return localVarFp
                .overriddenChildEntities(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * HierarchyApi - object-oriented interface
 * @export
 * @class HierarchyApi
 * @extends {BaseAPI}
 */
export class HierarchyApi extends BaseAPI {
    /**
     * Finds entities with given ID in hierarchy (e.g. to check possible future conflicts).
     * @summary Finds entities with given ID in hierarchy.
     * @param {HierarchyApiCheckEntityOverridesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyApi
     */
    checkEntityOverrides(requestParameters, options) {
        return HierarchyApiFp(this.configuration)
            .checkEntityOverrides(requestParameters.workspaceId, requestParameters.hierarchyObjectIdentification, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Finds API identifier conflicts in given workspace hierarchy.
     * @summary Finds identifier conflicts in workspace hierarchy.
     * @param {HierarchyApiInheritedEntityConflictsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyApi
     */
    inheritedEntityConflicts(requestParameters, options) {
        return HierarchyApiFp(this.configuration)
            .inheritedEntityConflicts(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get used entity prefixes in hierarchy of parent workspaces
     * @summary Get used entity prefixes in hierarchy
     * @param {HierarchyApiInheritedEntityPrefixesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyApi
     */
    inheritedEntityPrefixes(requestParameters, options) {
        return HierarchyApiFp(this.configuration)
            .inheritedEntityPrefixes(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Finds API identifier overrides in given workspace hierarchy.
     * @summary Finds identifier overrides in workspace hierarchy.
     * @param {HierarchyApiOverriddenChildEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyApi
     */
    overriddenChildEntities(requestParameters, options) {
        return HierarchyApiFp(this.configuration)
            .overriddenChildEntities(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * IdentityProvidersApi - axios parameter creator
 * @export
 */
export const IdentityProvidersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Identity Providers
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityIdentityProviders: async (jsonApiIdentityProviderInDocument, options = {}) => {
            // verify required parameter 'jsonApiIdentityProviderInDocument' is not null or undefined
            assertParamExists("createEntityIdentityProviders", "jsonApiIdentityProviderInDocument", jsonApiIdentityProviderInDocument);
            const localVarPath = `/api/v1/entities/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiIdentityProviderInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiIdentityProviderInDocument !== undefined
                    ? jsonApiIdentityProviderInDocument
                    : {})
                : jsonApiIdentityProviderInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityIdentityProviders: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityIdentityProviders", "id", id);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Identity Providers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesIdentityProviders: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityIdentityProviders: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityIdentityProviders", "id", id);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets complete layout of identity providers.
         * @summary Get all identity providers layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityProvidersLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderPatchDocument} jsonApiIdentityProviderPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityIdentityProviders: async (id, jsonApiIdentityProviderPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityIdentityProviders", "id", id);
            // verify required parameter 'jsonApiIdentityProviderPatchDocument' is not null or undefined
            assertParamExists("patchEntityIdentityProviders", "jsonApiIdentityProviderPatchDocument", jsonApiIdentityProviderPatchDocument);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiIdentityProviderPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiIdentityProviderPatchDocument !== undefined
                    ? jsonApiIdentityProviderPatchDocument
                    : {})
                : jsonApiIdentityProviderPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets identity providers in organization.
         * @summary Set all identity providers
         * @param {Array<DeclarativeIdentityProvider>} declarativeIdentityProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIdentityProviders: async (declarativeIdentityProvider, options = {}) => {
            // verify required parameter 'declarativeIdentityProvider' is not null or undefined
            assertParamExists("setIdentityProviders", "declarativeIdentityProvider", declarativeIdentityProvider);
            const localVarPath = `/api/v1/layout/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeIdentityProvider !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeIdentityProvider !== undefined ? declarativeIdentityProvider : {})
                : declarativeIdentityProvider || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityIdentityProviders: async (id, jsonApiIdentityProviderInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityIdentityProviders", "id", id);
            // verify required parameter 'jsonApiIdentityProviderInDocument' is not null or undefined
            assertParamExists("updateEntityIdentityProviders", "jsonApiIdentityProviderInDocument", jsonApiIdentityProviderInDocument);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiIdentityProviderInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiIdentityProviderInDocument !== undefined
                    ? jsonApiIdentityProviderInDocument
                    : {})
                : jsonApiIdentityProviderInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IdentityProvidersApi - functional programming interface
 * @export
 */
export const IdentityProvidersApiFp = function (configuration) {
    const localVarAxiosParamCreator = IdentityProvidersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Identity Providers
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityIdentityProviders(jsonApiIdentityProviderInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityIdentityProviders(jsonApiIdentityProviderInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityIdentityProviders(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityIdentityProviders(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Identity Providers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesIdentityProviders(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesIdentityProviders(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityIdentityProviders(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityIdentityProviders(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets complete layout of identity providers.
         * @summary Get all identity providers layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentityProvidersLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentityProvidersLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderPatchDocument} jsonApiIdentityProviderPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityIdentityProviders(id, jsonApiIdentityProviderPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityIdentityProviders(id, jsonApiIdentityProviderPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets identity providers in organization.
         * @summary Set all identity providers
         * @param {Array<DeclarativeIdentityProvider>} declarativeIdentityProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setIdentityProviders(declarativeIdentityProvider, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setIdentityProviders(declarativeIdentityProvider, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityIdentityProviders(id, jsonApiIdentityProviderInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityIdentityProviders(id, jsonApiIdentityProviderInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * IdentityProvidersApi - factory interface
 * @export
 */
export const IdentityProvidersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IdentityProvidersApiFp(configuration);
    return {
        /**
         *
         * @summary Post Identity Providers
         * @param {IdentityProvidersApiCreateEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .createEntityIdentityProviders(requestParameters.jsonApiIdentityProviderInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Identity Provider
         * @param {IdentityProvidersApiDeleteEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .deleteEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Identity Providers
         * @param {IdentityProvidersApiGetAllEntitiesIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesIdentityProviders(requestParameters, options) {
            return localVarFp
                .getAllEntitiesIdentityProviders(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Identity Provider
         * @param {IdentityProvidersApiGetEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .getEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Gets complete layout of identity providers.
         * @summary Get all identity providers layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityProvidersLayout(options) {
            return localVarFp.getIdentityProvidersLayout(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Identity Provider
         * @param {IdentityProvidersApiPatchEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .patchEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets identity providers in organization.
         * @summary Set all identity providers
         * @param {IdentityProvidersApiSetIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIdentityProviders(requestParameters, options) {
            return localVarFp
                .setIdentityProviders(requestParameters.declarativeIdentityProvider, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Identity Provider
         * @param {IdentityProvidersApiUpdateEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .updateEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * IdentityProvidersApi - object-oriented interface
 * @export
 * @class IdentityProvidersApi
 * @extends {BaseAPI}
 */
export class IdentityProvidersApi extends BaseAPI {
    /**
     *
     * @summary Post Identity Providers
     * @param {IdentityProvidersApiCreateEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    createEntityIdentityProviders(requestParameters, options) {
        return IdentityProvidersApiFp(this.configuration)
            .createEntityIdentityProviders(requestParameters.jsonApiIdentityProviderInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Identity Provider
     * @param {IdentityProvidersApiDeleteEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    deleteEntityIdentityProviders(requestParameters, options) {
        return IdentityProvidersApiFp(this.configuration)
            .deleteEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Identity Providers
     * @param {IdentityProvidersApiGetAllEntitiesIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    getAllEntitiesIdentityProviders(requestParameters = {}, options) {
        return IdentityProvidersApiFp(this.configuration)
            .getAllEntitiesIdentityProviders(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Identity Provider
     * @param {IdentityProvidersApiGetEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    getEntityIdentityProviders(requestParameters, options) {
        return IdentityProvidersApiFp(this.configuration)
            .getEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets complete layout of identity providers.
     * @summary Get all identity providers layout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    getIdentityProvidersLayout(options) {
        return IdentityProvidersApiFp(this.configuration)
            .getIdentityProvidersLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Identity Provider
     * @param {IdentityProvidersApiPatchEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    patchEntityIdentityProviders(requestParameters, options) {
        return IdentityProvidersApiFp(this.configuration)
            .patchEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets identity providers in organization.
     * @summary Set all identity providers
     * @param {IdentityProvidersApiSetIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    setIdentityProviders(requestParameters, options) {
        return IdentityProvidersApiFp(this.configuration)
            .setIdentityProviders(requestParameters.declarativeIdentityProvider, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Identity Provider
     * @param {IdentityProvidersApiUpdateEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    updateEntityIdentityProviders(requestParameters, options) {
        return IdentityProvidersApiFp(this.configuration)
            .updateEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InvalidateCacheApi - axios parameter creator
 * @export
 */
export const InvalidateCacheApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Notification sets up all reports to be computed again with new data.
         * @summary Register an upload notification
         * @param {string} dataSourceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUploadNotification: async (dataSourceId, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("registerUploadNotification", "dataSourceId", dataSourceId);
            const localVarPath = `/api/v1/actions/dataSources/{dataSourceId}/uploadNotification`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * InvalidateCacheApi - functional programming interface
 * @export
 */
export const InvalidateCacheApiFp = function (configuration) {
    const localVarAxiosParamCreator = InvalidateCacheApiAxiosParamCreator(configuration);
    return {
        /**
         * Notification sets up all reports to be computed again with new data.
         * @summary Register an upload notification
         * @param {string} dataSourceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerUploadNotification(dataSourceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerUploadNotification(dataSourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * InvalidateCacheApi - factory interface
 * @export
 */
export const InvalidateCacheApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InvalidateCacheApiFp(configuration);
    return {
        /**
         * Notification sets up all reports to be computed again with new data.
         * @summary Register an upload notification
         * @param {InvalidateCacheApiRegisterUploadNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUploadNotification(requestParameters, options) {
            return localVarFp
                .registerUploadNotification(requestParameters.dataSourceId, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * InvalidateCacheApi - object-oriented interface
 * @export
 * @class InvalidateCacheApi
 * @extends {BaseAPI}
 */
export class InvalidateCacheApi extends BaseAPI {
    /**
     * Notification sets up all reports to be computed again with new data.
     * @summary Register an upload notification
     * @param {InvalidateCacheApiRegisterUploadNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvalidateCacheApi
     */
    registerUploadNotification(requestParameters, options) {
        return InvalidateCacheApiFp(this.configuration)
            .registerUploadNotification(requestParameters.dataSourceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * JWKSApi - axios parameter creator
 * @export
 */
export const JWKSApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Post Jwks
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityJwks: async (jsonApiJwkInDocument, options = {}) => {
            // verify required parameter 'jsonApiJwkInDocument' is not null or undefined
            assertParamExists("createEntityJwks", "jsonApiJwkInDocument", jsonApiJwkInDocument);
            const localVarPath = `/api/v1/entities/jwks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiJwkInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiJwkInDocument !== undefined ? jsonApiJwkInDocument : {})
                : jsonApiJwkInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Delete Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityJwks: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityJwks", "id", id);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
         * @summary Get all Jwks
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesJwks: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/jwks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Get Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityJwks: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityJwks", "id", id);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patches JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Patch Jwk
         * @param {string} id
         * @param {JsonApiJwkPatchDocument} jsonApiJwkPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityJwks: async (id, jsonApiJwkPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityJwks", "id", id);
            // verify required parameter 'jsonApiJwkPatchDocument' is not null or undefined
            assertParamExists("patchEntityJwks", "jsonApiJwkPatchDocument", jsonApiJwkPatchDocument);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiJwkPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiJwkPatchDocument !== undefined ? jsonApiJwkPatchDocument : {})
                : jsonApiJwkPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Put Jwk
         * @param {string} id
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityJwks: async (id, jsonApiJwkInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityJwks", "id", id);
            // verify required parameter 'jsonApiJwkInDocument' is not null or undefined
            assertParamExists("updateEntityJwks", "jsonApiJwkInDocument", jsonApiJwkInDocument);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiJwkInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiJwkInDocument !== undefined ? jsonApiJwkInDocument : {})
                : jsonApiJwkInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * JWKSApi - functional programming interface
 * @export
 */
export const JWKSApiFp = function (configuration) {
    const localVarAxiosParamCreator = JWKSApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Post Jwks
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityJwks(jsonApiJwkInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityJwks(jsonApiJwkInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Delete Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityJwks(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityJwks(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
         * @summary Get all Jwks
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesJwks(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesJwks(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Get Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityJwks(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityJwks(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Patches JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Patch Jwk
         * @param {string} id
         * @param {JsonApiJwkPatchDocument} jsonApiJwkPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityJwks(id, jsonApiJwkPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityJwks(id, jsonApiJwkPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Put Jwk
         * @param {string} id
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityJwks(id, jsonApiJwkInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityJwks(id, jsonApiJwkInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * JWKSApi - factory interface
 * @export
 */
export const JWKSApiFactory = function (configuration, basePath, axios) {
    const localVarFp = JWKSApiFp(configuration);
    return {
        /**
         * Creates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Post Jwks
         * @param {JWKSApiCreateEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityJwks(requestParameters, options) {
            return localVarFp
                .createEntityJwks(requestParameters.jsonApiJwkInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Deletes JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Delete Jwk
         * @param {JWKSApiDeleteEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityJwks(requestParameters, options) {
            return localVarFp
                .deleteEntityJwks(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
         * @summary Get all Jwks
         * @param {JWKSApiGetAllEntitiesJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesJwks(requestParameters, options) {
            return localVarFp
                .getAllEntitiesJwks(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Get Jwk
         * @param {JWKSApiGetEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityJwks(requestParameters, options) {
            return localVarFp
                .getEntityJwks(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Patches JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Patch Jwk
         * @param {JWKSApiPatchEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityJwks(requestParameters, options) {
            return localVarFp
                .patchEntityJwks(requestParameters.id, requestParameters.jsonApiJwkPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Updates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Put Jwk
         * @param {JWKSApiUpdateEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityJwks(requestParameters, options) {
            return localVarFp
                .updateEntityJwks(requestParameters.id, requestParameters.jsonApiJwkInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * JWKSApi - object-oriented interface
 * @export
 * @class JWKSApi
 * @extends {BaseAPI}
 */
export class JWKSApi extends BaseAPI {
    /**
     * Creates JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Post Jwks
     * @param {JWKSApiCreateEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWKSApi
     */
    createEntityJwks(requestParameters, options) {
        return JWKSApiFp(this.configuration)
            .createEntityJwks(requestParameters.jsonApiJwkInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Delete Jwk
     * @param {JWKSApiDeleteEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWKSApi
     */
    deleteEntityJwks(requestParameters, options) {
        return JWKSApiFp(this.configuration)
            .deleteEntityJwks(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
     * @summary Get all Jwks
     * @param {JWKSApiGetAllEntitiesJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWKSApi
     */
    getAllEntitiesJwks(requestParameters = {}, options) {
        return JWKSApiFp(this.configuration)
            .getAllEntitiesJwks(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Get Jwk
     * @param {JWKSApiGetEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWKSApi
     */
    getEntityJwks(requestParameters, options) {
        return JWKSApiFp(this.configuration)
            .getEntityJwks(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Patches JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Patch Jwk
     * @param {JWKSApiPatchEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWKSApi
     */
    patchEntityJwks(requestParameters, options) {
        return JWKSApiFp(this.configuration)
            .patchEntityJwks(requestParameters.id, requestParameters.jsonApiJwkPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Put Jwk
     * @param {JWKSApiUpdateEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWKSApi
     */
    updateEntityJwks(requestParameters, options) {
        return JWKSApiFp(this.configuration)
            .updateEntityJwks(requestParameters.id, requestParameters.jsonApiJwkInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LDMDeclarativeAPIsApi - axios parameter creator
 * @export
 */
export const LDMDeclarativeAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve current logical model of the workspace in declarative form.
         * @summary Get logical model
         * @param {string} workspaceId
         * @param {boolean} [includeParents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogicalModel: async (workspaceId, includeParents, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getLogicalModel", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/logicalModel`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeParents !== undefined) {
                localVarQueryParameter["includeParents"] = includeParents;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective logical model of the workspace.
         * @summary Set logical model
         * @param {string} workspaceId
         * @param {DeclarativeModel} declarativeModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLogicalModel: async (workspaceId, declarativeModel, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setLogicalModel", "workspaceId", workspaceId);
            // verify required parameter 'declarativeModel' is not null or undefined
            assertParamExists("setLogicalModel", "declarativeModel", declarativeModel);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/logicalModel`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeModel !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeModel !== undefined ? declarativeModel : {})
                : declarativeModel || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LDMDeclarativeAPIsApi - functional programming interface
 * @export
 */
export const LDMDeclarativeAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LDMDeclarativeAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve current logical model of the workspace in declarative form.
         * @summary Get logical model
         * @param {string} workspaceId
         * @param {boolean} [includeParents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogicalModel(workspaceId, includeParents, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogicalModel(workspaceId, includeParents, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective logical model of the workspace.
         * @summary Set logical model
         * @param {string} workspaceId
         * @param {DeclarativeModel} declarativeModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setLogicalModel(workspaceId, declarativeModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setLogicalModel(workspaceId, declarativeModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LDMDeclarativeAPIsApi - factory interface
 * @export
 */
export const LDMDeclarativeAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LDMDeclarativeAPIsApiFp(configuration);
    return {
        /**
         * Retrieve current logical model of the workspace in declarative form.
         * @summary Get logical model
         * @param {LDMDeclarativeAPIsApiGetLogicalModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogicalModel(requestParameters, options) {
            return localVarFp
                .getLogicalModel(requestParameters.workspaceId, requestParameters.includeParents, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective logical model of the workspace.
         * @summary Set logical model
         * @param {LDMDeclarativeAPIsApiSetLogicalModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLogicalModel(requestParameters, options) {
            return localVarFp
                .setLogicalModel(requestParameters.workspaceId, requestParameters.declarativeModel, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * LDMDeclarativeAPIsApi - object-oriented interface
 * @export
 * @class LDMDeclarativeAPIsApi
 * @extends {BaseAPI}
 */
export class LDMDeclarativeAPIsApi extends BaseAPI {
    /**
     * Retrieve current logical model of the workspace in declarative form.
     * @summary Get logical model
     * @param {LDMDeclarativeAPIsApiGetLogicalModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LDMDeclarativeAPIsApi
     */
    getLogicalModel(requestParameters, options) {
        return LDMDeclarativeAPIsApiFp(this.configuration)
            .getLogicalModel(requestParameters.workspaceId, requestParameters.includeParents, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective logical model of the workspace.
     * @summary Set logical model
     * @param {LDMDeclarativeAPIsApiSetLogicalModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LDMDeclarativeAPIsApi
     */
    setLogicalModel(requestParameters, options) {
        return LDMDeclarativeAPIsApiFp(this.configuration)
            .setLogicalModel(requestParameters.workspaceId, requestParameters.declarativeModel, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LLMEndpointsApi - axios parameter creator
 * @export
 */
export const LLMEndpointsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post LLM endpoint entities
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityLlmEndpoints: async (jsonApiLlmEndpointInDocument, options = {}) => {
            // verify required parameter 'jsonApiLlmEndpointInDocument' is not null or undefined
            assertParamExists("createEntityLlmEndpoints", "jsonApiLlmEndpointInDocument", jsonApiLlmEndpointInDocument);
            const localVarPath = `/api/v1/entities/llmEndpoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiLlmEndpointInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiLlmEndpointInDocument !== undefined ? jsonApiLlmEndpointInDocument : {})
                : jsonApiLlmEndpointInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityLlmEndpoints: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityLlmEndpoints", "id", id);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all LLM endpoint entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLlmEndpoints: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/llmEndpoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get LLM endpoint entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLlmEndpoints: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityLlmEndpoints", "id", id);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointPatchDocument} jsonApiLlmEndpointPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityLlmEndpoints: async (id, jsonApiLlmEndpointPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityLlmEndpoints", "id", id);
            // verify required parameter 'jsonApiLlmEndpointPatchDocument' is not null or undefined
            assertParamExists("patchEntityLlmEndpoints", "jsonApiLlmEndpointPatchDocument", jsonApiLlmEndpointPatchDocument);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiLlmEndpointPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiLlmEndpointPatchDocument !== undefined ? jsonApiLlmEndpointPatchDocument : {})
                : jsonApiLlmEndpointPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary PUT LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityLlmEndpoints: async (id, jsonApiLlmEndpointInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityLlmEndpoints", "id", id);
            // verify required parameter 'jsonApiLlmEndpointInDocument' is not null or undefined
            assertParamExists("updateEntityLlmEndpoints", "jsonApiLlmEndpointInDocument", jsonApiLlmEndpointInDocument);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiLlmEndpointInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiLlmEndpointInDocument !== undefined ? jsonApiLlmEndpointInDocument : {})
                : jsonApiLlmEndpointInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LLMEndpointsApi - functional programming interface
 * @export
 */
export const LLMEndpointsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LLMEndpointsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post LLM endpoint entities
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityLlmEndpoints(jsonApiLlmEndpointInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityLlmEndpoints(jsonApiLlmEndpointInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityLlmEndpoints(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityLlmEndpoints(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all LLM endpoint entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesLlmEndpoints(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesLlmEndpoints(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get LLM endpoint entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityLlmEndpoints(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityLlmEndpoints(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointPatchDocument} jsonApiLlmEndpointPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityLlmEndpoints(id, jsonApiLlmEndpointPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityLlmEndpoints(id, jsonApiLlmEndpointPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary PUT LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityLlmEndpoints(id, jsonApiLlmEndpointInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityLlmEndpoints(id, jsonApiLlmEndpointInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LLMEndpointsApi - factory interface
 * @export
 */
export const LLMEndpointsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LLMEndpointsApiFp(configuration);
    return {
        /**
         *
         * @summary Post LLM endpoint entities
         * @param {LLMEndpointsApiCreateEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .createEntityLlmEndpoints(requestParameters.jsonApiLlmEndpointInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LLMEndpointsApiDeleteEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .deleteEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all LLM endpoint entities
         * @param {LLMEndpointsApiGetAllEntitiesLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLlmEndpoints(requestParameters, options) {
            return localVarFp
                .getAllEntitiesLlmEndpoints(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get LLM endpoint entity
         * @param {LLMEndpointsApiGetEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .getEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch LLM endpoint entity
         * @param {LLMEndpointsApiPatchEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .patchEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary PUT LLM endpoint entity
         * @param {LLMEndpointsApiUpdateEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .updateEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * LLMEndpointsApi - object-oriented interface
 * @export
 * @class LLMEndpointsApi
 * @extends {BaseAPI}
 */
export class LLMEndpointsApi extends BaseAPI {
    /**
     *
     * @summary Post LLM endpoint entities
     * @param {LLMEndpointsApiCreateEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMEndpointsApi
     */
    createEntityLlmEndpoints(requestParameters, options) {
        return LLMEndpointsApiFp(this.configuration)
            .createEntityLlmEndpoints(requestParameters.jsonApiLlmEndpointInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LLMEndpointsApiDeleteEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMEndpointsApi
     */
    deleteEntityLlmEndpoints(requestParameters, options) {
        return LLMEndpointsApiFp(this.configuration)
            .deleteEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all LLM endpoint entities
     * @param {LLMEndpointsApiGetAllEntitiesLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMEndpointsApi
     */
    getAllEntitiesLlmEndpoints(requestParameters = {}, options) {
        return LLMEndpointsApiFp(this.configuration)
            .getAllEntitiesLlmEndpoints(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get LLM endpoint entity
     * @param {LLMEndpointsApiGetEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMEndpointsApi
     */
    getEntityLlmEndpoints(requestParameters, options) {
        return LLMEndpointsApiFp(this.configuration)
            .getEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch LLM endpoint entity
     * @param {LLMEndpointsApiPatchEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMEndpointsApi
     */
    patchEntityLlmEndpoints(requestParameters, options) {
        return LLMEndpointsApiFp(this.configuration)
            .patchEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PUT LLM endpoint entity
     * @param {LLMEndpointsApiUpdateEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMEndpointsApi
     */
    updateEntityLlmEndpoints(requestParameters, options) {
        return LLMEndpointsApiFp(this.configuration)
            .updateEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LabelsApi - axios parameter creator
 * @export
 */
export const LabelsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all Labels
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLabels: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesLabels", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/labels`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Label
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLabels: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityLabels", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityLabels", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/labels/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LabelsApi - functional programming interface
 * @export
 */
export const LabelsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LabelsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all Labels
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesLabels(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesLabels(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Label
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityLabels(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityLabels(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LabelsApi - factory interface
 * @export
 */
export const LabelsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LabelsApiFp(configuration);
    return {
        /**
         *
         * @summary Get all Labels
         * @param {LabelsApiGetAllEntitiesLabelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLabels(requestParameters, options) {
            return localVarFp
                .getAllEntitiesLabels(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Label
         * @param {LabelsApiGetEntityLabelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLabels(requestParameters, options) {
            return localVarFp
                .getEntityLabels(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * LabelsApi - object-oriented interface
 * @export
 * @class LabelsApi
 * @extends {BaseAPI}
 */
export class LabelsApi extends BaseAPI {
    /**
     *
     * @summary Get all Labels
     * @param {LabelsApiGetAllEntitiesLabelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelsApi
     */
    getAllEntitiesLabels(requestParameters, options) {
        return LabelsApiFp(this.configuration)
            .getAllEntitiesLabels(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Label
     * @param {LabelsApiGetEntityLabelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelsApi
     */
    getEntityLabels(requestParameters, options) {
        return LabelsApiFp(this.configuration)
            .getEntityLabels(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LayoutApi - axios parameter creator
 * @export
 */
export const LayoutApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve current analytics model of the workspace.
         * @summary Get analytics model
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalyticsModel: async (workspaceId, exclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAnalyticsModel", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/analyticsModel`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve automations for the specific workspace
         * @summary Get automations
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutomations: async (workspaceId, exclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAutomations", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current set of permissions of the data source in a declarative form.
         * @summary Get permissions for the data source
         * @param {string} dataSourceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcePermissions: async (dataSourceId, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("getDataSourcePermissions", "dataSourceId", dataSourceId);
            const localVarPath = `/api/v1/layout/dataSources/{dataSourceId}/permissions`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all data sources including related physical model.
         * @summary Get all data sources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcesLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve filter views for the specific workspace
         * @summary Get filter views
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterViews: async (workspaceId, exclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getFilterViews", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets complete layout of identity providers.
         * @summary Get all identity providers layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityProvidersLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current logical model of the workspace in declarative form.
         * @summary Get logical model
         * @param {string} workspaceId
         * @param {boolean} [includeParents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogicalModel: async (workspaceId, includeParents, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getLogicalModel", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/logicalModel`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeParents !== undefined) {
                localVarQueryParameter["includeParents"] = includeParents;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets complete layout of notification channels.
         * @summary Get all notification channels layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationChannelsLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve complete layout of organization, workspaces, user-groups, etc.
         * @summary Get organization layout
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationLayout: async (exclude, options = {}) => {
            const localVarPath = `/api/v1/layout/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve organization permissions
         * @summary Get organization permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPermissions: async (options = {}) => {
            const localVarPath = `/api/v1/layout/organization/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current user data filters assigned to the workspace.
         * @summary Get user data filters
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDataFilters: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getUserDataFilters", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current set of permissions of the user-group in a declarative form.
         * @summary Get permissions for the user-group
         * @param {string} userGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupPermissions: async (userGroupId, options = {}) => {
            // verify required parameter 'userGroupId' is not null or undefined
            assertParamExists("getUserGroupPermissions", "userGroupId", userGroupId);
            const localVarPath = `/api/v1/layout/userGroups/{userGroupId}/permissions`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(userGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all user-groups eventually with parent group.
         * @summary Get all user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupsLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current set of permissions of the user in a declarative form.
         * @summary Get permissions for the user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getUserPermissions", "userId", userId);
            const localVarPath = `/api/v1/layout/users/{userId}/permissions`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all users including authentication properties.
         * @summary Get all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all users and user groups with theirs properties.
         * @summary Get all users and user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUserGroupsLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/usersAndUserGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all workspaces and related workspace data filters (and their settings / values).
         * @summary Get workspace data filters for all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDataFiltersLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/workspaceDataFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current model of the workspace in declarative form.
         * @summary Get workspace layout
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceLayout: async (workspaceId, exclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getWorkspaceLayout", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current set of permissions of the workspace in a declarative form.
         * @summary Get permissions for the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacePermissions: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getWorkspacePermissions", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/permissions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets complete layout of workspaces, their hierarchy, models.
         * @summary Get all workspaces layout
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesLayout: async (exclude, options = {}) => {
            const localVarPath = `/api/v1/layout/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set all data sources including related physical model.
         * @summary Put all data sources
         * @param {DeclarativeDataSources} declarativeDataSources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDataSourcesLayout: async (declarativeDataSources, options = {}) => {
            // verify required parameter 'declarativeDataSources' is not null or undefined
            assertParamExists("putDataSourcesLayout", "declarativeDataSources", declarativeDataSources);
            const localVarPath = `/api/v1/layout/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeDataSources !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeDataSources !== undefined ? declarativeDataSources : {})
                : declarativeDataSources || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Define all user groups with their parents eventually.
         * @summary Put all user groups
         * @param {DeclarativeUserGroups} declarativeUserGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserGroupsLayout: async (declarativeUserGroups, options = {}) => {
            // verify required parameter 'declarativeUserGroups' is not null or undefined
            assertParamExists("putUserGroupsLayout", "declarativeUserGroups", declarativeUserGroups);
            const localVarPath = `/api/v1/layout/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUserGroups !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUserGroups !== undefined ? declarativeUserGroups : {})
                : declarativeUserGroups || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set all users and their authentication properties.
         * @summary Put all users
         * @param {DeclarativeUsers} declarativeUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersLayout: async (declarativeUsers, options = {}) => {
            // verify required parameter 'declarativeUsers' is not null or undefined
            assertParamExists("putUsersLayout", "declarativeUsers", declarativeUsers);
            const localVarPath = `/api/v1/layout/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUsers !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUsers !== undefined ? declarativeUsers : {})
                : declarativeUsers || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Define all users and user groups with theirs properties.
         * @summary Put all users and user groups
         * @param {DeclarativeUsersUserGroups} declarativeUsersUserGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUserGroupsLayout: async (declarativeUsersUserGroups, options = {}) => {
            // verify required parameter 'declarativeUsersUserGroups' is not null or undefined
            assertParamExists("putUsersUserGroupsLayout", "declarativeUsersUserGroups", declarativeUsersUserGroups);
            const localVarPath = `/api/v1/layout/usersAndUserGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUsersUserGroups !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUsersUserGroups !== undefined ? declarativeUsersUserGroups : {})
                : declarativeUsersUserGroups || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set complete layout of workspace, like model, authorization, etc.
         * @summary Set workspace layout
         * @param {string} workspaceId
         * @param {DeclarativeWorkspaceModel} declarativeWorkspaceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWorkspaceLayout: async (workspaceId, declarativeWorkspaceModel, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("putWorkspaceLayout", "workspaceId", workspaceId);
            // verify required parameter 'declarativeWorkspaceModel' is not null or undefined
            assertParamExists("putWorkspaceLayout", "declarativeWorkspaceModel", declarativeWorkspaceModel);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeWorkspaceModel !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeWorkspaceModel !== undefined ? declarativeWorkspaceModel : {})
                : declarativeWorkspaceModel || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective analytics model of the workspace.
         * @summary Set analytics model
         * @param {string} workspaceId
         * @param {DeclarativeAnalytics} declarativeAnalytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalyticsModel: async (workspaceId, declarativeAnalytics, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setAnalyticsModel", "workspaceId", workspaceId);
            // verify required parameter 'declarativeAnalytics' is not null or undefined
            assertParamExists("setAnalyticsModel", "declarativeAnalytics", declarativeAnalytics);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/analyticsModel`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeAnalytics !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeAnalytics !== undefined ? declarativeAnalytics : {})
                : declarativeAnalytics || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set automations for the specific workspace.
         * @summary Set automations
         * @param {string} workspaceId
         * @param {Array<DeclarativeAutomation>} declarativeAutomation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAutomations: async (workspaceId, declarativeAutomation, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setAutomations", "workspaceId", workspaceId);
            // verify required parameter 'declarativeAutomation' is not null or undefined
            assertParamExists("setAutomations", "declarativeAutomation", declarativeAutomation);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeAutomation !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeAutomation !== undefined ? declarativeAutomation : {})
                : declarativeAutomation || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * set data source permissions.
         * @summary Set data source permissions.
         * @param {string} dataSourceId
         * @param {DeclarativeDataSourcePermissions} declarativeDataSourcePermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDataSourcePermissions: async (dataSourceId, declarativeDataSourcePermissions, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("setDataSourcePermissions", "dataSourceId", dataSourceId);
            // verify required parameter 'declarativeDataSourcePermissions' is not null or undefined
            assertParamExists("setDataSourcePermissions", "declarativeDataSourcePermissions", declarativeDataSourcePermissions);
            const localVarPath = `/api/v1/layout/dataSources/{dataSourceId}/permissions`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeDataSourcePermissions !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeDataSourcePermissions !== undefined ? declarativeDataSourcePermissions : {})
                : declarativeDataSourcePermissions || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set filter views for the specific workspace.
         * @summary Set filter views
         * @param {string} workspaceId
         * @param {Array<DeclarativeFilterView>} declarativeFilterView
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFilterViews: async (workspaceId, declarativeFilterView, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'declarativeFilterView' is not null or undefined
            assertParamExists("setFilterViews", "declarativeFilterView", declarativeFilterView);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeFilterView !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeFilterView !== undefined ? declarativeFilterView : {})
                : declarativeFilterView || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets identity providers in organization.
         * @summary Set all identity providers
         * @param {Array<DeclarativeIdentityProvider>} declarativeIdentityProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIdentityProviders: async (declarativeIdentityProvider, options = {}) => {
            // verify required parameter 'declarativeIdentityProvider' is not null or undefined
            assertParamExists("setIdentityProviders", "declarativeIdentityProvider", declarativeIdentityProvider);
            const localVarPath = `/api/v1/layout/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeIdentityProvider !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeIdentityProvider !== undefined ? declarativeIdentityProvider : {})
                : declarativeIdentityProvider || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective logical model of the workspace.
         * @summary Set logical model
         * @param {string} workspaceId
         * @param {DeclarativeModel} declarativeModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLogicalModel: async (workspaceId, declarativeModel, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setLogicalModel", "workspaceId", workspaceId);
            // verify required parameter 'declarativeModel' is not null or undefined
            assertParamExists("setLogicalModel", "declarativeModel", declarativeModel);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/logicalModel`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeModel !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeModel !== undefined ? declarativeModel : {})
                : declarativeModel || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets notification channels in organization.
         * @summary Set all notification channels
         * @param {DeclarativeNotificationChannels} declarativeNotificationChannels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotificationChannels: async (declarativeNotificationChannels, options = {}) => {
            // verify required parameter 'declarativeNotificationChannels' is not null or undefined
            assertParamExists("setNotificationChannels", "declarativeNotificationChannels", declarativeNotificationChannels);
            const localVarPath = `/api/v1/layout/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeNotificationChannels !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeNotificationChannels !== undefined ? declarativeNotificationChannels : {})
                : declarativeNotificationChannels || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets complete layout of organization, like workspaces, user-groups, etc.
         * @summary Set organization layout
         * @param {DeclarativeOrganization} declarativeOrganization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationLayout: async (declarativeOrganization, options = {}) => {
            // verify required parameter 'declarativeOrganization' is not null or undefined
            assertParamExists("setOrganizationLayout", "declarativeOrganization", declarativeOrganization);
            const localVarPath = `/api/v1/layout/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeOrganization !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeOrganization !== undefined ? declarativeOrganization : {})
                : declarativeOrganization || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets organization permissions
         * @summary Set organization permissions
         * @param {Array<DeclarativeOrganizationPermission>} declarativeOrganizationPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationPermissions: async (declarativeOrganizationPermission, options = {}) => {
            // verify required parameter 'declarativeOrganizationPermission' is not null or undefined
            assertParamExists("setOrganizationPermissions", "declarativeOrganizationPermission", declarativeOrganizationPermission);
            const localVarPath = `/api/v1/layout/organization/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeOrganizationPermission !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeOrganizationPermission !== undefined
                    ? declarativeOrganizationPermission
                    : {})
                : declarativeOrganizationPermission || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set user data filters assigned to the workspace.
         * @summary Set user data filters
         * @param {string} workspaceId
         * @param {DeclarativeUserDataFilters} declarativeUserDataFilters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserDataFilters: async (workspaceId, declarativeUserDataFilters, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'declarativeUserDataFilters' is not null or undefined
            assertParamExists("setUserDataFilters", "declarativeUserDataFilters", declarativeUserDataFilters);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUserDataFilters !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUserDataFilters !== undefined ? declarativeUserDataFilters : {})
                : declarativeUserDataFilters || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective permissions for the user-group
         * @summary Set permissions for the user-group
         * @param {string} userGroupId
         * @param {DeclarativeUserGroupPermissions} declarativeUserGroupPermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserGroupPermissions: async (userGroupId, declarativeUserGroupPermissions, options = {}) => {
            // verify required parameter 'userGroupId' is not null or undefined
            assertParamExists("setUserGroupPermissions", "userGroupId", userGroupId);
            // verify required parameter 'declarativeUserGroupPermissions' is not null or undefined
            assertParamExists("setUserGroupPermissions", "declarativeUserGroupPermissions", declarativeUserGroupPermissions);
            const localVarPath = `/api/v1/layout/userGroups/{userGroupId}/permissions`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(userGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUserGroupPermissions !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUserGroupPermissions !== undefined ? declarativeUserGroupPermissions : {})
                : declarativeUserGroupPermissions || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective permissions for the user
         * @summary Set permissions for the user
         * @param {string} userId
         * @param {DeclarativeUserPermissions} declarativeUserPermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPermissions: async (userId, declarativeUserPermissions, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("setUserPermissions", "userId", userId);
            // verify required parameter 'declarativeUserPermissions' is not null or undefined
            assertParamExists("setUserPermissions", "declarativeUserPermissions", declarativeUserPermissions);
            const localVarPath = `/api/v1/layout/users/{userId}/permissions`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUserPermissions !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUserPermissions !== undefined ? declarativeUserPermissions : {})
                : declarativeUserPermissions || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets workspace data filters in all workspaces in entire organization.
         * @summary Set all workspace data filters
         * @param {DeclarativeWorkspaceDataFilters} declarativeWorkspaceDataFilters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspaceDataFiltersLayout: async (declarativeWorkspaceDataFilters, options = {}) => {
            // verify required parameter 'declarativeWorkspaceDataFilters' is not null or undefined
            assertParamExists("setWorkspaceDataFiltersLayout", "declarativeWorkspaceDataFilters", declarativeWorkspaceDataFilters);
            const localVarPath = `/api/v1/layout/workspaceDataFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeWorkspaceDataFilters !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeWorkspaceDataFilters !== undefined ? declarativeWorkspaceDataFilters : {})
                : declarativeWorkspaceDataFilters || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective permissions for the workspace
         * @summary Set permissions for the workspace
         * @param {string} workspaceId
         * @param {DeclarativeWorkspacePermissions} declarativeWorkspacePermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspacePermissions: async (workspaceId, declarativeWorkspacePermissions, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setWorkspacePermissions", "workspaceId", workspaceId);
            // verify required parameter 'declarativeWorkspacePermissions' is not null or undefined
            assertParamExists("setWorkspacePermissions", "declarativeWorkspacePermissions", declarativeWorkspacePermissions);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/permissions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeWorkspacePermissions !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeWorkspacePermissions !== undefined ? declarativeWorkspacePermissions : {})
                : declarativeWorkspacePermissions || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets complete layout of workspaces, their hierarchy, models.
         * @summary Set all workspaces layout
         * @param {DeclarativeWorkspaces} declarativeWorkspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspacesLayout: async (declarativeWorkspaces, options = {}) => {
            // verify required parameter 'declarativeWorkspaces' is not null or undefined
            assertParamExists("setWorkspacesLayout", "declarativeWorkspaces", declarativeWorkspaces);
            const localVarPath = `/api/v1/layout/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeWorkspaces !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeWorkspaces !== undefined ? declarativeWorkspaces : {})
                : declarativeWorkspaces || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LayoutApi - functional programming interface
 * @export
 */
export const LayoutApiFp = function (configuration) {
    const localVarAxiosParamCreator = LayoutApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve current analytics model of the workspace.
         * @summary Get analytics model
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalyticsModel(workspaceId, exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalyticsModel(workspaceId, exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve automations for the specific workspace
         * @summary Get automations
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutomations(workspaceId, exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutomations(workspaceId, exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current set of permissions of the data source in a declarative form.
         * @summary Get permissions for the data source
         * @param {string} dataSourceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourcePermissions(dataSourceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourcePermissions(dataSourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all data sources including related physical model.
         * @summary Get all data sources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourcesLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourcesLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve filter views for the specific workspace
         * @summary Get filter views
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilterViews(workspaceId, exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilterViews(workspaceId, exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets complete layout of identity providers.
         * @summary Get all identity providers layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentityProvidersLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentityProvidersLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current logical model of the workspace in declarative form.
         * @summary Get logical model
         * @param {string} workspaceId
         * @param {boolean} [includeParents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogicalModel(workspaceId, includeParents, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogicalModel(workspaceId, includeParents, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets complete layout of notification channels.
         * @summary Get all notification channels layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationChannelsLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationChannelsLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve complete layout of organization, workspaces, user-groups, etc.
         * @summary Get organization layout
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationLayout(exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationLayout(exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve organization permissions
         * @summary Get organization permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationPermissions(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationPermissions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current user data filters assigned to the workspace.
         * @summary Get user data filters
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDataFilters(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDataFilters(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current set of permissions of the user-group in a declarative form.
         * @summary Get permissions for the user-group
         * @param {string} userGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupPermissions(userGroupId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupPermissions(userGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all user-groups eventually with parent group.
         * @summary Get all user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupsLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupsLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current set of permissions of the user in a declarative form.
         * @summary Get permissions for the user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPermissions(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPermissions(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all users including authentication properties.
         * @summary Get all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all users and user groups with theirs properties.
         * @summary Get all users and user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersUserGroupsLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersUserGroupsLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all workspaces and related workspace data filters (and their settings / values).
         * @summary Get workspace data filters for all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceDataFiltersLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceDataFiltersLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current model of the workspace in declarative form.
         * @summary Get workspace layout
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceLayout(workspaceId, exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceLayout(workspaceId, exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current set of permissions of the workspace in a declarative form.
         * @summary Get permissions for the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspacePermissions(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspacePermissions(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets complete layout of workspaces, their hierarchy, models.
         * @summary Get all workspaces layout
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspacesLayout(exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspacesLayout(exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set all data sources including related physical model.
         * @summary Put all data sources
         * @param {DeclarativeDataSources} declarativeDataSources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDataSourcesLayout(declarativeDataSources, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDataSourcesLayout(declarativeDataSources, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Define all user groups with their parents eventually.
         * @summary Put all user groups
         * @param {DeclarativeUserGroups} declarativeUserGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUserGroupsLayout(declarativeUserGroups, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUserGroupsLayout(declarativeUserGroups, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set all users and their authentication properties.
         * @summary Put all users
         * @param {DeclarativeUsers} declarativeUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUsersLayout(declarativeUsers, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUsersLayout(declarativeUsers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Define all users and user groups with theirs properties.
         * @summary Put all users and user groups
         * @param {DeclarativeUsersUserGroups} declarativeUsersUserGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUsersUserGroupsLayout(declarativeUsersUserGroups, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUsersUserGroupsLayout(declarativeUsersUserGroups, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set complete layout of workspace, like model, authorization, etc.
         * @summary Set workspace layout
         * @param {string} workspaceId
         * @param {DeclarativeWorkspaceModel} declarativeWorkspaceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putWorkspaceLayout(workspaceId, declarativeWorkspaceModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putWorkspaceLayout(workspaceId, declarativeWorkspaceModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective analytics model of the workspace.
         * @summary Set analytics model
         * @param {string} workspaceId
         * @param {DeclarativeAnalytics} declarativeAnalytics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAnalyticsModel(workspaceId, declarativeAnalytics, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAnalyticsModel(workspaceId, declarativeAnalytics, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set automations for the specific workspace.
         * @summary Set automations
         * @param {string} workspaceId
         * @param {Array<DeclarativeAutomation>} declarativeAutomation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAutomations(workspaceId, declarativeAutomation, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAutomations(workspaceId, declarativeAutomation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * set data source permissions.
         * @summary Set data source permissions.
         * @param {string} dataSourceId
         * @param {DeclarativeDataSourcePermissions} declarativeDataSourcePermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDataSourcePermissions(dataSourceId, declarativeDataSourcePermissions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDataSourcePermissions(dataSourceId, declarativeDataSourcePermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set filter views for the specific workspace.
         * @summary Set filter views
         * @param {string} workspaceId
         * @param {Array<DeclarativeFilterView>} declarativeFilterView
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFilterViews(workspaceId, declarativeFilterView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFilterViews(workspaceId, declarativeFilterView, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets identity providers in organization.
         * @summary Set all identity providers
         * @param {Array<DeclarativeIdentityProvider>} declarativeIdentityProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setIdentityProviders(declarativeIdentityProvider, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setIdentityProviders(declarativeIdentityProvider, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective logical model of the workspace.
         * @summary Set logical model
         * @param {string} workspaceId
         * @param {DeclarativeModel} declarativeModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setLogicalModel(workspaceId, declarativeModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setLogicalModel(workspaceId, declarativeModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets notification channels in organization.
         * @summary Set all notification channels
         * @param {DeclarativeNotificationChannels} declarativeNotificationChannels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setNotificationChannels(declarativeNotificationChannels, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setNotificationChannels(declarativeNotificationChannels, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets complete layout of organization, like workspaces, user-groups, etc.
         * @summary Set organization layout
         * @param {DeclarativeOrganization} declarativeOrganization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOrganizationLayout(declarativeOrganization, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOrganizationLayout(declarativeOrganization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets organization permissions
         * @summary Set organization permissions
         * @param {Array<DeclarativeOrganizationPermission>} declarativeOrganizationPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOrganizationPermissions(declarativeOrganizationPermission, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOrganizationPermissions(declarativeOrganizationPermission, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set user data filters assigned to the workspace.
         * @summary Set user data filters
         * @param {string} workspaceId
         * @param {DeclarativeUserDataFilters} declarativeUserDataFilters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserDataFilters(workspaceId, declarativeUserDataFilters, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserDataFilters(workspaceId, declarativeUserDataFilters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective permissions for the user-group
         * @summary Set permissions for the user-group
         * @param {string} userGroupId
         * @param {DeclarativeUserGroupPermissions} declarativeUserGroupPermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserGroupPermissions(userGroupId, declarativeUserGroupPermissions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserGroupPermissions(userGroupId, declarativeUserGroupPermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective permissions for the user
         * @summary Set permissions for the user
         * @param {string} userId
         * @param {DeclarativeUserPermissions} declarativeUserPermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserPermissions(userId, declarativeUserPermissions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserPermissions(userId, declarativeUserPermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets workspace data filters in all workspaces in entire organization.
         * @summary Set all workspace data filters
         * @param {DeclarativeWorkspaceDataFilters} declarativeWorkspaceDataFilters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWorkspaceDataFiltersLayout(declarativeWorkspaceDataFilters, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWorkspaceDataFiltersLayout(declarativeWorkspaceDataFilters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective permissions for the workspace
         * @summary Set permissions for the workspace
         * @param {string} workspaceId
         * @param {DeclarativeWorkspacePermissions} declarativeWorkspacePermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWorkspacePermissions(workspaceId, declarativeWorkspacePermissions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWorkspacePermissions(workspaceId, declarativeWorkspacePermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets complete layout of workspaces, their hierarchy, models.
         * @summary Set all workspaces layout
         * @param {DeclarativeWorkspaces} declarativeWorkspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWorkspacesLayout(declarativeWorkspaces, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWorkspacesLayout(declarativeWorkspaces, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * LayoutApi - factory interface
 * @export
 */
export const LayoutApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LayoutApiFp(configuration);
    return {
        /**
         * Retrieve current analytics model of the workspace.
         * @summary Get analytics model
         * @param {LayoutApiGetAnalyticsModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalyticsModel(requestParameters, options) {
            return localVarFp
                .getAnalyticsModel(requestParameters.workspaceId, requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve automations for the specific workspace
         * @summary Get automations
         * @param {LayoutApiGetAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutomations(requestParameters, options) {
            return localVarFp
                .getAutomations(requestParameters.workspaceId, requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current set of permissions of the data source in a declarative form.
         * @summary Get permissions for the data source
         * @param {LayoutApiGetDataSourcePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcePermissions(requestParameters, options) {
            return localVarFp
                .getDataSourcePermissions(requestParameters.dataSourceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all data sources including related physical model.
         * @summary Get all data sources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcesLayout(options) {
            return localVarFp.getDataSourcesLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve filter views for the specific workspace
         * @summary Get filter views
         * @param {LayoutApiGetFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterViews(requestParameters, options) {
            return localVarFp
                .getFilterViews(requestParameters.workspaceId, requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Gets complete layout of identity providers.
         * @summary Get all identity providers layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityProvidersLayout(options) {
            return localVarFp.getIdentityProvidersLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current logical model of the workspace in declarative form.
         * @summary Get logical model
         * @param {LayoutApiGetLogicalModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogicalModel(requestParameters, options) {
            return localVarFp
                .getLogicalModel(requestParameters.workspaceId, requestParameters.includeParents, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Gets complete layout of notification channels.
         * @summary Get all notification channels layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationChannelsLayout(options) {
            return localVarFp
                .getNotificationChannelsLayout(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve complete layout of organization, workspaces, user-groups, etc.
         * @summary Get organization layout
         * @param {LayoutApiGetOrganizationLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationLayout(requestParameters, options) {
            return localVarFp
                .getOrganizationLayout(requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve organization permissions
         * @summary Get organization permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPermissions(options) {
            return localVarFp.getOrganizationPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current user data filters assigned to the workspace.
         * @summary Get user data filters
         * @param {LayoutApiGetUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDataFilters(requestParameters, options) {
            return localVarFp
                .getUserDataFilters(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current set of permissions of the user-group in a declarative form.
         * @summary Get permissions for the user-group
         * @param {LayoutApiGetUserGroupPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupPermissions(requestParameters, options) {
            return localVarFp
                .getUserGroupPermissions(requestParameters.userGroupId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all user-groups eventually with parent group.
         * @summary Get all user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupsLayout(options) {
            return localVarFp.getUserGroupsLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current set of permissions of the user in a declarative form.
         * @summary Get permissions for the user
         * @param {LayoutApiGetUserPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions(requestParameters, options) {
            return localVarFp
                .getUserPermissions(requestParameters.userId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all users including authentication properties.
         * @summary Get all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersLayout(options) {
            return localVarFp.getUsersLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all users and user groups with theirs properties.
         * @summary Get all users and user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUserGroupsLayout(options) {
            return localVarFp.getUsersUserGroupsLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all workspaces and related workspace data filters (and their settings / values).
         * @summary Get workspace data filters for all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDataFiltersLayout(options) {
            return localVarFp
                .getWorkspaceDataFiltersLayout(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current model of the workspace in declarative form.
         * @summary Get workspace layout
         * @param {LayoutApiGetWorkspaceLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceLayout(requestParameters, options) {
            return localVarFp
                .getWorkspaceLayout(requestParameters.workspaceId, requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current set of permissions of the workspace in a declarative form.
         * @summary Get permissions for the workspace
         * @param {LayoutApiGetWorkspacePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacePermissions(requestParameters, options) {
            return localVarFp
                .getWorkspacePermissions(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Gets complete layout of workspaces, their hierarchy, models.
         * @summary Get all workspaces layout
         * @param {LayoutApiGetWorkspacesLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesLayout(requestParameters, options) {
            return localVarFp
                .getWorkspacesLayout(requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set all data sources including related physical model.
         * @summary Put all data sources
         * @param {LayoutApiPutDataSourcesLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDataSourcesLayout(requestParameters, options) {
            return localVarFp
                .putDataSourcesLayout(requestParameters.declarativeDataSources, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Define all user groups with their parents eventually.
         * @summary Put all user groups
         * @param {LayoutApiPutUserGroupsLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserGroupsLayout(requestParameters, options) {
            return localVarFp
                .putUserGroupsLayout(requestParameters.declarativeUserGroups, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set all users and their authentication properties.
         * @summary Put all users
         * @param {LayoutApiPutUsersLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersLayout(requestParameters, options) {
            return localVarFp
                .putUsersLayout(requestParameters.declarativeUsers, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Define all users and user groups with theirs properties.
         * @summary Put all users and user groups
         * @param {LayoutApiPutUsersUserGroupsLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUserGroupsLayout(requestParameters, options) {
            return localVarFp
                .putUsersUserGroupsLayout(requestParameters.declarativeUsersUserGroups, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set complete layout of workspace, like model, authorization, etc.
         * @summary Set workspace layout
         * @param {LayoutApiPutWorkspaceLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWorkspaceLayout(requestParameters, options) {
            return localVarFp
                .putWorkspaceLayout(requestParameters.workspaceId, requestParameters.declarativeWorkspaceModel, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective analytics model of the workspace.
         * @summary Set analytics model
         * @param {LayoutApiSetAnalyticsModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalyticsModel(requestParameters, options) {
            return localVarFp
                .setAnalyticsModel(requestParameters.workspaceId, requestParameters.declarativeAnalytics, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set automations for the specific workspace.
         * @summary Set automations
         * @param {LayoutApiSetAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAutomations(requestParameters, options) {
            return localVarFp
                .setAutomations(requestParameters.workspaceId, requestParameters.declarativeAutomation, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * set data source permissions.
         * @summary Set data source permissions.
         * @param {LayoutApiSetDataSourcePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDataSourcePermissions(requestParameters, options) {
            return localVarFp
                .setDataSourcePermissions(requestParameters.dataSourceId, requestParameters.declarativeDataSourcePermissions, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set filter views for the specific workspace.
         * @summary Set filter views
         * @param {LayoutApiSetFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFilterViews(requestParameters, options) {
            return localVarFp
                .setFilterViews(requestParameters.workspaceId, requestParameters.declarativeFilterView, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets identity providers in organization.
         * @summary Set all identity providers
         * @param {LayoutApiSetIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIdentityProviders(requestParameters, options) {
            return localVarFp
                .setIdentityProviders(requestParameters.declarativeIdentityProvider, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective logical model of the workspace.
         * @summary Set logical model
         * @param {LayoutApiSetLogicalModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLogicalModel(requestParameters, options) {
            return localVarFp
                .setLogicalModel(requestParameters.workspaceId, requestParameters.declarativeModel, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets notification channels in organization.
         * @summary Set all notification channels
         * @param {LayoutApiSetNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotificationChannels(requestParameters, options) {
            return localVarFp
                .setNotificationChannels(requestParameters.declarativeNotificationChannels, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets complete layout of organization, like workspaces, user-groups, etc.
         * @summary Set organization layout
         * @param {LayoutApiSetOrganizationLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationLayout(requestParameters, options) {
            return localVarFp
                .setOrganizationLayout(requestParameters.declarativeOrganization, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets organization permissions
         * @summary Set organization permissions
         * @param {LayoutApiSetOrganizationPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationPermissions(requestParameters, options) {
            return localVarFp
                .setOrganizationPermissions(requestParameters.declarativeOrganizationPermission, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set user data filters assigned to the workspace.
         * @summary Set user data filters
         * @param {LayoutApiSetUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserDataFilters(requestParameters, options) {
            return localVarFp
                .setUserDataFilters(requestParameters.workspaceId, requestParameters.declarativeUserDataFilters, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective permissions for the user-group
         * @summary Set permissions for the user-group
         * @param {LayoutApiSetUserGroupPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserGroupPermissions(requestParameters, options) {
            return localVarFp
                .setUserGroupPermissions(requestParameters.userGroupId, requestParameters.declarativeUserGroupPermissions, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective permissions for the user
         * @summary Set permissions for the user
         * @param {LayoutApiSetUserPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPermissions(requestParameters, options) {
            return localVarFp
                .setUserPermissions(requestParameters.userId, requestParameters.declarativeUserPermissions, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets workspace data filters in all workspaces in entire organization.
         * @summary Set all workspace data filters
         * @param {LayoutApiSetWorkspaceDataFiltersLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspaceDataFiltersLayout(requestParameters, options) {
            return localVarFp
                .setWorkspaceDataFiltersLayout(requestParameters.declarativeWorkspaceDataFilters, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective permissions for the workspace
         * @summary Set permissions for the workspace
         * @param {LayoutApiSetWorkspacePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspacePermissions(requestParameters, options) {
            return localVarFp
                .setWorkspacePermissions(requestParameters.workspaceId, requestParameters.declarativeWorkspacePermissions, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets complete layout of workspaces, their hierarchy, models.
         * @summary Set all workspaces layout
         * @param {LayoutApiSetWorkspacesLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspacesLayout(requestParameters, options) {
            return localVarFp
                .setWorkspacesLayout(requestParameters.declarativeWorkspaces, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * LayoutApi - object-oriented interface
 * @export
 * @class LayoutApi
 * @extends {BaseAPI}
 */
export class LayoutApi extends BaseAPI {
    /**
     * Retrieve current analytics model of the workspace.
     * @summary Get analytics model
     * @param {LayoutApiGetAnalyticsModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getAnalyticsModel(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getAnalyticsModel(requestParameters.workspaceId, requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve automations for the specific workspace
     * @summary Get automations
     * @param {LayoutApiGetAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getAutomations(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getAutomations(requestParameters.workspaceId, requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current set of permissions of the data source in a declarative form.
     * @summary Get permissions for the data source
     * @param {LayoutApiGetDataSourcePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getDataSourcePermissions(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getDataSourcePermissions(requestParameters.dataSourceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all data sources including related physical model.
     * @summary Get all data sources
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getDataSourcesLayout(options) {
        return LayoutApiFp(this.configuration)
            .getDataSourcesLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve filter views for the specific workspace
     * @summary Get filter views
     * @param {LayoutApiGetFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getFilterViews(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getFilterViews(requestParameters.workspaceId, requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets complete layout of identity providers.
     * @summary Get all identity providers layout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getIdentityProvidersLayout(options) {
        return LayoutApiFp(this.configuration)
            .getIdentityProvidersLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current logical model of the workspace in declarative form.
     * @summary Get logical model
     * @param {LayoutApiGetLogicalModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getLogicalModel(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getLogicalModel(requestParameters.workspaceId, requestParameters.includeParents, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets complete layout of notification channels.
     * @summary Get all notification channels layout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getNotificationChannelsLayout(options) {
        return LayoutApiFp(this.configuration)
            .getNotificationChannelsLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve complete layout of organization, workspaces, user-groups, etc.
     * @summary Get organization layout
     * @param {LayoutApiGetOrganizationLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getOrganizationLayout(requestParameters = {}, options) {
        return LayoutApiFp(this.configuration)
            .getOrganizationLayout(requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve organization permissions
     * @summary Get organization permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getOrganizationPermissions(options) {
        return LayoutApiFp(this.configuration)
            .getOrganizationPermissions(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current user data filters assigned to the workspace.
     * @summary Get user data filters
     * @param {LayoutApiGetUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getUserDataFilters(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getUserDataFilters(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current set of permissions of the user-group in a declarative form.
     * @summary Get permissions for the user-group
     * @param {LayoutApiGetUserGroupPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getUserGroupPermissions(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getUserGroupPermissions(requestParameters.userGroupId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all user-groups eventually with parent group.
     * @summary Get all user groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getUserGroupsLayout(options) {
        return LayoutApiFp(this.configuration)
            .getUserGroupsLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current set of permissions of the user in a declarative form.
     * @summary Get permissions for the user
     * @param {LayoutApiGetUserPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getUserPermissions(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getUserPermissions(requestParameters.userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all users including authentication properties.
     * @summary Get all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getUsersLayout(options) {
        return LayoutApiFp(this.configuration)
            .getUsersLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all users and user groups with theirs properties.
     * @summary Get all users and user groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getUsersUserGroupsLayout(options) {
        return LayoutApiFp(this.configuration)
            .getUsersUserGroupsLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all workspaces and related workspace data filters (and their settings / values).
     * @summary Get workspace data filters for all workspaces
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getWorkspaceDataFiltersLayout(options) {
        return LayoutApiFp(this.configuration)
            .getWorkspaceDataFiltersLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current model of the workspace in declarative form.
     * @summary Get workspace layout
     * @param {LayoutApiGetWorkspaceLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getWorkspaceLayout(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getWorkspaceLayout(requestParameters.workspaceId, requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current set of permissions of the workspace in a declarative form.
     * @summary Get permissions for the workspace
     * @param {LayoutApiGetWorkspacePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getWorkspacePermissions(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .getWorkspacePermissions(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets complete layout of workspaces, their hierarchy, models.
     * @summary Get all workspaces layout
     * @param {LayoutApiGetWorkspacesLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    getWorkspacesLayout(requestParameters = {}, options) {
        return LayoutApiFp(this.configuration)
            .getWorkspacesLayout(requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set all data sources including related physical model.
     * @summary Put all data sources
     * @param {LayoutApiPutDataSourcesLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    putDataSourcesLayout(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .putDataSourcesLayout(requestParameters.declarativeDataSources, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Define all user groups with their parents eventually.
     * @summary Put all user groups
     * @param {LayoutApiPutUserGroupsLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    putUserGroupsLayout(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .putUserGroupsLayout(requestParameters.declarativeUserGroups, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set all users and their authentication properties.
     * @summary Put all users
     * @param {LayoutApiPutUsersLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    putUsersLayout(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .putUsersLayout(requestParameters.declarativeUsers, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Define all users and user groups with theirs properties.
     * @summary Put all users and user groups
     * @param {LayoutApiPutUsersUserGroupsLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    putUsersUserGroupsLayout(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .putUsersUserGroupsLayout(requestParameters.declarativeUsersUserGroups, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set complete layout of workspace, like model, authorization, etc.
     * @summary Set workspace layout
     * @param {LayoutApiPutWorkspaceLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    putWorkspaceLayout(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .putWorkspaceLayout(requestParameters.workspaceId, requestParameters.declarativeWorkspaceModel, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective analytics model of the workspace.
     * @summary Set analytics model
     * @param {LayoutApiSetAnalyticsModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setAnalyticsModel(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setAnalyticsModel(requestParameters.workspaceId, requestParameters.declarativeAnalytics, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set automations for the specific workspace.
     * @summary Set automations
     * @param {LayoutApiSetAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setAutomations(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setAutomations(requestParameters.workspaceId, requestParameters.declarativeAutomation, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * set data source permissions.
     * @summary Set data source permissions.
     * @param {LayoutApiSetDataSourcePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setDataSourcePermissions(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setDataSourcePermissions(requestParameters.dataSourceId, requestParameters.declarativeDataSourcePermissions, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set filter views for the specific workspace.
     * @summary Set filter views
     * @param {LayoutApiSetFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setFilterViews(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setFilterViews(requestParameters.workspaceId, requestParameters.declarativeFilterView, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets identity providers in organization.
     * @summary Set all identity providers
     * @param {LayoutApiSetIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setIdentityProviders(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setIdentityProviders(requestParameters.declarativeIdentityProvider, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective logical model of the workspace.
     * @summary Set logical model
     * @param {LayoutApiSetLogicalModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setLogicalModel(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setLogicalModel(requestParameters.workspaceId, requestParameters.declarativeModel, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets notification channels in organization.
     * @summary Set all notification channels
     * @param {LayoutApiSetNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setNotificationChannels(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setNotificationChannels(requestParameters.declarativeNotificationChannels, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets complete layout of organization, like workspaces, user-groups, etc.
     * @summary Set organization layout
     * @param {LayoutApiSetOrganizationLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setOrganizationLayout(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setOrganizationLayout(requestParameters.declarativeOrganization, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets organization permissions
     * @summary Set organization permissions
     * @param {LayoutApiSetOrganizationPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setOrganizationPermissions(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setOrganizationPermissions(requestParameters.declarativeOrganizationPermission, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set user data filters assigned to the workspace.
     * @summary Set user data filters
     * @param {LayoutApiSetUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setUserDataFilters(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setUserDataFilters(requestParameters.workspaceId, requestParameters.declarativeUserDataFilters, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective permissions for the user-group
     * @summary Set permissions for the user-group
     * @param {LayoutApiSetUserGroupPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setUserGroupPermissions(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setUserGroupPermissions(requestParameters.userGroupId, requestParameters.declarativeUserGroupPermissions, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective permissions for the user
     * @summary Set permissions for the user
     * @param {LayoutApiSetUserPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setUserPermissions(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setUserPermissions(requestParameters.userId, requestParameters.declarativeUserPermissions, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets workspace data filters in all workspaces in entire organization.
     * @summary Set all workspace data filters
     * @param {LayoutApiSetWorkspaceDataFiltersLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setWorkspaceDataFiltersLayout(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setWorkspaceDataFiltersLayout(requestParameters.declarativeWorkspaceDataFilters, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective permissions for the workspace
     * @summary Set permissions for the workspace
     * @param {LayoutApiSetWorkspacePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setWorkspacePermissions(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setWorkspacePermissions(requestParameters.workspaceId, requestParameters.declarativeWorkspacePermissions, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets complete layout of workspaces, their hierarchy, models.
     * @summary Set all workspaces layout
     * @param {LayoutApiSetWorkspacesLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayoutApi
     */
    setWorkspacesLayout(requestParameters, options) {
        return LayoutApiFp(this.configuration)
            .setWorkspacesLayout(requestParameters.declarativeWorkspaces, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ManagePermissionsApi - axios parameter creator
 * @export
 */
export const ManagePermissionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve current set of permissions of the data source in a declarative form.
         * @summary Get permissions for the data source
         * @param {string} dataSourceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcePermissions: async (dataSourceId, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("getDataSourcePermissions", "dataSourceId", dataSourceId);
            const localVarPath = `/api/v1/layout/dataSources/{dataSourceId}/permissions`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manage Permissions for a Data Source
         * @summary Manage Permissions for a Data Source
         * @param {string} dataSourceId
         * @param {Array<DataSourcePermissionAssignment>} dataSourcePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDataSourcePermissions: async (dataSourceId, dataSourcePermissionAssignment, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("manageDataSourcePermissions", "dataSourceId", dataSourceId);
            // verify required parameter 'dataSourcePermissionAssignment' is not null or undefined
            assertParamExists("manageDataSourcePermissions", "dataSourcePermissionAssignment", dataSourcePermissionAssignment);
            const localVarPath = `/api/v1/actions/dataSources/{dataSourceId}/managePermissions`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof dataSourcePermissionAssignment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(dataSourcePermissionAssignment !== undefined ? dataSourcePermissionAssignment : {})
                : dataSourcePermissionAssignment || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * set data source permissions.
         * @summary Set data source permissions.
         * @param {string} dataSourceId
         * @param {DeclarativeDataSourcePermissions} declarativeDataSourcePermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDataSourcePermissions: async (dataSourceId, declarativeDataSourcePermissions, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("setDataSourcePermissions", "dataSourceId", dataSourceId);
            // verify required parameter 'declarativeDataSourcePermissions' is not null or undefined
            assertParamExists("setDataSourcePermissions", "declarativeDataSourcePermissions", declarativeDataSourcePermissions);
            const localVarPath = `/api/v1/layout/dataSources/{dataSourceId}/permissions`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeDataSourcePermissions !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeDataSourcePermissions !== undefined ? declarativeDataSourcePermissions : {})
                : declarativeDataSourcePermissions || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ManagePermissionsApi - functional programming interface
 * @export
 */
export const ManagePermissionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ManagePermissionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve current set of permissions of the data source in a declarative form.
         * @summary Get permissions for the data source
         * @param {string} dataSourceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourcePermissions(dataSourceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourcePermissions(dataSourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Manage Permissions for a Data Source
         * @summary Manage Permissions for a Data Source
         * @param {string} dataSourceId
         * @param {Array<DataSourcePermissionAssignment>} dataSourcePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageDataSourcePermissions(dataSourceId, dataSourcePermissionAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageDataSourcePermissions(dataSourceId, dataSourcePermissionAssignment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * set data source permissions.
         * @summary Set data source permissions.
         * @param {string} dataSourceId
         * @param {DeclarativeDataSourcePermissions} declarativeDataSourcePermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDataSourcePermissions(dataSourceId, declarativeDataSourcePermissions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDataSourcePermissions(dataSourceId, declarativeDataSourcePermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ManagePermissionsApi - factory interface
 * @export
 */
export const ManagePermissionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ManagePermissionsApiFp(configuration);
    return {
        /**
         * Retrieve current set of permissions of the data source in a declarative form.
         * @summary Get permissions for the data source
         * @param {ManagePermissionsApiGetDataSourcePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourcePermissions(requestParameters, options) {
            return localVarFp
                .getDataSourcePermissions(requestParameters.dataSourceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Manage Permissions for a Data Source
         * @summary Manage Permissions for a Data Source
         * @param {ManagePermissionsApiManageDataSourcePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDataSourcePermissions(requestParameters, options) {
            return localVarFp
                .manageDataSourcePermissions(requestParameters.dataSourceId, requestParameters.dataSourcePermissionAssignment, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * set data source permissions.
         * @summary Set data source permissions.
         * @param {ManagePermissionsApiSetDataSourcePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDataSourcePermissions(requestParameters, options) {
            return localVarFp
                .setDataSourcePermissions(requestParameters.dataSourceId, requestParameters.declarativeDataSourcePermissions, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ManagePermissionsApi - object-oriented interface
 * @export
 * @class ManagePermissionsApi
 * @extends {BaseAPI}
 */
export class ManagePermissionsApi extends BaseAPI {
    /**
     * Retrieve current set of permissions of the data source in a declarative form.
     * @summary Get permissions for the data source
     * @param {ManagePermissionsApiGetDataSourcePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagePermissionsApi
     */
    getDataSourcePermissions(requestParameters, options) {
        return ManagePermissionsApiFp(this.configuration)
            .getDataSourcePermissions(requestParameters.dataSourceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Manage Permissions for a Data Source
     * @summary Manage Permissions for a Data Source
     * @param {ManagePermissionsApiManageDataSourcePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagePermissionsApi
     */
    manageDataSourcePermissions(requestParameters, options) {
        return ManagePermissionsApiFp(this.configuration)
            .manageDataSourcePermissions(requestParameters.dataSourceId, requestParameters.dataSourcePermissionAssignment, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * set data source permissions.
     * @summary Set data source permissions.
     * @param {ManagePermissionsApiSetDataSourcePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagePermissionsApi
     */
    setDataSourcePermissions(requestParameters, options) {
        return ManagePermissionsApiFp(this.configuration)
            .setDataSourcePermissions(requestParameters.dataSourceId, requestParameters.declarativeDataSourcePermissions, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MetadataSyncApi - axios parameter creator
 * @export
 */
export const MetadataSyncApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
         * @summary (BETA) Sync Metadata to other services
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSync: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("metadataSync", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/metadataSync`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
         * @summary (BETA) Sync organization scope Metadata to other services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSyncOrganization: async (options = {}) => {
            const localVarPath = `/api/v1/actions/organization/metadataSync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MetadataSyncApi - functional programming interface
 * @export
 */
export const MetadataSyncApiFp = function (configuration) {
    const localVarAxiosParamCreator = MetadataSyncApiAxiosParamCreator(configuration);
    return {
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
         * @summary (BETA) Sync Metadata to other services
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metadataSync(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metadataSync(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
         * @summary (BETA) Sync organization scope Metadata to other services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metadataSyncOrganization(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metadataSyncOrganization(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * MetadataSyncApi - factory interface
 * @export
 */
export const MetadataSyncApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MetadataSyncApiFp(configuration);
    return {
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
         * @summary (BETA) Sync Metadata to other services
         * @param {MetadataSyncApiMetadataSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSync(requestParameters, options) {
            return localVarFp
                .metadataSync(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
         * @summary (BETA) Sync organization scope Metadata to other services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataSyncOrganization(options) {
            return localVarFp.metadataSyncOrganization(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MetadataSyncApi - object-oriented interface
 * @export
 * @class MetadataSyncApi
 * @extends {BaseAPI}
 */
export class MetadataSyncApi extends BaseAPI {
    /**
     * (BETA) Temporary solution. Later relevant metadata actions will trigger it in its scope only.
     * @summary (BETA) Sync Metadata to other services
     * @param {MetadataSyncApiMetadataSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataSyncApi
     */
    metadataSync(requestParameters, options) {
        return MetadataSyncApiFp(this.configuration)
            .metadataSync(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * (BETA) Temporary solution. Later relevant metadata actions will trigger sync in their scope only.
     * @summary (BETA) Sync organization scope Metadata to other services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataSyncApi
     */
    metadataSyncOrganization(options) {
        return MetadataSyncApiFp(this.configuration)
            .metadataSyncOrganization(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MetricsApi - axios parameter creator
 * @export
 */
export const MetricsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Metrics
         * @param {string} workspaceId
         * @param {JsonApiMetricPostOptionalIdDocument} jsonApiMetricPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityMetrics: async (workspaceId, jsonApiMetricPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiMetricPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityMetrics", "jsonApiMetricPostOptionalIdDocument", jsonApiMetricPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiMetricPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiMetricPostOptionalIdDocument !== undefined
                    ? jsonApiMetricPostOptionalIdDocument
                    : {})
                : jsonApiMetricPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityMetrics: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityMetrics", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Metrics
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesMetrics: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesMetrics", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityMetrics: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityMetrics", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricPatchDocument} jsonApiMetricPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityMetrics: async (workspaceId, objectId, jsonApiMetricPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityMetrics", "objectId", objectId);
            // verify required parameter 'jsonApiMetricPatchDocument' is not null or undefined
            assertParamExists("patchEntityMetrics", "jsonApiMetricPatchDocument", jsonApiMetricPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiMetricPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiMetricPatchDocument !== undefined ? jsonApiMetricPatchDocument : {})
                : jsonApiMetricPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricInDocument} jsonApiMetricInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityMetrics: async (workspaceId, objectId, jsonApiMetricInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityMetrics", "objectId", objectId);
            // verify required parameter 'jsonApiMetricInDocument' is not null or undefined
            assertParamExists("updateEntityMetrics", "jsonApiMetricInDocument", jsonApiMetricInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiMetricInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiMetricInDocument !== undefined ? jsonApiMetricInDocument : {})
                : jsonApiMetricInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MetricsApi - functional programming interface
 * @export
 */
export const MetricsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MetricsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Metrics
         * @param {string} workspaceId
         * @param {JsonApiMetricPostOptionalIdDocument} jsonApiMetricPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityMetrics(workspaceId, jsonApiMetricPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityMetrics(workspaceId, jsonApiMetricPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityMetrics(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityMetrics(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Metrics
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesMetrics(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesMetrics(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityMetrics(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityMetrics(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricPatchDocument} jsonApiMetricPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityMetrics(workspaceId, objectId, jsonApiMetricPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityMetrics(workspaceId, objectId, jsonApiMetricPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricInDocument} jsonApiMetricInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityMetrics(workspaceId, objectId, jsonApiMetricInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityMetrics(workspaceId, objectId, jsonApiMetricInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * MetricsApi - factory interface
 * @export
 */
export const MetricsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MetricsApiFp(configuration);
    return {
        /**
         *
         * @summary Post Metrics
         * @param {MetricsApiCreateEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityMetrics(requestParameters, options) {
            return localVarFp
                .createEntityMetrics(requestParameters.workspaceId, requestParameters.jsonApiMetricPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Metric
         * @param {MetricsApiDeleteEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityMetrics(requestParameters, options) {
            return localVarFp
                .deleteEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Metrics
         * @param {MetricsApiGetAllEntitiesMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesMetrics(requestParameters, options) {
            return localVarFp
                .getAllEntitiesMetrics(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Metric
         * @param {MetricsApiGetEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityMetrics(requestParameters, options) {
            return localVarFp
                .getEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Metric
         * @param {MetricsApiPatchEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityMetrics(requestParameters, options) {
            return localVarFp
                .patchEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Metric
         * @param {MetricsApiUpdateEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityMetrics(requestParameters, options) {
            return localVarFp
                .updateEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * MetricsApi - object-oriented interface
 * @export
 * @class MetricsApi
 * @extends {BaseAPI}
 */
export class MetricsApi extends BaseAPI {
    /**
     *
     * @summary Post Metrics
     * @param {MetricsApiCreateEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    createEntityMetrics(requestParameters, options) {
        return MetricsApiFp(this.configuration)
            .createEntityMetrics(requestParameters.workspaceId, requestParameters.jsonApiMetricPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Metric
     * @param {MetricsApiDeleteEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    deleteEntityMetrics(requestParameters, options) {
        return MetricsApiFp(this.configuration)
            .deleteEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Metrics
     * @param {MetricsApiGetAllEntitiesMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    getAllEntitiesMetrics(requestParameters, options) {
        return MetricsApiFp(this.configuration)
            .getAllEntitiesMetrics(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Metric
     * @param {MetricsApiGetEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    getEntityMetrics(requestParameters, options) {
        return MetricsApiFp(this.configuration)
            .getEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Metric
     * @param {MetricsApiPatchEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    patchEntityMetrics(requestParameters, options) {
        return MetricsApiFp(this.configuration)
            .patchEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Metric
     * @param {MetricsApiUpdateEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    updateEntityMetrics(requestParameters, options) {
        return MetricsApiFp(this.configuration)
            .updateEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NotificationChannelsApi - axios parameter creator
 * @export
 */
export const NotificationChannelsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Notification Channel entities
         * @param {JsonApiNotificationChannelPostOptionalIdDocument} jsonApiNotificationChannelPostOptionalIdDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityNotificationChannels: async (jsonApiNotificationChannelPostOptionalIdDocument, options = {}) => {
            // verify required parameter 'jsonApiNotificationChannelPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityNotificationChannels", "jsonApiNotificationChannelPostOptionalIdDocument", jsonApiNotificationChannelPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiNotificationChannelPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiNotificationChannelPostOptionalIdDocument !== undefined
                    ? jsonApiNotificationChannelPostOptionalIdDocument
                    : {})
                : jsonApiNotificationChannelPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityNotificationChannels: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityNotificationChannels", "id", id);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Notification Channel entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesNotificationChannels: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityNotificationChannels: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityNotificationChannels", "id", id);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets complete layout of notification channels.
         * @summary Get all notification channels layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationChannelsLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelPatchDocument} jsonApiNotificationChannelPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityNotificationChannels: async (id, jsonApiNotificationChannelPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityNotificationChannels", "id", id);
            // verify required parameter 'jsonApiNotificationChannelPatchDocument' is not null or undefined
            assertParamExists("patchEntityNotificationChannels", "jsonApiNotificationChannelPatchDocument", jsonApiNotificationChannelPatchDocument);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiNotificationChannelPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiNotificationChannelPatchDocument !== undefined
                    ? jsonApiNotificationChannelPatchDocument
                    : {})
                : jsonApiNotificationChannelPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets notification channels in organization.
         * @summary Set all notification channels
         * @param {DeclarativeNotificationChannels} declarativeNotificationChannels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotificationChannels: async (declarativeNotificationChannels, options = {}) => {
            // verify required parameter 'declarativeNotificationChannels' is not null or undefined
            assertParamExists("setNotificationChannels", "declarativeNotificationChannels", declarativeNotificationChannels);
            const localVarPath = `/api/v1/layout/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeNotificationChannels !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeNotificationChannels !== undefined ? declarativeNotificationChannels : {})
                : declarativeNotificationChannels || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelInDocument} jsonApiNotificationChannelInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityNotificationChannels: async (id, jsonApiNotificationChannelInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityNotificationChannels", "id", id);
            // verify required parameter 'jsonApiNotificationChannelInDocument' is not null or undefined
            assertParamExists("updateEntityNotificationChannels", "jsonApiNotificationChannelInDocument", jsonApiNotificationChannelInDocument);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiNotificationChannelInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiNotificationChannelInDocument !== undefined
                    ? jsonApiNotificationChannelInDocument
                    : {})
                : jsonApiNotificationChannelInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NotificationChannelsApi - functional programming interface
 * @export
 */
export const NotificationChannelsApiFp = function (configuration) {
    const localVarAxiosParamCreator = NotificationChannelsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Notification Channel entities
         * @param {JsonApiNotificationChannelPostOptionalIdDocument} jsonApiNotificationChannelPostOptionalIdDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityNotificationChannels(jsonApiNotificationChannelPostOptionalIdDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityNotificationChannels(jsonApiNotificationChannelPostOptionalIdDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityNotificationChannels(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityNotificationChannels(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Notification Channel entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesNotificationChannels(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesNotificationChannels(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityNotificationChannels(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityNotificationChannels(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets complete layout of notification channels.
         * @summary Get all notification channels layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationChannelsLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationChannelsLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelPatchDocument} jsonApiNotificationChannelPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityNotificationChannels(id, jsonApiNotificationChannelPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityNotificationChannels(id, jsonApiNotificationChannelPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets notification channels in organization.
         * @summary Set all notification channels
         * @param {DeclarativeNotificationChannels} declarativeNotificationChannels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setNotificationChannels(declarativeNotificationChannels, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setNotificationChannels(declarativeNotificationChannels, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelInDocument} jsonApiNotificationChannelInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityNotificationChannels(id, jsonApiNotificationChannelInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityNotificationChannels(id, jsonApiNotificationChannelInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * NotificationChannelsApi - factory interface
 * @export
 */
export const NotificationChannelsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NotificationChannelsApiFp(configuration);
    return {
        /**
         *
         * @summary Post Notification Channel entities
         * @param {NotificationChannelsApiCreateEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .createEntityNotificationChannels(requestParameters.jsonApiNotificationChannelPostOptionalIdDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Notification Channel entity
         * @param {NotificationChannelsApiDeleteEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .deleteEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Notification Channel entities
         * @param {NotificationChannelsApiGetAllEntitiesNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesNotificationChannels(requestParameters, options) {
            return localVarFp
                .getAllEntitiesNotificationChannels(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Notification Channel entity
         * @param {NotificationChannelsApiGetEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .getEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Gets complete layout of notification channels.
         * @summary Get all notification channels layout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationChannelsLayout(options) {
            return localVarFp
                .getNotificationChannelsLayout(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Notification Channel entity
         * @param {NotificationChannelsApiPatchEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .patchEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets notification channels in organization.
         * @summary Set all notification channels
         * @param {NotificationChannelsApiSetNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotificationChannels(requestParameters, options) {
            return localVarFp
                .setNotificationChannels(requestParameters.declarativeNotificationChannels, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Notification Channel entity
         * @param {NotificationChannelsApiUpdateEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .updateEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * NotificationChannelsApi - object-oriented interface
 * @export
 * @class NotificationChannelsApi
 * @extends {BaseAPI}
 */
export class NotificationChannelsApi extends BaseAPI {
    /**
     *
     * @summary Post Notification Channel entities
     * @param {NotificationChannelsApiCreateEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationChannelsApi
     */
    createEntityNotificationChannels(requestParameters, options) {
        return NotificationChannelsApiFp(this.configuration)
            .createEntityNotificationChannels(requestParameters.jsonApiNotificationChannelPostOptionalIdDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Notification Channel entity
     * @param {NotificationChannelsApiDeleteEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationChannelsApi
     */
    deleteEntityNotificationChannels(requestParameters, options) {
        return NotificationChannelsApiFp(this.configuration)
            .deleteEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Notification Channel entities
     * @param {NotificationChannelsApiGetAllEntitiesNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationChannelsApi
     */
    getAllEntitiesNotificationChannels(requestParameters = {}, options) {
        return NotificationChannelsApiFp(this.configuration)
            .getAllEntitiesNotificationChannels(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Notification Channel entity
     * @param {NotificationChannelsApiGetEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationChannelsApi
     */
    getEntityNotificationChannels(requestParameters, options) {
        return NotificationChannelsApiFp(this.configuration)
            .getEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets complete layout of notification channels.
     * @summary Get all notification channels layout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationChannelsApi
     */
    getNotificationChannelsLayout(options) {
        return NotificationChannelsApiFp(this.configuration)
            .getNotificationChannelsLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Notification Channel entity
     * @param {NotificationChannelsApiPatchEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationChannelsApi
     */
    patchEntityNotificationChannels(requestParameters, options) {
        return NotificationChannelsApiFp(this.configuration)
            .patchEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets notification channels in organization.
     * @summary Set all notification channels
     * @param {NotificationChannelsApiSetNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationChannelsApi
     */
    setNotificationChannels(requestParameters, options) {
        return NotificationChannelsApiFp(this.configuration)
            .setNotificationChannels(requestParameters.declarativeNotificationChannels, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Notification Channel entity
     * @param {NotificationChannelsApiUpdateEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationChannelsApi
     */
    updateEntityNotificationChannels(requestParameters, options) {
        return NotificationChannelsApiFp(this.configuration)
            .updateEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OptionsApi - axios parameter creator
 * @export
 */
export const OptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves links for all options for different configurations.
         * @summary Links for all configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOptions: async (options = {}) => {
            const localVarPath = `/api/v1/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OptionsApi - functional programming interface
 * @export
 */
export const OptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OptionsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves links for all options for different configurations.
         * @summary Links for all configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOptions(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * OptionsApi - factory interface
 * @export
 */
export const OptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OptionsApiFp(configuration);
    return {
        /**
         * Retrieves links for all options for different configurations.
         * @summary Links for all configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOptions(options) {
            return localVarFp.getAllOptions(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OptionsApi - object-oriented interface
 * @export
 * @class OptionsApi
 * @extends {BaseAPI}
 */
export class OptionsApi extends BaseAPI {
    /**
     * Retrieves links for all options for different configurations.
     * @summary Links for all configuration options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    getAllOptions(options) {
        return OptionsApiFp(this.configuration)
            .getAllOptions(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrganizationControllerApi - axios parameter creator
 * @export
 */
export const OrganizationControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get CookieSecurityConfiguration
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCookieSecurityConfigurations: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityCookieSecurityConfigurations", "id", id);
            const localVarPath = `/api/v1/entities/admin/cookieSecurityConfigurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Organizations
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizations: async (id, filter, include, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityOrganizations", "id", id);
            const localVarPath = `/api/v1/entities/admin/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationPatchDocument} jsonApiCookieSecurityConfigurationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCookieSecurityConfigurations: async (id, jsonApiCookieSecurityConfigurationPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityCookieSecurityConfigurations", "id", id);
            // verify required parameter 'jsonApiCookieSecurityConfigurationPatchDocument' is not null or undefined
            assertParamExists("patchEntityCookieSecurityConfigurations", "jsonApiCookieSecurityConfigurationPatchDocument", jsonApiCookieSecurityConfigurationPatchDocument);
            const localVarPath = `/api/v1/entities/admin/cookieSecurityConfigurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCookieSecurityConfigurationPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCookieSecurityConfigurationPatchDocument !== undefined
                    ? jsonApiCookieSecurityConfigurationPatchDocument
                    : {})
                : jsonApiCookieSecurityConfigurationPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Organization
         * @param {string} id
         * @param {JsonApiOrganizationPatchDocument} jsonApiOrganizationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizations: async (id, jsonApiOrganizationPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityOrganizations", "id", id);
            // verify required parameter 'jsonApiOrganizationPatchDocument' is not null or undefined
            assertParamExists("patchEntityOrganizations", "jsonApiOrganizationPatchDocument", jsonApiOrganizationPatchDocument);
            const localVarPath = `/api/v1/entities/admin/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationPatchDocument !== undefined ? jsonApiOrganizationPatchDocument : {})
                : jsonApiOrganizationPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationInDocument} jsonApiCookieSecurityConfigurationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCookieSecurityConfigurations: async (id, jsonApiCookieSecurityConfigurationInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityCookieSecurityConfigurations", "id", id);
            // verify required parameter 'jsonApiCookieSecurityConfigurationInDocument' is not null or undefined
            assertParamExists("updateEntityCookieSecurityConfigurations", "jsonApiCookieSecurityConfigurationInDocument", jsonApiCookieSecurityConfigurationInDocument);
            const localVarPath = `/api/v1/entities/admin/cookieSecurityConfigurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCookieSecurityConfigurationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCookieSecurityConfigurationInDocument !== undefined
                    ? jsonApiCookieSecurityConfigurationInDocument
                    : {})
                : jsonApiCookieSecurityConfigurationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Organization
         * @param {string} id
         * @param {JsonApiOrganizationInDocument} jsonApiOrganizationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizations: async (id, jsonApiOrganizationInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityOrganizations", "id", id);
            // verify required parameter 'jsonApiOrganizationInDocument' is not null or undefined
            assertParamExists("updateEntityOrganizations", "jsonApiOrganizationInDocument", jsonApiOrganizationInDocument);
            const localVarPath = `/api/v1/entities/admin/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationInDocument !== undefined ? jsonApiOrganizationInDocument : {})
                : jsonApiOrganizationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganizationControllerApi - functional programming interface
 * @export
 */
export const OrganizationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get CookieSecurityConfiguration
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCookieSecurityConfigurations(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCookieSecurityConfigurations(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Organizations
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityOrganizations(id, filter, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityOrganizations(id, filter, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationPatchDocument} jsonApiCookieSecurityConfigurationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Organization
         * @param {string} id
         * @param {JsonApiOrganizationPatchDocument} jsonApiOrganizationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityOrganizations(id, jsonApiOrganizationPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityOrganizations(id, jsonApiOrganizationPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put CookieSecurityConfiguration
         * @param {string} id
         * @param {JsonApiCookieSecurityConfigurationInDocument} jsonApiCookieSecurityConfigurationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityCookieSecurityConfigurations(id, jsonApiCookieSecurityConfigurationInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Organization
         * @param {string} id
         * @param {JsonApiOrganizationInDocument} jsonApiOrganizationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityOrganizations(id, jsonApiOrganizationInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityOrganizations(id, jsonApiOrganizationInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * OrganizationControllerApi - factory interface
 * @export
 */
export const OrganizationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Get CookieSecurityConfiguration
         * @param {OrganizationControllerApiGetEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCookieSecurityConfigurations(requestParameters, options) {
            return localVarFp
                .getEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Organizations
         * @param {OrganizationControllerApiGetEntityOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizations(requestParameters, options) {
            return localVarFp
                .getEntityOrganizations(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch CookieSecurityConfiguration
         * @param {OrganizationControllerApiPatchEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCookieSecurityConfigurations(requestParameters, options) {
            return localVarFp
                .patchEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Organization
         * @param {OrganizationControllerApiPatchEntityOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizations(requestParameters, options) {
            return localVarFp
                .patchEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put CookieSecurityConfiguration
         * @param {OrganizationControllerApiUpdateEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCookieSecurityConfigurations(requestParameters, options) {
            return localVarFp
                .updateEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Organization
         * @param {OrganizationControllerApiUpdateEntityOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizations(requestParameters, options) {
            return localVarFp
                .updateEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganizationControllerApi - object-oriented interface
 * @export
 * @class OrganizationControllerApi
 * @extends {BaseAPI}
 */
export class OrganizationControllerApi extends BaseAPI {
    /**
     *
     * @summary Get CookieSecurityConfiguration
     * @param {OrganizationControllerApiGetEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationControllerApi
     */
    getEntityCookieSecurityConfigurations(requestParameters, options) {
        return OrganizationControllerApiFp(this.configuration)
            .getEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Organizations
     * @param {OrganizationControllerApiGetEntityOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationControllerApi
     */
    getEntityOrganizations(requestParameters, options) {
        return OrganizationControllerApiFp(this.configuration)
            .getEntityOrganizations(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch CookieSecurityConfiguration
     * @param {OrganizationControllerApiPatchEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationControllerApi
     */
    patchEntityCookieSecurityConfigurations(requestParameters, options) {
        return OrganizationControllerApiFp(this.configuration)
            .patchEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Organization
     * @param {OrganizationControllerApiPatchEntityOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationControllerApi
     */
    patchEntityOrganizations(requestParameters, options) {
        return OrganizationControllerApiFp(this.configuration)
            .patchEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put CookieSecurityConfiguration
     * @param {OrganizationControllerApiUpdateEntityCookieSecurityConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationControllerApi
     */
    updateEntityCookieSecurityConfigurations(requestParameters, options) {
        return OrganizationControllerApiFp(this.configuration)
            .updateEntityCookieSecurityConfigurations(requestParameters.id, requestParameters.jsonApiCookieSecurityConfigurationInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Organization
     * @param {OrganizationControllerApiUpdateEntityOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationControllerApi
     */
    updateEntityOrganizations(requestParameters, options) {
        return OrganizationControllerApiFp(this.configuration)
            .updateEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrganizationDeclarativeAPIsApi - axios parameter creator
 * @export
 */
export const OrganizationDeclarativeAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve complete layout of organization, workspaces, user-groups, etc.
         * @summary Get organization layout
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationLayout: async (exclude, options = {}) => {
            const localVarPath = `/api/v1/layout/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets complete layout of organization, like workspaces, user-groups, etc.
         * @summary Set organization layout
         * @param {DeclarativeOrganization} declarativeOrganization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationLayout: async (declarativeOrganization, options = {}) => {
            // verify required parameter 'declarativeOrganization' is not null or undefined
            assertParamExists("setOrganizationLayout", "declarativeOrganization", declarativeOrganization);
            const localVarPath = `/api/v1/layout/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeOrganization !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeOrganization !== undefined ? declarativeOrganization : {})
                : declarativeOrganization || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganizationDeclarativeAPIsApi - functional programming interface
 * @export
 */
export const OrganizationDeclarativeAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationDeclarativeAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve complete layout of organization, workspaces, user-groups, etc.
         * @summary Get organization layout
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationLayout(exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationLayout(exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets complete layout of organization, like workspaces, user-groups, etc.
         * @summary Set organization layout
         * @param {DeclarativeOrganization} declarativeOrganization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOrganizationLayout(declarativeOrganization, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOrganizationLayout(declarativeOrganization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * OrganizationDeclarativeAPIsApi - factory interface
 * @export
 */
export const OrganizationDeclarativeAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationDeclarativeAPIsApiFp(configuration);
    return {
        /**
         * Retrieve complete layout of organization, workspaces, user-groups, etc.
         * @summary Get organization layout
         * @param {OrganizationDeclarativeAPIsApiGetOrganizationLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationLayout(requestParameters, options) {
            return localVarFp
                .getOrganizationLayout(requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets complete layout of organization, like workspaces, user-groups, etc.
         * @summary Set organization layout
         * @param {OrganizationDeclarativeAPIsApiSetOrganizationLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationLayout(requestParameters, options) {
            return localVarFp
                .setOrganizationLayout(requestParameters.declarativeOrganization, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganizationDeclarativeAPIsApi - object-oriented interface
 * @export
 * @class OrganizationDeclarativeAPIsApi
 * @extends {BaseAPI}
 */
export class OrganizationDeclarativeAPIsApi extends BaseAPI {
    /**
     * Retrieve complete layout of organization, workspaces, user-groups, etc.
     * @summary Get organization layout
     * @param {OrganizationDeclarativeAPIsApiGetOrganizationLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationDeclarativeAPIsApi
     */
    getOrganizationLayout(requestParameters = {}, options) {
        return OrganizationDeclarativeAPIsApiFp(this.configuration)
            .getOrganizationLayout(requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets complete layout of organization, like workspaces, user-groups, etc.
     * @summary Set organization layout
     * @param {OrganizationDeclarativeAPIsApiSetOrganizationLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationDeclarativeAPIsApi
     */
    setOrganizationLayout(requestParameters, options) {
        return OrganizationDeclarativeAPIsApiFp(this.configuration)
            .setOrganizationLayout(requestParameters.declarativeOrganization, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrganizationEntityAPIsApi - axios parameter creator
 * @export
 */
export const OrganizationEntityAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Organization Setting entities
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityOrganizationSettings: async (jsonApiOrganizationSettingInDocument, options = {}) => {
            // verify required parameter 'jsonApiOrganizationSettingInDocument' is not null or undefined
            assertParamExists("createEntityOrganizationSettings", "jsonApiOrganizationSettingInDocument", jsonApiOrganizationSettingInDocument);
            const localVarPath = `/api/v1/entities/organizationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationSettingInDocument !== undefined
                    ? jsonApiOrganizationSettingInDocument
                    : {})
                : jsonApiOrganizationSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityOrganizationSettings: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityOrganizationSettings", "id", id);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Organization entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesOrganizationSettings: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/organizationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizationSettings: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityOrganizationSettings", "id", id);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Organizations
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizations: async (id, filter, include, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityOrganizations", "id", id);
            const localVarPath = `/api/v1/entities/admin/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a basic information about organization.
         * @summary Get current organization info
         * @param {Array<'permissions' | 'all'>} [metaInclude] Return list of permissions available to logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingPatchDocument} jsonApiOrganizationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizationSettings: async (id, jsonApiOrganizationSettingPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityOrganizationSettings", "id", id);
            // verify required parameter 'jsonApiOrganizationSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityOrganizationSettings", "jsonApiOrganizationSettingPatchDocument", jsonApiOrganizationSettingPatchDocument);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationSettingPatchDocument !== undefined
                    ? jsonApiOrganizationSettingPatchDocument
                    : {})
                : jsonApiOrganizationSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Organization
         * @param {string} id
         * @param {JsonApiOrganizationPatchDocument} jsonApiOrganizationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizations: async (id, jsonApiOrganizationPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityOrganizations", "id", id);
            // verify required parameter 'jsonApiOrganizationPatchDocument' is not null or undefined
            assertParamExists("patchEntityOrganizations", "jsonApiOrganizationPatchDocument", jsonApiOrganizationPatchDocument);
            const localVarPath = `/api/v1/entities/admin/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationPatchDocument !== undefined ? jsonApiOrganizationPatchDocument : {})
                : jsonApiOrganizationPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizationSettings: async (id, jsonApiOrganizationSettingInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityOrganizationSettings", "id", id);
            // verify required parameter 'jsonApiOrganizationSettingInDocument' is not null or undefined
            assertParamExists("updateEntityOrganizationSettings", "jsonApiOrganizationSettingInDocument", jsonApiOrganizationSettingInDocument);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationSettingInDocument !== undefined
                    ? jsonApiOrganizationSettingInDocument
                    : {})
                : jsonApiOrganizationSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Organization
         * @param {string} id
         * @param {JsonApiOrganizationInDocument} jsonApiOrganizationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizations: async (id, jsonApiOrganizationInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityOrganizations", "id", id);
            // verify required parameter 'jsonApiOrganizationInDocument' is not null or undefined
            assertParamExists("updateEntityOrganizations", "jsonApiOrganizationInDocument", jsonApiOrganizationInDocument);
            const localVarPath = `/api/v1/entities/admin/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationInDocument !== undefined ? jsonApiOrganizationInDocument : {})
                : jsonApiOrganizationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganizationEntityAPIsApi - functional programming interface
 * @export
 */
export const OrganizationEntityAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationEntityAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Organization Setting entities
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityOrganizationSettings(jsonApiOrganizationSettingInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityOrganizationSettings(jsonApiOrganizationSettingInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityOrganizationSettings(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityOrganizationSettings(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Organization entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesOrganizationSettings(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesOrganizationSettings(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityOrganizationSettings(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityOrganizationSettings(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Organizations
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityOrganizations(id, filter, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityOrganizations(id, filter, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a basic information about organization.
         * @summary Get current organization info
         * @param {Array<'permissions' | 'all'>} [metaInclude] Return list of permissions available to logged user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingPatchDocument} jsonApiOrganizationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityOrganizationSettings(id, jsonApiOrganizationSettingPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityOrganizationSettings(id, jsonApiOrganizationSettingPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Organization
         * @param {string} id
         * @param {JsonApiOrganizationPatchDocument} jsonApiOrganizationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityOrganizations(id, jsonApiOrganizationPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityOrganizations(id, jsonApiOrganizationPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityOrganizationSettings(id, jsonApiOrganizationSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityOrganizationSettings(id, jsonApiOrganizationSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Organization
         * @param {string} id
         * @param {JsonApiOrganizationInDocument} jsonApiOrganizationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'bootstrapUser' | 'bootstrapUserGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityOrganizations(id, jsonApiOrganizationInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityOrganizations(id, jsonApiOrganizationInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * OrganizationEntityAPIsApi - factory interface
 * @export
 */
export const OrganizationEntityAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationEntityAPIsApiFp(configuration);
    return {
        /**
         *
         * @summary Post Organization Setting entities
         * @param {OrganizationEntityAPIsApiCreateEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .createEntityOrganizationSettings(requestParameters.jsonApiOrganizationSettingInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Organization entity
         * @param {OrganizationEntityAPIsApiDeleteEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Organization entities
         * @param {OrganizationEntityAPIsApiGetAllEntitiesOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesOrganizationSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesOrganizationSettings(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Organization entity
         * @param {OrganizationEntityAPIsApiGetEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .getEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Organizations
         * @param {OrganizationEntityAPIsApiGetEntityOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizations(requestParameters, options) {
            return localVarFp
                .getEntityOrganizations(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Gets a basic information about organization.
         * @summary Get current organization info
         * @param {OrganizationEntityAPIsApiGetOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(requestParameters, options) {
            return localVarFp
                .getOrganization(requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Organization entity
         * @param {OrganizationEntityAPIsApiPatchEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .patchEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Organization
         * @param {OrganizationEntityAPIsApiPatchEntityOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizations(requestParameters, options) {
            return localVarFp
                .patchEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Organization entity
         * @param {OrganizationEntityAPIsApiUpdateEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .updateEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Organization
         * @param {OrganizationEntityAPIsApiUpdateEntityOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizations(requestParameters, options) {
            return localVarFp
                .updateEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganizationEntityAPIsApi - object-oriented interface
 * @export
 * @class OrganizationEntityAPIsApi
 * @extends {BaseAPI}
 */
export class OrganizationEntityAPIsApi extends BaseAPI {
    /**
     *
     * @summary Post Organization Setting entities
     * @param {OrganizationEntityAPIsApiCreateEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    createEntityOrganizationSettings(requestParameters, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .createEntityOrganizationSettings(requestParameters.jsonApiOrganizationSettingInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Organization entity
     * @param {OrganizationEntityAPIsApiDeleteEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    deleteEntityOrganizationSettings(requestParameters, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .deleteEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Organization entities
     * @param {OrganizationEntityAPIsApiGetAllEntitiesOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    getAllEntitiesOrganizationSettings(requestParameters = {}, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .getAllEntitiesOrganizationSettings(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Organization entity
     * @param {OrganizationEntityAPIsApiGetEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    getEntityOrganizationSettings(requestParameters, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .getEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Organizations
     * @param {OrganizationEntityAPIsApiGetEntityOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    getEntityOrganizations(requestParameters, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .getEntityOrganizations(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a basic information about organization.
     * @summary Get current organization info
     * @param {OrganizationEntityAPIsApiGetOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    getOrganization(requestParameters = {}, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .getOrganization(requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Organization entity
     * @param {OrganizationEntityAPIsApiPatchEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    patchEntityOrganizationSettings(requestParameters, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .patchEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Organization
     * @param {OrganizationEntityAPIsApiPatchEntityOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    patchEntityOrganizations(requestParameters, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .patchEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Organization entity
     * @param {OrganizationEntityAPIsApiUpdateEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    updateEntityOrganizationSettings(requestParameters, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .updateEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Organization
     * @param {OrganizationEntityAPIsApiUpdateEntityOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationEntityAPIsApi
     */
    updateEntityOrganizations(requestParameters, options) {
        return OrganizationEntityAPIsApiFp(this.configuration)
            .updateEntityOrganizations(requestParameters.id, requestParameters.jsonApiOrganizationInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrganizationModelControllerApi - axios parameter creator
 * @export
 */
export const OrganizationModelControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Color Pallettes
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityColorPalettes: async (jsonApiColorPaletteInDocument, options = {}) => {
            // verify required parameter 'jsonApiColorPaletteInDocument' is not null or undefined
            assertParamExists("createEntityColorPalettes", "jsonApiColorPaletteInDocument", jsonApiColorPaletteInDocument);
            const localVarPath = `/api/v1/entities/colorPalettes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiColorPaletteInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiColorPaletteInDocument !== undefined ? jsonApiColorPaletteInDocument : {})
                : jsonApiColorPaletteInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Post CSP Directives
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCspDirectives: async (jsonApiCspDirectiveInDocument, options = {}) => {
            // verify required parameter 'jsonApiCspDirectiveInDocument' is not null or undefined
            assertParamExists("createEntityCspDirectives", "jsonApiCspDirectiveInDocument", jsonApiCspDirectiveInDocument);
            const localVarPath = `/api/v1/entities/cspDirectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCspDirectiveInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCspDirectiveInDocument !== undefined ? jsonApiCspDirectiveInDocument : {})
                : jsonApiCspDirectiveInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Post Data Sources
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDataSources: async (jsonApiDataSourceInDocument, metaInclude, options = {}) => {
            // verify required parameter 'jsonApiDataSourceInDocument' is not null or undefined
            assertParamExists("createEntityDataSources", "jsonApiDataSourceInDocument", jsonApiDataSourceInDocument);
            const localVarPath = `/api/v1/entities/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDataSourceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDataSourceInDocument !== undefined ? jsonApiDataSourceInDocument : {})
                : jsonApiDataSourceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Identity Providers
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityIdentityProviders: async (jsonApiIdentityProviderInDocument, options = {}) => {
            // verify required parameter 'jsonApiIdentityProviderInDocument' is not null or undefined
            assertParamExists("createEntityIdentityProviders", "jsonApiIdentityProviderInDocument", jsonApiIdentityProviderInDocument);
            const localVarPath = `/api/v1/entities/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiIdentityProviderInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiIdentityProviderInDocument !== undefined
                    ? jsonApiIdentityProviderInDocument
                    : {})
                : jsonApiIdentityProviderInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Post Jwks
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityJwks: async (jsonApiJwkInDocument, options = {}) => {
            // verify required parameter 'jsonApiJwkInDocument' is not null or undefined
            assertParamExists("createEntityJwks", "jsonApiJwkInDocument", jsonApiJwkInDocument);
            const localVarPath = `/api/v1/entities/jwks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiJwkInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiJwkInDocument !== undefined ? jsonApiJwkInDocument : {})
                : jsonApiJwkInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post LLM endpoint entities
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityLlmEndpoints: async (jsonApiLlmEndpointInDocument, options = {}) => {
            // verify required parameter 'jsonApiLlmEndpointInDocument' is not null or undefined
            assertParamExists("createEntityLlmEndpoints", "jsonApiLlmEndpointInDocument", jsonApiLlmEndpointInDocument);
            const localVarPath = `/api/v1/entities/llmEndpoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiLlmEndpointInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiLlmEndpointInDocument !== undefined ? jsonApiLlmEndpointInDocument : {})
                : jsonApiLlmEndpointInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Notification Channel entities
         * @param {JsonApiNotificationChannelPostOptionalIdDocument} jsonApiNotificationChannelPostOptionalIdDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityNotificationChannels: async (jsonApiNotificationChannelPostOptionalIdDocument, options = {}) => {
            // verify required parameter 'jsonApiNotificationChannelPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityNotificationChannels", "jsonApiNotificationChannelPostOptionalIdDocument", jsonApiNotificationChannelPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiNotificationChannelPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiNotificationChannelPostOptionalIdDocument !== undefined
                    ? jsonApiNotificationChannelPostOptionalIdDocument
                    : {})
                : jsonApiNotificationChannelPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Organization Setting entities
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityOrganizationSettings: async (jsonApiOrganizationSettingInDocument, options = {}) => {
            // verify required parameter 'jsonApiOrganizationSettingInDocument' is not null or undefined
            assertParamExists("createEntityOrganizationSettings", "jsonApiOrganizationSettingInDocument", jsonApiOrganizationSettingInDocument);
            const localVarPath = `/api/v1/entities/organizationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationSettingInDocument !== undefined
                    ? jsonApiOrganizationSettingInDocument
                    : {})
                : jsonApiOrganizationSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Theming
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityThemes: async (jsonApiThemeInDocument, options = {}) => {
            // verify required parameter 'jsonApiThemeInDocument' is not null or undefined
            assertParamExists("createEntityThemes", "jsonApiThemeInDocument", jsonApiThemeInDocument);
            const localVarPath = `/api/v1/entities/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiThemeInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiThemeInDocument !== undefined ? jsonApiThemeInDocument : {})
                : jsonApiThemeInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Post User Group entities
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserGroups: async (jsonApiUserGroupInDocument, include, options = {}) => {
            // verify required parameter 'jsonApiUserGroupInDocument' is not null or undefined
            assertParamExists("createEntityUserGroups", "jsonApiUserGroupInDocument", jsonApiUserGroupInDocument);
            const localVarPath = `/api/v1/entities/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserGroupInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserGroupInDocument !== undefined ? jsonApiUserGroupInDocument : {})
                : jsonApiUserGroupInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Post User entities
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUsers: async (jsonApiUserInDocument, include, options = {}) => {
            // verify required parameter 'jsonApiUserInDocument' is not null or undefined
            assertParamExists("createEntityUsers", "jsonApiUserInDocument", jsonApiUserInDocument);
            const localVarPath = `/api/v1/entities/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserInDocument !== undefined ? jsonApiUserInDocument : {})
                : jsonApiUserInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Post Workspace entities
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaces: async (jsonApiWorkspaceInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'jsonApiWorkspaceInDocument' is not null or undefined
            assertParamExists("createEntityWorkspaces", "jsonApiWorkspaceInDocument", jsonApiWorkspaceInDocument);
            const localVarPath = `/api/v1/entities/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceInDocument !== undefined ? jsonApiWorkspaceInDocument : {})
                : jsonApiWorkspaceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityColorPalettes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityColorPalettes", "id", id);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Delete CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCspDirectives: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityCspDirectives", "id", id);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Delete Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDataSources: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityDataSources", "id", id);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityIdentityProviders: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityIdentityProviders", "id", id);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Delete Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityJwks: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityJwks", "id", id);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityLlmEndpoints: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityLlmEndpoints", "id", id);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityNotificationChannels: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityNotificationChannels", "id", id);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityOrganizationSettings: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityOrganizationSettings", "id", id);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityThemes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityThemes", "id", id);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Delete UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserGroups: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityUserGroups", "id", id);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Delete User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUsers: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityUsers", "id", id);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Delete Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaces: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityWorkspaces", "id", id);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Color Pallettes
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesColorPalettes: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/colorPalettes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCspDirectives: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/cspDirectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Data Source Identifiers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSourceIdentifiers: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/dataSourceIdentifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSources: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/dataSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlements
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesEntitlements: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Identity Providers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesIdentityProviders: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/identityProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
         * @summary Get all Jwks
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesJwks: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/jwks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all LLM endpoint entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLlmEndpoints: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/llmEndpoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Notification Channel entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesNotificationChannels: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/notificationChannels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Organization entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesOrganizationSettings: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/organizationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Theming entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesThemes: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserGroups: async (filter, include, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UserIdentifier - represents entity interacting with platform
         * @summary Get UserIdentifier entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserIdentifiers: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/userIdentifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUsers: async (filter, include, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaces: async (filter, include, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityColorPalettes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityColorPalettes", "id", id);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCspDirectives: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityCspDirectives", "id", id);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Data Source Identifier
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSourceIdentifiers: async (id, filter, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityDataSourceIdentifiers", "id", id);
            const localVarPath = `/api/v1/entities/dataSourceIdentifiers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSources: async (id, filter, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityDataSources", "id", id);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlement
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityEntitlements: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityEntitlements", "id", id);
            const localVarPath = `/api/v1/entities/entitlements/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityIdentityProviders: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityIdentityProviders", "id", id);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Get Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityJwks: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityJwks", "id", id);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get LLM endpoint entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLlmEndpoints: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityLlmEndpoints", "id", id);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityNotificationChannels: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityNotificationChannels", "id", id);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizationSettings: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityOrganizationSettings", "id", id);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityThemes: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityThemes", "id", id);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserGroups: async (id, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUserGroups", "id", id);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UserIdentifier - represents basic information about entity interacting with platform
         * @summary Get UserIdentifier entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserIdentifiers: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUserIdentifiers", "id", id);
            const localVarPath = `/api/v1/entities/userIdentifiers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUsers: async (id, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUsers", "id", id);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaces: async (id, filter, include, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityWorkspaces", "id", id);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Color Pallette
         * @param {string} id
         * @param {JsonApiColorPalettePatchDocument} jsonApiColorPalettePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityColorPalettes: async (id, jsonApiColorPalettePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityColorPalettes", "id", id);
            // verify required parameter 'jsonApiColorPalettePatchDocument' is not null or undefined
            assertParamExists("patchEntityColorPalettes", "jsonApiColorPalettePatchDocument", jsonApiColorPalettePatchDocument);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiColorPalettePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiColorPalettePatchDocument !== undefined ? jsonApiColorPalettePatchDocument : {})
                : jsonApiColorPalettePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Patch CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectivePatchDocument} jsonApiCspDirectivePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCspDirectives: async (id, jsonApiCspDirectivePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityCspDirectives", "id", id);
            // verify required parameter 'jsonApiCspDirectivePatchDocument' is not null or undefined
            assertParamExists("patchEntityCspDirectives", "jsonApiCspDirectivePatchDocument", jsonApiCspDirectivePatchDocument);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCspDirectivePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCspDirectivePatchDocument !== undefined ? jsonApiCspDirectivePatchDocument : {})
                : jsonApiCspDirectivePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Patch Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourcePatchDocument} jsonApiDataSourcePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDataSources: async (id, jsonApiDataSourcePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityDataSources", "id", id);
            // verify required parameter 'jsonApiDataSourcePatchDocument' is not null or undefined
            assertParamExists("patchEntityDataSources", "jsonApiDataSourcePatchDocument", jsonApiDataSourcePatchDocument);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDataSourcePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDataSourcePatchDocument !== undefined ? jsonApiDataSourcePatchDocument : {})
                : jsonApiDataSourcePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderPatchDocument} jsonApiIdentityProviderPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityIdentityProviders: async (id, jsonApiIdentityProviderPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityIdentityProviders", "id", id);
            // verify required parameter 'jsonApiIdentityProviderPatchDocument' is not null or undefined
            assertParamExists("patchEntityIdentityProviders", "jsonApiIdentityProviderPatchDocument", jsonApiIdentityProviderPatchDocument);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiIdentityProviderPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiIdentityProviderPatchDocument !== undefined
                    ? jsonApiIdentityProviderPatchDocument
                    : {})
                : jsonApiIdentityProviderPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patches JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Patch Jwk
         * @param {string} id
         * @param {JsonApiJwkPatchDocument} jsonApiJwkPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityJwks: async (id, jsonApiJwkPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityJwks", "id", id);
            // verify required parameter 'jsonApiJwkPatchDocument' is not null or undefined
            assertParamExists("patchEntityJwks", "jsonApiJwkPatchDocument", jsonApiJwkPatchDocument);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiJwkPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiJwkPatchDocument !== undefined ? jsonApiJwkPatchDocument : {})
                : jsonApiJwkPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointPatchDocument} jsonApiLlmEndpointPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityLlmEndpoints: async (id, jsonApiLlmEndpointPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityLlmEndpoints", "id", id);
            // verify required parameter 'jsonApiLlmEndpointPatchDocument' is not null or undefined
            assertParamExists("patchEntityLlmEndpoints", "jsonApiLlmEndpointPatchDocument", jsonApiLlmEndpointPatchDocument);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiLlmEndpointPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiLlmEndpointPatchDocument !== undefined ? jsonApiLlmEndpointPatchDocument : {})
                : jsonApiLlmEndpointPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelPatchDocument} jsonApiNotificationChannelPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityNotificationChannels: async (id, jsonApiNotificationChannelPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityNotificationChannels", "id", id);
            // verify required parameter 'jsonApiNotificationChannelPatchDocument' is not null or undefined
            assertParamExists("patchEntityNotificationChannels", "jsonApiNotificationChannelPatchDocument", jsonApiNotificationChannelPatchDocument);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiNotificationChannelPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiNotificationChannelPatchDocument !== undefined
                    ? jsonApiNotificationChannelPatchDocument
                    : {})
                : jsonApiNotificationChannelPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingPatchDocument} jsonApiOrganizationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizationSettings: async (id, jsonApiOrganizationSettingPatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityOrganizationSettings", "id", id);
            // verify required parameter 'jsonApiOrganizationSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityOrganizationSettings", "jsonApiOrganizationSettingPatchDocument", jsonApiOrganizationSettingPatchDocument);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationSettingPatchDocument !== undefined
                    ? jsonApiOrganizationSettingPatchDocument
                    : {})
                : jsonApiOrganizationSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Theming
         * @param {string} id
         * @param {JsonApiThemePatchDocument} jsonApiThemePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityThemes: async (id, jsonApiThemePatchDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityThemes", "id", id);
            // verify required parameter 'jsonApiThemePatchDocument' is not null or undefined
            assertParamExists("patchEntityThemes", "jsonApiThemePatchDocument", jsonApiThemePatchDocument);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiThemePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiThemePatchDocument !== undefined ? jsonApiThemePatchDocument : {})
                : jsonApiThemePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Patch UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupPatchDocument} jsonApiUserGroupPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserGroups: async (id, jsonApiUserGroupPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityUserGroups", "id", id);
            // verify required parameter 'jsonApiUserGroupPatchDocument' is not null or undefined
            assertParamExists("patchEntityUserGroups", "jsonApiUserGroupPatchDocument", jsonApiUserGroupPatchDocument);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserGroupPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserGroupPatchDocument !== undefined ? jsonApiUserGroupPatchDocument : {})
                : jsonApiUserGroupPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Patch User entity
         * @param {string} id
         * @param {JsonApiUserPatchDocument} jsonApiUserPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUsers: async (id, jsonApiUserPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityUsers", "id", id);
            // verify required parameter 'jsonApiUserPatchDocument' is not null or undefined
            assertParamExists("patchEntityUsers", "jsonApiUserPatchDocument", jsonApiUserPatchDocument);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserPatchDocument !== undefined ? jsonApiUserPatchDocument : {})
                : jsonApiUserPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Patch Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspacePatchDocument} jsonApiWorkspacePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaces: async (id, jsonApiWorkspacePatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityWorkspaces", "id", id);
            // verify required parameter 'jsonApiWorkspacePatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaces", "jsonApiWorkspacePatchDocument", jsonApiWorkspacePatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspacePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspacePatchDocument !== undefined ? jsonApiWorkspacePatchDocument : {})
                : jsonApiWorkspacePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Color Pallette
         * @param {string} id
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityColorPalettes: async (id, jsonApiColorPaletteInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityColorPalettes", "id", id);
            // verify required parameter 'jsonApiColorPaletteInDocument' is not null or undefined
            assertParamExists("updateEntityColorPalettes", "jsonApiColorPaletteInDocument", jsonApiColorPaletteInDocument);
            const localVarPath = `/api/v1/entities/colorPalettes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiColorPaletteInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiColorPaletteInDocument !== undefined ? jsonApiColorPaletteInDocument : {})
                : jsonApiColorPaletteInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Context Security Police Directive
         * @summary Put CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCspDirectives: async (id, jsonApiCspDirectiveInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityCspDirectives", "id", id);
            // verify required parameter 'jsonApiCspDirectiveInDocument' is not null or undefined
            assertParamExists("updateEntityCspDirectives", "jsonApiCspDirectiveInDocument", jsonApiCspDirectiveInDocument);
            const localVarPath = `/api/v1/entities/cspDirectives/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCspDirectiveInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCspDirectiveInDocument !== undefined ? jsonApiCspDirectiveInDocument : {})
                : jsonApiCspDirectiveInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Put Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDataSources: async (id, jsonApiDataSourceInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityDataSources", "id", id);
            // verify required parameter 'jsonApiDataSourceInDocument' is not null or undefined
            assertParamExists("updateEntityDataSources", "jsonApiDataSourceInDocument", jsonApiDataSourceInDocument);
            const localVarPath = `/api/v1/entities/dataSources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDataSourceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDataSourceInDocument !== undefined ? jsonApiDataSourceInDocument : {})
                : jsonApiDataSourceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityIdentityProviders: async (id, jsonApiIdentityProviderInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityIdentityProviders", "id", id);
            // verify required parameter 'jsonApiIdentityProviderInDocument' is not null or undefined
            assertParamExists("updateEntityIdentityProviders", "jsonApiIdentityProviderInDocument", jsonApiIdentityProviderInDocument);
            const localVarPath = `/api/v1/entities/identityProviders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiIdentityProviderInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiIdentityProviderInDocument !== undefined
                    ? jsonApiIdentityProviderInDocument
                    : {})
                : jsonApiIdentityProviderInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Put Jwk
         * @param {string} id
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityJwks: async (id, jsonApiJwkInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityJwks", "id", id);
            // verify required parameter 'jsonApiJwkInDocument' is not null or undefined
            assertParamExists("updateEntityJwks", "jsonApiJwkInDocument", jsonApiJwkInDocument);
            const localVarPath = `/api/v1/entities/jwks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiJwkInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiJwkInDocument !== undefined ? jsonApiJwkInDocument : {})
                : jsonApiJwkInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary PUT LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityLlmEndpoints: async (id, jsonApiLlmEndpointInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityLlmEndpoints", "id", id);
            // verify required parameter 'jsonApiLlmEndpointInDocument' is not null or undefined
            assertParamExists("updateEntityLlmEndpoints", "jsonApiLlmEndpointInDocument", jsonApiLlmEndpointInDocument);
            const localVarPath = `/api/v1/entities/llmEndpoints/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiLlmEndpointInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiLlmEndpointInDocument !== undefined ? jsonApiLlmEndpointInDocument : {})
                : jsonApiLlmEndpointInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelInDocument} jsonApiNotificationChannelInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityNotificationChannels: async (id, jsonApiNotificationChannelInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityNotificationChannels", "id", id);
            // verify required parameter 'jsonApiNotificationChannelInDocument' is not null or undefined
            assertParamExists("updateEntityNotificationChannels", "jsonApiNotificationChannelInDocument", jsonApiNotificationChannelInDocument);
            const localVarPath = `/api/v1/entities/notificationChannels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiNotificationChannelInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiNotificationChannelInDocument !== undefined
                    ? jsonApiNotificationChannelInDocument
                    : {})
                : jsonApiNotificationChannelInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizationSettings: async (id, jsonApiOrganizationSettingInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityOrganizationSettings", "id", id);
            // verify required parameter 'jsonApiOrganizationSettingInDocument' is not null or undefined
            assertParamExists("updateEntityOrganizationSettings", "jsonApiOrganizationSettingInDocument", jsonApiOrganizationSettingInDocument);
            const localVarPath = `/api/v1/entities/organizationSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiOrganizationSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiOrganizationSettingInDocument !== undefined
                    ? jsonApiOrganizationSettingInDocument
                    : {})
                : jsonApiOrganizationSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Theming
         * @param {string} id
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityThemes: async (id, jsonApiThemeInDocument, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityThemes", "id", id);
            // verify required parameter 'jsonApiThemeInDocument' is not null or undefined
            assertParamExists("updateEntityThemes", "jsonApiThemeInDocument", jsonApiThemeInDocument);
            const localVarPath = `/api/v1/entities/themes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiThemeInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiThemeInDocument !== undefined ? jsonApiThemeInDocument : {})
                : jsonApiThemeInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Put UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserGroups: async (id, jsonApiUserGroupInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityUserGroups", "id", id);
            // verify required parameter 'jsonApiUserGroupInDocument' is not null or undefined
            assertParamExists("updateEntityUserGroups", "jsonApiUserGroupInDocument", jsonApiUserGroupInDocument);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserGroupInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserGroupInDocument !== undefined ? jsonApiUserGroupInDocument : {})
                : jsonApiUserGroupInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Put User entity
         * @param {string} id
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUsers: async (id, jsonApiUserInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityUsers", "id", id);
            // verify required parameter 'jsonApiUserInDocument' is not null or undefined
            assertParamExists("updateEntityUsers", "jsonApiUserInDocument", jsonApiUserInDocument);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserInDocument !== undefined ? jsonApiUserInDocument : {})
                : jsonApiUserInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Put Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaces: async (id, jsonApiWorkspaceInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityWorkspaces", "id", id);
            // verify required parameter 'jsonApiWorkspaceInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaces", "jsonApiWorkspaceInDocument", jsonApiWorkspaceInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceInDocument !== undefined ? jsonApiWorkspaceInDocument : {})
                : jsonApiWorkspaceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OrganizationModelControllerApi - functional programming interface
 * @export
 */
export const OrganizationModelControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationModelControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Color Pallettes
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityColorPalettes(jsonApiColorPaletteInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityColorPalettes(jsonApiColorPaletteInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Post CSP Directives
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityCspDirectives(jsonApiCspDirectiveInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityCspDirectives(jsonApiCspDirectiveInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Post Data Sources
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityDataSources(jsonApiDataSourceInDocument, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityDataSources(jsonApiDataSourceInDocument, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Identity Providers
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityIdentityProviders(jsonApiIdentityProviderInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityIdentityProviders(jsonApiIdentityProviderInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Post Jwks
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityJwks(jsonApiJwkInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityJwks(jsonApiJwkInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post LLM endpoint entities
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityLlmEndpoints(jsonApiLlmEndpointInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityLlmEndpoints(jsonApiLlmEndpointInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Notification Channel entities
         * @param {JsonApiNotificationChannelPostOptionalIdDocument} jsonApiNotificationChannelPostOptionalIdDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityNotificationChannels(jsonApiNotificationChannelPostOptionalIdDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityNotificationChannels(jsonApiNotificationChannelPostOptionalIdDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Organization Setting entities
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityOrganizationSettings(jsonApiOrganizationSettingInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityOrganizationSettings(jsonApiOrganizationSettingInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Theming
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityThemes(jsonApiThemeInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityThemes(jsonApiThemeInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Post User Group entities
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUserGroups(jsonApiUserGroupInDocument, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUserGroups(jsonApiUserGroupInDocument, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Post User entities
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUsers(jsonApiUserInDocument, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUsers(jsonApiUserInDocument, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Post Workspace entities
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaces(jsonApiWorkspaceInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaces(jsonApiWorkspaceInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityColorPalettes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityColorPalettes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Delete CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityCspDirectives(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityCspDirectives(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Delete Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityDataSources(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityDataSources(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityIdentityProviders(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityIdentityProviders(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Delete Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityJwks(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityJwks(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityLlmEndpoints(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityLlmEndpoints(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityNotificationChannels(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityNotificationChannels(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityOrganizationSettings(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityOrganizationSettings(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityThemes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityThemes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Delete UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUserGroups(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUserGroups(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Delete User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUsers(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUsers(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Delete Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaces(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaces(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Color Pallettes
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesColorPalettes(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesColorPalettes(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesCspDirectives(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesCspDirectives(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Data Source Identifiers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDataSourceIdentifiers(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDataSourceIdentifiers(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'permissions' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDataSources(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDataSources(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlements
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesEntitlements(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesEntitlements(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Identity Providers
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesIdentityProviders(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesIdentityProviders(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
         * @summary Get all Jwks
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesJwks(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesJwks(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all LLM endpoint entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesLlmEndpoints(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesLlmEndpoints(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Notification Channel entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesNotificationChannels(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesNotificationChannels(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Organization entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesOrganizationSettings(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesOrganizationSettings(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Theming entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesThemes(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesThemes(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserGroups(filter, include, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserGroups(filter, include, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UserIdentifier - represents entity interacting with platform
         * @summary Get UserIdentifier entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserIdentifiers(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserIdentifiers(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUsers(filter, include, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUsers(filter, include, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaces(filter, include, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaces(filter, include, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Color Pallette
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityColorPalettes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityColorPalettes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCspDirectives(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCspDirectives(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Data Source Identifier
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDataSourceIdentifiers(id, filter, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDataSourceIdentifiers(id, filter, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'permissions' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDataSources(id, filter, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDataSources(id, filter, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlement
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityEntitlements(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityEntitlements(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Identity Provider
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityIdentityProviders(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityIdentityProviders(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Get Jwk
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityJwks(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityJwks(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get LLM endpoint entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityLlmEndpoints(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityLlmEndpoints(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Notification Channel entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityNotificationChannels(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityNotificationChannels(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Organization entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityOrganizationSettings(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityOrganizationSettings(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Theming
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityThemes(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityThemes(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserGroups(id, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserGroups(id, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UserIdentifier - represents basic information about entity interacting with platform
         * @summary Get UserIdentifier entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserIdentifiers(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserIdentifiers(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUsers(id, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUsers(id, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaces(id, filter, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaces(id, filter, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Color Pallette
         * @param {string} id
         * @param {JsonApiColorPalettePatchDocument} jsonApiColorPalettePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityColorPalettes(id, jsonApiColorPalettePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityColorPalettes(id, jsonApiColorPalettePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Patch CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectivePatchDocument} jsonApiCspDirectivePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityCspDirectives(id, jsonApiCspDirectivePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityCspDirectives(id, jsonApiCspDirectivePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Patch Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourcePatchDocument} jsonApiDataSourcePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityDataSources(id, jsonApiDataSourcePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityDataSources(id, jsonApiDataSourcePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderPatchDocument} jsonApiIdentityProviderPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityIdentityProviders(id, jsonApiIdentityProviderPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityIdentityProviders(id, jsonApiIdentityProviderPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Patches JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Patch Jwk
         * @param {string} id
         * @param {JsonApiJwkPatchDocument} jsonApiJwkPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityJwks(id, jsonApiJwkPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityJwks(id, jsonApiJwkPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointPatchDocument} jsonApiLlmEndpointPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityLlmEndpoints(id, jsonApiLlmEndpointPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityLlmEndpoints(id, jsonApiLlmEndpointPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelPatchDocument} jsonApiNotificationChannelPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityNotificationChannels(id, jsonApiNotificationChannelPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityNotificationChannels(id, jsonApiNotificationChannelPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingPatchDocument} jsonApiOrganizationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityOrganizationSettings(id, jsonApiOrganizationSettingPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityOrganizationSettings(id, jsonApiOrganizationSettingPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Theming
         * @param {string} id
         * @param {JsonApiThemePatchDocument} jsonApiThemePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityThemes(id, jsonApiThemePatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityThemes(id, jsonApiThemePatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Patch UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupPatchDocument} jsonApiUserGroupPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityUserGroups(id, jsonApiUserGroupPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityUserGroups(id, jsonApiUserGroupPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Patch User entity
         * @param {string} id
         * @param {JsonApiUserPatchDocument} jsonApiUserPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityUsers(id, jsonApiUserPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityUsers(id, jsonApiUserPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Patch Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspacePatchDocument} jsonApiWorkspacePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaces(id, jsonApiWorkspacePatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaces(id, jsonApiWorkspacePatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Color Pallette
         * @param {string} id
         * @param {JsonApiColorPaletteInDocument} jsonApiColorPaletteInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityColorPalettes(id, jsonApiColorPaletteInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityColorPalettes(id, jsonApiColorPaletteInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Context Security Police Directive
         * @summary Put CSP Directives
         * @param {string} id
         * @param {JsonApiCspDirectiveInDocument} jsonApiCspDirectiveInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityCspDirectives(id, jsonApiCspDirectiveInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityCspDirectives(id, jsonApiCspDirectiveInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Put Data Source entity
         * @param {string} id
         * @param {JsonApiDataSourceInDocument} jsonApiDataSourceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityDataSources(id, jsonApiDataSourceInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityDataSources(id, jsonApiDataSourceInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Identity Provider
         * @param {string} id
         * @param {JsonApiIdentityProviderInDocument} jsonApiIdentityProviderInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityIdentityProviders(id, jsonApiIdentityProviderInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityIdentityProviders(id, jsonApiIdentityProviderInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Put Jwk
         * @param {string} id
         * @param {JsonApiJwkInDocument} jsonApiJwkInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityJwks(id, jsonApiJwkInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityJwks(id, jsonApiJwkInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary PUT LLM endpoint entity
         * @param {string} id
         * @param {JsonApiLlmEndpointInDocument} jsonApiLlmEndpointInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityLlmEndpoints(id, jsonApiLlmEndpointInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityLlmEndpoints(id, jsonApiLlmEndpointInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Notification Channel entity
         * @param {string} id
         * @param {JsonApiNotificationChannelInDocument} jsonApiNotificationChannelInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityNotificationChannels(id, jsonApiNotificationChannelInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityNotificationChannels(id, jsonApiNotificationChannelInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Organization entity
         * @param {string} id
         * @param {JsonApiOrganizationSettingInDocument} jsonApiOrganizationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityOrganizationSettings(id, jsonApiOrganizationSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityOrganizationSettings(id, jsonApiOrganizationSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Theming
         * @param {string} id
         * @param {JsonApiThemeInDocument} jsonApiThemeInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityThemes(id, jsonApiThemeInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityThemes(id, jsonApiThemeInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Put UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUserGroups(id, jsonApiUserGroupInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUserGroups(id, jsonApiUserGroupInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Put User entity
         * @param {string} id
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUsers(id, jsonApiUserInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUsers(id, jsonApiUserInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Put Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaces(id, jsonApiWorkspaceInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaces(id, jsonApiWorkspaceInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * OrganizationModelControllerApi - factory interface
 * @export
 */
export const OrganizationModelControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationModelControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Post Color Pallettes
         * @param {OrganizationModelControllerApiCreateEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .createEntityColorPalettes(requestParameters.jsonApiColorPaletteInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Post CSP Directives
         * @param {OrganizationModelControllerApiCreateEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .createEntityCspDirectives(requestParameters.jsonApiCspDirectiveInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Post Data Sources
         * @param {OrganizationModelControllerApiCreateEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDataSources(requestParameters, options) {
            return localVarFp
                .createEntityDataSources(requestParameters.jsonApiDataSourceInDocument, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Identity Providers
         * @param {OrganizationModelControllerApiCreateEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .createEntityIdentityProviders(requestParameters.jsonApiIdentityProviderInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Post Jwks
         * @param {OrganizationModelControllerApiCreateEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityJwks(requestParameters, options) {
            return localVarFp
                .createEntityJwks(requestParameters.jsonApiJwkInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post LLM endpoint entities
         * @param {OrganizationModelControllerApiCreateEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .createEntityLlmEndpoints(requestParameters.jsonApiLlmEndpointInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Notification Channel entities
         * @param {OrganizationModelControllerApiCreateEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .createEntityNotificationChannels(requestParameters.jsonApiNotificationChannelPostOptionalIdDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Organization Setting entities
         * @param {OrganizationModelControllerApiCreateEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .createEntityOrganizationSettings(requestParameters.jsonApiOrganizationSettingInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Theming
         * @param {OrganizationModelControllerApiCreateEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityThemes(requestParameters, options) {
            return localVarFp
                .createEntityThemes(requestParameters.jsonApiThemeInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Post User Group entities
         * @param {OrganizationModelControllerApiCreateEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserGroups(requestParameters, options) {
            return localVarFp
                .createEntityUserGroups(requestParameters.jsonApiUserGroupInDocument, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Post User entities
         * @param {OrganizationModelControllerApiCreateEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUsers(requestParameters, options) {
            return localVarFp
                .createEntityUsers(requestParameters.jsonApiUserInDocument, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Post Workspace entities
         * @param {OrganizationModelControllerApiCreateEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaces(requestParameters.jsonApiWorkspaceInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Color Pallette
         * @param {OrganizationModelControllerApiDeleteEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .deleteEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Delete CSP Directives
         * @param {OrganizationModelControllerApiDeleteEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .deleteEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Delete Data Source entity
         * @param {OrganizationModelControllerApiDeleteEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDataSources(requestParameters, options) {
            return localVarFp
                .deleteEntityDataSources(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Identity Provider
         * @param {OrganizationModelControllerApiDeleteEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .deleteEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Deletes JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Delete Jwk
         * @param {OrganizationModelControllerApiDeleteEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityJwks(requestParameters, options) {
            return localVarFp
                .deleteEntityJwks(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrganizationModelControllerApiDeleteEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .deleteEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Notification Channel entity
         * @param {OrganizationModelControllerApiDeleteEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .deleteEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Organization entity
         * @param {OrganizationModelControllerApiDeleteEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Theming
         * @param {OrganizationModelControllerApiDeleteEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityThemes(requestParameters, options) {
            return localVarFp
                .deleteEntityThemes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Delete UserGroup entity
         * @param {OrganizationModelControllerApiDeleteEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserGroups(requestParameters, options) {
            return localVarFp
                .deleteEntityUserGroups(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Delete User entity
         * @param {OrganizationModelControllerApiDeleteEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUsers(requestParameters, options) {
            return localVarFp
                .deleteEntityUsers(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Delete Workspace entity
         * @param {OrganizationModelControllerApiDeleteEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaces(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Color Pallettes
         * @param {OrganizationModelControllerApiGetAllEntitiesColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesColorPalettes(requestParameters, options) {
            return localVarFp
                .getAllEntitiesColorPalettes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {OrganizationModelControllerApiGetAllEntitiesCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCspDirectives(requestParameters, options) {
            return localVarFp
                .getAllEntitiesCspDirectives(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Data Source Identifiers
         * @param {OrganizationModelControllerApiGetAllEntitiesDataSourceIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSourceIdentifiers(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDataSourceIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entities
         * @param {OrganizationModelControllerApiGetAllEntitiesDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDataSources(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDataSources(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlements
         * @param {OrganizationModelControllerApiGetAllEntitiesEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesEntitlements(requestParameters, options) {
            return localVarFp
                .getAllEntitiesEntitlements(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Identity Providers
         * @param {OrganizationModelControllerApiGetAllEntitiesIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesIdentityProviders(requestParameters, options) {
            return localVarFp
                .getAllEntitiesIdentityProviders(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
         * @summary Get all Jwks
         * @param {OrganizationModelControllerApiGetAllEntitiesJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesJwks(requestParameters, options) {
            return localVarFp
                .getAllEntitiesJwks(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all LLM endpoint entities
         * @param {OrganizationModelControllerApiGetAllEntitiesLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLlmEndpoints(requestParameters, options) {
            return localVarFp
                .getAllEntitiesLlmEndpoints(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Notification Channel entities
         * @param {OrganizationModelControllerApiGetAllEntitiesNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesNotificationChannels(requestParameters, options) {
            return localVarFp
                .getAllEntitiesNotificationChannels(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Organization entities
         * @param {OrganizationModelControllerApiGetAllEntitiesOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesOrganizationSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesOrganizationSettings(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Theming entities
         * @param {OrganizationModelControllerApiGetAllEntitiesThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesThemes(requestParameters, options) {
            return localVarFp
                .getAllEntitiesThemes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entities
         * @param {OrganizationModelControllerApiGetAllEntitiesUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserGroups(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserGroups(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * UserIdentifier - represents entity interacting with platform
         * @summary Get UserIdentifier entities
         * @param {OrganizationModelControllerApiGetAllEntitiesUserIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserIdentifiers(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entities
         * @param {OrganizationModelControllerApiGetAllEntitiesUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUsers(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUsers(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entities
         * @param {OrganizationModelControllerApiGetAllEntitiesWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaces(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaces(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Color Pallette
         * @param {OrganizationModelControllerApiGetEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .getEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Get CSP Directives
         * @param {OrganizationModelControllerApiGetEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .getEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Data Source Identifier
         * @param {OrganizationModelControllerApiGetEntityDataSourceIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSourceIdentifiers(requestParameters, options) {
            return localVarFp
                .getEntityDataSourceIdentifiers(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Get Data Source entity
         * @param {OrganizationModelControllerApiGetEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDataSources(requestParameters, options) {
            return localVarFp
                .getEntityDataSources(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Entitlement
         * @param {OrganizationModelControllerApiGetEntityEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityEntitlements(requestParameters, options) {
            return localVarFp
                .getEntityEntitlements(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Identity Provider
         * @param {OrganizationModelControllerApiGetEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .getEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Get Jwk
         * @param {OrganizationModelControllerApiGetEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityJwks(requestParameters, options) {
            return localVarFp
                .getEntityJwks(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get LLM endpoint entity
         * @param {OrganizationModelControllerApiGetEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .getEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Notification Channel entity
         * @param {OrganizationModelControllerApiGetEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .getEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Organization entity
         * @param {OrganizationModelControllerApiGetEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .getEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Theming
         * @param {OrganizationModelControllerApiGetEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityThemes(requestParameters, options) {
            return localVarFp
                .getEntityThemes(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entity
         * @param {OrganizationModelControllerApiGetEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserGroups(requestParameters, options) {
            return localVarFp
                .getEntityUserGroups(requestParameters.id, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * UserIdentifier - represents basic information about entity interacting with platform
         * @summary Get UserIdentifier entity
         * @param {OrganizationModelControllerApiGetEntityUserIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserIdentifiers(requestParameters, options) {
            return localVarFp
                .getEntityUserIdentifiers(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entity
         * @param {OrganizationModelControllerApiGetEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUsers(requestParameters, options) {
            return localVarFp
                .getEntityUsers(requestParameters.id, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entity
         * @param {OrganizationModelControllerApiGetEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaces(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Color Pallette
         * @param {OrganizationModelControllerApiPatchEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .patchEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPalettePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Patch CSP Directives
         * @param {OrganizationModelControllerApiPatchEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .patchEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectivePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Patch Data Source entity
         * @param {OrganizationModelControllerApiPatchEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDataSources(requestParameters, options) {
            return localVarFp
                .patchEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourcePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Identity Provider
         * @param {OrganizationModelControllerApiPatchEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .patchEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Patches JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Patch Jwk
         * @param {OrganizationModelControllerApiPatchEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityJwks(requestParameters, options) {
            return localVarFp
                .patchEntityJwks(requestParameters.id, requestParameters.jsonApiJwkPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch LLM endpoint entity
         * @param {OrganizationModelControllerApiPatchEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .patchEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Notification Channel entity
         * @param {OrganizationModelControllerApiPatchEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .patchEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Organization entity
         * @param {OrganizationModelControllerApiPatchEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .patchEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Theming
         * @param {OrganizationModelControllerApiPatchEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityThemes(requestParameters, options) {
            return localVarFp
                .patchEntityThemes(requestParameters.id, requestParameters.jsonApiThemePatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Patch UserGroup entity
         * @param {OrganizationModelControllerApiPatchEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserGroups(requestParameters, options) {
            return localVarFp
                .patchEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Patch User entity
         * @param {OrganizationModelControllerApiPatchEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUsers(requestParameters, options) {
            return localVarFp
                .patchEntityUsers(requestParameters.id, requestParameters.jsonApiUserPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Patch Workspace entity
         * @param {OrganizationModelControllerApiPatchEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspacePatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Color Pallette
         * @param {OrganizationModelControllerApiUpdateEntityColorPalettesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityColorPalettes(requestParameters, options) {
            return localVarFp
                .updateEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPaletteInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *  Context Security Police Directive
         * @summary Put CSP Directives
         * @param {OrganizationModelControllerApiUpdateEntityCspDirectivesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCspDirectives(requestParameters, options) {
            return localVarFp
                .updateEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectiveInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Data Source - represents data source for the workspace
         * @summary Put Data Source entity
         * @param {OrganizationModelControllerApiUpdateEntityDataSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDataSources(requestParameters, options) {
            return localVarFp
                .updateEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourceInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Identity Provider
         * @param {OrganizationModelControllerApiUpdateEntityIdentityProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityIdentityProviders(requestParameters, options) {
            return localVarFp
                .updateEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Updates JSON web key - used to verify JSON web tokens (Jwts)
         * @summary Put Jwk
         * @param {OrganizationModelControllerApiUpdateEntityJwksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityJwks(requestParameters, options) {
            return localVarFp
                .updateEntityJwks(requestParameters.id, requestParameters.jsonApiJwkInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary PUT LLM endpoint entity
         * @param {OrganizationModelControllerApiUpdateEntityLlmEndpointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityLlmEndpoints(requestParameters, options) {
            return localVarFp
                .updateEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Notification Channel entity
         * @param {OrganizationModelControllerApiUpdateEntityNotificationChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityNotificationChannels(requestParameters, options) {
            return localVarFp
                .updateEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Organization entity
         * @param {OrganizationModelControllerApiUpdateEntityOrganizationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityOrganizationSettings(requestParameters, options) {
            return localVarFp
                .updateEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Theming
         * @param {OrganizationModelControllerApiUpdateEntityThemesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityThemes(requestParameters, options) {
            return localVarFp
                .updateEntityThemes(requestParameters.id, requestParameters.jsonApiThemeInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Put UserGroup entity
         * @param {OrganizationModelControllerApiUpdateEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserGroups(requestParameters, options) {
            return localVarFp
                .updateEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Put User entity
         * @param {OrganizationModelControllerApiUpdateEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUsers(requestParameters, options) {
            return localVarFp
                .updateEntityUsers(requestParameters.id, requestParameters.jsonApiUserInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Put Workspace entity
         * @param {OrganizationModelControllerApiUpdateEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspaceInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrganizationModelControllerApi - object-oriented interface
 * @export
 * @class OrganizationModelControllerApi
 * @extends {BaseAPI}
 */
export class OrganizationModelControllerApi extends BaseAPI {
    /**
     *
     * @summary Post Color Pallettes
     * @param {OrganizationModelControllerApiCreateEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityColorPalettes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityColorPalettes(requestParameters.jsonApiColorPaletteInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Post CSP Directives
     * @param {OrganizationModelControllerApiCreateEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityCspDirectives(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityCspDirectives(requestParameters.jsonApiCspDirectiveInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Post Data Sources
     * @param {OrganizationModelControllerApiCreateEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityDataSources(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityDataSources(requestParameters.jsonApiDataSourceInDocument, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Identity Providers
     * @param {OrganizationModelControllerApiCreateEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityIdentityProviders(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityIdentityProviders(requestParameters.jsonApiIdentityProviderInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Post Jwks
     * @param {OrganizationModelControllerApiCreateEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityJwks(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityJwks(requestParameters.jsonApiJwkInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post LLM endpoint entities
     * @param {OrganizationModelControllerApiCreateEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityLlmEndpoints(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityLlmEndpoints(requestParameters.jsonApiLlmEndpointInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Notification Channel entities
     * @param {OrganizationModelControllerApiCreateEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityNotificationChannels(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityNotificationChannels(requestParameters.jsonApiNotificationChannelPostOptionalIdDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Organization Setting entities
     * @param {OrganizationModelControllerApiCreateEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityOrganizationSettings(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityOrganizationSettings(requestParameters.jsonApiOrganizationSettingInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Theming
     * @param {OrganizationModelControllerApiCreateEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityThemes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityThemes(requestParameters.jsonApiThemeInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Post User Group entities
     * @param {OrganizationModelControllerApiCreateEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityUserGroups(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityUserGroups(requestParameters.jsonApiUserGroupInDocument, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Post User entities
     * @param {OrganizationModelControllerApiCreateEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityUsers(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityUsers(requestParameters.jsonApiUserInDocument, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Post Workspace entities
     * @param {OrganizationModelControllerApiCreateEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    createEntityWorkspaces(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .createEntityWorkspaces(requestParameters.jsonApiWorkspaceInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Color Pallette
     * @param {OrganizationModelControllerApiDeleteEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityColorPalettes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Delete CSP Directives
     * @param {OrganizationModelControllerApiDeleteEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityCspDirectives(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Delete Data Source entity
     * @param {OrganizationModelControllerApiDeleteEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityDataSources(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityDataSources(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Identity Provider
     * @param {OrganizationModelControllerApiDeleteEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityIdentityProviders(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Delete Jwk
     * @param {OrganizationModelControllerApiDeleteEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityJwks(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityJwks(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrganizationModelControllerApiDeleteEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityLlmEndpoints(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Notification Channel entity
     * @param {OrganizationModelControllerApiDeleteEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityNotificationChannels(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Organization entity
     * @param {OrganizationModelControllerApiDeleteEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityOrganizationSettings(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Theming
     * @param {OrganizationModelControllerApiDeleteEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityThemes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityThemes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Delete UserGroup entity
     * @param {OrganizationModelControllerApiDeleteEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityUserGroups(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityUserGroups(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Delete User entity
     * @param {OrganizationModelControllerApiDeleteEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityUsers(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityUsers(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Delete Workspace entity
     * @param {OrganizationModelControllerApiDeleteEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    deleteEntityWorkspaces(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .deleteEntityWorkspaces(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Color Pallettes
     * @param {OrganizationModelControllerApiGetAllEntitiesColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesColorPalettes(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesColorPalettes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Get CSP Directives
     * @param {OrganizationModelControllerApiGetAllEntitiesCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesCspDirectives(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesCspDirectives(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Data Source Identifiers
     * @param {OrganizationModelControllerApiGetAllEntitiesDataSourceIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesDataSourceIdentifiers(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesDataSourceIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Get Data Source entities
     * @param {OrganizationModelControllerApiGetAllEntitiesDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesDataSources(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesDataSources(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Entitlements
     * @param {OrganizationModelControllerApiGetAllEntitiesEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesEntitlements(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesEntitlements(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Identity Providers
     * @param {OrganizationModelControllerApiGetAllEntitiesIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesIdentityProviders(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesIdentityProviders(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all JSON web keys - used to verify JSON web tokens (Jwts)
     * @summary Get all Jwks
     * @param {OrganizationModelControllerApiGetAllEntitiesJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesJwks(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesJwks(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all LLM endpoint entities
     * @param {OrganizationModelControllerApiGetAllEntitiesLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesLlmEndpoints(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesLlmEndpoints(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Notification Channel entities
     * @param {OrganizationModelControllerApiGetAllEntitiesNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesNotificationChannels(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesNotificationChannels(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Organization entities
     * @param {OrganizationModelControllerApiGetAllEntitiesOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesOrganizationSettings(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesOrganizationSettings(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Theming entities
     * @param {OrganizationModelControllerApiGetAllEntitiesThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesThemes(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesThemes(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Get UserGroup entities
     * @param {OrganizationModelControllerApiGetAllEntitiesUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesUserGroups(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesUserGroups(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * UserIdentifier - represents entity interacting with platform
     * @summary Get UserIdentifier entities
     * @param {OrganizationModelControllerApiGetAllEntitiesUserIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesUserIdentifiers(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesUserIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Get User entities
     * @param {OrganizationModelControllerApiGetAllEntitiesUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesUsers(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesUsers(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Workspace entities
     * @param {OrganizationModelControllerApiGetAllEntitiesWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getAllEntitiesWorkspaces(requestParameters = {}, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getAllEntitiesWorkspaces(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Color Pallette
     * @param {OrganizationModelControllerApiGetEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityColorPalettes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityColorPalettes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Get CSP Directives
     * @param {OrganizationModelControllerApiGetEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityCspDirectives(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityCspDirectives(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Data Source Identifier
     * @param {OrganizationModelControllerApiGetEntityDataSourceIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityDataSourceIdentifiers(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityDataSourceIdentifiers(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Get Data Source entity
     * @param {OrganizationModelControllerApiGetEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityDataSources(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityDataSources(requestParameters.id, requestParameters.filter, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Entitlement
     * @param {OrganizationModelControllerApiGetEntityEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityEntitlements(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityEntitlements(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Identity Provider
     * @param {OrganizationModelControllerApiGetEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityIdentityProviders(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityIdentityProviders(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Get Jwk
     * @param {OrganizationModelControllerApiGetEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityJwks(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityJwks(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get LLM endpoint entity
     * @param {OrganizationModelControllerApiGetEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityLlmEndpoints(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityLlmEndpoints(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Notification Channel entity
     * @param {OrganizationModelControllerApiGetEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityNotificationChannels(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityNotificationChannels(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Organization entity
     * @param {OrganizationModelControllerApiGetEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityOrganizationSettings(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityOrganizationSettings(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Theming
     * @param {OrganizationModelControllerApiGetEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityThemes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityThemes(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Get UserGroup entity
     * @param {OrganizationModelControllerApiGetEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityUserGroups(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityUserGroups(requestParameters.id, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * UserIdentifier - represents basic information about entity interacting with platform
     * @summary Get UserIdentifier entity
     * @param {OrganizationModelControllerApiGetEntityUserIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityUserIdentifiers(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityUserIdentifiers(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Get User entity
     * @param {OrganizationModelControllerApiGetEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityUsers(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityUsers(requestParameters.id, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Workspace entity
     * @param {OrganizationModelControllerApiGetEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    getEntityWorkspaces(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .getEntityWorkspaces(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Color Pallette
     * @param {OrganizationModelControllerApiPatchEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityColorPalettes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPalettePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Patch CSP Directives
     * @param {OrganizationModelControllerApiPatchEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityCspDirectives(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectivePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Patch Data Source entity
     * @param {OrganizationModelControllerApiPatchEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityDataSources(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourcePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Identity Provider
     * @param {OrganizationModelControllerApiPatchEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityIdentityProviders(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Patches JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Patch Jwk
     * @param {OrganizationModelControllerApiPatchEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityJwks(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityJwks(requestParameters.id, requestParameters.jsonApiJwkPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch LLM endpoint entity
     * @param {OrganizationModelControllerApiPatchEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityLlmEndpoints(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Notification Channel entity
     * @param {OrganizationModelControllerApiPatchEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityNotificationChannels(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Organization entity
     * @param {OrganizationModelControllerApiPatchEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityOrganizationSettings(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Theming
     * @param {OrganizationModelControllerApiPatchEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityThemes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityThemes(requestParameters.id, requestParameters.jsonApiThemePatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Patch UserGroup entity
     * @param {OrganizationModelControllerApiPatchEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityUserGroups(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Patch User entity
     * @param {OrganizationModelControllerApiPatchEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityUsers(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityUsers(requestParameters.id, requestParameters.jsonApiUserPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Patch Workspace entity
     * @param {OrganizationModelControllerApiPatchEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    patchEntityWorkspaces(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .patchEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspacePatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Color Pallette
     * @param {OrganizationModelControllerApiUpdateEntityColorPalettesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityColorPalettes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityColorPalettes(requestParameters.id, requestParameters.jsonApiColorPaletteInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Context Security Police Directive
     * @summary Put CSP Directives
     * @param {OrganizationModelControllerApiUpdateEntityCspDirectivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityCspDirectives(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityCspDirectives(requestParameters.id, requestParameters.jsonApiCspDirectiveInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Data Source - represents data source for the workspace
     * @summary Put Data Source entity
     * @param {OrganizationModelControllerApiUpdateEntityDataSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityDataSources(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityDataSources(requestParameters.id, requestParameters.jsonApiDataSourceInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Identity Provider
     * @param {OrganizationModelControllerApiUpdateEntityIdentityProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityIdentityProviders(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityIdentityProviders(requestParameters.id, requestParameters.jsonApiIdentityProviderInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates JSON web key - used to verify JSON web tokens (Jwts)
     * @summary Put Jwk
     * @param {OrganizationModelControllerApiUpdateEntityJwksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityJwks(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityJwks(requestParameters.id, requestParameters.jsonApiJwkInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PUT LLM endpoint entity
     * @param {OrganizationModelControllerApiUpdateEntityLlmEndpointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityLlmEndpoints(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityLlmEndpoints(requestParameters.id, requestParameters.jsonApiLlmEndpointInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Notification Channel entity
     * @param {OrganizationModelControllerApiUpdateEntityNotificationChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityNotificationChannels(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityNotificationChannels(requestParameters.id, requestParameters.jsonApiNotificationChannelInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Organization entity
     * @param {OrganizationModelControllerApiUpdateEntityOrganizationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityOrganizationSettings(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityOrganizationSettings(requestParameters.id, requestParameters.jsonApiOrganizationSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Theming
     * @param {OrganizationModelControllerApiUpdateEntityThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityThemes(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityThemes(requestParameters.id, requestParameters.jsonApiThemeInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Put UserGroup entity
     * @param {OrganizationModelControllerApiUpdateEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityUserGroups(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Put User entity
     * @param {OrganizationModelControllerApiUpdateEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityUsers(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityUsers(requestParameters.id, requestParameters.jsonApiUserInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Put Workspace entity
     * @param {OrganizationModelControllerApiUpdateEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationModelControllerApi
     */
    updateEntityWorkspaces(requestParameters, options) {
        return OrganizationModelControllerApiFp(this.configuration)
            .updateEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspaceInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get Available Assignees
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableAssignees: async (workspaceId, dashboardId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("availableAssignees", "workspaceId", workspaceId);
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists("availableAssignees", "dashboardId", dashboardId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/analyticalDashboards/{dashboardId}/availableAssignees`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Dashboard Permissions
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardPermissions: async (workspaceId, dashboardId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("dashboardPermissions", "workspaceId", workspaceId);
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists("dashboardPermissions", "dashboardId", dashboardId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/analyticalDashboards/{dashboardId}/permissions`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve organization permissions
         * @summary Get organization permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPermissions: async (options = {}) => {
            const localVarPath = `/api/v1/layout/organization/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current set of permissions of the user-group in a declarative form.
         * @summary Get permissions for the user-group
         * @param {string} userGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupPermissions: async (userGroupId, options = {}) => {
            // verify required parameter 'userGroupId' is not null or undefined
            assertParamExists("getUserGroupPermissions", "userGroupId", userGroupId);
            const localVarPath = `/api/v1/layout/userGroups/{userGroupId}/permissions`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(userGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current set of permissions of the user in a declarative form.
         * @summary Get permissions for the user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getUserPermissions", "userId", userId);
            const localVarPath = `/api/v1/layout/users/{userId}/permissions`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve current set of permissions of the workspace in a declarative form.
         * @summary Get permissions for the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacePermissions: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getWorkspacePermissions", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/permissions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Manage Permissions for a Dashboard
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {Array<PermissionsForAssignee | PermissionsForAssigneeRule>} permissionsForAssigneePermissionsForAssigneeRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDashboardPermissions: async (workspaceId, dashboardId, permissionsForAssigneePermissionsForAssigneeRule, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("manageDashboardPermissions", "workspaceId", workspaceId);
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists("manageDashboardPermissions", "dashboardId", dashboardId);
            // verify required parameter 'permissionsForAssigneePermissionsForAssigneeRule' is not null or undefined
            assertParamExists("manageDashboardPermissions", "permissionsForAssigneePermissionsForAssigneeRule", permissionsForAssigneePermissionsForAssigneeRule);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/analyticalDashboards/{dashboardId}/managePermissions`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof permissionsForAssigneePermissionsForAssigneeRule !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(permissionsForAssigneePermissionsForAssigneeRule !== undefined
                    ? permissionsForAssigneePermissionsForAssigneeRule
                    : {})
                : permissionsForAssigneePermissionsForAssigneeRule || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manage Permissions for a Data Source
         * @summary Manage Permissions for a Data Source
         * @param {string} dataSourceId
         * @param {Array<DataSourcePermissionAssignment>} dataSourcePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDataSourcePermissions: async (dataSourceId, dataSourcePermissionAssignment, options = {}) => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists("manageDataSourcePermissions", "dataSourceId", dataSourceId);
            // verify required parameter 'dataSourcePermissionAssignment' is not null or undefined
            assertParamExists("manageDataSourcePermissions", "dataSourcePermissionAssignment", dataSourcePermissionAssignment);
            const localVarPath = `/api/v1/actions/dataSources/{dataSourceId}/managePermissions`.replace(`{${"dataSourceId"}}`, encodeURIComponent(String(dataSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof dataSourcePermissionAssignment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(dataSourcePermissionAssignment !== undefined ? dataSourcePermissionAssignment : {})
                : dataSourcePermissionAssignment || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manage Permissions for a Organization
         * @summary Manage Permissions for a Organization
         * @param {Array<OrganizationPermissionAssignment>} organizationPermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageOrganizationPermissions: async (organizationPermissionAssignment, options = {}) => {
            // verify required parameter 'organizationPermissionAssignment' is not null or undefined
            assertParamExists("manageOrganizationPermissions", "organizationPermissionAssignment", organizationPermissionAssignment);
            const localVarPath = `/api/v1/actions/organization/managePermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof organizationPermissionAssignment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(organizationPermissionAssignment !== undefined ? organizationPermissionAssignment : {})
                : organizationPermissionAssignment || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manage Permissions for a Workspace and its Workspace Hierarchy
         * @summary Manage Permissions for a Workspace
         * @param {string} workspaceId
         * @param {Array<WorkspacePermissionAssignment>} workspacePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageWorkspacePermissions: async (workspaceId, workspacePermissionAssignment, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("manageWorkspacePermissions", "workspaceId", workspaceId);
            // verify required parameter 'workspacePermissionAssignment' is not null or undefined
            assertParamExists("manageWorkspacePermissions", "workspacePermissionAssignment", workspacePermissionAssignment);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/managePermissions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof workspacePermissionAssignment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(workspacePermissionAssignment !== undefined ? workspacePermissionAssignment : {})
                : workspacePermissionAssignment || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets organization permissions
         * @summary Set organization permissions
         * @param {Array<DeclarativeOrganizationPermission>} declarativeOrganizationPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationPermissions: async (declarativeOrganizationPermission, options = {}) => {
            // verify required parameter 'declarativeOrganizationPermission' is not null or undefined
            assertParamExists("setOrganizationPermissions", "declarativeOrganizationPermission", declarativeOrganizationPermission);
            const localVarPath = `/api/v1/layout/organization/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeOrganizationPermission !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeOrganizationPermission !== undefined
                    ? declarativeOrganizationPermission
                    : {})
                : declarativeOrganizationPermission || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective permissions for the user-group
         * @summary Set permissions for the user-group
         * @param {string} userGroupId
         * @param {DeclarativeUserGroupPermissions} declarativeUserGroupPermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserGroupPermissions: async (userGroupId, declarativeUserGroupPermissions, options = {}) => {
            // verify required parameter 'userGroupId' is not null or undefined
            assertParamExists("setUserGroupPermissions", "userGroupId", userGroupId);
            // verify required parameter 'declarativeUserGroupPermissions' is not null or undefined
            assertParamExists("setUserGroupPermissions", "declarativeUserGroupPermissions", declarativeUserGroupPermissions);
            const localVarPath = `/api/v1/layout/userGroups/{userGroupId}/permissions`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(userGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUserGroupPermissions !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUserGroupPermissions !== undefined ? declarativeUserGroupPermissions : {})
                : declarativeUserGroupPermissions || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective permissions for the user
         * @summary Set permissions for the user
         * @param {string} userId
         * @param {DeclarativeUserPermissions} declarativeUserPermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPermissions: async (userId, declarativeUserPermissions, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("setUserPermissions", "userId", userId);
            // verify required parameter 'declarativeUserPermissions' is not null or undefined
            assertParamExists("setUserPermissions", "declarativeUserPermissions", declarativeUserPermissions);
            const localVarPath = `/api/v1/layout/users/{userId}/permissions`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUserPermissions !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUserPermissions !== undefined ? declarativeUserPermissions : {})
                : declarativeUserPermissions || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set effective permissions for the workspace
         * @summary Set permissions for the workspace
         * @param {string} workspaceId
         * @param {DeclarativeWorkspacePermissions} declarativeWorkspacePermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspacePermissions: async (workspaceId, declarativeWorkspacePermissions, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setWorkspacePermissions", "workspaceId", workspaceId);
            // verify required parameter 'declarativeWorkspacePermissions' is not null or undefined
            assertParamExists("setWorkspacePermissions", "declarativeWorkspacePermissions", declarativeWorkspacePermissions);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/permissions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeWorkspacePermissions !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeWorkspacePermissions !== undefined ? declarativeWorkspacePermissions : {})
                : declarativeWorkspacePermissions || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get Available Assignees
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availableAssignees(workspaceId, dashboardId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.availableAssignees(workspaceId, dashboardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Dashboard Permissions
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardPermissions(workspaceId, dashboardId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardPermissions(workspaceId, dashboardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve organization permissions
         * @summary Get organization permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationPermissions(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationPermissions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current set of permissions of the user-group in a declarative form.
         * @summary Get permissions for the user-group
         * @param {string} userGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupPermissions(userGroupId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupPermissions(userGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current set of permissions of the user in a declarative form.
         * @summary Get permissions for the user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPermissions(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPermissions(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve current set of permissions of the workspace in a declarative form.
         * @summary Get permissions for the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspacePermissions(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspacePermissions(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Manage Permissions for a Dashboard
         * @param {string} workspaceId
         * @param {string} dashboardId
         * @param {Array<PermissionsForAssignee | PermissionsForAssigneeRule>} permissionsForAssigneePermissionsForAssigneeRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageDashboardPermissions(workspaceId, dashboardId, permissionsForAssigneePermissionsForAssigneeRule, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageDashboardPermissions(workspaceId, dashboardId, permissionsForAssigneePermissionsForAssigneeRule, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Manage Permissions for a Data Source
         * @summary Manage Permissions for a Data Source
         * @param {string} dataSourceId
         * @param {Array<DataSourcePermissionAssignment>} dataSourcePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageDataSourcePermissions(dataSourceId, dataSourcePermissionAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageDataSourcePermissions(dataSourceId, dataSourcePermissionAssignment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Manage Permissions for a Organization
         * @summary Manage Permissions for a Organization
         * @param {Array<OrganizationPermissionAssignment>} organizationPermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageOrganizationPermissions(organizationPermissionAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageOrganizationPermissions(organizationPermissionAssignment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Manage Permissions for a Workspace and its Workspace Hierarchy
         * @summary Manage Permissions for a Workspace
         * @param {string} workspaceId
         * @param {Array<WorkspacePermissionAssignment>} workspacePermissionAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageWorkspacePermissions(workspaceId, workspacePermissionAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageWorkspacePermissions(workspaceId, workspacePermissionAssignment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets organization permissions
         * @summary Set organization permissions
         * @param {Array<DeclarativeOrganizationPermission>} declarativeOrganizationPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOrganizationPermissions(declarativeOrganizationPermission, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOrganizationPermissions(declarativeOrganizationPermission, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective permissions for the user-group
         * @summary Set permissions for the user-group
         * @param {string} userGroupId
         * @param {DeclarativeUserGroupPermissions} declarativeUserGroupPermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserGroupPermissions(userGroupId, declarativeUserGroupPermissions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserGroupPermissions(userGroupId, declarativeUserGroupPermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective permissions for the user
         * @summary Set permissions for the user
         * @param {string} userId
         * @param {DeclarativeUserPermissions} declarativeUserPermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserPermissions(userId, declarativeUserPermissions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserPermissions(userId, declarativeUserPermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set effective permissions for the workspace
         * @summary Set permissions for the workspace
         * @param {string} workspaceId
         * @param {DeclarativeWorkspacePermissions} declarativeWorkspacePermissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWorkspacePermissions(workspaceId, declarativeWorkspacePermissions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWorkspacePermissions(workspaceId, declarativeWorkspacePermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PermissionsApiFp(configuration);
    return {
        /**
         *
         * @summary Get Available Assignees
         * @param {PermissionsApiAvailableAssigneesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableAssignees(requestParameters, options) {
            return localVarFp
                .availableAssignees(requestParameters.workspaceId, requestParameters.dashboardId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Dashboard Permissions
         * @param {PermissionsApiDashboardPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardPermissions(requestParameters, options) {
            return localVarFp
                .dashboardPermissions(requestParameters.workspaceId, requestParameters.dashboardId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve organization permissions
         * @summary Get organization permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPermissions(options) {
            return localVarFp.getOrganizationPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current set of permissions of the user-group in a declarative form.
         * @summary Get permissions for the user-group
         * @param {PermissionsApiGetUserGroupPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupPermissions(requestParameters, options) {
            return localVarFp
                .getUserGroupPermissions(requestParameters.userGroupId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current set of permissions of the user in a declarative form.
         * @summary Get permissions for the user
         * @param {PermissionsApiGetUserPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions(requestParameters, options) {
            return localVarFp
                .getUserPermissions(requestParameters.userId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current set of permissions of the workspace in a declarative form.
         * @summary Get permissions for the workspace
         * @param {PermissionsApiGetWorkspacePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacePermissions(requestParameters, options) {
            return localVarFp
                .getWorkspacePermissions(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Manage Permissions for a Dashboard
         * @param {PermissionsApiManageDashboardPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDashboardPermissions(requestParameters, options) {
            return localVarFp
                .manageDashboardPermissions(requestParameters.workspaceId, requestParameters.dashboardId, requestParameters.permissionsForAssigneePermissionsForAssigneeRule, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Manage Permissions for a Data Source
         * @summary Manage Permissions for a Data Source
         * @param {PermissionsApiManageDataSourcePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageDataSourcePermissions(requestParameters, options) {
            return localVarFp
                .manageDataSourcePermissions(requestParameters.dataSourceId, requestParameters.dataSourcePermissionAssignment, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Manage Permissions for a Organization
         * @summary Manage Permissions for a Organization
         * @param {PermissionsApiManageOrganizationPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageOrganizationPermissions(requestParameters, options) {
            return localVarFp
                .manageOrganizationPermissions(requestParameters.organizationPermissionAssignment, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Manage Permissions for a Workspace and its Workspace Hierarchy
         * @summary Manage Permissions for a Workspace
         * @param {PermissionsApiManageWorkspacePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageWorkspacePermissions(requestParameters, options) {
            return localVarFp
                .manageWorkspacePermissions(requestParameters.workspaceId, requestParameters.workspacePermissionAssignment, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets organization permissions
         * @summary Set organization permissions
         * @param {PermissionsApiSetOrganizationPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrganizationPermissions(requestParameters, options) {
            return localVarFp
                .setOrganizationPermissions(requestParameters.declarativeOrganizationPermission, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective permissions for the user-group
         * @summary Set permissions for the user-group
         * @param {PermissionsApiSetUserGroupPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserGroupPermissions(requestParameters, options) {
            return localVarFp
                .setUserGroupPermissions(requestParameters.userGroupId, requestParameters.declarativeUserGroupPermissions, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective permissions for the user
         * @summary Set permissions for the user
         * @param {PermissionsApiSetUserPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserPermissions(requestParameters, options) {
            return localVarFp
                .setUserPermissions(requestParameters.userId, requestParameters.declarativeUserPermissions, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set effective permissions for the workspace
         * @summary Set permissions for the workspace
         * @param {PermissionsApiSetWorkspacePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspacePermissions(requestParameters, options) {
            return localVarFp
                .setWorkspacePermissions(requestParameters.workspaceId, requestParameters.declarativeWorkspacePermissions, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     *
     * @summary Get Available Assignees
     * @param {PermissionsApiAvailableAssigneesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    availableAssignees(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .availableAssignees(requestParameters.workspaceId, requestParameters.dashboardId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Dashboard Permissions
     * @param {PermissionsApiDashboardPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    dashboardPermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .dashboardPermissions(requestParameters.workspaceId, requestParameters.dashboardId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve organization permissions
     * @summary Get organization permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    getOrganizationPermissions(options) {
        return PermissionsApiFp(this.configuration)
            .getOrganizationPermissions(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current set of permissions of the user-group in a declarative form.
     * @summary Get permissions for the user-group
     * @param {PermissionsApiGetUserGroupPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    getUserGroupPermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .getUserGroupPermissions(requestParameters.userGroupId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current set of permissions of the user in a declarative form.
     * @summary Get permissions for the user
     * @param {PermissionsApiGetUserPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    getUserPermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .getUserPermissions(requestParameters.userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current set of permissions of the workspace in a declarative form.
     * @summary Get permissions for the workspace
     * @param {PermissionsApiGetWorkspacePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    getWorkspacePermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .getWorkspacePermissions(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Manage Permissions for a Dashboard
     * @param {PermissionsApiManageDashboardPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    manageDashboardPermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .manageDashboardPermissions(requestParameters.workspaceId, requestParameters.dashboardId, requestParameters.permissionsForAssigneePermissionsForAssigneeRule, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Manage Permissions for a Data Source
     * @summary Manage Permissions for a Data Source
     * @param {PermissionsApiManageDataSourcePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    manageDataSourcePermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .manageDataSourcePermissions(requestParameters.dataSourceId, requestParameters.dataSourcePermissionAssignment, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Manage Permissions for a Organization
     * @summary Manage Permissions for a Organization
     * @param {PermissionsApiManageOrganizationPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    manageOrganizationPermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .manageOrganizationPermissions(requestParameters.organizationPermissionAssignment, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Manage Permissions for a Workspace and its Workspace Hierarchy
     * @summary Manage Permissions for a Workspace
     * @param {PermissionsApiManageWorkspacePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    manageWorkspacePermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .manageWorkspacePermissions(requestParameters.workspaceId, requestParameters.workspacePermissionAssignment, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets organization permissions
     * @summary Set organization permissions
     * @param {PermissionsApiSetOrganizationPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    setOrganizationPermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .setOrganizationPermissions(requestParameters.declarativeOrganizationPermission, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective permissions for the user-group
     * @summary Set permissions for the user-group
     * @param {PermissionsApiSetUserGroupPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    setUserGroupPermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .setUserGroupPermissions(requestParameters.userGroupId, requestParameters.declarativeUserGroupPermissions, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective permissions for the user
     * @summary Set permissions for the user
     * @param {PermissionsApiSetUserPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    setUserPermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .setUserPermissions(requestParameters.userId, requestParameters.declarativeUserPermissions, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set effective permissions for the workspace
     * @summary Set permissions for the workspace
     * @param {PermissionsApiSetWorkspacePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    setWorkspacePermissions(requestParameters, options) {
        return PermissionsApiFp(this.configuration)
            .setWorkspacePermissions(requestParameters.workspaceId, requestParameters.declarativeWorkspacePermissions, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PluginsApi - axios parameter creator
 * @export
 */
export const PluginsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Plugins
         * @param {string} workspaceId
         * @param {JsonApiDashboardPluginPostOptionalIdDocument} jsonApiDashboardPluginPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDashboardPlugins: async (workspaceId, jsonApiDashboardPluginPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiDashboardPluginPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityDashboardPlugins", "jsonApiDashboardPluginPostOptionalIdDocument", jsonApiDashboardPluginPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDashboardPluginPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDashboardPluginPostOptionalIdDocument !== undefined
                    ? jsonApiDashboardPluginPostOptionalIdDocument
                    : {})
                : jsonApiDashboardPluginPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDashboardPlugins: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityDashboardPlugins", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Plugins
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDashboardPlugins: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesDashboardPlugins", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDashboardPlugins: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityDashboardPlugins", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginPatchDocument} jsonApiDashboardPluginPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDashboardPlugins: async (workspaceId, objectId, jsonApiDashboardPluginPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityDashboardPlugins", "objectId", objectId);
            // verify required parameter 'jsonApiDashboardPluginPatchDocument' is not null or undefined
            assertParamExists("patchEntityDashboardPlugins", "jsonApiDashboardPluginPatchDocument", jsonApiDashboardPluginPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDashboardPluginPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDashboardPluginPatchDocument !== undefined
                    ? jsonApiDashboardPluginPatchDocument
                    : {})
                : jsonApiDashboardPluginPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginInDocument} jsonApiDashboardPluginInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDashboardPlugins: async (workspaceId, objectId, jsonApiDashboardPluginInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityDashboardPlugins", "objectId", objectId);
            // verify required parameter 'jsonApiDashboardPluginInDocument' is not null or undefined
            assertParamExists("updateEntityDashboardPlugins", "jsonApiDashboardPluginInDocument", jsonApiDashboardPluginInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDashboardPluginInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDashboardPluginInDocument !== undefined ? jsonApiDashboardPluginInDocument : {})
                : jsonApiDashboardPluginInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PluginsApi - functional programming interface
 * @export
 */
export const PluginsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PluginsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Plugins
         * @param {string} workspaceId
         * @param {JsonApiDashboardPluginPostOptionalIdDocument} jsonApiDashboardPluginPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityDashboardPlugins(workspaceId, jsonApiDashboardPluginPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityDashboardPlugins(workspaceId, jsonApiDashboardPluginPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityDashboardPlugins(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityDashboardPlugins(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Plugins
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDashboardPlugins(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDashboardPlugins(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDashboardPlugins(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDashboardPlugins(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginPatchDocument} jsonApiDashboardPluginPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginInDocument} jsonApiDashboardPluginInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * PluginsApi - factory interface
 * @export
 */
export const PluginsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PluginsApiFp(configuration);
    return {
        /**
         *
         * @summary Post Plugins
         * @param {PluginsApiCreateEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .createEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.jsonApiDashboardPluginPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Plugin
         * @param {PluginsApiDeleteEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .deleteEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Plugins
         * @param {PluginsApiGetAllEntitiesDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDashboardPlugins(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDashboardPlugins(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Plugin
         * @param {PluginsApiGetEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .getEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Plugin
         * @param {PluginsApiPatchEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .patchEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Plugin
         * @param {PluginsApiUpdateEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .updateEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * PluginsApi - object-oriented interface
 * @export
 * @class PluginsApi
 * @extends {BaseAPI}
 */
export class PluginsApi extends BaseAPI {
    /**
     *
     * @summary Post Plugins
     * @param {PluginsApiCreateEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    createEntityDashboardPlugins(requestParameters, options) {
        return PluginsApiFp(this.configuration)
            .createEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.jsonApiDashboardPluginPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Plugin
     * @param {PluginsApiDeleteEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    deleteEntityDashboardPlugins(requestParameters, options) {
        return PluginsApiFp(this.configuration)
            .deleteEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Plugins
     * @param {PluginsApiGetAllEntitiesDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    getAllEntitiesDashboardPlugins(requestParameters, options) {
        return PluginsApiFp(this.configuration)
            .getAllEntitiesDashboardPlugins(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Plugin
     * @param {PluginsApiGetEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    getEntityDashboardPlugins(requestParameters, options) {
        return PluginsApiFp(this.configuration)
            .getEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Plugin
     * @param {PluginsApiPatchEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    patchEntityDashboardPlugins(requestParameters, options) {
        return PluginsApiFp(this.configuration)
            .patchEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Plugin
     * @param {PluginsApiUpdateEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    updateEntityDashboardPlugins(requestParameters, options) {
        return PluginsApiFp(this.configuration)
            .updateEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReportingSettingsApi - axios parameter creator
 * @export
 */
export const ReportingSettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Resolves values for all settings without workspace by current user, organization, or default settings.
         * @summary Values for all settings without workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAllSettingsWithoutWorkspace: async (options = {}) => {
            const localVarPath = `/api/v1/actions/resolveSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves values for selected settings without workspace by current user, organization, or default settings.
         * @summary Values for selected settings without workspace.
         * @param {ResolveSettingsRequest} resolveSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSettingsWithoutWorkspace: async (resolveSettingsRequest, options = {}) => {
            // verify required parameter 'resolveSettingsRequest' is not null or undefined
            assertParamExists("resolveSettingsWithoutWorkspace", "resolveSettingsRequest", resolveSettingsRequest);
            const localVarPath = `/api/v1/actions/resolveSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof resolveSettingsRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(resolveSettingsRequest !== undefined ? resolveSettingsRequest : {})
                : resolveSettingsRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReportingSettingsApi - functional programming interface
 * @export
 */
export const ReportingSettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReportingSettingsApiAxiosParamCreator(configuration);
    return {
        /**
         * Resolves values for all settings without workspace by current user, organization, or default settings.
         * @summary Values for all settings without workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveAllSettingsWithoutWorkspace(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveAllSettingsWithoutWorkspace(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves values for selected settings without workspace by current user, organization, or default settings.
         * @summary Values for selected settings without workspace.
         * @param {ResolveSettingsRequest} resolveSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveSettingsWithoutWorkspace(resolveSettingsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveSettingsWithoutWorkspace(resolveSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * ReportingSettingsApi - factory interface
 * @export
 */
export const ReportingSettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReportingSettingsApiFp(configuration);
    return {
        /**
         * Resolves values for all settings without workspace by current user, organization, or default settings.
         * @summary Values for all settings without workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAllSettingsWithoutWorkspace(options) {
            return localVarFp
                .resolveAllSettingsWithoutWorkspace(options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Resolves values for selected settings without workspace by current user, organization, or default settings.
         * @summary Values for selected settings without workspace.
         * @param {ReportingSettingsApiResolveSettingsWithoutWorkspaceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSettingsWithoutWorkspace(requestParameters, options) {
            return localVarFp
                .resolveSettingsWithoutWorkspace(requestParameters.resolveSettingsRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReportingSettingsApi - object-oriented interface
 * @export
 * @class ReportingSettingsApi
 * @extends {BaseAPI}
 */
export class ReportingSettingsApi extends BaseAPI {
    /**
     * Resolves values for all settings without workspace by current user, organization, or default settings.
     * @summary Values for all settings without workspace.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingSettingsApi
     */
    resolveAllSettingsWithoutWorkspace(options) {
        return ReportingSettingsApiFp(this.configuration)
            .resolveAllSettingsWithoutWorkspace(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves values for selected settings without workspace by current user, organization, or default settings.
     * @summary Values for selected settings without workspace.
     * @param {ReportingSettingsApiResolveSettingsWithoutWorkspaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingSettingsApi
     */
    resolveSettingsWithoutWorkspace(requestParameters, options) {
        return ReportingSettingsApiFp(this.configuration)
            .resolveSettingsWithoutWorkspace(requestParameters.resolveSettingsRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TranslationsApi - axios parameter creator
 * @export
 */
export const TranslationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Cleans up all translations for a particular locale.
         * @summary Cleans up translations.
         * @param {string} workspaceId
         * @param {LocaleRequest} localeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanTranslations: async (workspaceId, localeRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("cleanTranslations", "workspaceId", workspaceId);
            // verify required parameter 'localeRequest' is not null or undefined
            assertParamExists("cleanTranslations", "localeRequest", localeRequest);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/translations/clean`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof localeRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(localeRequest !== undefined ? localeRequest : {})
                : localeRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provides a list of effective translation tags.
         * @summary Get translation tags.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationTags: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getTranslationTags", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/translations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all translation for existing entities in a particular locale. The source translations returned by this endpoint are always original, not translated, texts. Because the XLIFF schema definition has the \'xs:language\' constraint for the \'srcLang\' attribute, it is always set to \'en-US\' value.
         * @summary Retrieve translations for entities.
         * @param {string} workspaceId
         * @param {LocaleRequest} localeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTranslations: async (workspaceId, localeRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("retrieveTranslations", "workspaceId", workspaceId);
            // verify required parameter 'localeRequest' is not null or undefined
            assertParamExists("retrieveTranslations", "localeRequest", localeRequest);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/translations/retrieve`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof localeRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(localeRequest !== undefined ? localeRequest : {})
                : localeRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set translation for existing entities in a particular locale.
         * @summary Set translations for entities.
         * @param {string} workspaceId
         * @param {Xliff} xliff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTranslations: async (workspaceId, xliff, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setTranslations", "workspaceId", workspaceId);
            // verify required parameter 'xliff' is not null or undefined
            assertParamExists("setTranslations", "xliff", xliff);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/translations/set`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/xml";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof xliff !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(xliff !== undefined ? xliff : {})
                : xliff || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TranslationsApi - functional programming interface
 * @export
 */
export const TranslationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TranslationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Cleans up all translations for a particular locale.
         * @summary Cleans up translations.
         * @param {string} workspaceId
         * @param {LocaleRequest} localeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cleanTranslations(workspaceId, localeRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cleanTranslations(workspaceId, localeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Provides a list of effective translation tags.
         * @summary Get translation tags.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslationTags(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslationTags(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all translation for existing entities in a particular locale. The source translations returned by this endpoint are always original, not translated, texts. Because the XLIFF schema definition has the \'xs:language\' constraint for the \'srcLang\' attribute, it is always set to \'en-US\' value.
         * @summary Retrieve translations for entities.
         * @param {string} workspaceId
         * @param {LocaleRequest} localeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTranslations(workspaceId, localeRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTranslations(workspaceId, localeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set translation for existing entities in a particular locale.
         * @summary Set translations for entities.
         * @param {string} workspaceId
         * @param {Xliff} xliff
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTranslations(workspaceId, xliff, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTranslations(workspaceId, xliff, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * TranslationsApi - factory interface
 * @export
 */
export const TranslationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TranslationsApiFp(configuration);
    return {
        /**
         * Cleans up all translations for a particular locale.
         * @summary Cleans up translations.
         * @param {TranslationsApiCleanTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanTranslations(requestParameters, options) {
            return localVarFp
                .cleanTranslations(requestParameters.workspaceId, requestParameters.localeRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Provides a list of effective translation tags.
         * @summary Get translation tags.
         * @param {TranslationsApiGetTranslationTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationTags(requestParameters, options) {
            return localVarFp
                .getTranslationTags(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all translation for existing entities in a particular locale. The source translations returned by this endpoint are always original, not translated, texts. Because the XLIFF schema definition has the \'xs:language\' constraint for the \'srcLang\' attribute, it is always set to \'en-US\' value.
         * @summary Retrieve translations for entities.
         * @param {TranslationsApiRetrieveTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTranslations(requestParameters, options) {
            return localVarFp
                .retrieveTranslations(requestParameters.workspaceId, requestParameters.localeRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set translation for existing entities in a particular locale.
         * @summary Set translations for entities.
         * @param {TranslationsApiSetTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTranslations(requestParameters, options) {
            return localVarFp
                .setTranslations(requestParameters.workspaceId, requestParameters.xliff, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * TranslationsApi - object-oriented interface
 * @export
 * @class TranslationsApi
 * @extends {BaseAPI}
 */
export class TranslationsApi extends BaseAPI {
    /**
     * Cleans up all translations for a particular locale.
     * @summary Cleans up translations.
     * @param {TranslationsApiCleanTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationsApi
     */
    cleanTranslations(requestParameters, options) {
        return TranslationsApiFp(this.configuration)
            .cleanTranslations(requestParameters.workspaceId, requestParameters.localeRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides a list of effective translation tags.
     * @summary Get translation tags.
     * @param {TranslationsApiGetTranslationTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationsApi
     */
    getTranslationTags(requestParameters, options) {
        return TranslationsApiFp(this.configuration)
            .getTranslationTags(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all translation for existing entities in a particular locale. The source translations returned by this endpoint are always original, not translated, texts. Because the XLIFF schema definition has the \'xs:language\' constraint for the \'srcLang\' attribute, it is always set to \'en-US\' value.
     * @summary Retrieve translations for entities.
     * @param {TranslationsApiRetrieveTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationsApi
     */
    retrieveTranslations(requestParameters, options) {
        return TranslationsApiFp(this.configuration)
            .retrieveTranslations(requestParameters.workspaceId, requestParameters.localeRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set translation for existing entities in a particular locale.
     * @summary Set translations for entities.
     * @param {TranslationsApiSetTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationsApi
     */
    setTranslations(requestParameters, options) {
        return TranslationsApiFp(this.configuration)
            .setTranslations(requestParameters.workspaceId, requestParameters.xliff, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UnsubscribeApi - axios parameter creator
 * @export
 */
export const UnsubscribeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Unsubscribe from all automations in all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeAllAutomations: async (options = {}) => {
            const localVarPath = `/api/v1/actions/organization/automations/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unsubscribe from an automation
         * @param {string} workspaceId
         * @param {string} automationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeAutomation: async (workspaceId, automationId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("unsubscribeAutomation", "workspaceId", workspaceId);
            // verify required parameter 'automationId' is not null or undefined
            assertParamExists("unsubscribeAutomation", "automationId", automationId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/automations/{automationId}/unsubscribe`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"automationId"}}`, encodeURIComponent(String(automationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unsubscribe from all automations in the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWorkspaceAutomations: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("unsubscribeWorkspaceAutomations", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/automations/unsubscribe`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UnsubscribeApi - functional programming interface
 * @export
 */
export const UnsubscribeApiFp = function (configuration) {
    const localVarAxiosParamCreator = UnsubscribeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Unsubscribe from all automations in all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeAllAutomations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeAllAutomations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unsubscribe from an automation
         * @param {string} workspaceId
         * @param {string} automationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeAutomation(workspaceId, automationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeAutomation(workspaceId, automationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Unsubscribe from all automations in the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeWorkspaceAutomations(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeWorkspaceAutomations(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UnsubscribeApi - factory interface
 * @export
 */
export const UnsubscribeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UnsubscribeApiFp(configuration);
    return {
        /**
         *
         * @summary Unsubscribe from all automations in all workspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeAllAutomations(options) {
            return localVarFp.unsubscribeAllAutomations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unsubscribe from an automation
         * @param {UnsubscribeApiUnsubscribeAutomationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeAutomation(requestParameters, options) {
            return localVarFp
                .unsubscribeAutomation(requestParameters.workspaceId, requestParameters.automationId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unsubscribe from all automations in the workspace
         * @param {UnsubscribeApiUnsubscribeWorkspaceAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWorkspaceAutomations(requestParameters, options) {
            return localVarFp
                .unsubscribeWorkspaceAutomations(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UnsubscribeApi - object-oriented interface
 * @export
 * @class UnsubscribeApi
 * @extends {BaseAPI}
 */
export class UnsubscribeApi extends BaseAPI {
    /**
     *
     * @summary Unsubscribe from all automations in all workspaces
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnsubscribeApi
     */
    unsubscribeAllAutomations(options) {
        return UnsubscribeApiFp(this.configuration)
            .unsubscribeAllAutomations(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unsubscribe from an automation
     * @param {UnsubscribeApiUnsubscribeAutomationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnsubscribeApi
     */
    unsubscribeAutomation(requestParameters, options) {
        return UnsubscribeApiFp(this.configuration)
            .unsubscribeAutomation(requestParameters.workspaceId, requestParameters.automationId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unsubscribe from all automations in the workspace
     * @param {UnsubscribeApiUnsubscribeWorkspaceAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnsubscribeApi
     */
    unsubscribeWorkspaceAutomations(requestParameters, options) {
        return UnsubscribeApiFp(this.configuration)
            .unsubscribeWorkspaceAutomations(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsageApi - axios parameter creator
 * @export
 */
export const UsageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allPlatformUsage: async (options = {}) => {
            const localVarPath = `/api/v1/actions/collectUsage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage for particular items.
         * @param {PlatformUsageRequest} platformUsageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        particularPlatformUsage: async (platformUsageRequest, options = {}) => {
            // verify required parameter 'platformUsageRequest' is not null or undefined
            assertParamExists("particularPlatformUsage", "platformUsageRequest", platformUsageRequest);
            const localVarPath = `/api/v1/actions/collectUsage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof platformUsageRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(platformUsageRequest !== undefined ? platformUsageRequest : {})
                : platformUsageRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsageApi - functional programming interface
 * @export
 */
export const UsageApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsageApiAxiosParamCreator(configuration);
    return {
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allPlatformUsage(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allPlatformUsage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage for particular items.
         * @param {PlatformUsageRequest} platformUsageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async particularPlatformUsage(platformUsageRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.particularPlatformUsage(platformUsageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UsageApi - factory interface
 * @export
 */
export const UsageApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsageApiFp(configuration);
    return {
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allPlatformUsage(options) {
            return localVarFp.allPlatformUsage(options).then((request) => request(axios, basePath));
        },
        /**
         * Provides information about platform usage, like amount of users, workspaces, ...
         * @summary Info about the platform usage for particular items.
         * @param {UsageApiParticularPlatformUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        particularPlatformUsage(requestParameters, options) {
            return localVarFp
                .particularPlatformUsage(requestParameters.platformUsageRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsageApi - object-oriented interface
 * @export
 * @class UsageApi
 * @extends {BaseAPI}
 */
export class UsageApi extends BaseAPI {
    /**
     * Provides information about platform usage, like amount of users, workspaces, ...
     * @summary Info about the platform usage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    allPlatformUsage(options) {
        return UsageApiFp(this.configuration)
            .allPlatformUsage(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides information about platform usage, like amount of users, workspaces, ...
     * @summary Info about the platform usage for particular items.
     * @param {UsageApiParticularPlatformUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    particularPlatformUsage(requestParameters, options) {
        return UsageApiFp(this.configuration)
            .particularPlatformUsage(requestParameters.platformUsageRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserDataFiltersApi - axios parameter creator
 * @export
 */
export const UserDataFiltersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve current user data filters assigned to the workspace.
         * @summary Get user data filters
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDataFilters: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getUserDataFilters", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set user data filters assigned to the workspace.
         * @summary Set user data filters
         * @param {string} workspaceId
         * @param {DeclarativeUserDataFilters} declarativeUserDataFilters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserDataFilters: async (workspaceId, declarativeUserDataFilters, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("setUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'declarativeUserDataFilters' is not null or undefined
            assertParamExists("setUserDataFilters", "declarativeUserDataFilters", declarativeUserDataFilters);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUserDataFilters !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUserDataFilters !== undefined ? declarativeUserDataFilters : {})
                : declarativeUserDataFilters || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserDataFiltersApi - functional programming interface
 * @export
 */
export const UserDataFiltersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserDataFiltersApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve current user data filters assigned to the workspace.
         * @summary Get user data filters
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDataFilters(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDataFilters(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set user data filters assigned to the workspace.
         * @summary Set user data filters
         * @param {string} workspaceId
         * @param {DeclarativeUserDataFilters} declarativeUserDataFilters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserDataFilters(workspaceId, declarativeUserDataFilters, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserDataFilters(workspaceId, declarativeUserDataFilters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UserDataFiltersApi - factory interface
 * @export
 */
export const UserDataFiltersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserDataFiltersApiFp(configuration);
    return {
        /**
         * Retrieve current user data filters assigned to the workspace.
         * @summary Get user data filters
         * @param {UserDataFiltersApiGetUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDataFilters(requestParameters, options) {
            return localVarFp
                .getUserDataFilters(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set user data filters assigned to the workspace.
         * @summary Set user data filters
         * @param {UserDataFiltersApiSetUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserDataFilters(requestParameters, options) {
            return localVarFp
                .setUserDataFilters(requestParameters.workspaceId, requestParameters.declarativeUserDataFilters, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserDataFiltersApi - object-oriented interface
 * @export
 * @class UserDataFiltersApi
 * @extends {BaseAPI}
 */
export class UserDataFiltersApi extends BaseAPI {
    /**
     * Retrieve current user data filters assigned to the workspace.
     * @summary Get user data filters
     * @param {UserDataFiltersApiGetUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDataFiltersApi
     */
    getUserDataFilters(requestParameters, options) {
        return UserDataFiltersApiFp(this.configuration)
            .getUserDataFilters(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set user data filters assigned to the workspace.
     * @summary Set user data filters
     * @param {UserDataFiltersApiSetUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDataFiltersApi
     */
    setUserDataFilters(requestParameters, options) {
        return UserDataFiltersApiFp(this.configuration)
            .setUserDataFilters(requestParameters.workspaceId, requestParameters.declarativeUserDataFilters, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserGroupsDeclarativeAPIsApi - axios parameter creator
 * @export
 */
export const UserGroupsDeclarativeAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve all user-groups eventually with parent group.
         * @summary Get all user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupsLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all users and user groups with theirs properties.
         * @summary Get all users and user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUserGroupsLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/usersAndUserGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Define all user groups with their parents eventually.
         * @summary Put all user groups
         * @param {DeclarativeUserGroups} declarativeUserGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserGroupsLayout: async (declarativeUserGroups, options = {}) => {
            // verify required parameter 'declarativeUserGroups' is not null or undefined
            assertParamExists("putUserGroupsLayout", "declarativeUserGroups", declarativeUserGroups);
            const localVarPath = `/api/v1/layout/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUserGroups !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUserGroups !== undefined ? declarativeUserGroups : {})
                : declarativeUserGroups || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Define all users and user groups with theirs properties.
         * @summary Put all users and user groups
         * @param {DeclarativeUsersUserGroups} declarativeUsersUserGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUserGroupsLayout: async (declarativeUsersUserGroups, options = {}) => {
            // verify required parameter 'declarativeUsersUserGroups' is not null or undefined
            assertParamExists("putUsersUserGroupsLayout", "declarativeUsersUserGroups", declarativeUsersUserGroups);
            const localVarPath = `/api/v1/layout/usersAndUserGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUsersUserGroups !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUsersUserGroups !== undefined ? declarativeUsersUserGroups : {})
                : declarativeUsersUserGroups || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserGroupsDeclarativeAPIsApi - functional programming interface
 * @export
 */
export const UserGroupsDeclarativeAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserGroupsDeclarativeAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve all user-groups eventually with parent group.
         * @summary Get all user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupsLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupsLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all users and user groups with theirs properties.
         * @summary Get all users and user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersUserGroupsLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersUserGroupsLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Define all user groups with their parents eventually.
         * @summary Put all user groups
         * @param {DeclarativeUserGroups} declarativeUserGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUserGroupsLayout(declarativeUserGroups, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUserGroupsLayout(declarativeUserGroups, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Define all users and user groups with theirs properties.
         * @summary Put all users and user groups
         * @param {DeclarativeUsersUserGroups} declarativeUsersUserGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUsersUserGroupsLayout(declarativeUsersUserGroups, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUsersUserGroupsLayout(declarativeUsersUserGroups, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UserGroupsDeclarativeAPIsApi - factory interface
 * @export
 */
export const UserGroupsDeclarativeAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserGroupsDeclarativeAPIsApiFp(configuration);
    return {
        /**
         * Retrieve all user-groups eventually with parent group.
         * @summary Get all user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupsLayout(options) {
            return localVarFp.getUserGroupsLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all users and user groups with theirs properties.
         * @summary Get all users and user groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUserGroupsLayout(options) {
            return localVarFp.getUsersUserGroupsLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * Define all user groups with their parents eventually.
         * @summary Put all user groups
         * @param {UserGroupsDeclarativeAPIsApiPutUserGroupsLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserGroupsLayout(requestParameters, options) {
            return localVarFp
                .putUserGroupsLayout(requestParameters.declarativeUserGroups, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Define all users and user groups with theirs properties.
         * @summary Put all users and user groups
         * @param {UserGroupsDeclarativeAPIsApiPutUsersUserGroupsLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersUserGroupsLayout(requestParameters, options) {
            return localVarFp
                .putUsersUserGroupsLayout(requestParameters.declarativeUsersUserGroups, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserGroupsDeclarativeAPIsApi - object-oriented interface
 * @export
 * @class UserGroupsDeclarativeAPIsApi
 * @extends {BaseAPI}
 */
export class UserGroupsDeclarativeAPIsApi extends BaseAPI {
    /**
     * Retrieve all user-groups eventually with parent group.
     * @summary Get all user groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsDeclarativeAPIsApi
     */
    getUserGroupsLayout(options) {
        return UserGroupsDeclarativeAPIsApiFp(this.configuration)
            .getUserGroupsLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all users and user groups with theirs properties.
     * @summary Get all users and user groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsDeclarativeAPIsApi
     */
    getUsersUserGroupsLayout(options) {
        return UserGroupsDeclarativeAPIsApiFp(this.configuration)
            .getUsersUserGroupsLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Define all user groups with their parents eventually.
     * @summary Put all user groups
     * @param {UserGroupsDeclarativeAPIsApiPutUserGroupsLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsDeclarativeAPIsApi
     */
    putUserGroupsLayout(requestParameters, options) {
        return UserGroupsDeclarativeAPIsApiFp(this.configuration)
            .putUserGroupsLayout(requestParameters.declarativeUserGroups, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Define all users and user groups with theirs properties.
     * @summary Put all users and user groups
     * @param {UserGroupsDeclarativeAPIsApiPutUsersUserGroupsLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsDeclarativeAPIsApi
     */
    putUsersUserGroupsLayout(requestParameters, options) {
        return UserGroupsDeclarativeAPIsApiFp(this.configuration)
            .putUsersUserGroupsLayout(requestParameters.declarativeUsersUserGroups, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserGroupsEntityAPIsApi - axios parameter creator
 * @export
 */
export const UserGroupsEntityAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Post User Group entities
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserGroups: async (jsonApiUserGroupInDocument, include, options = {}) => {
            // verify required parameter 'jsonApiUserGroupInDocument' is not null or undefined
            assertParamExists("createEntityUserGroups", "jsonApiUserGroupInDocument", jsonApiUserGroupInDocument);
            const localVarPath = `/api/v1/entities/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserGroupInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserGroupInDocument !== undefined ? jsonApiUserGroupInDocument : {})
                : jsonApiUserGroupInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Delete UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserGroups: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityUserGroups", "id", id);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserGroups: async (filter, include, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserGroups: async (id, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUserGroups", "id", id);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Patch UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupPatchDocument} jsonApiUserGroupPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserGroups: async (id, jsonApiUserGroupPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityUserGroups", "id", id);
            // verify required parameter 'jsonApiUserGroupPatchDocument' is not null or undefined
            assertParamExists("patchEntityUserGroups", "jsonApiUserGroupPatchDocument", jsonApiUserGroupPatchDocument);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserGroupPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserGroupPatchDocument !== undefined ? jsonApiUserGroupPatchDocument : {})
                : jsonApiUserGroupPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Put UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserGroups: async (id, jsonApiUserGroupInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityUserGroups", "id", id);
            // verify required parameter 'jsonApiUserGroupInDocument' is not null or undefined
            assertParamExists("updateEntityUserGroups", "jsonApiUserGroupInDocument", jsonApiUserGroupInDocument);
            const localVarPath = `/api/v1/entities/userGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserGroupInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserGroupInDocument !== undefined ? jsonApiUserGroupInDocument : {})
                : jsonApiUserGroupInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserGroupsEntityAPIsApi - functional programming interface
 * @export
 */
export const UserGroupsEntityAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserGroupsEntityAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Post User Group entities
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUserGroups(jsonApiUserGroupInDocument, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUserGroups(jsonApiUserGroupInDocument, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Delete UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUserGroups(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUserGroups(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserGroups(filter, include, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserGroups(filter, include, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserGroups(id, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserGroups(id, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Patch UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupPatchDocument} jsonApiUserGroupPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityUserGroups(id, jsonApiUserGroupPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityUserGroups(id, jsonApiUserGroupPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Put UserGroup entity
         * @param {string} id
         * @param {JsonApiUserGroupInDocument} jsonApiUserGroupInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'parents' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUserGroups(id, jsonApiUserGroupInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUserGroups(id, jsonApiUserGroupInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UserGroupsEntityAPIsApi - factory interface
 * @export
 */
export const UserGroupsEntityAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserGroupsEntityAPIsApiFp(configuration);
    return {
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Post User Group entities
         * @param {UserGroupsEntityAPIsApiCreateEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserGroups(requestParameters, options) {
            return localVarFp
                .createEntityUserGroups(requestParameters.jsonApiUserGroupInDocument, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Delete UserGroup entity
         * @param {UserGroupsEntityAPIsApiDeleteEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserGroups(requestParameters, options) {
            return localVarFp
                .deleteEntityUserGroups(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entities
         * @param {UserGroupsEntityAPIsApiGetAllEntitiesUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserGroups(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserGroups(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Get UserGroup entity
         * @param {UserGroupsEntityAPIsApiGetEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserGroups(requestParameters, options) {
            return localVarFp
                .getEntityUserGroups(requestParameters.id, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Patch UserGroup entity
         * @param {UserGroupsEntityAPIsApiPatchEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserGroups(requestParameters, options) {
            return localVarFp
                .patchEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User Group - creates tree-like structure for categorizing users
         * @summary Put UserGroup entity
         * @param {UserGroupsEntityAPIsApiUpdateEntityUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserGroups(requestParameters, options) {
            return localVarFp
                .updateEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserGroupsEntityAPIsApi - object-oriented interface
 * @export
 * @class UserGroupsEntityAPIsApi
 * @extends {BaseAPI}
 */
export class UserGroupsEntityAPIsApi extends BaseAPI {
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Post User Group entities
     * @param {UserGroupsEntityAPIsApiCreateEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsEntityAPIsApi
     */
    createEntityUserGroups(requestParameters, options) {
        return UserGroupsEntityAPIsApiFp(this.configuration)
            .createEntityUserGroups(requestParameters.jsonApiUserGroupInDocument, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Delete UserGroup entity
     * @param {UserGroupsEntityAPIsApiDeleteEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsEntityAPIsApi
     */
    deleteEntityUserGroups(requestParameters, options) {
        return UserGroupsEntityAPIsApiFp(this.configuration)
            .deleteEntityUserGroups(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Get UserGroup entities
     * @param {UserGroupsEntityAPIsApiGetAllEntitiesUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsEntityAPIsApi
     */
    getAllEntitiesUserGroups(requestParameters = {}, options) {
        return UserGroupsEntityAPIsApiFp(this.configuration)
            .getAllEntitiesUserGroups(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Get UserGroup entity
     * @param {UserGroupsEntityAPIsApiGetEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsEntityAPIsApi
     */
    getEntityUserGroups(requestParameters, options) {
        return UserGroupsEntityAPIsApiFp(this.configuration)
            .getEntityUserGroups(requestParameters.id, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Patch UserGroup entity
     * @param {UserGroupsEntityAPIsApiPatchEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsEntityAPIsApi
     */
    patchEntityUserGroups(requestParameters, options) {
        return UserGroupsEntityAPIsApiFp(this.configuration)
            .patchEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User Group - creates tree-like structure for categorizing users
     * @summary Put UserGroup entity
     * @param {UserGroupsEntityAPIsApiUpdateEntityUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsEntityAPIsApi
     */
    updateEntityUserGroups(requestParameters, options) {
        return UserGroupsEntityAPIsApiFp(this.configuration)
            .updateEntityUserGroups(requestParameters.id, requestParameters.jsonApiUserGroupInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserIdentifiersApi - axios parameter creator
 * @export
 */
export const UserIdentifiersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * UserIdentifier - represents entity interacting with platform
         * @summary Get UserIdentifier entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserIdentifiers: async (filter, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/userIdentifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UserIdentifier - represents basic information about entity interacting with platform
         * @summary Get UserIdentifier entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserIdentifiers: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUserIdentifiers", "id", id);
            const localVarPath = `/api/v1/entities/userIdentifiers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserIdentifiersApi - functional programming interface
 * @export
 */
export const UserIdentifiersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserIdentifiersApiAxiosParamCreator(configuration);
    return {
        /**
         * UserIdentifier - represents entity interacting with platform
         * @summary Get UserIdentifier entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserIdentifiers(filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserIdentifiers(filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UserIdentifier - represents basic information about entity interacting with platform
         * @summary Get UserIdentifier entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserIdentifiers(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserIdentifiers(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UserIdentifiersApi - factory interface
 * @export
 */
export const UserIdentifiersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserIdentifiersApiFp(configuration);
    return {
        /**
         * UserIdentifier - represents entity interacting with platform
         * @summary Get UserIdentifier entities
         * @param {UserIdentifiersApiGetAllEntitiesUserIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserIdentifiers(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * UserIdentifier - represents basic information about entity interacting with platform
         * @summary Get UserIdentifier entity
         * @param {UserIdentifiersApiGetEntityUserIdentifiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserIdentifiers(requestParameters, options) {
            return localVarFp
                .getEntityUserIdentifiers(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserIdentifiersApi - object-oriented interface
 * @export
 * @class UserIdentifiersApi
 * @extends {BaseAPI}
 */
export class UserIdentifiersApi extends BaseAPI {
    /**
     * UserIdentifier - represents entity interacting with platform
     * @summary Get UserIdentifier entities
     * @param {UserIdentifiersApiGetAllEntitiesUserIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserIdentifiersApi
     */
    getAllEntitiesUserIdentifiers(requestParameters = {}, options) {
        return UserIdentifiersApiFp(this.configuration)
            .getAllEntitiesUserIdentifiers(requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * UserIdentifier - represents basic information about entity interacting with platform
     * @summary Get UserIdentifier entity
     * @param {UserIdentifiersApiGetEntityUserIdentifiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserIdentifiersApi
     */
    getEntityUserIdentifiers(requestParameters, options) {
        return UserIdentifiersApiFp(this.configuration)
            .getEntityUserIdentifiers(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserManagementApi - axios parameter creator
 * @export
 */
export const UserManagementApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} userGroupId
         * @param {UserManagementUserGroupMembers} userManagementUserGroupMembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupMembers: async (userGroupId, userManagementUserGroupMembers, options = {}) => {
            // verify required parameter 'userGroupId' is not null or undefined
            assertParamExists("addGroupMembers", "userGroupId", userGroupId);
            // verify required parameter 'userManagementUserGroupMembers' is not null or undefined
            assertParamExists("addGroupMembers", "userManagementUserGroupMembers", userManagementUserGroupMembers);
            const localVarPath = `/api/v1/actions/userManagement/userGroups/{userGroupId}/addMembers`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(userGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof userManagementUserGroupMembers !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(userManagementUserGroupMembers !== undefined ? userManagementUserGroupMembers : {})
                : userManagementUserGroupMembers || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PermissionsAssignment} permissionsAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPermissions: async (permissionsAssignment, options = {}) => {
            // verify required parameter 'permissionsAssignment' is not null or undefined
            assertParamExists("assignPermissions", "permissionsAssignment", permissionsAssignment);
            const localVarPath = `/api/v1/actions/userManagement/assignPermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof permissionsAssignment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(permissionsAssignment !== undefined ? permissionsAssignment : {})
                : permissionsAssignment || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMembers: async (userGroupId, options = {}) => {
            // verify required parameter 'userGroupId' is not null or undefined
            assertParamExists("getGroupMembers", "userGroupId", userGroupId);
            const localVarPath = `/api/v1/actions/userManagement/userGroups/{userGroupId}/members`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(userGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissionsForUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("listPermissionsForUser", "userId", userId);
            const localVarPath = `/api/v1/actions/userManagement/users/{userId}/permissions`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissionsForUserGroup: async (userGroupId, options = {}) => {
            // verify required parameter 'userGroupId' is not null or undefined
            assertParamExists("listPermissionsForUserGroup", "userGroupId", userGroupId);
            const localVarPath = `/api/v1/actions/userManagement/userGroups/{userGroupId}/permissions`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(userGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned.
         * @param {string} [name] Filter by user name. Note that user name is case insensitive.
         * @param {string} [workspace] Filter by workspaceId.
         * @param {string} [dataSource] Filter by dataSourceId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserGroups: async (page, size, name, workspace, dataSource, options = {}) => {
            const localVarPath = `/api/v1/actions/userManagement/userGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (name !== undefined) {
                localVarQueryParameter["name"] = name;
            }
            if (workspace !== undefined) {
                localVarQueryParameter["workspace"] = workspace;
            }
            if (dataSource !== undefined) {
                localVarQueryParameter["dataSource"] = dataSource;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned.
         * @param {string} [name] Filter by user name. Note that user name is case insensitive.
         * @param {string} [workspace] Filter by workspaceId.
         * @param {string} [group] Filter by userGroupId.
         * @param {string} [dataSource] Filter by dataSourceId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (page, size, name, workspace, group, dataSource, options = {}) => {
            const localVarPath = `/api/v1/actions/userManagement/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (name !== undefined) {
                localVarQueryParameter["name"] = name;
            }
            if (workspace !== undefined) {
                localVarQueryParameter["workspace"] = workspace;
            }
            if (group !== undefined) {
                localVarQueryParameter["group"] = group;
            }
            if (dataSource !== undefined) {
                localVarQueryParameter["dataSource"] = dataSource;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userId
         * @param {UserManagementPermissionAssignments} userManagementPermissionAssignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managePermissionsForUser: async (userId, userManagementPermissionAssignments, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("managePermissionsForUser", "userId", userId);
            // verify required parameter 'userManagementPermissionAssignments' is not null or undefined
            assertParamExists("managePermissionsForUser", "userManagementPermissionAssignments", userManagementPermissionAssignments);
            const localVarPath = `/api/v1/actions/userManagement/users/{userId}/permissions`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof userManagementPermissionAssignments !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(userManagementPermissionAssignments !== undefined
                    ? userManagementPermissionAssignments
                    : {})
                : userManagementPermissionAssignments || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userGroupId
         * @param {UserManagementPermissionAssignments} userManagementPermissionAssignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managePermissionsForUserGroup: async (userGroupId, userManagementPermissionAssignments, options = {}) => {
            // verify required parameter 'userGroupId' is not null or undefined
            assertParamExists("managePermissionsForUserGroup", "userGroupId", userGroupId);
            // verify required parameter 'userManagementPermissionAssignments' is not null or undefined
            assertParamExists("managePermissionsForUserGroup", "userManagementPermissionAssignments", userManagementPermissionAssignments);
            const localVarPath = `/api/v1/actions/userManagement/userGroups/{userGroupId}/permissions`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(userGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof userManagementPermissionAssignments !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(userManagementPermissionAssignments !== undefined
                    ? userManagementPermissionAssignments
                    : {})
                : userManagementPermissionAssignments || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userGroupId
         * @param {UserManagementUserGroupMembers} userManagementUserGroupMembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupMembers: async (userGroupId, userManagementUserGroupMembers, options = {}) => {
            // verify required parameter 'userGroupId' is not null or undefined
            assertParamExists("removeGroupMembers", "userGroupId", userGroupId);
            // verify required parameter 'userManagementUserGroupMembers' is not null or undefined
            assertParamExists("removeGroupMembers", "userManagementUserGroupMembers", userManagementUserGroupMembers);
            const localVarPath = `/api/v1/actions/userManagement/userGroups/{userGroupId}/removeMembers`.replace(`{${"userGroupId"}}`, encodeURIComponent(String(userGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof userManagementUserGroupMembers !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(userManagementUserGroupMembers !== undefined ? userManagementUserGroupMembers : {})
                : userManagementUserGroupMembers || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<AssigneeIdentifier>} assigneeIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUsersUserGroups: async (assigneeIdentifier, options = {}) => {
            // verify required parameter 'assigneeIdentifier' is not null or undefined
            assertParamExists("removeUsersUserGroups", "assigneeIdentifier", assigneeIdentifier);
            const localVarPath = `/api/v1/actions/userManagement/removeUsersUserGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof assigneeIdentifier !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(assigneeIdentifier !== undefined ? assigneeIdentifier : {})
                : assigneeIdentifier || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PermissionsAssignment} permissionsAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokePermissions: async (permissionsAssignment, options = {}) => {
            // verify required parameter 'permissionsAssignment' is not null or undefined
            assertParamExists("revokePermissions", "permissionsAssignment", permissionsAssignment);
            const localVarPath = `/api/v1/actions/userManagement/revokePermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof permissionsAssignment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(permissionsAssignment !== undefined ? permissionsAssignment : {})
                : permissionsAssignment || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserManagementApi - functional programming interface
 * @export
 */
export const UserManagementApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserManagementApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} userGroupId
         * @param {UserManagementUserGroupMembers} userManagementUserGroupMembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addGroupMembers(userGroupId, userManagementUserGroupMembers, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addGroupMembers(userGroupId, userManagementUserGroupMembers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PermissionsAssignment} permissionsAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignPermissions(permissionsAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignPermissions(permissionsAssignment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} userGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupMembers(userGroupId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupMembers(userGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPermissionsForUser(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPermissionsForUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} userGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPermissionsForUserGroup(userGroupId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPermissionsForUserGroup(userGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned.
         * @param {string} [name] Filter by user name. Note that user name is case insensitive.
         * @param {string} [workspace] Filter by workspaceId.
         * @param {string} [dataSource] Filter by dataSourceId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserGroups(page, size, name, workspace, dataSource, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserGroups(page, size, name, workspace, dataSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned.
         * @param {string} [name] Filter by user name. Note that user name is case insensitive.
         * @param {string} [workspace] Filter by workspaceId.
         * @param {string} [group] Filter by userGroupId.
         * @param {string} [dataSource] Filter by dataSourceId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(page, size, name, workspace, group, dataSource, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(page, size, name, workspace, group, dataSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} userId
         * @param {UserManagementPermissionAssignments} userManagementPermissionAssignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managePermissionsForUser(userId, userManagementPermissionAssignments, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managePermissionsForUser(userId, userManagementPermissionAssignments, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} userGroupId
         * @param {UserManagementPermissionAssignments} userManagementPermissionAssignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managePermissionsForUserGroup(userGroupId, userManagementPermissionAssignments, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managePermissionsForUserGroup(userGroupId, userManagementPermissionAssignments, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} userGroupId
         * @param {UserManagementUserGroupMembers} userManagementUserGroupMembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeGroupMembers(userGroupId, userManagementUserGroupMembers, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeGroupMembers(userGroupId, userManagementUserGroupMembers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {Array<AssigneeIdentifier>} assigneeIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUsersUserGroups(assigneeIdentifier, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUsersUserGroups(assigneeIdentifier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {PermissionsAssignment} permissionsAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokePermissions(permissionsAssignment, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokePermissions(permissionsAssignment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UserManagementApi - factory interface
 * @export
 */
export const UserManagementApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserManagementApiFp(configuration);
    return {
        /**
         *
         * @param {UserManagementApiAddGroupMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupMembers(requestParameters, options) {
            return localVarFp
                .addGroupMembers(requestParameters.userGroupId, requestParameters.userManagementUserGroupMembers, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiAssignPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPermissions(requestParameters, options) {
            return localVarFp
                .assignPermissions(requestParameters.permissionsAssignment, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiGetGroupMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMembers(requestParameters, options) {
            return localVarFp
                .getGroupMembers(requestParameters.userGroupId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiListPermissionsForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissionsForUser(requestParameters, options) {
            return localVarFp
                .listPermissionsForUser(requestParameters.userId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiListPermissionsForUserGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissionsForUserGroup(requestParameters, options) {
            return localVarFp
                .listPermissionsForUserGroup(requestParameters.userGroupId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiListUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserGroups(requestParameters, options) {
            return localVarFp
                .listUserGroups(requestParameters.page, requestParameters.size, requestParameters.name, requestParameters.workspace, requestParameters.dataSource, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiListUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(requestParameters, options) {
            return localVarFp
                .listUsers(requestParameters.page, requestParameters.size, requestParameters.name, requestParameters.workspace, requestParameters.group, requestParameters.dataSource, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiManagePermissionsForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managePermissionsForUser(requestParameters, options) {
            return localVarFp
                .managePermissionsForUser(requestParameters.userId, requestParameters.userManagementPermissionAssignments, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiManagePermissionsForUserGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managePermissionsForUserGroup(requestParameters, options) {
            return localVarFp
                .managePermissionsForUserGroup(requestParameters.userGroupId, requestParameters.userManagementPermissionAssignments, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiRemoveGroupMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupMembers(requestParameters, options) {
            return localVarFp
                .removeGroupMembers(requestParameters.userGroupId, requestParameters.userManagementUserGroupMembers, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiRemoveUsersUserGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUsersUserGroups(requestParameters, options) {
            return localVarFp
                .removeUsersUserGroups(requestParameters.assigneeIdentifier, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserManagementApiRevokePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokePermissions(requestParameters, options) {
            return localVarFp
                .revokePermissions(requestParameters.permissionsAssignment, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserManagementApi - object-oriented interface
 * @export
 * @class UserManagementApi
 * @extends {BaseAPI}
 */
export class UserManagementApi extends BaseAPI {
    /**
     *
     * @param {UserManagementApiAddGroupMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    addGroupMembers(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .addGroupMembers(requestParameters.userGroupId, requestParameters.userManagementUserGroupMembers, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiAssignPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    assignPermissions(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .assignPermissions(requestParameters.permissionsAssignment, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiGetGroupMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    getGroupMembers(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .getGroupMembers(requestParameters.userGroupId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiListPermissionsForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    listPermissionsForUser(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .listPermissionsForUser(requestParameters.userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiListPermissionsForUserGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    listPermissionsForUserGroup(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .listPermissionsForUserGroup(requestParameters.userGroupId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiListUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    listUserGroups(requestParameters = {}, options) {
        return UserManagementApiFp(this.configuration)
            .listUserGroups(requestParameters.page, requestParameters.size, requestParameters.name, requestParameters.workspace, requestParameters.dataSource, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiListUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    listUsers(requestParameters = {}, options) {
        return UserManagementApiFp(this.configuration)
            .listUsers(requestParameters.page, requestParameters.size, requestParameters.name, requestParameters.workspace, requestParameters.group, requestParameters.dataSource, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiManagePermissionsForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    managePermissionsForUser(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .managePermissionsForUser(requestParameters.userId, requestParameters.userManagementPermissionAssignments, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiManagePermissionsForUserGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    managePermissionsForUserGroup(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .managePermissionsForUserGroup(requestParameters.userGroupId, requestParameters.userManagementPermissionAssignments, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiRemoveGroupMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    removeGroupMembers(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .removeGroupMembers(requestParameters.userGroupId, requestParameters.userManagementUserGroupMembers, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiRemoveUsersUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    removeUsersUserGroups(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .removeUsersUserGroups(requestParameters.assigneeIdentifier, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserManagementApiRevokePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    revokePermissions(requestParameters, options) {
        return UserManagementApiFp(this.configuration)
            .revokePermissions(requestParameters.permissionsAssignment, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserModelControllerApi - axios parameter creator
 * @export
 */
export const UserModelControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post a new API token for the user
         * @param {string} userId
         * @param {JsonApiApiTokenInDocument} jsonApiApiTokenInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityApiTokens: async (userId, jsonApiApiTokenInDocument, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("createEntityApiTokens", "userId", userId);
            // verify required parameter 'jsonApiApiTokenInDocument' is not null or undefined
            assertParamExists("createEntityApiTokens", "jsonApiApiTokenInDocument", jsonApiApiTokenInDocument);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiApiTokenInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiApiTokenInDocument !== undefined ? jsonApiApiTokenInDocument : {})
                : jsonApiApiTokenInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post new user settings for the user
         * @param {string} userId
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserSettings: async (userId, jsonApiUserSettingInDocument, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("createEntityUserSettings", "userId", userId);
            // verify required parameter 'jsonApiUserSettingInDocument' is not null or undefined
            assertParamExists("createEntityUserSettings", "jsonApiUserSettingInDocument", jsonApiUserSettingInDocument);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserSettingInDocument !== undefined ? jsonApiUserSettingInDocument : {})
                : jsonApiUserSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityApiTokens: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("deleteEntityApiTokens", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityApiTokens", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserSettings: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("deleteEntityUserSettings", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityUserSettings", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all api tokens for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesApiTokens: async (userId, filter, page, size, sort, metaInclude, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getAllEntitiesApiTokens", "userId", userId);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all settings for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserSettings: async (userId, filter, page, size, sort, metaInclude, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getAllEntitiesUserSettings", "userId", userId);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityApiTokens: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getEntityApiTokens", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityApiTokens", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/apiTokens/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserSettings: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getEntityUserSettings", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUserSettings", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put new user settings for the user
         * @param {string} userId
         * @param {string} id
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserSettings: async (userId, id, jsonApiUserSettingInDocument, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("updateEntityUserSettings", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityUserSettings", "id", id);
            // verify required parameter 'jsonApiUserSettingInDocument' is not null or undefined
            assertParamExists("updateEntityUserSettings", "jsonApiUserSettingInDocument", jsonApiUserSettingInDocument);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserSettingInDocument !== undefined ? jsonApiUserSettingInDocument : {})
                : jsonApiUserSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserModelControllerApi - functional programming interface
 * @export
 */
export const UserModelControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserModelControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post a new API token for the user
         * @param {string} userId
         * @param {JsonApiApiTokenInDocument} jsonApiApiTokenInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityApiTokens(userId, jsonApiApiTokenInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityApiTokens(userId, jsonApiApiTokenInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post new user settings for the user
         * @param {string} userId
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUserSettings(userId, jsonApiUserSettingInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUserSettings(userId, jsonApiUserSettingInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityApiTokens(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityApiTokens(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUserSettings(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUserSettings(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List all api tokens for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesApiTokens(userId, filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesApiTokens(userId, filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List all settings for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserSettings(userId, filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserSettings(userId, filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an API Token for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityApiTokens(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityApiTokens(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserSettings(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserSettings(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put new user settings for the user
         * @param {string} userId
         * @param {string} id
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUserSettings(userId, id, jsonApiUserSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUserSettings(userId, id, jsonApiUserSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UserModelControllerApi - factory interface
 * @export
 */
export const UserModelControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserModelControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Post a new API token for the user
         * @param {UserModelControllerApiCreateEntityApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityApiTokens(requestParameters, options) {
            return localVarFp
                .createEntityApiTokens(requestParameters.userId, requestParameters.jsonApiApiTokenInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post new user settings for the user
         * @param {UserModelControllerApiCreateEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserSettings(requestParameters, options) {
            return localVarFp
                .createEntityUserSettings(requestParameters.userId, requestParameters.jsonApiUserSettingInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an API Token for a user
         * @param {UserModelControllerApiDeleteEntityApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityApiTokens(requestParameters, options) {
            return localVarFp
                .deleteEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a setting for a user
         * @param {UserModelControllerApiDeleteEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all api tokens for a user
         * @param {UserModelControllerApiGetAllEntitiesApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesApiTokens(requestParameters, options) {
            return localVarFp
                .getAllEntitiesApiTokens(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all settings for a user
         * @param {UserModelControllerApiGetAllEntitiesUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserSettings(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an API Token for a user
         * @param {UserModelControllerApiGetEntityApiTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityApiTokens(requestParameters, options) {
            return localVarFp
                .getEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a setting for a user
         * @param {UserModelControllerApiGetEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserSettings(requestParameters, options) {
            return localVarFp
                .getEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put new user settings for the user
         * @param {UserModelControllerApiUpdateEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserSettings(requestParameters, options) {
            return localVarFp
                .updateEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.jsonApiUserSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserModelControllerApi - object-oriented interface
 * @export
 * @class UserModelControllerApi
 * @extends {BaseAPI}
 */
export class UserModelControllerApi extends BaseAPI {
    /**
     *
     * @summary Post a new API token for the user
     * @param {UserModelControllerApiCreateEntityApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserModelControllerApi
     */
    createEntityApiTokens(requestParameters, options) {
        return UserModelControllerApiFp(this.configuration)
            .createEntityApiTokens(requestParameters.userId, requestParameters.jsonApiApiTokenInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post new user settings for the user
     * @param {UserModelControllerApiCreateEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserModelControllerApi
     */
    createEntityUserSettings(requestParameters, options) {
        return UserModelControllerApiFp(this.configuration)
            .createEntityUserSettings(requestParameters.userId, requestParameters.jsonApiUserSettingInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an API Token for a user
     * @param {UserModelControllerApiDeleteEntityApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserModelControllerApi
     */
    deleteEntityApiTokens(requestParameters, options) {
        return UserModelControllerApiFp(this.configuration)
            .deleteEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a setting for a user
     * @param {UserModelControllerApiDeleteEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserModelControllerApi
     */
    deleteEntityUserSettings(requestParameters, options) {
        return UserModelControllerApiFp(this.configuration)
            .deleteEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all api tokens for a user
     * @param {UserModelControllerApiGetAllEntitiesApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserModelControllerApi
     */
    getAllEntitiesApiTokens(requestParameters, options) {
        return UserModelControllerApiFp(this.configuration)
            .getAllEntitiesApiTokens(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all settings for a user
     * @param {UserModelControllerApiGetAllEntitiesUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserModelControllerApi
     */
    getAllEntitiesUserSettings(requestParameters, options) {
        return UserModelControllerApiFp(this.configuration)
            .getAllEntitiesUserSettings(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an API Token for a user
     * @param {UserModelControllerApiGetEntityApiTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserModelControllerApi
     */
    getEntityApiTokens(requestParameters, options) {
        return UserModelControllerApiFp(this.configuration)
            .getEntityApiTokens(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a setting for a user
     * @param {UserModelControllerApiGetEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserModelControllerApi
     */
    getEntityUserSettings(requestParameters, options) {
        return UserModelControllerApiFp(this.configuration)
            .getEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put new user settings for the user
     * @param {UserModelControllerApiUpdateEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserModelControllerApi
     */
    updateEntityUserSettings(requestParameters, options) {
        return UserModelControllerApiFp(this.configuration)
            .updateEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.jsonApiUserSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserSettingsApi - axios parameter creator
 * @export
 */
export const UserSettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post new user settings for the user
         * @param {string} userId
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserSettings: async (userId, jsonApiUserSettingInDocument, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("createEntityUserSettings", "userId", userId);
            // verify required parameter 'jsonApiUserSettingInDocument' is not null or undefined
            assertParamExists("createEntityUserSettings", "jsonApiUserSettingInDocument", jsonApiUserSettingInDocument);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserSettingInDocument !== undefined ? jsonApiUserSettingInDocument : {})
                : jsonApiUserSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserSettings: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("deleteEntityUserSettings", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityUserSettings", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all settings for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserSettings: async (userId, filter, page, size, sort, metaInclude, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getAllEntitiesUserSettings", "userId", userId);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserSettings: async (userId, id, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("getEntityUserSettings", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUserSettings", "id", id);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put new user settings for the user
         * @param {string} userId
         * @param {string} id
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserSettings: async (userId, id, jsonApiUserSettingInDocument, filter, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists("updateEntityUserSettings", "userId", userId);
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityUserSettings", "id", id);
            // verify required parameter 'jsonApiUserSettingInDocument' is not null or undefined
            assertParamExists("updateEntityUserSettings", "jsonApiUserSettingInDocument", jsonApiUserSettingInDocument);
            const localVarPath = `/api/v1/entities/users/{userId}/userSettings/{id}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserSettingInDocument !== undefined ? jsonApiUserSettingInDocument : {})
                : jsonApiUserSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserSettingsApi - functional programming interface
 * @export
 */
export const UserSettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserSettingsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post new user settings for the user
         * @param {string} userId
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUserSettings(userId, jsonApiUserSettingInDocument, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUserSettings(userId, jsonApiUserSettingInDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUserSettings(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUserSettings(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List all settings for a user
         * @param {string} userId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserSettings(userId, filter, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserSettings(userId, filter, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a setting for a user
         * @param {string} userId
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserSettings(userId, id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserSettings(userId, id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put new user settings for the user
         * @param {string} userId
         * @param {string} id
         * @param {JsonApiUserSettingInDocument} jsonApiUserSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUserSettings(userId, id, jsonApiUserSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUserSettings(userId, id, jsonApiUserSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UserSettingsApi - factory interface
 * @export
 */
export const UserSettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserSettingsApiFp(configuration);
    return {
        /**
         *
         * @summary Post new user settings for the user
         * @param {UserSettingsApiCreateEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserSettings(requestParameters, options) {
            return localVarFp
                .createEntityUserSettings(requestParameters.userId, requestParameters.jsonApiUserSettingInDocument, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a setting for a user
         * @param {UserSettingsApiDeleteEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all settings for a user
         * @param {UserSettingsApiGetAllEntitiesUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserSettings(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a setting for a user
         * @param {UserSettingsApiGetEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserSettings(requestParameters, options) {
            return localVarFp
                .getEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put new user settings for the user
         * @param {UserSettingsApiUpdateEntityUserSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserSettings(requestParameters, options) {
            return localVarFp
                .updateEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.jsonApiUserSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserSettingsApi - object-oriented interface
 * @export
 * @class UserSettingsApi
 * @extends {BaseAPI}
 */
export class UserSettingsApi extends BaseAPI {
    /**
     *
     * @summary Post new user settings for the user
     * @param {UserSettingsApiCreateEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    createEntityUserSettings(requestParameters, options) {
        return UserSettingsApiFp(this.configuration)
            .createEntityUserSettings(requestParameters.userId, requestParameters.jsonApiUserSettingInDocument, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a setting for a user
     * @param {UserSettingsApiDeleteEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    deleteEntityUserSettings(requestParameters, options) {
        return UserSettingsApiFp(this.configuration)
            .deleteEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all settings for a user
     * @param {UserSettingsApiGetAllEntitiesUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    getAllEntitiesUserSettings(requestParameters, options) {
        return UserSettingsApiFp(this.configuration)
            .getAllEntitiesUserSettings(requestParameters.userId, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a setting for a user
     * @param {UserSettingsApiGetEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    getEntityUserSettings(requestParameters, options) {
        return UserSettingsApiFp(this.configuration)
            .getEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put new user settings for the user
     * @param {UserSettingsApiUpdateEntityUserSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    updateEntityUserSettings(requestParameters, options) {
        return UserSettingsApiFp(this.configuration)
            .updateEntityUserSettings(requestParameters.userId, requestParameters.id, requestParameters.jsonApiUserSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersDeclarativeAPIsApi - axios parameter creator
 * @export
 */
export const UsersDeclarativeAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve all users including authentication properties.
         * @summary Get all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersLayout: async (options = {}) => {
            const localVarPath = `/api/v1/layout/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set all users and their authentication properties.
         * @summary Put all users
         * @param {DeclarativeUsers} declarativeUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersLayout: async (declarativeUsers, options = {}) => {
            // verify required parameter 'declarativeUsers' is not null or undefined
            assertParamExists("putUsersLayout", "declarativeUsers", declarativeUsers);
            const localVarPath = `/api/v1/layout/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeUsers !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeUsers !== undefined ? declarativeUsers : {})
                : declarativeUsers || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersDeclarativeAPIsApi - functional programming interface
 * @export
 */
export const UsersDeclarativeAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersDeclarativeAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve all users including authentication properties.
         * @summary Get all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersLayout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersLayout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set all users and their authentication properties.
         * @summary Put all users
         * @param {DeclarativeUsers} declarativeUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUsersLayout(declarativeUsers, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUsersLayout(declarativeUsers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UsersDeclarativeAPIsApi - factory interface
 * @export
 */
export const UsersDeclarativeAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersDeclarativeAPIsApiFp(configuration);
    return {
        /**
         * Retrieve all users including authentication properties.
         * @summary Get all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersLayout(options) {
            return localVarFp.getUsersLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * Set all users and their authentication properties.
         * @summary Put all users
         * @param {UsersDeclarativeAPIsApiPutUsersLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUsersLayout(requestParameters, options) {
            return localVarFp
                .putUsersLayout(requestParameters.declarativeUsers, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersDeclarativeAPIsApi - object-oriented interface
 * @export
 * @class UsersDeclarativeAPIsApi
 * @extends {BaseAPI}
 */
export class UsersDeclarativeAPIsApi extends BaseAPI {
    /**
     * Retrieve all users including authentication properties.
     * @summary Get all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersDeclarativeAPIsApi
     */
    getUsersLayout(options) {
        return UsersDeclarativeAPIsApiFp(this.configuration)
            .getUsersLayout(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set all users and their authentication properties.
     * @summary Put all users
     * @param {UsersDeclarativeAPIsApiPutUsersLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersDeclarativeAPIsApi
     */
    putUsersLayout(requestParameters, options) {
        return UsersDeclarativeAPIsApiFp(this.configuration)
            .putUsersLayout(requestParameters.declarativeUsers, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersEntityAPIsApi - axios parameter creator
 * @export
 */
export const UsersEntityAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * User - represents entity interacting with platform
         * @summary Post User entities
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUsers: async (jsonApiUserInDocument, include, options = {}) => {
            // verify required parameter 'jsonApiUserInDocument' is not null or undefined
            assertParamExists("createEntityUsers", "jsonApiUserInDocument", jsonApiUserInDocument);
            const localVarPath = `/api/v1/entities/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserInDocument !== undefined ? jsonApiUserInDocument : {})
                : jsonApiUserInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Delete User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUsers: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityUsers", "id", id);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUsers: async (filter, include, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUsers: async (id, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityUsers", "id", id);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Patch User entity
         * @param {string} id
         * @param {JsonApiUserPatchDocument} jsonApiUserPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUsers: async (id, jsonApiUserPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityUsers", "id", id);
            // verify required parameter 'jsonApiUserPatchDocument' is not null or undefined
            assertParamExists("patchEntityUsers", "jsonApiUserPatchDocument", jsonApiUserPatchDocument);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserPatchDocument !== undefined ? jsonApiUserPatchDocument : {})
                : jsonApiUserPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User - represents entity interacting with platform
         * @summary Put User entity
         * @param {string} id
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUsers: async (id, jsonApiUserInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityUsers", "id", id);
            // verify required parameter 'jsonApiUserInDocument' is not null or undefined
            assertParamExists("updateEntityUsers", "jsonApiUserInDocument", jsonApiUserInDocument);
            const localVarPath = `/api/v1/entities/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserInDocument !== undefined ? jsonApiUserInDocument : {})
                : jsonApiUserInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersEntityAPIsApi - functional programming interface
 * @export
 */
export const UsersEntityAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersEntityAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * User - represents entity interacting with platform
         * @summary Post User entities
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUsers(jsonApiUserInDocument, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUsers(jsonApiUserInDocument, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Delete User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUsers(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUsers(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUsers(filter, include, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUsers(filter, include, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUsers(id, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUsers(id, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Patch User entity
         * @param {string} id
         * @param {JsonApiUserPatchDocument} jsonApiUserPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityUsers(id, jsonApiUserPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityUsers(id, jsonApiUserPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User - represents entity interacting with platform
         * @summary Put User entity
         * @param {string} id
         * @param {JsonApiUserInDocument} jsonApiUserInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userGroups' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUsers(id, jsonApiUserInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUsers(id, jsonApiUserInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * UsersEntityAPIsApi - factory interface
 * @export
 */
export const UsersEntityAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersEntityAPIsApiFp(configuration);
    return {
        /**
         * User - represents entity interacting with platform
         * @summary Post User entities
         * @param {UsersEntityAPIsApiCreateEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUsers(requestParameters, options) {
            return localVarFp
                .createEntityUsers(requestParameters.jsonApiUserInDocument, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Delete User entity
         * @param {UsersEntityAPIsApiDeleteEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUsers(requestParameters, options) {
            return localVarFp
                .deleteEntityUsers(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entities
         * @param {UsersEntityAPIsApiGetAllEntitiesUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUsers(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUsers(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Get User entity
         * @param {UsersEntityAPIsApiGetEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUsers(requestParameters, options) {
            return localVarFp
                .getEntityUsers(requestParameters.id, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Patch User entity
         * @param {UsersEntityAPIsApiPatchEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUsers(requestParameters, options) {
            return localVarFp
                .patchEntityUsers(requestParameters.id, requestParameters.jsonApiUserPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * User - represents entity interacting with platform
         * @summary Put User entity
         * @param {UsersEntityAPIsApiUpdateEntityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUsers(requestParameters, options) {
            return localVarFp
                .updateEntityUsers(requestParameters.id, requestParameters.jsonApiUserInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersEntityAPIsApi - object-oriented interface
 * @export
 * @class UsersEntityAPIsApi
 * @extends {BaseAPI}
 */
export class UsersEntityAPIsApi extends BaseAPI {
    /**
     * User - represents entity interacting with platform
     * @summary Post User entities
     * @param {UsersEntityAPIsApiCreateEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersEntityAPIsApi
     */
    createEntityUsers(requestParameters, options) {
        return UsersEntityAPIsApiFp(this.configuration)
            .createEntityUsers(requestParameters.jsonApiUserInDocument, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Delete User entity
     * @param {UsersEntityAPIsApiDeleteEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersEntityAPIsApi
     */
    deleteEntityUsers(requestParameters, options) {
        return UsersEntityAPIsApiFp(this.configuration)
            .deleteEntityUsers(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Get User entities
     * @param {UsersEntityAPIsApiGetAllEntitiesUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersEntityAPIsApi
     */
    getAllEntitiesUsers(requestParameters = {}, options) {
        return UsersEntityAPIsApiFp(this.configuration)
            .getAllEntitiesUsers(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Get User entity
     * @param {UsersEntityAPIsApiGetEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersEntityAPIsApi
     */
    getEntityUsers(requestParameters, options) {
        return UsersEntityAPIsApiFp(this.configuration)
            .getEntityUsers(requestParameters.id, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Patch User entity
     * @param {UsersEntityAPIsApiPatchEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersEntityAPIsApi
     */
    patchEntityUsers(requestParameters, options) {
        return UsersEntityAPIsApiFp(this.configuration)
            .patchEntityUsers(requestParameters.id, requestParameters.jsonApiUserPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * User - represents entity interacting with platform
     * @summary Put User entity
     * @param {UsersEntityAPIsApiUpdateEntityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersEntityAPIsApi
     */
    updateEntityUsers(requestParameters, options) {
        return UsersEntityAPIsApiFp(this.configuration)
            .updateEntityUsers(requestParameters.id, requestParameters.jsonApiUserInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VisualizationObjectApi - axios parameter creator
 * @export
 */
export const VisualizationObjectApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Visualization Objects
         * @param {string} workspaceId
         * @param {JsonApiVisualizationObjectPostOptionalIdDocument} jsonApiVisualizationObjectPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityVisualizationObjects: async (workspaceId, jsonApiVisualizationObjectPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiVisualizationObjectPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityVisualizationObjects", "jsonApiVisualizationObjectPostOptionalIdDocument", jsonApiVisualizationObjectPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiVisualizationObjectPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiVisualizationObjectPostOptionalIdDocument !== undefined
                    ? jsonApiVisualizationObjectPostOptionalIdDocument
                    : {})
                : jsonApiVisualizationObjectPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityVisualizationObjects: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityVisualizationObjects", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Visualization Objects
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesVisualizationObjects: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesVisualizationObjects", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityVisualizationObjects: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityVisualizationObjects", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectPatchDocument} jsonApiVisualizationObjectPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityVisualizationObjects: async (workspaceId, objectId, jsonApiVisualizationObjectPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityVisualizationObjects", "objectId", objectId);
            // verify required parameter 'jsonApiVisualizationObjectPatchDocument' is not null or undefined
            assertParamExists("patchEntityVisualizationObjects", "jsonApiVisualizationObjectPatchDocument", jsonApiVisualizationObjectPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiVisualizationObjectPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiVisualizationObjectPatchDocument !== undefined
                    ? jsonApiVisualizationObjectPatchDocument
                    : {})
                : jsonApiVisualizationObjectPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectInDocument} jsonApiVisualizationObjectInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityVisualizationObjects: async (workspaceId, objectId, jsonApiVisualizationObjectInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityVisualizationObjects", "objectId", objectId);
            // verify required parameter 'jsonApiVisualizationObjectInDocument' is not null or undefined
            assertParamExists("updateEntityVisualizationObjects", "jsonApiVisualizationObjectInDocument", jsonApiVisualizationObjectInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiVisualizationObjectInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiVisualizationObjectInDocument !== undefined
                    ? jsonApiVisualizationObjectInDocument
                    : {})
                : jsonApiVisualizationObjectInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * VisualizationObjectApi - functional programming interface
 * @export
 */
export const VisualizationObjectApiFp = function (configuration) {
    const localVarAxiosParamCreator = VisualizationObjectApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Visualization Objects
         * @param {string} workspaceId
         * @param {JsonApiVisualizationObjectPostOptionalIdDocument} jsonApiVisualizationObjectPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityVisualizationObjects(workspaceId, jsonApiVisualizationObjectPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityVisualizationObjects(workspaceId, jsonApiVisualizationObjectPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityVisualizationObjects(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityVisualizationObjects(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Visualization Objects
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesVisualizationObjects(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesVisualizationObjects(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityVisualizationObjects(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityVisualizationObjects(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectPatchDocument} jsonApiVisualizationObjectPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectInDocument} jsonApiVisualizationObjectInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * VisualizationObjectApi - factory interface
 * @export
 */
export const VisualizationObjectApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VisualizationObjectApiFp(configuration);
    return {
        /**
         *
         * @summary Post Visualization Objects
         * @param {VisualizationObjectApiCreateEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .createEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.jsonApiVisualizationObjectPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Visualization Object
         * @param {VisualizationObjectApiDeleteEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .deleteEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Visualization Objects
         * @param {VisualizationObjectApiGetAllEntitiesVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesVisualizationObjects(requestParameters, options) {
            return localVarFp
                .getAllEntitiesVisualizationObjects(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Visualization Object
         * @param {VisualizationObjectApiGetEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .getEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Visualization Object
         * @param {VisualizationObjectApiPatchEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .patchEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Visualization Object
         * @param {VisualizationObjectApiUpdateEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .updateEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * VisualizationObjectApi - object-oriented interface
 * @export
 * @class VisualizationObjectApi
 * @extends {BaseAPI}
 */
export class VisualizationObjectApi extends BaseAPI {
    /**
     *
     * @summary Post Visualization Objects
     * @param {VisualizationObjectApiCreateEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualizationObjectApi
     */
    createEntityVisualizationObjects(requestParameters, options) {
        return VisualizationObjectApiFp(this.configuration)
            .createEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.jsonApiVisualizationObjectPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Visualization Object
     * @param {VisualizationObjectApiDeleteEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualizationObjectApi
     */
    deleteEntityVisualizationObjects(requestParameters, options) {
        return VisualizationObjectApiFp(this.configuration)
            .deleteEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Visualization Objects
     * @param {VisualizationObjectApiGetAllEntitiesVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualizationObjectApi
     */
    getAllEntitiesVisualizationObjects(requestParameters, options) {
        return VisualizationObjectApiFp(this.configuration)
            .getAllEntitiesVisualizationObjects(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Visualization Object
     * @param {VisualizationObjectApiGetEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualizationObjectApi
     */
    getEntityVisualizationObjects(requestParameters, options) {
        return VisualizationObjectApiFp(this.configuration)
            .getEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Visualization Object
     * @param {VisualizationObjectApiPatchEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualizationObjectApi
     */
    patchEntityVisualizationObjects(requestParameters, options) {
        return VisualizationObjectApiFp(this.configuration)
            .patchEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Visualization Object
     * @param {VisualizationObjectApiUpdateEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualizationObjectApi
     */
    updateEntityVisualizationObjects(requestParameters, options) {
        return VisualizationObjectApiFp(this.configuration)
            .updateEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkspaceObjectControllerApi - axios parameter creator
 * @export
 */
export const WorkspaceObjectControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Dashboards
         * @param {string} workspaceId
         * @param {JsonApiAnalyticalDashboardPostOptionalIdDocument} jsonApiAnalyticalDashboardPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAnalyticalDashboards: async (workspaceId, jsonApiAnalyticalDashboardPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiAnalyticalDashboardPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityAnalyticalDashboards", "jsonApiAnalyticalDashboardPostOptionalIdDocument", jsonApiAnalyticalDashboardPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAnalyticalDashboardPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAnalyticalDashboardPostOptionalIdDocument !== undefined
                    ? jsonApiAnalyticalDashboardPostOptionalIdDocument
                    : {})
                : jsonApiAnalyticalDashboardPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Attribute Hierarchies
         * @param {string} workspaceId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAttributeHierarchies: async (workspaceId, jsonApiAttributeHierarchyInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiAttributeHierarchyInDocument' is not null or undefined
            assertParamExists("createEntityAttributeHierarchies", "jsonApiAttributeHierarchyInDocument", jsonApiAttributeHierarchyInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAttributeHierarchyInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAttributeHierarchyInDocument !== undefined
                    ? jsonApiAttributeHierarchyInDocument
                    : {})
                : jsonApiAttributeHierarchyInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Automations
         * @param {string} workspaceId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAutomations: async (workspaceId, jsonApiAutomationInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiAutomationInDocument' is not null or undefined
            assertParamExists("createEntityAutomations", "jsonApiAutomationInDocument", jsonApiAutomationInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAutomationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAutomationInDocument !== undefined ? jsonApiAutomationInDocument : {})
                : jsonApiAutomationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Custom Application Settings
         * @param {string} workspaceId
         * @param {JsonApiCustomApplicationSettingPostOptionalIdDocument} jsonApiCustomApplicationSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCustomApplicationSettings: async (workspaceId, jsonApiCustomApplicationSettingPostOptionalIdDocument, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiCustomApplicationSettingPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityCustomApplicationSettings", "jsonApiCustomApplicationSettingPostOptionalIdDocument", jsonApiCustomApplicationSettingPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCustomApplicationSettingPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCustomApplicationSettingPostOptionalIdDocument !== undefined
                    ? jsonApiCustomApplicationSettingPostOptionalIdDocument
                    : {})
                : jsonApiCustomApplicationSettingPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Plugins
         * @param {string} workspaceId
         * @param {JsonApiDashboardPluginPostOptionalIdDocument} jsonApiDashboardPluginPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDashboardPlugins: async (workspaceId, jsonApiDashboardPluginPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiDashboardPluginPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityDashboardPlugins", "jsonApiDashboardPluginPostOptionalIdDocument", jsonApiDashboardPluginPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDashboardPluginPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDashboardPluginPostOptionalIdDocument !== undefined
                    ? jsonApiDashboardPluginPostOptionalIdDocument
                    : {})
                : jsonApiDashboardPluginPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Export Definitions
         * @param {string} workspaceId
         * @param {JsonApiExportDefinitionPostOptionalIdDocument} jsonApiExportDefinitionPostOptionalIdDocument
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityExportDefinitions: async (workspaceId, jsonApiExportDefinitionPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiExportDefinitionPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityExportDefinitions", "jsonApiExportDefinitionPostOptionalIdDocument", jsonApiExportDefinitionPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiExportDefinitionPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiExportDefinitionPostOptionalIdDocument !== undefined
                    ? jsonApiExportDefinitionPostOptionalIdDocument
                    : {})
                : jsonApiExportDefinitionPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Context Filters
         * @param {string} workspaceId
         * @param {JsonApiFilterContextPostOptionalIdDocument} jsonApiFilterContextPostOptionalIdDocument
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterContexts: async (workspaceId, jsonApiFilterContextPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiFilterContextPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityFilterContexts", "jsonApiFilterContextPostOptionalIdDocument", jsonApiFilterContextPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterContextPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterContextPostOptionalIdDocument !== undefined
                    ? jsonApiFilterContextPostOptionalIdDocument
                    : {})
                : jsonApiFilterContextPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Filter views
         * @param {string} workspaceId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterViews: async (workspaceId, jsonApiFilterViewInDocument, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiFilterViewInDocument' is not null or undefined
            assertParamExists("createEntityFilterViews", "jsonApiFilterViewInDocument", jsonApiFilterViewInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterViewInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterViewInDocument !== undefined ? jsonApiFilterViewInDocument : {})
                : jsonApiFilterViewInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Metrics
         * @param {string} workspaceId
         * @param {JsonApiMetricPostOptionalIdDocument} jsonApiMetricPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityMetrics: async (workspaceId, jsonApiMetricPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiMetricPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityMetrics", "jsonApiMetricPostOptionalIdDocument", jsonApiMetricPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiMetricPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiMetricPostOptionalIdDocument !== undefined
                    ? jsonApiMetricPostOptionalIdDocument
                    : {})
                : jsonApiMetricPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post User Data Filters
         * @param {string} workspaceId
         * @param {JsonApiUserDataFilterPostOptionalIdDocument} jsonApiUserDataFilterPostOptionalIdDocument
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserDataFilters: async (workspaceId, jsonApiUserDataFilterPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiUserDataFilterPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityUserDataFilters", "jsonApiUserDataFilterPostOptionalIdDocument", jsonApiUserDataFilterPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserDataFilterPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserDataFilterPostOptionalIdDocument !== undefined
                    ? jsonApiUserDataFilterPostOptionalIdDocument
                    : {})
                : jsonApiUserDataFilterPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Visualization Objects
         * @param {string} workspaceId
         * @param {JsonApiVisualizationObjectPostOptionalIdDocument} jsonApiVisualizationObjectPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityVisualizationObjects: async (workspaceId, jsonApiVisualizationObjectPostOptionalIdDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiVisualizationObjectPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityVisualizationObjects", "jsonApiVisualizationObjectPostOptionalIdDocument", jsonApiVisualizationObjectPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiVisualizationObjectPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiVisualizationObjectPostOptionalIdDocument !== undefined
                    ? jsonApiVisualizationObjectPostOptionalIdDocument
                    : {})
                : jsonApiVisualizationObjectPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilterSettings: async (workspaceId, jsonApiWorkspaceDataFilterSettingInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiWorkspaceDataFilterSettingInDocument' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilterSettings", "jsonApiWorkspaceDataFilterSettingInDocument", jsonApiWorkspaceDataFilterSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterSettingInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterSettingInDocument
                    : {})
                : jsonApiWorkspaceDataFilterSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilters: async (workspaceId, jsonApiWorkspaceDataFilterInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiWorkspaceDataFilterInDocument' is not null or undefined
            assertParamExists("createEntityWorkspaceDataFilters", "jsonApiWorkspaceDataFilterInDocument", jsonApiWorkspaceDataFilterInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterInDocument
                    : {})
                : jsonApiWorkspaceDataFilterInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Settings for Workspaces
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceSettingPostOptionalIdDocument} jsonApiWorkspaceSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceSettings: async (workspaceId, jsonApiWorkspaceSettingPostOptionalIdDocument, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiWorkspaceSettingPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityWorkspaceSettings", "jsonApiWorkspaceSettingPostOptionalIdDocument", jsonApiWorkspaceSettingPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceSettingPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceSettingPostOptionalIdDocument !== undefined
                    ? jsonApiWorkspaceSettingPostOptionalIdDocument
                    : {})
                : jsonApiWorkspaceSettingPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAnalyticalDashboards: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityAnalyticalDashboards", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAttributeHierarchies: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityAttributeHierarchies", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAutomations: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityAutomations", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCustomApplicationSettings: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityCustomApplicationSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDashboardPlugins: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityDashboardPlugins", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityExportDefinitions: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityExportDefinitions", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterContexts: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityFilterContexts", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterViews: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityFilterViews", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityMetrics: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityMetrics", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserDataFilters: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityUserDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityVisualizationObjects: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityVisualizationObjects", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilterSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilters: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceSettings: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Dashboards
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAnalyticalDashboards: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAnalyticalDashboards", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Attribute Hierarchies
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributeHierarchies: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAttributeHierarchies", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Attributes
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributes: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAttributes", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributes`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Automations
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAutomations: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesAutomations", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Custom Application Settings
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCustomApplicationSettings: async (workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesCustomApplicationSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Plugins
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDashboardPlugins: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesDashboardPlugins", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Datasets
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDatasets: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesDatasets", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/datasets`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Export Definitions
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesExportDefinitions: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesExportDefinitions", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Facts
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFacts: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesFacts", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/facts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Context Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterContexts: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesFilterContexts", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Filter views
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterViews: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesFilterViews", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Labels
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLabels: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesLabels", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/labels`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Metrics
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesMetrics: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesMetrics", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all User Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserDataFilters: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesUserDataFilters", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Visualization Objects
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesVisualizationObjects: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesVisualizationObjects", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilterSettings: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilters: async (workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesWorkspaceDataFilters", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Setting for Workspaces
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceSettings: async (workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesWorkspaceSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAnalyticalDashboards: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAnalyticalDashboards", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributeHierarchies: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAttributeHierarchies", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Attribute
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributes: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAttributes", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAttributes", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributes/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAutomations: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityAutomations", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomApplicationSettings: async (workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityCustomApplicationSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDashboardPlugins: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityDashboardPlugins", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Dataset
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDatasets: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityDatasets", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityDatasets", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/datasets/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityExportDefinitions: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityExportDefinitions", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Fact
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFacts: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityFacts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityFacts", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/facts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterContexts: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityFilterContexts", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterViews: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityFilterViews", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Label
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLabels: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityLabels", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityLabels", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/labels/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityMetrics: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityMetrics", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserDataFilters: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityUserDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityVisualizationObjects: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityVisualizationObjects", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Setting for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilterSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilters: async (workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityWorkspaceDataFilters", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceSettings: async (workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityWorkspaceSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardPatchDocument} jsonApiAnalyticalDashboardPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAnalyticalDashboards: async (workspaceId, objectId, jsonApiAnalyticalDashboardPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityAnalyticalDashboards", "objectId", objectId);
            // verify required parameter 'jsonApiAnalyticalDashboardPatchDocument' is not null or undefined
            assertParamExists("patchEntityAnalyticalDashboards", "jsonApiAnalyticalDashboardPatchDocument", jsonApiAnalyticalDashboardPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAnalyticalDashboardPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAnalyticalDashboardPatchDocument !== undefined
                    ? jsonApiAnalyticalDashboardPatchDocument
                    : {})
                : jsonApiAnalyticalDashboardPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyPatchDocument} jsonApiAttributeHierarchyPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAttributeHierarchies: async (workspaceId, objectId, jsonApiAttributeHierarchyPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityAttributeHierarchies", "objectId", objectId);
            // verify required parameter 'jsonApiAttributeHierarchyPatchDocument' is not null or undefined
            assertParamExists("patchEntityAttributeHierarchies", "jsonApiAttributeHierarchyPatchDocument", jsonApiAttributeHierarchyPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAttributeHierarchyPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAttributeHierarchyPatchDocument !== undefined
                    ? jsonApiAttributeHierarchyPatchDocument
                    : {})
                : jsonApiAttributeHierarchyPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationPatchDocument} jsonApiAutomationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAutomations: async (workspaceId, objectId, jsonApiAutomationPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityAutomations", "objectId", objectId);
            // verify required parameter 'jsonApiAutomationPatchDocument' is not null or undefined
            assertParamExists("patchEntityAutomations", "jsonApiAutomationPatchDocument", jsonApiAutomationPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAutomationPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAutomationPatchDocument !== undefined ? jsonApiAutomationPatchDocument : {})
                : jsonApiAutomationPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingPatchDocument} jsonApiCustomApplicationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCustomApplicationSettings: async (workspaceId, objectId, jsonApiCustomApplicationSettingPatchDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityCustomApplicationSettings", "objectId", objectId);
            // verify required parameter 'jsonApiCustomApplicationSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityCustomApplicationSettings", "jsonApiCustomApplicationSettingPatchDocument", jsonApiCustomApplicationSettingPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCustomApplicationSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCustomApplicationSettingPatchDocument !== undefined
                    ? jsonApiCustomApplicationSettingPatchDocument
                    : {})
                : jsonApiCustomApplicationSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginPatchDocument} jsonApiDashboardPluginPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDashboardPlugins: async (workspaceId, objectId, jsonApiDashboardPluginPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityDashboardPlugins", "objectId", objectId);
            // verify required parameter 'jsonApiDashboardPluginPatchDocument' is not null or undefined
            assertParamExists("patchEntityDashboardPlugins", "jsonApiDashboardPluginPatchDocument", jsonApiDashboardPluginPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDashboardPluginPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDashboardPluginPatchDocument !== undefined
                    ? jsonApiDashboardPluginPatchDocument
                    : {})
                : jsonApiDashboardPluginPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionPatchDocument} jsonApiExportDefinitionPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityExportDefinitions: async (workspaceId, objectId, jsonApiExportDefinitionPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityExportDefinitions", "objectId", objectId);
            // verify required parameter 'jsonApiExportDefinitionPatchDocument' is not null or undefined
            assertParamExists("patchEntityExportDefinitions", "jsonApiExportDefinitionPatchDocument", jsonApiExportDefinitionPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiExportDefinitionPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiExportDefinitionPatchDocument !== undefined
                    ? jsonApiExportDefinitionPatchDocument
                    : {})
                : jsonApiExportDefinitionPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextPatchDocument} jsonApiFilterContextPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterContexts: async (workspaceId, objectId, jsonApiFilterContextPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityFilterContexts", "objectId", objectId);
            // verify required parameter 'jsonApiFilterContextPatchDocument' is not null or undefined
            assertParamExists("patchEntityFilterContexts", "jsonApiFilterContextPatchDocument", jsonApiFilterContextPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterContextPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterContextPatchDocument !== undefined
                    ? jsonApiFilterContextPatchDocument
                    : {})
                : jsonApiFilterContextPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewPatchDocument} jsonApiFilterViewPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterViews: async (workspaceId, objectId, jsonApiFilterViewPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityFilterViews", "objectId", objectId);
            // verify required parameter 'jsonApiFilterViewPatchDocument' is not null or undefined
            assertParamExists("patchEntityFilterViews", "jsonApiFilterViewPatchDocument", jsonApiFilterViewPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterViewPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterViewPatchDocument !== undefined ? jsonApiFilterViewPatchDocument : {})
                : jsonApiFilterViewPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricPatchDocument} jsonApiMetricPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityMetrics: async (workspaceId, objectId, jsonApiMetricPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityMetrics", "objectId", objectId);
            // verify required parameter 'jsonApiMetricPatchDocument' is not null or undefined
            assertParamExists("patchEntityMetrics", "jsonApiMetricPatchDocument", jsonApiMetricPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiMetricPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiMetricPatchDocument !== undefined ? jsonApiMetricPatchDocument : {})
                : jsonApiMetricPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterPatchDocument} jsonApiUserDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserDataFilters: async (workspaceId, objectId, jsonApiUserDataFilterPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityUserDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiUserDataFilterPatchDocument' is not null or undefined
            assertParamExists("patchEntityUserDataFilters", "jsonApiUserDataFilterPatchDocument", jsonApiUserDataFilterPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserDataFilterPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserDataFilterPatchDocument !== undefined
                    ? jsonApiUserDataFilterPatchDocument
                    : {})
                : jsonApiUserDataFilterPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectPatchDocument} jsonApiVisualizationObjectPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityVisualizationObjects: async (workspaceId, objectId, jsonApiVisualizationObjectPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityVisualizationObjects", "objectId", objectId);
            // verify required parameter 'jsonApiVisualizationObjectPatchDocument' is not null or undefined
            assertParamExists("patchEntityVisualizationObjects", "jsonApiVisualizationObjectPatchDocument", jsonApiVisualizationObjectPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiVisualizationObjectPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiVisualizationObjectPatchDocument !== undefined
                    ? jsonApiVisualizationObjectPatchDocument
                    : {})
                : jsonApiVisualizationObjectPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingPatchDocument} jsonApiWorkspaceDataFilterSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, jsonApiWorkspaceDataFilterSettingPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilterSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilterSettings", "jsonApiWorkspaceDataFilterSettingPatchDocument", jsonApiWorkspaceDataFilterSettingPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterSettingPatchDocument !== undefined
                    ? jsonApiWorkspaceDataFilterSettingPatchDocument
                    : {})
                : jsonApiWorkspaceDataFilterSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterPatchDocument} jsonApiWorkspaceDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilters: async (workspaceId, objectId, jsonApiWorkspaceDataFilterPatchDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterPatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaceDataFilters", "jsonApiWorkspaceDataFilterPatchDocument", jsonApiWorkspaceDataFilterPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterPatchDocument !== undefined
                    ? jsonApiWorkspaceDataFilterPatchDocument
                    : {})
                : jsonApiWorkspaceDataFilterPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingPatchDocument} jsonApiWorkspaceSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceSettings: async (workspaceId, objectId, jsonApiWorkspaceSettingPatchDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityWorkspaceSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaceSettings", "jsonApiWorkspaceSettingPatchDocument", jsonApiWorkspaceSettingPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceSettingPatchDocument !== undefined
                    ? jsonApiWorkspaceSettingPatchDocument
                    : {})
                : jsonApiWorkspaceSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Dashboards
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardInDocument} jsonApiAnalyticalDashboardInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAnalyticalDashboards: async (workspaceId, objectId, jsonApiAnalyticalDashboardInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityAnalyticalDashboards", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityAnalyticalDashboards", "objectId", objectId);
            // verify required parameter 'jsonApiAnalyticalDashboardInDocument' is not null or undefined
            assertParamExists("updateEntityAnalyticalDashboards", "jsonApiAnalyticalDashboardInDocument", jsonApiAnalyticalDashboardInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/analyticalDashboards/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAnalyticalDashboardInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAnalyticalDashboardInDocument !== undefined
                    ? jsonApiAnalyticalDashboardInDocument
                    : {})
                : jsonApiAnalyticalDashboardInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAttributeHierarchies: async (workspaceId, objectId, jsonApiAttributeHierarchyInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityAttributeHierarchies", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityAttributeHierarchies", "objectId", objectId);
            // verify required parameter 'jsonApiAttributeHierarchyInDocument' is not null or undefined
            assertParamExists("updateEntityAttributeHierarchies", "jsonApiAttributeHierarchyInDocument", jsonApiAttributeHierarchyInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/attributeHierarchies/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAttributeHierarchyInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAttributeHierarchyInDocument !== undefined
                    ? jsonApiAttributeHierarchyInDocument
                    : {})
                : jsonApiAttributeHierarchyInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAutomations: async (workspaceId, objectId, jsonApiAutomationInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityAutomations", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityAutomations", "objectId", objectId);
            // verify required parameter 'jsonApiAutomationInDocument' is not null or undefined
            assertParamExists("updateEntityAutomations", "jsonApiAutomationInDocument", jsonApiAutomationInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/automations/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiAutomationInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiAutomationInDocument !== undefined ? jsonApiAutomationInDocument : {})
                : jsonApiAutomationInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingInDocument} jsonApiCustomApplicationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCustomApplicationSettings: async (workspaceId, objectId, jsonApiCustomApplicationSettingInDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityCustomApplicationSettings", "objectId", objectId);
            // verify required parameter 'jsonApiCustomApplicationSettingInDocument' is not null or undefined
            assertParamExists("updateEntityCustomApplicationSettings", "jsonApiCustomApplicationSettingInDocument", jsonApiCustomApplicationSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCustomApplicationSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCustomApplicationSettingInDocument !== undefined
                    ? jsonApiCustomApplicationSettingInDocument
                    : {})
                : jsonApiCustomApplicationSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginInDocument} jsonApiDashboardPluginInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDashboardPlugins: async (workspaceId, objectId, jsonApiDashboardPluginInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityDashboardPlugins", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityDashboardPlugins", "objectId", objectId);
            // verify required parameter 'jsonApiDashboardPluginInDocument' is not null or undefined
            assertParamExists("updateEntityDashboardPlugins", "jsonApiDashboardPluginInDocument", jsonApiDashboardPluginInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/dashboardPlugins/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiDashboardPluginInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiDashboardPluginInDocument !== undefined ? jsonApiDashboardPluginInDocument : {})
                : jsonApiDashboardPluginInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionInDocument} jsonApiExportDefinitionInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityExportDefinitions: async (workspaceId, objectId, jsonApiExportDefinitionInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityExportDefinitions", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityExportDefinitions", "objectId", objectId);
            // verify required parameter 'jsonApiExportDefinitionInDocument' is not null or undefined
            assertParamExists("updateEntityExportDefinitions", "jsonApiExportDefinitionInDocument", jsonApiExportDefinitionInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/exportDefinitions/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiExportDefinitionInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiExportDefinitionInDocument !== undefined
                    ? jsonApiExportDefinitionInDocument
                    : {})
                : jsonApiExportDefinitionInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextInDocument} jsonApiFilterContextInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterContexts: async (workspaceId, objectId, jsonApiFilterContextInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityFilterContexts", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityFilterContexts", "objectId", objectId);
            // verify required parameter 'jsonApiFilterContextInDocument' is not null or undefined
            assertParamExists("updateEntityFilterContexts", "jsonApiFilterContextInDocument", jsonApiFilterContextInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterContexts/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterContextInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterContextInDocument !== undefined ? jsonApiFilterContextInDocument : {})
                : jsonApiFilterContextInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put Filter views
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterViews: async (workspaceId, objectId, jsonApiFilterViewInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityFilterViews", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityFilterViews", "objectId", objectId);
            // verify required parameter 'jsonApiFilterViewInDocument' is not null or undefined
            assertParamExists("updateEntityFilterViews", "jsonApiFilterViewInDocument", jsonApiFilterViewInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/filterViews/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiFilterViewInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiFilterViewInDocument !== undefined ? jsonApiFilterViewInDocument : {})
                : jsonApiFilterViewInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricInDocument} jsonApiMetricInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityMetrics: async (workspaceId, objectId, jsonApiMetricInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityMetrics", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityMetrics", "objectId", objectId);
            // verify required parameter 'jsonApiMetricInDocument' is not null or undefined
            assertParamExists("updateEntityMetrics", "jsonApiMetricInDocument", jsonApiMetricInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/metrics/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiMetricInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiMetricInDocument !== undefined ? jsonApiMetricInDocument : {})
                : jsonApiMetricInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterInDocument} jsonApiUserDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserDataFilters: async (workspaceId, objectId, jsonApiUserDataFilterInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityUserDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityUserDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiUserDataFilterInDocument' is not null or undefined
            assertParamExists("updateEntityUserDataFilters", "jsonApiUserDataFilterInDocument", jsonApiUserDataFilterInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/userDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiUserDataFilterInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiUserDataFilterInDocument !== undefined ? jsonApiUserDataFilterInDocument : {})
                : jsonApiUserDataFilterInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectInDocument} jsonApiVisualizationObjectInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityVisualizationObjects: async (workspaceId, objectId, jsonApiVisualizationObjectInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityVisualizationObjects", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityVisualizationObjects", "objectId", objectId);
            // verify required parameter 'jsonApiVisualizationObjectInDocument' is not null or undefined
            assertParamExists("updateEntityVisualizationObjects", "jsonApiVisualizationObjectInDocument", jsonApiVisualizationObjectInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/visualizationObjects/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiVisualizationObjectInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiVisualizationObjectInDocument !== undefined
                    ? jsonApiVisualizationObjectInDocument
                    : {})
                : jsonApiVisualizationObjectInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilterSettings: async (workspaceId, objectId, jsonApiWorkspaceDataFilterSettingInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilterSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilterSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterSettingInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilterSettings", "jsonApiWorkspaceDataFilterSettingInDocument", jsonApiWorkspaceDataFilterSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilterSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterSettingInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterSettingInDocument
                    : {})
                : jsonApiWorkspaceDataFilterSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilters: async (workspaceId, objectId, jsonApiWorkspaceDataFilterInDocument, filter, include, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilters", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilters", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceDataFilterInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaceDataFilters", "jsonApiWorkspaceDataFilterInDocument", jsonApiWorkspaceDataFilterInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceDataFilters/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceDataFilterInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceDataFilterInDocument !== undefined
                    ? jsonApiWorkspaceDataFilterInDocument
                    : {})
                : jsonApiWorkspaceDataFilterInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Setting for a Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingInDocument} jsonApiWorkspaceSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceSettings: async (workspaceId, objectId, jsonApiWorkspaceSettingInDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityWorkspaceSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceSettingInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaceSettings", "jsonApiWorkspaceSettingInDocument", jsonApiWorkspaceSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceSettingInDocument !== undefined
                    ? jsonApiWorkspaceSettingInDocument
                    : {})
                : jsonApiWorkspaceSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WorkspaceObjectControllerApi - functional programming interface
 * @export
 */
export const WorkspaceObjectControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkspaceObjectControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Dashboards
         * @param {string} workspaceId
         * @param {JsonApiAnalyticalDashboardPostOptionalIdDocument} jsonApiAnalyticalDashboardPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityAnalyticalDashboards(workspaceId, jsonApiAnalyticalDashboardPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityAnalyticalDashboards(workspaceId, jsonApiAnalyticalDashboardPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Attribute Hierarchies
         * @param {string} workspaceId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityAttributeHierarchies(workspaceId, jsonApiAttributeHierarchyInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityAttributeHierarchies(workspaceId, jsonApiAttributeHierarchyInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Automations
         * @param {string} workspaceId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityAutomations(workspaceId, jsonApiAutomationInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityAutomations(workspaceId, jsonApiAutomationInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Custom Application Settings
         * @param {string} workspaceId
         * @param {JsonApiCustomApplicationSettingPostOptionalIdDocument} jsonApiCustomApplicationSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityCustomApplicationSettings(workspaceId, jsonApiCustomApplicationSettingPostOptionalIdDocument, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityCustomApplicationSettings(workspaceId, jsonApiCustomApplicationSettingPostOptionalIdDocument, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Plugins
         * @param {string} workspaceId
         * @param {JsonApiDashboardPluginPostOptionalIdDocument} jsonApiDashboardPluginPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityDashboardPlugins(workspaceId, jsonApiDashboardPluginPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityDashboardPlugins(workspaceId, jsonApiDashboardPluginPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Export Definitions
         * @param {string} workspaceId
         * @param {JsonApiExportDefinitionPostOptionalIdDocument} jsonApiExportDefinitionPostOptionalIdDocument
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityExportDefinitions(workspaceId, jsonApiExportDefinitionPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityExportDefinitions(workspaceId, jsonApiExportDefinitionPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Context Filters
         * @param {string} workspaceId
         * @param {JsonApiFilterContextPostOptionalIdDocument} jsonApiFilterContextPostOptionalIdDocument
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityFilterContexts(workspaceId, jsonApiFilterContextPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityFilterContexts(workspaceId, jsonApiFilterContextPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Filter views
         * @param {string} workspaceId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityFilterViews(workspaceId, jsonApiFilterViewInDocument, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityFilterViews(workspaceId, jsonApiFilterViewInDocument, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Metrics
         * @param {string} workspaceId
         * @param {JsonApiMetricPostOptionalIdDocument} jsonApiMetricPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityMetrics(workspaceId, jsonApiMetricPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityMetrics(workspaceId, jsonApiMetricPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post User Data Filters
         * @param {string} workspaceId
         * @param {JsonApiUserDataFilterPostOptionalIdDocument} jsonApiUserDataFilterPostOptionalIdDocument
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityUserDataFilters(workspaceId, jsonApiUserDataFilterPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityUserDataFilters(workspaceId, jsonApiUserDataFilterPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Visualization Objects
         * @param {string} workspaceId
         * @param {JsonApiVisualizationObjectPostOptionalIdDocument} jsonApiVisualizationObjectPostOptionalIdDocument
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityVisualizationObjects(workspaceId, jsonApiVisualizationObjectPostOptionalIdDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityVisualizationObjects(workspaceId, jsonApiVisualizationObjectPostOptionalIdDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaceDataFilterSettings(workspaceId, jsonApiWorkspaceDataFilterSettingInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaceDataFilterSettings(workspaceId, jsonApiWorkspaceDataFilterSettingInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Workspace Data Filters
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaceDataFilters(workspaceId, jsonApiWorkspaceDataFilterInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaceDataFilters(workspaceId, jsonApiWorkspaceDataFilterInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Settings for Workspaces
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceSettingPostOptionalIdDocument} jsonApiWorkspaceSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaceSettings(workspaceId, jsonApiWorkspaceSettingPostOptionalIdDocument, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaceSettings(workspaceId, jsonApiWorkspaceSettingPostOptionalIdDocument, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAnalyticalDashboards(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAnalyticalDashboards(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAttributeHierarchies(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAttributeHierarchies(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAutomations(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAutomations(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityCustomApplicationSettings(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityCustomApplicationSettings(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityDashboardPlugins(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityDashboardPlugins(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityExportDefinitions(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityExportDefinitions(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityFilterContexts(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityFilterContexts(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityFilterViews(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityFilterViews(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityMetrics(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityMetrics(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityUserDataFilters(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityUserDataFilters(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityVisualizationObjects(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityVisualizationObjects(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaceDataFilters(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaceDataFilters(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaceSettings(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaceSettings(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Dashboards
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAnalyticalDashboards(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAnalyticalDashboards(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Attribute Hierarchies
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAttributeHierarchies(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAttributeHierarchies(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Attributes
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAttributes(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAttributes(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Automations
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesAutomations(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesAutomations(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Custom Application Settings
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesCustomApplicationSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesCustomApplicationSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Plugins
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDashboardPlugins(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDashboardPlugins(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Datasets
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesDatasets(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesDatasets(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Export Definitions
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesExportDefinitions(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesExportDefinitions(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Facts
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFacts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFacts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Context Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFilterContexts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFilterContexts(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Filter views
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFilterViews(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFilterViews(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Labels
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesLabels(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesLabels(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Metrics
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesMetrics(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesMetrics(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all User Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesUserDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesUserDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Visualization Objects
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesVisualizationObjects(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesVisualizationObjects(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Settings for Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaceDataFilterSettings(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaceDataFilterSettings(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Workspace Data Filters
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaceDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaceDataFilters(workspaceId, origin, filter, include, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Setting for Workspaces
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaceSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaceSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'permissions' | 'origin' | 'accessInfo' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAnalyticalDashboards(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAnalyticalDashboards(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAttributeHierarchies(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAttributeHierarchies(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Attribute
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'labels' | 'attributeHierarchies' | 'dataset' | 'defaultView' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAttributes(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAttributes(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAutomations(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAutomations(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCustomApplicationSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCustomApplicationSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDashboardPlugins(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDashboardPlugins(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Dataset
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'facts' | 'datasets' | 'workspaceDataFilters' | 'references' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityDatasets(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityDatasets(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityExportDefinitions(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityExportDefinitions(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Fact
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'datasets' | 'dataset' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityFacts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityFacts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityFilterContexts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityFilterContexts(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityFilterViews(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityFilterViews(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Label
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'attribute' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityLabels(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityLabels(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityMetrics(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityMetrics(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityUserDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityUserDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityVisualizationObjects(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityVisualizationObjects(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Setting for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaceDataFilterSettings(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaceDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaceDataFilters(workspaceId, objectId, filter, include, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaceSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaceSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Dashboard
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardPatchDocument} jsonApiAnalyticalDashboardPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyPatchDocument} jsonApiAttributeHierarchyPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationPatchDocument} jsonApiAutomationPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityAutomations(workspaceId, objectId, jsonApiAutomationPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityAutomations(workspaceId, objectId, jsonApiAutomationPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingPatchDocument} jsonApiCustomApplicationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginPatchDocument} jsonApiDashboardPluginPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionPatchDocument} jsonApiExportDefinitionPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextPatchDocument} jsonApiFilterContextPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch Filter view
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewPatchDocument} jsonApiFilterViewPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityFilterViews(workspaceId, objectId, jsonApiFilterViewPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityFilterViews(workspaceId, objectId, jsonApiFilterViewPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricPatchDocument} jsonApiMetricPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityMetrics(workspaceId, objectId, jsonApiMetricPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityMetrics(workspaceId, objectId, jsonApiMetricPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterPatchDocument} jsonApiUserDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectPatchDocument} jsonApiVisualizationObjectPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingPatchDocument} jsonApiWorkspaceDataFilterSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterPatchDocument} jsonApiWorkspaceDataFilterPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterPatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterPatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingPatchDocument} jsonApiWorkspaceSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Dashboards
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAnalyticalDashboardInDocument} jsonApiAnalyticalDashboardInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'visualizationObjects' | 'analyticalDashboards' | 'labels' | 'metrics' | 'datasets' | 'filterContexts' | 'dashboardPlugins' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAnalyticalDashboards(workspaceId, objectId, jsonApiAnalyticalDashboardInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put an Attribute Hierarchy
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAttributeHierarchyInDocument} jsonApiAttributeHierarchyInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'attributes' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAttributeHierarchies(workspaceId, objectId, jsonApiAttributeHierarchyInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put an Automation
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiAutomationInDocument} jsonApiAutomationInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'notificationChannels' | 'analyticalDashboards' | 'userIdentifiers' | 'exportDefinitions' | 'users' | 'notificationChannel' | 'analyticalDashboard' | 'createdBy' | 'modifiedBy' | 'recipients' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAutomations(workspaceId, objectId, jsonApiAutomationInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAutomations(workspaceId, objectId, jsonApiAutomationInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingInDocument} jsonApiCustomApplicationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Plugin
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiDashboardPluginInDocument} jsonApiDashboardPluginInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityDashboardPlugins(workspaceId, objectId, jsonApiDashboardPluginInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put an Export Definition
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiExportDefinitionInDocument} jsonApiExportDefinitionInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'visualizationObjects' | 'analyticalDashboards' | 'automations' | 'userIdentifiers' | 'visualizationObject' | 'analyticalDashboard' | 'automation' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityExportDefinitions(workspaceId, objectId, jsonApiExportDefinitionInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Context Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterContextInDocument} jsonApiFilterContextInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'attributes' | 'datasets' | 'labels' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityFilterContexts(workspaceId, objectId, jsonApiFilterContextInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put Filter views
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiFilterViewInDocument} jsonApiFilterViewInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'analyticalDashboards' | 'users' | 'analyticalDashboard' | 'user' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityFilterViews(workspaceId, objectId, jsonApiFilterViewInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityFilterViews(workspaceId, objectId, jsonApiFilterViewInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Metric
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiMetricInDocument} jsonApiMetricInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityMetrics(workspaceId, objectId, jsonApiMetricInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityMetrics(workspaceId, objectId, jsonApiMetricInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a User Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiUserDataFilterInDocument} jsonApiUserDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'users' | 'userGroups' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'user' | 'userGroup' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityUserDataFilters(workspaceId, objectId, jsonApiUserDataFilterInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Visualization Object
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiVisualizationObjectInDocument} jsonApiVisualizationObjectInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'userIdentifiers' | 'facts' | 'attributes' | 'labels' | 'metrics' | 'datasets' | 'createdBy' | 'modifiedBy' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityVisualizationObjects(workspaceId, objectId, jsonApiVisualizationObjectInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Settings for Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterSettingInDocument} jsonApiWorkspaceDataFilterSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilters' | 'workspaceDataFilter' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaceDataFilterSettings(workspaceId, objectId, jsonApiWorkspaceDataFilterSettingInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Workspace Data Filter
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceDataFilterInDocument} jsonApiWorkspaceDataFilterInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaceDataFilterSettings' | 'filterSettings' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaceDataFilters(workspaceId, objectId, jsonApiWorkspaceDataFilterInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Setting for a Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingInDocument} jsonApiWorkspaceSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * WorkspaceObjectControllerApi - factory interface
 * @export
 */
export const WorkspaceObjectControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkspaceObjectControllerApiFp(configuration);
    return {
        /**
         *
         * @summary Post Dashboards
         * @param {WorkspaceObjectControllerApiCreateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .createEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.jsonApiAnalyticalDashboardPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Attribute Hierarchies
         * @param {WorkspaceObjectControllerApiCreateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .createEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Automations
         * @param {WorkspaceObjectControllerApiCreateEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityAutomations(requestParameters, options) {
            return localVarFp
                .createEntityAutomations(requestParameters.workspaceId, requestParameters.jsonApiAutomationInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Custom Application Settings
         * @param {WorkspaceObjectControllerApiCreateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .createEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.jsonApiCustomApplicationSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Plugins
         * @param {WorkspaceObjectControllerApiCreateEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .createEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.jsonApiDashboardPluginPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Export Definitions
         * @param {WorkspaceObjectControllerApiCreateEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .createEntityExportDefinitions(requestParameters.workspaceId, requestParameters.jsonApiExportDefinitionPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Context Filters
         * @param {WorkspaceObjectControllerApiCreateEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .createEntityFilterContexts(requestParameters.workspaceId, requestParameters.jsonApiFilterContextPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Filter views
         * @param {WorkspaceObjectControllerApiCreateEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityFilterViews(requestParameters, options) {
            return localVarFp
                .createEntityFilterViews(requestParameters.workspaceId, requestParameters.jsonApiFilterViewInDocument, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Metrics
         * @param {WorkspaceObjectControllerApiCreateEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityMetrics(requestParameters, options) {
            return localVarFp
                .createEntityMetrics(requestParameters.workspaceId, requestParameters.jsonApiMetricPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post User Data Filters
         * @param {WorkspaceObjectControllerApiCreateEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .createEntityUserDataFilters(requestParameters.workspaceId, requestParameters.jsonApiUserDataFilterPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Visualization Objects
         * @param {WorkspaceObjectControllerApiCreateEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .createEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.jsonApiVisualizationObjectPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Settings for Workspace Data Filters
         * @param {WorkspaceObjectControllerApiCreateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Workspace Data Filters
         * @param {WorkspaceObjectControllerApiCreateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Settings for Workspaces
         * @param {WorkspaceObjectControllerApiCreateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Dashboard
         * @param {WorkspaceObjectControllerApiDeleteEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .deleteEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Attribute Hierarchy
         * @param {WorkspaceObjectControllerApiDeleteEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .deleteEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Automation
         * @param {WorkspaceObjectControllerApiDeleteEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAutomations(requestParameters, options) {
            return localVarFp
                .deleteEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Custom Application Setting
         * @param {WorkspaceObjectControllerApiDeleteEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Plugin
         * @param {WorkspaceObjectControllerApiDeleteEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .deleteEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Export Definition
         * @param {WorkspaceObjectControllerApiDeleteEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .deleteEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Context Filter
         * @param {WorkspaceObjectControllerApiDeleteEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .deleteEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Filter view
         * @param {WorkspaceObjectControllerApiDeleteEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityFilterViews(requestParameters, options) {
            return localVarFp
                .deleteEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Metric
         * @param {WorkspaceObjectControllerApiDeleteEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityMetrics(requestParameters, options) {
            return localVarFp
                .deleteEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a User Data Filter
         * @param {WorkspaceObjectControllerApiDeleteEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .deleteEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Visualization Object
         * @param {WorkspaceObjectControllerApiDeleteEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .deleteEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Settings for Workspace Data Filter
         * @param {WorkspaceObjectControllerApiDeleteEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Workspace Data Filter
         * @param {WorkspaceObjectControllerApiDeleteEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Setting for Workspace
         * @param {WorkspaceObjectControllerApiDeleteEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Dashboards
         * @param {WorkspaceObjectControllerApiGetAllEntitiesAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAnalyticalDashboards(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Attribute Hierarchies
         * @param {WorkspaceObjectControllerApiGetAllEntitiesAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAttributeHierarchies(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Attributes
         * @param {WorkspaceObjectControllerApiGetAllEntitiesAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAttributes(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAttributes(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Automations
         * @param {WorkspaceObjectControllerApiGetAllEntitiesAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesAutomations(requestParameters, options) {
            return localVarFp
                .getAllEntitiesAutomations(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Custom Application Settings
         * @param {WorkspaceObjectControllerApiGetAllEntitiesCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesCustomApplicationSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Plugins
         * @param {WorkspaceObjectControllerApiGetAllEntitiesDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDashboardPlugins(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDashboardPlugins(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Datasets
         * @param {WorkspaceObjectControllerApiGetAllEntitiesDatasetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesDatasets(requestParameters, options) {
            return localVarFp
                .getAllEntitiesDatasets(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Export Definitions
         * @param {WorkspaceObjectControllerApiGetAllEntitiesExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesExportDefinitions(requestParameters, options) {
            return localVarFp
                .getAllEntitiesExportDefinitions(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Facts
         * @param {WorkspaceObjectControllerApiGetAllEntitiesFactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFacts(requestParameters, options) {
            return localVarFp
                .getAllEntitiesFacts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Context Filters
         * @param {WorkspaceObjectControllerApiGetAllEntitiesFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterContexts(requestParameters, options) {
            return localVarFp
                .getAllEntitiesFilterContexts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Filter views
         * @param {WorkspaceObjectControllerApiGetAllEntitiesFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFilterViews(requestParameters, options) {
            return localVarFp
                .getAllEntitiesFilterViews(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Labels
         * @param {WorkspaceObjectControllerApiGetAllEntitiesLabelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesLabels(requestParameters, options) {
            return localVarFp
                .getAllEntitiesLabels(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Metrics
         * @param {WorkspaceObjectControllerApiGetAllEntitiesMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesMetrics(requestParameters, options) {
            return localVarFp
                .getAllEntitiesMetrics(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all User Data Filters
         * @param {WorkspaceObjectControllerApiGetAllEntitiesUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesUserDataFilters(requestParameters, options) {
            return localVarFp
                .getAllEntitiesUserDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Visualization Objects
         * @param {WorkspaceObjectControllerApiGetAllEntitiesVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesVisualizationObjects(requestParameters, options) {
            return localVarFp
                .getAllEntitiesVisualizationObjects(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Settings for Workspace Data Filters
         * @param {WorkspaceObjectControllerApiGetAllEntitiesWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Workspace Data Filters
         * @param {WorkspaceObjectControllerApiGetAllEntitiesWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Setting for Workspaces
         * @param {WorkspaceObjectControllerApiGetAllEntitiesWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaceSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Dashboard
         * @param {WorkspaceObjectControllerApiGetEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .getEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Attribute Hierarchy
         * @param {WorkspaceObjectControllerApiGetEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .getEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Attribute
         * @param {WorkspaceObjectControllerApiGetEntityAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttributes(requestParameters, options) {
            return localVarFp
                .getEntityAttributes(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Automation
         * @param {WorkspaceObjectControllerApiGetEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAutomations(requestParameters, options) {
            return localVarFp
                .getEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Custom Application Setting
         * @param {WorkspaceObjectControllerApiGetEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .getEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Plugin
         * @param {WorkspaceObjectControllerApiGetEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .getEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Dataset
         * @param {WorkspaceObjectControllerApiGetEntityDatasetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityDatasets(requestParameters, options) {
            return localVarFp
                .getEntityDatasets(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an Export Definition
         * @param {WorkspaceObjectControllerApiGetEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .getEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Fact
         * @param {WorkspaceObjectControllerApiGetEntityFactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFacts(requestParameters, options) {
            return localVarFp
                .getEntityFacts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Context Filter
         * @param {WorkspaceObjectControllerApiGetEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .getEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Filter view
         * @param {WorkspaceObjectControllerApiGetEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityFilterViews(requestParameters, options) {
            return localVarFp
                .getEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Label
         * @param {WorkspaceObjectControllerApiGetEntityLabelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLabels(requestParameters, options) {
            return localVarFp
                .getEntityLabels(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Metric
         * @param {WorkspaceObjectControllerApiGetEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityMetrics(requestParameters, options) {
            return localVarFp
                .getEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a User Data Filter
         * @param {WorkspaceObjectControllerApiGetEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .getEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Visualization Object
         * @param {WorkspaceObjectControllerApiGetEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .getEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Setting for Workspace Data Filter
         * @param {WorkspaceObjectControllerApiGetEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Workspace Data Filter
         * @param {WorkspaceObjectControllerApiGetEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Setting for Workspace
         * @param {WorkspaceObjectControllerApiGetEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Dashboard
         * @param {WorkspaceObjectControllerApiPatchEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .patchEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an Attribute Hierarchy
         * @param {WorkspaceObjectControllerApiPatchEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .patchEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an Automation
         * @param {WorkspaceObjectControllerApiPatchEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityAutomations(requestParameters, options) {
            return localVarFp
                .patchEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Custom Application Setting
         * @param {WorkspaceObjectControllerApiPatchEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .patchEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Plugin
         * @param {WorkspaceObjectControllerApiPatchEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .patchEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an Export Definition
         * @param {WorkspaceObjectControllerApiPatchEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .patchEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Context Filter
         * @param {WorkspaceObjectControllerApiPatchEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .patchEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Filter view
         * @param {WorkspaceObjectControllerApiPatchEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityFilterViews(requestParameters, options) {
            return localVarFp
                .patchEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Metric
         * @param {WorkspaceObjectControllerApiPatchEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityMetrics(requestParameters, options) {
            return localVarFp
                .patchEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a User Data Filter
         * @param {WorkspaceObjectControllerApiPatchEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .patchEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Visualization Object
         * @param {WorkspaceObjectControllerApiPatchEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .patchEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Settings for Workspace Data Filter
         * @param {WorkspaceObjectControllerApiPatchEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Workspace Data Filter
         * @param {WorkspaceObjectControllerApiPatchEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Setting for Workspace
         * @param {WorkspaceObjectControllerApiPatchEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Dashboards
         * @param {WorkspaceObjectControllerApiUpdateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAnalyticalDashboards(requestParameters, options) {
            return localVarFp
                .updateEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put an Attribute Hierarchy
         * @param {WorkspaceObjectControllerApiUpdateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAttributeHierarchies(requestParameters, options) {
            return localVarFp
                .updateEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put an Automation
         * @param {WorkspaceObjectControllerApiUpdateEntityAutomationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAutomations(requestParameters, options) {
            return localVarFp
                .updateEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Custom Application Setting
         * @param {WorkspaceObjectControllerApiUpdateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .updateEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Plugin
         * @param {WorkspaceObjectControllerApiUpdateEntityDashboardPluginsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityDashboardPlugins(requestParameters, options) {
            return localVarFp
                .updateEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put an Export Definition
         * @param {WorkspaceObjectControllerApiUpdateEntityExportDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityExportDefinitions(requestParameters, options) {
            return localVarFp
                .updateEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Context Filter
         * @param {WorkspaceObjectControllerApiUpdateEntityFilterContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterContexts(requestParameters, options) {
            return localVarFp
                .updateEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put Filter views
         * @param {WorkspaceObjectControllerApiUpdateEntityFilterViewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityFilterViews(requestParameters, options) {
            return localVarFp
                .updateEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Metric
         * @param {WorkspaceObjectControllerApiUpdateEntityMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityMetrics(requestParameters, options) {
            return localVarFp
                .updateEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a User Data Filter
         * @param {WorkspaceObjectControllerApiUpdateEntityUserDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityUserDataFilters(requestParameters, options) {
            return localVarFp
                .updateEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Visualization Object
         * @param {WorkspaceObjectControllerApiUpdateEntityVisualizationObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityVisualizationObjects(requestParameters, options) {
            return localVarFp
                .updateEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Settings for Workspace Data Filter
         * @param {WorkspaceObjectControllerApiUpdateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilterSettings(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Workspace Data Filter
         * @param {WorkspaceObjectControllerApiUpdateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceDataFilters(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Setting for a Workspace
         * @param {WorkspaceObjectControllerApiUpdateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkspaceObjectControllerApi - object-oriented interface
 * @export
 * @class WorkspaceObjectControllerApi
 * @extends {BaseAPI}
 */
export class WorkspaceObjectControllerApi extends BaseAPI {
    /**
     *
     * @summary Post Dashboards
     * @param {WorkspaceObjectControllerApiCreateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityAnalyticalDashboards(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.jsonApiAnalyticalDashboardPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Attribute Hierarchies
     * @param {WorkspaceObjectControllerApiCreateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityAttributeHierarchies(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Automations
     * @param {WorkspaceObjectControllerApiCreateEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityAutomations(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityAutomations(requestParameters.workspaceId, requestParameters.jsonApiAutomationInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Custom Application Settings
     * @param {WorkspaceObjectControllerApiCreateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.jsonApiCustomApplicationSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Plugins
     * @param {WorkspaceObjectControllerApiCreateEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityDashboardPlugins(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.jsonApiDashboardPluginPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Export Definitions
     * @param {WorkspaceObjectControllerApiCreateEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityExportDefinitions(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityExportDefinitions(requestParameters.workspaceId, requestParameters.jsonApiExportDefinitionPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Context Filters
     * @param {WorkspaceObjectControllerApiCreateEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityFilterContexts(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityFilterContexts(requestParameters.workspaceId, requestParameters.jsonApiFilterContextPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Filter views
     * @param {WorkspaceObjectControllerApiCreateEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityFilterViews(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityFilterViews(requestParameters.workspaceId, requestParameters.jsonApiFilterViewInDocument, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Metrics
     * @param {WorkspaceObjectControllerApiCreateEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityMetrics(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityMetrics(requestParameters.workspaceId, requestParameters.jsonApiMetricPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post User Data Filters
     * @param {WorkspaceObjectControllerApiCreateEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityUserDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityUserDataFilters(requestParameters.workspaceId, requestParameters.jsonApiUserDataFilterPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Visualization Objects
     * @param {WorkspaceObjectControllerApiCreateEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityVisualizationObjects(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.jsonApiVisualizationObjectPostOptionalIdDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Settings for Workspace Data Filters
     * @param {WorkspaceObjectControllerApiCreateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Workspace Data Filters
     * @param {WorkspaceObjectControllerApiCreateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityWorkspaceDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Settings for Workspaces
     * @param {WorkspaceObjectControllerApiCreateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    createEntityWorkspaceSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .createEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Dashboard
     * @param {WorkspaceObjectControllerApiDeleteEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityAnalyticalDashboards(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Attribute Hierarchy
     * @param {WorkspaceObjectControllerApiDeleteEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityAttributeHierarchies(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Automation
     * @param {WorkspaceObjectControllerApiDeleteEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityAutomations(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Custom Application Setting
     * @param {WorkspaceObjectControllerApiDeleteEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Plugin
     * @param {WorkspaceObjectControllerApiDeleteEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityDashboardPlugins(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Export Definition
     * @param {WorkspaceObjectControllerApiDeleteEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityExportDefinitions(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Context Filter
     * @param {WorkspaceObjectControllerApiDeleteEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityFilterContexts(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Filter view
     * @param {WorkspaceObjectControllerApiDeleteEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityFilterViews(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Metric
     * @param {WorkspaceObjectControllerApiDeleteEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityMetrics(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a User Data Filter
     * @param {WorkspaceObjectControllerApiDeleteEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityUserDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Visualization Object
     * @param {WorkspaceObjectControllerApiDeleteEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityVisualizationObjects(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Settings for Workspace Data Filter
     * @param {WorkspaceObjectControllerApiDeleteEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Workspace Data Filter
     * @param {WorkspaceObjectControllerApiDeleteEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityWorkspaceDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Setting for Workspace
     * @param {WorkspaceObjectControllerApiDeleteEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    deleteEntityWorkspaceSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .deleteEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Dashboards
     * @param {WorkspaceObjectControllerApiGetAllEntitiesAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesAnalyticalDashboards(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesAnalyticalDashboards(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Attribute Hierarchies
     * @param {WorkspaceObjectControllerApiGetAllEntitiesAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesAttributeHierarchies(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesAttributeHierarchies(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Attributes
     * @param {WorkspaceObjectControllerApiGetAllEntitiesAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesAttributes(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesAttributes(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Automations
     * @param {WorkspaceObjectControllerApiGetAllEntitiesAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesAutomations(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesAutomations(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Custom Application Settings
     * @param {WorkspaceObjectControllerApiGetAllEntitiesCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesCustomApplicationSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesCustomApplicationSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Plugins
     * @param {WorkspaceObjectControllerApiGetAllEntitiesDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesDashboardPlugins(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesDashboardPlugins(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Datasets
     * @param {WorkspaceObjectControllerApiGetAllEntitiesDatasetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesDatasets(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesDatasets(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Export Definitions
     * @param {WorkspaceObjectControllerApiGetAllEntitiesExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesExportDefinitions(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesExportDefinitions(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Facts
     * @param {WorkspaceObjectControllerApiGetAllEntitiesFactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesFacts(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesFacts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Context Filters
     * @param {WorkspaceObjectControllerApiGetAllEntitiesFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesFilterContexts(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesFilterContexts(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Filter views
     * @param {WorkspaceObjectControllerApiGetAllEntitiesFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesFilterViews(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesFilterViews(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Labels
     * @param {WorkspaceObjectControllerApiGetAllEntitiesLabelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesLabels(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesLabels(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Metrics
     * @param {WorkspaceObjectControllerApiGetAllEntitiesMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesMetrics(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesMetrics(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all User Data Filters
     * @param {WorkspaceObjectControllerApiGetAllEntitiesUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesUserDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesUserDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Visualization Objects
     * @param {WorkspaceObjectControllerApiGetAllEntitiesVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesVisualizationObjects(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesVisualizationObjects(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Settings for Workspace Data Filters
     * @param {WorkspaceObjectControllerApiGetAllEntitiesWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesWorkspaceDataFilterSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Workspace Data Filters
     * @param {WorkspaceObjectControllerApiGetAllEntitiesWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesWorkspaceDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Setting for Workspaces
     * @param {WorkspaceObjectControllerApiGetAllEntitiesWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getAllEntitiesWorkspaceSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getAllEntitiesWorkspaceSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Dashboard
     * @param {WorkspaceObjectControllerApiGetEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityAnalyticalDashboards(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Attribute Hierarchy
     * @param {WorkspaceObjectControllerApiGetEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityAttributeHierarchies(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Attribute
     * @param {WorkspaceObjectControllerApiGetEntityAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityAttributes(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityAttributes(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Automation
     * @param {WorkspaceObjectControllerApiGetEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityAutomations(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Custom Application Setting
     * @param {WorkspaceObjectControllerApiGetEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Plugin
     * @param {WorkspaceObjectControllerApiGetEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityDashboardPlugins(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Dataset
     * @param {WorkspaceObjectControllerApiGetEntityDatasetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityDatasets(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityDatasets(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an Export Definition
     * @param {WorkspaceObjectControllerApiGetEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityExportDefinitions(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Fact
     * @param {WorkspaceObjectControllerApiGetEntityFactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityFacts(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityFacts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Context Filter
     * @param {WorkspaceObjectControllerApiGetEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityFilterContexts(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Filter view
     * @param {WorkspaceObjectControllerApiGetEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityFilterViews(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Label
     * @param {WorkspaceObjectControllerApiGetEntityLabelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityLabels(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityLabels(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Metric
     * @param {WorkspaceObjectControllerApiGetEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityMetrics(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a User Data Filter
     * @param {WorkspaceObjectControllerApiGetEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityUserDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Visualization Object
     * @param {WorkspaceObjectControllerApiGetEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityVisualizationObjects(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Setting for Workspace Data Filter
     * @param {WorkspaceObjectControllerApiGetEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Workspace Data Filter
     * @param {WorkspaceObjectControllerApiGetEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityWorkspaceDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.include, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Setting for Workspace
     * @param {WorkspaceObjectControllerApiGetEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    getEntityWorkspaceSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .getEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Dashboard
     * @param {WorkspaceObjectControllerApiPatchEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityAnalyticalDashboards(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an Attribute Hierarchy
     * @param {WorkspaceObjectControllerApiPatchEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityAttributeHierarchies(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an Automation
     * @param {WorkspaceObjectControllerApiPatchEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityAutomations(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Custom Application Setting
     * @param {WorkspaceObjectControllerApiPatchEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Plugin
     * @param {WorkspaceObjectControllerApiPatchEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityDashboardPlugins(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an Export Definition
     * @param {WorkspaceObjectControllerApiPatchEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityExportDefinitions(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Context Filter
     * @param {WorkspaceObjectControllerApiPatchEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityFilterContexts(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch Filter view
     * @param {WorkspaceObjectControllerApiPatchEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityFilterViews(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Metric
     * @param {WorkspaceObjectControllerApiPatchEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityMetrics(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a User Data Filter
     * @param {WorkspaceObjectControllerApiPatchEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityUserDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Visualization Object
     * @param {WorkspaceObjectControllerApiPatchEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityVisualizationObjects(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Settings for Workspace Data Filter
     * @param {WorkspaceObjectControllerApiPatchEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Workspace Data Filter
     * @param {WorkspaceObjectControllerApiPatchEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityWorkspaceDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterPatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Setting for Workspace
     * @param {WorkspaceObjectControllerApiPatchEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    patchEntityWorkspaceSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .patchEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Dashboards
     * @param {WorkspaceObjectControllerApiUpdateEntityAnalyticalDashboardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityAnalyticalDashboards(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityAnalyticalDashboards(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAnalyticalDashboardInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put an Attribute Hierarchy
     * @param {WorkspaceObjectControllerApiUpdateEntityAttributeHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityAttributeHierarchies(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityAttributeHierarchies(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAttributeHierarchyInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put an Automation
     * @param {WorkspaceObjectControllerApiUpdateEntityAutomationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityAutomations(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityAutomations(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiAutomationInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Custom Application Setting
     * @param {WorkspaceObjectControllerApiUpdateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Plugin
     * @param {WorkspaceObjectControllerApiUpdateEntityDashboardPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityDashboardPlugins(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityDashboardPlugins(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiDashboardPluginInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put an Export Definition
     * @param {WorkspaceObjectControllerApiUpdateEntityExportDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityExportDefinitions(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityExportDefinitions(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiExportDefinitionInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Context Filter
     * @param {WorkspaceObjectControllerApiUpdateEntityFilterContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityFilterContexts(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityFilterContexts(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterContextInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put Filter views
     * @param {WorkspaceObjectControllerApiUpdateEntityFilterViewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityFilterViews(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityFilterViews(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiFilterViewInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Metric
     * @param {WorkspaceObjectControllerApiUpdateEntityMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityMetrics(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityMetrics(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiMetricInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a User Data Filter
     * @param {WorkspaceObjectControllerApiUpdateEntityUserDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityUserDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityUserDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiUserDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Visualization Object
     * @param {WorkspaceObjectControllerApiUpdateEntityVisualizationObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityVisualizationObjects(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityVisualizationObjects(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiVisualizationObjectInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Settings for Workspace Data Filter
     * @param {WorkspaceObjectControllerApiUpdateEntityWorkspaceDataFilterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityWorkspaceDataFilterSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityWorkspaceDataFilterSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterSettingInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Workspace Data Filter
     * @param {WorkspaceObjectControllerApiUpdateEntityWorkspaceDataFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityWorkspaceDataFilters(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityWorkspaceDataFilters(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceDataFilterInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Setting for a Workspace
     * @param {WorkspaceObjectControllerApiUpdateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceObjectControllerApi
     */
    updateEntityWorkspaceSettings(requestParameters, options) {
        return WorkspaceObjectControllerApiFp(this.configuration)
            .updateEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkspacesDeclarativeAPIsApi - axios parameter creator
 * @export
 */
export const WorkspacesDeclarativeAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve current model of the workspace in declarative form.
         * @summary Get workspace layout
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceLayout: async (workspaceId, exclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getWorkspaceLayout", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets complete layout of workspaces, their hierarchy, models.
         * @summary Get all workspaces layout
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesLayout: async (exclude, options = {}) => {
            const localVarPath = `/api/v1/layout/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (exclude) {
                localVarQueryParameter["exclude"] = exclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set complete layout of workspace, like model, authorization, etc.
         * @summary Set workspace layout
         * @param {string} workspaceId
         * @param {DeclarativeWorkspaceModel} declarativeWorkspaceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWorkspaceLayout: async (workspaceId, declarativeWorkspaceModel, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("putWorkspaceLayout", "workspaceId", workspaceId);
            // verify required parameter 'declarativeWorkspaceModel' is not null or undefined
            assertParamExists("putWorkspaceLayout", "declarativeWorkspaceModel", declarativeWorkspaceModel);
            const localVarPath = `/api/v1/layout/workspaces/{workspaceId}`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeWorkspaceModel !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeWorkspaceModel !== undefined ? declarativeWorkspaceModel : {})
                : declarativeWorkspaceModel || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets complete layout of workspaces, their hierarchy, models.
         * @summary Set all workspaces layout
         * @param {DeclarativeWorkspaces} declarativeWorkspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspacesLayout: async (declarativeWorkspaces, options = {}) => {
            // verify required parameter 'declarativeWorkspaces' is not null or undefined
            assertParamExists("setWorkspacesLayout", "declarativeWorkspaces", declarativeWorkspaces);
            const localVarPath = `/api/v1/layout/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof declarativeWorkspaces !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(declarativeWorkspaces !== undefined ? declarativeWorkspaces : {})
                : declarativeWorkspaces || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WorkspacesDeclarativeAPIsApi - functional programming interface
 * @export
 */
export const WorkspacesDeclarativeAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkspacesDeclarativeAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve current model of the workspace in declarative form.
         * @summary Get workspace layout
         * @param {string} workspaceId
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceLayout(workspaceId, exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceLayout(workspaceId, exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets complete layout of workspaces, their hierarchy, models.
         * @summary Get all workspaces layout
         * @param {Array<'ACTIVITY_INFO'>} [exclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspacesLayout(exclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspacesLayout(exclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set complete layout of workspace, like model, authorization, etc.
         * @summary Set workspace layout
         * @param {string} workspaceId
         * @param {DeclarativeWorkspaceModel} declarativeWorkspaceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putWorkspaceLayout(workspaceId, declarativeWorkspaceModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putWorkspaceLayout(workspaceId, declarativeWorkspaceModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets complete layout of workspaces, their hierarchy, models.
         * @summary Set all workspaces layout
         * @param {DeclarativeWorkspaces} declarativeWorkspaces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWorkspacesLayout(declarativeWorkspaces, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWorkspacesLayout(declarativeWorkspaces, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * WorkspacesDeclarativeAPIsApi - factory interface
 * @export
 */
export const WorkspacesDeclarativeAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkspacesDeclarativeAPIsApiFp(configuration);
    return {
        /**
         * Retrieve current model of the workspace in declarative form.
         * @summary Get workspace layout
         * @param {WorkspacesDeclarativeAPIsApiGetWorkspaceLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceLayout(requestParameters, options) {
            return localVarFp
                .getWorkspaceLayout(requestParameters.workspaceId, requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Gets complete layout of workspaces, their hierarchy, models.
         * @summary Get all workspaces layout
         * @param {WorkspacesDeclarativeAPIsApiGetWorkspacesLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesLayout(requestParameters, options) {
            return localVarFp
                .getWorkspacesLayout(requestParameters.exclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Set complete layout of workspace, like model, authorization, etc.
         * @summary Set workspace layout
         * @param {WorkspacesDeclarativeAPIsApiPutWorkspaceLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWorkspaceLayout(requestParameters, options) {
            return localVarFp
                .putWorkspaceLayout(requestParameters.workspaceId, requestParameters.declarativeWorkspaceModel, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Sets complete layout of workspaces, their hierarchy, models.
         * @summary Set all workspaces layout
         * @param {WorkspacesDeclarativeAPIsApiSetWorkspacesLayoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWorkspacesLayout(requestParameters, options) {
            return localVarFp
                .setWorkspacesLayout(requestParameters.declarativeWorkspaces, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkspacesDeclarativeAPIsApi - object-oriented interface
 * @export
 * @class WorkspacesDeclarativeAPIsApi
 * @extends {BaseAPI}
 */
export class WorkspacesDeclarativeAPIsApi extends BaseAPI {
    /**
     * Retrieve current model of the workspace in declarative form.
     * @summary Get workspace layout
     * @param {WorkspacesDeclarativeAPIsApiGetWorkspaceLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesDeclarativeAPIsApi
     */
    getWorkspaceLayout(requestParameters, options) {
        return WorkspacesDeclarativeAPIsApiFp(this.configuration)
            .getWorkspaceLayout(requestParameters.workspaceId, requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets complete layout of workspaces, their hierarchy, models.
     * @summary Get all workspaces layout
     * @param {WorkspacesDeclarativeAPIsApiGetWorkspacesLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesDeclarativeAPIsApi
     */
    getWorkspacesLayout(requestParameters = {}, options) {
        return WorkspacesDeclarativeAPIsApiFp(this.configuration)
            .getWorkspacesLayout(requestParameters.exclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set complete layout of workspace, like model, authorization, etc.
     * @summary Set workspace layout
     * @param {WorkspacesDeclarativeAPIsApiPutWorkspaceLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesDeclarativeAPIsApi
     */
    putWorkspaceLayout(requestParameters, options) {
        return WorkspacesDeclarativeAPIsApiFp(this.configuration)
            .putWorkspaceLayout(requestParameters.workspaceId, requestParameters.declarativeWorkspaceModel, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets complete layout of workspaces, their hierarchy, models.
     * @summary Set all workspaces layout
     * @param {WorkspacesDeclarativeAPIsApiSetWorkspacesLayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesDeclarativeAPIsApi
     */
    setWorkspacesLayout(requestParameters, options) {
        return WorkspacesDeclarativeAPIsApiFp(this.configuration)
            .setWorkspacesLayout(requestParameters.declarativeWorkspaces, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkspacesEntityAPIsApi - axios parameter creator
 * @export
 */
export const WorkspacesEntityAPIsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Space of the shared interest
         * @summary Post Workspace entities
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaces: async (jsonApiWorkspaceInDocument, include, metaInclude, options = {}) => {
            // verify required parameter 'jsonApiWorkspaceInDocument' is not null or undefined
            assertParamExists("createEntityWorkspaces", "jsonApiWorkspaceInDocument", jsonApiWorkspaceInDocument);
            const localVarPath = `/api/v1/entities/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceInDocument !== undefined ? jsonApiWorkspaceInDocument : {})
                : jsonApiWorkspaceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Delete Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaces: async (id, filter, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("deleteEntityWorkspaces", "id", id);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaces: async (filter, include, page, size, sort, metaInclude, options = {}) => {
            const localVarPath = `/api/v1/entities/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaces: async (id, filter, include, metaInclude, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("getEntityWorkspaces", "id", id);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Patch Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspacePatchDocument} jsonApiWorkspacePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaces: async (id, jsonApiWorkspacePatchDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("patchEntityWorkspaces", "id", id);
            // verify required parameter 'jsonApiWorkspacePatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaces", "jsonApiWorkspacePatchDocument", jsonApiWorkspacePatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspacePatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspacePatchDocument !== undefined ? jsonApiWorkspacePatchDocument : {})
                : jsonApiWorkspacePatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Space of the shared interest
         * @summary Put Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaces: async (id, jsonApiWorkspaceInDocument, filter, include, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists("updateEntityWorkspaces", "id", id);
            // verify required parameter 'jsonApiWorkspaceInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaces", "jsonApiWorkspaceInDocument", jsonApiWorkspaceInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (include) {
                localVarQueryParameter["include"] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceInDocument !== undefined ? jsonApiWorkspaceInDocument : {})
                : jsonApiWorkspaceInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WorkspacesEntityAPIsApi - functional programming interface
 * @export
 */
export const WorkspacesEntityAPIsApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkspacesEntityAPIsApiAxiosParamCreator(configuration);
    return {
        /**
         * Space of the shared interest
         * @summary Post Workspace entities
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaces(jsonApiWorkspaceInDocument, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaces(jsonApiWorkspaceInDocument, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Delete Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaces(id, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaces(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entities
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaces(filter, include, page, size, sort, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaces(filter, include, page, size, sort, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entity
         * @param {string} id
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {Array<'config' | 'permissions' | 'hierarchy' | 'dataModelDatasets' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaces(id, filter, include, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaces(id, filter, include, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Patch Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspacePatchDocument} jsonApiWorkspacePatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaces(id, jsonApiWorkspacePatchDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaces(id, jsonApiWorkspacePatchDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Space of the shared interest
         * @summary Put Workspace entity
         * @param {string} id
         * @param {JsonApiWorkspaceInDocument} jsonApiWorkspaceInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {Array<'workspaces' | 'parent' | 'ALL'>} [include] Array of included collections or individual relationships. Includes are separated by commas (e.g. include&#x3D;entity1s,entity2s). Collection include represents the inclusion of every relationship between this entity and the given collection. Relationship include represents the inclusion of the particular relationships only. If single parameter \&quot;ALL\&quot; is present, all possible includes are used (include&#x3D;ALL).  __WARNING:__ Individual include types (collection, relationship or ALL) cannot be combined together.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaces(id, jsonApiWorkspaceInDocument, filter, include, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaces(id, jsonApiWorkspaceInDocument, filter, include, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * WorkspacesEntityAPIsApi - factory interface
 * @export
 */
export const WorkspacesEntityAPIsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkspacesEntityAPIsApiFp(configuration);
    return {
        /**
         * Space of the shared interest
         * @summary Post Workspace entities
         * @param {WorkspacesEntityAPIsApiCreateEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaces(requestParameters.jsonApiWorkspaceInDocument, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Delete Workspace entity
         * @param {WorkspacesEntityAPIsApiDeleteEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaces(requestParameters.id, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entities
         * @param {WorkspacesEntityAPIsApiGetAllEntitiesWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaces(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaces(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Get Workspace entity
         * @param {WorkspacesEntityAPIsApiGetEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaces(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Patch Workspace entity
         * @param {WorkspacesEntityAPIsApiPatchEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspacePatchDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Space of the shared interest
         * @summary Put Workspace entity
         * @param {WorkspacesEntityAPIsApiUpdateEntityWorkspacesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaces(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspaceInDocument, requestParameters.filter, requestParameters.include, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkspacesEntityAPIsApi - object-oriented interface
 * @export
 * @class WorkspacesEntityAPIsApi
 * @extends {BaseAPI}
 */
export class WorkspacesEntityAPIsApi extends BaseAPI {
    /**
     * Space of the shared interest
     * @summary Post Workspace entities
     * @param {WorkspacesEntityAPIsApiCreateEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesEntityAPIsApi
     */
    createEntityWorkspaces(requestParameters, options) {
        return WorkspacesEntityAPIsApiFp(this.configuration)
            .createEntityWorkspaces(requestParameters.jsonApiWorkspaceInDocument, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Delete Workspace entity
     * @param {WorkspacesEntityAPIsApiDeleteEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesEntityAPIsApi
     */
    deleteEntityWorkspaces(requestParameters, options) {
        return WorkspacesEntityAPIsApiFp(this.configuration)
            .deleteEntityWorkspaces(requestParameters.id, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Workspace entities
     * @param {WorkspacesEntityAPIsApiGetAllEntitiesWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesEntityAPIsApi
     */
    getAllEntitiesWorkspaces(requestParameters = {}, options) {
        return WorkspacesEntityAPIsApiFp(this.configuration)
            .getAllEntitiesWorkspaces(requestParameters.filter, requestParameters.include, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Get Workspace entity
     * @param {WorkspacesEntityAPIsApiGetEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesEntityAPIsApi
     */
    getEntityWorkspaces(requestParameters, options) {
        return WorkspacesEntityAPIsApiFp(this.configuration)
            .getEntityWorkspaces(requestParameters.id, requestParameters.filter, requestParameters.include, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Patch Workspace entity
     * @param {WorkspacesEntityAPIsApiPatchEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesEntityAPIsApi
     */
    patchEntityWorkspaces(requestParameters, options) {
        return WorkspacesEntityAPIsApiFp(this.configuration)
            .patchEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspacePatchDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Space of the shared interest
     * @summary Put Workspace entity
     * @param {WorkspacesEntityAPIsApiUpdateEntityWorkspacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesEntityAPIsApi
     */
    updateEntityWorkspaces(requestParameters, options) {
        return WorkspacesEntityAPIsApiFp(this.configuration)
            .updateEntityWorkspaces(requestParameters.id, requestParameters.jsonApiWorkspaceInDocument, requestParameters.filter, requestParameters.include, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkspacesSettingsApi - axios parameter creator
 * @export
 */
export const WorkspacesSettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post Custom Application Settings
         * @param {string} workspaceId
         * @param {JsonApiCustomApplicationSettingPostOptionalIdDocument} jsonApiCustomApplicationSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCustomApplicationSettings: async (workspaceId, jsonApiCustomApplicationSettingPostOptionalIdDocument, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiCustomApplicationSettingPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityCustomApplicationSettings", "jsonApiCustomApplicationSettingPostOptionalIdDocument", jsonApiCustomApplicationSettingPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCustomApplicationSettingPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCustomApplicationSettingPostOptionalIdDocument !== undefined
                    ? jsonApiCustomApplicationSettingPostOptionalIdDocument
                    : {})
                : jsonApiCustomApplicationSettingPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Post Settings for Workspaces
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceSettingPostOptionalIdDocument} jsonApiWorkspaceSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceSettings: async (workspaceId, jsonApiWorkspaceSettingPostOptionalIdDocument, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("createEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'jsonApiWorkspaceSettingPostOptionalIdDocument' is not null or undefined
            assertParamExists("createEntityWorkspaceSettings", "jsonApiWorkspaceSettingPostOptionalIdDocument", jsonApiWorkspaceSettingPostOptionalIdDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceSettingPostOptionalIdDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceSettingPostOptionalIdDocument !== undefined
                    ? jsonApiWorkspaceSettingPostOptionalIdDocument
                    : {})
                : jsonApiWorkspaceSettingPostOptionalIdDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCustomApplicationSettings: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityCustomApplicationSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceSettings: async (workspaceId, objectId, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("deleteEntityWorkspaceSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Custom Application Settings
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCustomApplicationSettings: async (workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesCustomApplicationSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Setting for Workspaces
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceSettings: async (workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getAllEntitiesWorkspaceSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (origin !== undefined) {
                localVarQueryParameter["origin"] = origin;
            }
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (page !== undefined) {
                localVarQueryParameter["page"] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter["size"] = size;
            }
            if (sort) {
                localVarQueryParameter["sort"] = sort;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomApplicationSettings: async (workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityCustomApplicationSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceSettings: async (workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("getEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("getEntityWorkspaceSettings", "objectId", objectId);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            if (metaInclude) {
                localVarQueryParameter["metaInclude"] = Array.from(metaInclude).join(COLLECTION_FORMATS.csv);
            }
            if (xGDCVALIDATERELATIONS !== undefined && xGDCVALIDATERELATIONS !== null) {
                localVarHeaderParameter["X-GDC-VALIDATE-RELATIONS"] = String(JSON.stringify(xGDCVALIDATERELATIONS));
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingPatchDocument} jsonApiCustomApplicationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCustomApplicationSettings: async (workspaceId, objectId, jsonApiCustomApplicationSettingPatchDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityCustomApplicationSettings", "objectId", objectId);
            // verify required parameter 'jsonApiCustomApplicationSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityCustomApplicationSettings", "jsonApiCustomApplicationSettingPatchDocument", jsonApiCustomApplicationSettingPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCustomApplicationSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCustomApplicationSettingPatchDocument !== undefined
                    ? jsonApiCustomApplicationSettingPatchDocument
                    : {})
                : jsonApiCustomApplicationSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingPatchDocument} jsonApiWorkspaceSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceSettings: async (workspaceId, objectId, jsonApiWorkspaceSettingPatchDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("patchEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("patchEntityWorkspaceSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceSettingPatchDocument' is not null or undefined
            assertParamExists("patchEntityWorkspaceSettings", "jsonApiWorkspaceSettingPatchDocument", jsonApiWorkspaceSettingPatchDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceSettingPatchDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceSettingPatchDocument !== undefined
                    ? jsonApiWorkspaceSettingPatchDocument
                    : {})
                : jsonApiWorkspaceSettingPatchDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingInDocument} jsonApiCustomApplicationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCustomApplicationSettings: async (workspaceId, objectId, jsonApiCustomApplicationSettingInDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityCustomApplicationSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityCustomApplicationSettings", "objectId", objectId);
            // verify required parameter 'jsonApiCustomApplicationSettingInDocument' is not null or undefined
            assertParamExists("updateEntityCustomApplicationSettings", "jsonApiCustomApplicationSettingInDocument", jsonApiCustomApplicationSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/customApplicationSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiCustomApplicationSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiCustomApplicationSettingInDocument !== undefined
                    ? jsonApiCustomApplicationSettingInDocument
                    : {})
                : jsonApiCustomApplicationSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put a Setting for a Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingInDocument} jsonApiWorkspaceSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceSettings: async (workspaceId, objectId, jsonApiWorkspaceSettingInDocument, filter, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("updateEntityWorkspaceSettings", "workspaceId", workspaceId);
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists("updateEntityWorkspaceSettings", "objectId", objectId);
            // verify required parameter 'jsonApiWorkspaceSettingInDocument' is not null or undefined
            assertParamExists("updateEntityWorkspaceSettings", "jsonApiWorkspaceSettingInDocument", jsonApiWorkspaceSettingInDocument);
            const localVarPath = `/api/v1/entities/workspaces/{workspaceId}/workspaceSettings/{objectId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter["filter"] = filter;
            }
            localVarHeaderParameter["Content-Type"] = "application/vnd.gooddata.api+json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof jsonApiWorkspaceSettingInDocument !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(jsonApiWorkspaceSettingInDocument !== undefined
                    ? jsonApiWorkspaceSettingInDocument
                    : {})
                : jsonApiWorkspaceSettingInDocument || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves values for all settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for all settings.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceResolveAllSettings: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("workspaceResolveAllSettings", "workspaceId", workspaceId);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/resolveSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolves value for selected settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for selected settings.
         * @param {string} workspaceId
         * @param {ResolveSettingsRequest} resolveSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceResolveSettings: async (workspaceId, resolveSettingsRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists("workspaceResolveSettings", "workspaceId", workspaceId);
            // verify required parameter 'resolveSettingsRequest' is not null or undefined
            assertParamExists("workspaceResolveSettings", "resolveSettingsRequest", resolveSettingsRequest);
            const localVarPath = `/api/v1/actions/workspaces/{workspaceId}/resolveSettings`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const needsSerialization = typeof resolveSettingsRequest !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(resolveSettingsRequest !== undefined ? resolveSettingsRequest : {})
                : resolveSettingsRequest || "";
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WorkspacesSettingsApi - functional programming interface
 * @export
 */
export const WorkspacesSettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkspacesSettingsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post Custom Application Settings
         * @param {string} workspaceId
         * @param {JsonApiCustomApplicationSettingPostOptionalIdDocument} jsonApiCustomApplicationSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityCustomApplicationSettings(workspaceId, jsonApiCustomApplicationSettingPostOptionalIdDocument, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityCustomApplicationSettings(workspaceId, jsonApiCustomApplicationSettingPostOptionalIdDocument, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Post Settings for Workspaces
         * @param {string} workspaceId
         * @param {JsonApiWorkspaceSettingPostOptionalIdDocument} jsonApiWorkspaceSettingPostOptionalIdDocument
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityWorkspaceSettings(workspaceId, jsonApiWorkspaceSettingPostOptionalIdDocument, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityWorkspaceSettings(workspaceId, jsonApiWorkspaceSettingPostOptionalIdDocument, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityCustomApplicationSettings(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityCustomApplicationSettings(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityWorkspaceSettings(workspaceId, objectId, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityWorkspaceSettings(workspaceId, objectId, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Custom Application Settings
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesCustomApplicationSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesCustomApplicationSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all Setting for Workspaces
         * @param {string} workspaceId
         * @param {'ALL' | 'PARENTS' | 'NATIVE'} [origin]
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'page' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesWorkspaceSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesWorkspaceSettings(workspaceId, origin, filter, page, size, sort, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCustomApplicationSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCustomApplicationSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {boolean} [xGDCVALIDATERELATIONS]
         * @param {Array<'origin' | 'all' | 'ALL'>} [metaInclude] Include Meta objects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorkspaceSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorkspaceSettings(workspaceId, objectId, filter, xGDCVALIDATERELATIONS, metaInclude, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingPatchDocument} jsonApiCustomApplicationSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch a Setting for Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingPatchDocument} jsonApiWorkspaceSettingPatchDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingPatchDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingPatchDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Custom Application Setting
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiCustomApplicationSettingInDocument} jsonApiCustomApplicationSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityCustomApplicationSettings(workspaceId, objectId, jsonApiCustomApplicationSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Put a Setting for a Workspace
         * @param {string} workspaceId
         * @param {string} objectId
         * @param {JsonApiWorkspaceSettingInDocument} jsonApiWorkspaceSettingInDocument
         * @param {string} [filter] Filtering parameter in RSQL. See https://github.com/jirutka/rsql-parser. You can specify any object parameter and parameter of related entity (for example title&#x3D;&#x3D;\&#39;Some Title\&#39;;description&#x3D;&#x3D;\&#39;desc\&#39;). Additionally, if the entity relationship represents a polymorphic entity type, it can be casted to its subtypes (for example relatedEntity::subtype.subtypeProperty&#x3D;&#x3D;\&#39;Value 123\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingInDocument, filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityWorkspaceSettings(workspaceId, objectId, jsonApiWorkspaceSettingInDocument, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves values for all settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for all settings.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceResolveAllSettings(workspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceResolveAllSettings(workspaceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolves value for selected settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for selected settings.
         * @param {string} workspaceId
         * @param {ResolveSettingsRequest} resolveSettingsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workspaceResolveSettings(workspaceId, resolveSettingsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workspaceResolveSettings(workspaceId, resolveSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * WorkspacesSettingsApi - factory interface
 * @export
 */
export const WorkspacesSettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkspacesSettingsApiFp(configuration);
    return {
        /**
         *
         * @summary Post Custom Application Settings
         * @param {WorkspacesSettingsApiCreateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .createEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.jsonApiCustomApplicationSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post Settings for Workspaces
         * @param {WorkspacesSettingsApiCreateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .createEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Custom Application Setting
         * @param {WorkspacesSettingsApiDeleteEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Setting for Workspace
         * @param {WorkspacesSettingsApiDeleteEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .deleteEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Custom Application Settings
         * @param {WorkspacesSettingsApiGetAllEntitiesCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesCustomApplicationSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Setting for Workspaces
         * @param {WorkspacesSettingsApiGetAllEntitiesWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .getAllEntitiesWorkspaceSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Custom Application Setting
         * @param {WorkspacesSettingsApiGetEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .getEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Setting for Workspace
         * @param {WorkspacesSettingsApiGetEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .getEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Custom Application Setting
         * @param {WorkspacesSettingsApiPatchEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .patchEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a Setting for Workspace
         * @param {WorkspacesSettingsApiPatchEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .patchEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingPatchDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Custom Application Setting
         * @param {WorkspacesSettingsApiUpdateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityCustomApplicationSettings(requestParameters, options) {
            return localVarFp
                .updateEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put a Setting for a Workspace
         * @param {WorkspacesSettingsApiUpdateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityWorkspaceSettings(requestParameters, options) {
            return localVarFp
                .updateEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingInDocument, requestParameters.filter, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Resolves values for all settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for all settings.
         * @param {WorkspacesSettingsApiWorkspaceResolveAllSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceResolveAllSettings(requestParameters, options) {
            return localVarFp
                .workspaceResolveAllSettings(requestParameters.workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Resolves value for selected settings in a workspace by current user, workspace, organization, or default settings.
         * @summary Values for selected settings.
         * @param {WorkspacesSettingsApiWorkspaceResolveSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceResolveSettings(requestParameters, options) {
            return localVarFp
                .workspaceResolveSettings(requestParameters.workspaceId, requestParameters.resolveSettingsRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkspacesSettingsApi - object-oriented interface
 * @export
 * @class WorkspacesSettingsApi
 * @extends {BaseAPI}
 */
export class WorkspacesSettingsApi extends BaseAPI {
    /**
     *
     * @summary Post Custom Application Settings
     * @param {WorkspacesSettingsApiCreateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    createEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .createEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.jsonApiCustomApplicationSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post Settings for Workspaces
     * @param {WorkspacesSettingsApiCreateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    createEntityWorkspaceSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .createEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.jsonApiWorkspaceSettingPostOptionalIdDocument, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Custom Application Setting
     * @param {WorkspacesSettingsApiDeleteEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    deleteEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .deleteEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Setting for Workspace
     * @param {WorkspacesSettingsApiDeleteEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    deleteEntityWorkspaceSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .deleteEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Custom Application Settings
     * @param {WorkspacesSettingsApiGetAllEntitiesCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    getAllEntitiesCustomApplicationSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .getAllEntitiesCustomApplicationSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Setting for Workspaces
     * @param {WorkspacesSettingsApiGetAllEntitiesWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    getAllEntitiesWorkspaceSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .getAllEntitiesWorkspaceSettings(requestParameters.workspaceId, requestParameters.origin, requestParameters.filter, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Custom Application Setting
     * @param {WorkspacesSettingsApiGetEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    getEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .getEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Setting for Workspace
     * @param {WorkspacesSettingsApiGetEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    getEntityWorkspaceSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .getEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.filter, requestParameters.xGDCVALIDATERELATIONS, requestParameters.metaInclude, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Custom Application Setting
     * @param {WorkspacesSettingsApiPatchEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    patchEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .patchEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a Setting for Workspace
     * @param {WorkspacesSettingsApiPatchEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    patchEntityWorkspaceSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .patchEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingPatchDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Custom Application Setting
     * @param {WorkspacesSettingsApiUpdateEntityCustomApplicationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    updateEntityCustomApplicationSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .updateEntityCustomApplicationSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiCustomApplicationSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put a Setting for a Workspace
     * @param {WorkspacesSettingsApiUpdateEntityWorkspaceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    updateEntityWorkspaceSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .updateEntityWorkspaceSettings(requestParameters.workspaceId, requestParameters.objectId, requestParameters.jsonApiWorkspaceSettingInDocument, requestParameters.filter, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves values for all settings in a workspace by current user, workspace, organization, or default settings.
     * @summary Values for all settings.
     * @param {WorkspacesSettingsApiWorkspaceResolveAllSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    workspaceResolveAllSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .workspaceResolveAllSettings(requestParameters.workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolves value for selected settings in a workspace by current user, workspace, organization, or default settings.
     * @summary Values for selected settings.
     * @param {WorkspacesSettingsApiWorkspaceResolveSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesSettingsApi
     */
    workspaceResolveSettings(requestParameters, options) {
        return WorkspacesSettingsApiFp(this.configuration)
            .workspaceResolveSettings(requestParameters.workspaceId, requestParameters.resolveSettingsRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map